import { api } from './baseApi';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Decimal: any;
  EmailAddress: any;
  JSON: any;
  JSONArray: any;
  JSONObject: any;
  PhoneNumber: any;
  Time: any;
  UUID: string;
};

export type AclRole = {
  __typename?: 'AclRole';
  id?: Maybe<Scalars['UUID']>;
  key?: Maybe<Scalars['String']>;
  lvl?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export enum AclRoleKey {
  Admin = 'ADMIN',
  Doctor = 'DOCTOR',
  Manager = 'MANAGER',
  MonitoringCenter = 'MONITORING_CENTER',
  Nurse = 'NURSE',
  SurveillanceCenter = 'SURVEILLANCE_CENTER',
  Therapist = 'THERAPIST'
}

export type AclRoleResult = {
  __typename?: 'AclRoleResult';
  data?: Maybe<Array<Maybe<AclRole>>>;
  meta?: Maybe<PageInfo>;
};

export type Action = {
  __typename?: 'Action';
  extra?: Maybe<Scalars['JSONObject']>;
  type: Scalars['String'];
};

export type ActivateUserSubscriptionByRedeemCode = {
  admin?: InputMaybe<Scalars['String']>;
  redeemCode: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type AddLaboratoryRequisitionToPatientInput = {
  laboratoryRequisitionResultId: Scalars['UUID'];
};

export type Address = {
  __typename?: 'Address';
  accommodationZone?: Maybe<Scalars['String']>;
  apartmentNumber?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['EmailAddress']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  departmentNumber?: Maybe<Scalars['String']>;
  descriptiveNumber?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  formattedFullAddress?: Maybe<Scalars['String']>;
  formattedShortAddress?: Maybe<Scalars['String']>;
  fullAddress?: Maybe<Scalars['String']>;
  governName?: Maybe<Scalars['String']>;
  governType?: Maybe<Scalars['String']>;
  guideNumber?: Maybe<Scalars['String']>;
  houseType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identificationNumber?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  kilometer?: Maybe<Scalars['String']>;
  lot?: Maybe<Scalars['String']>;
  manzana?: Maybe<Scalars['String']>;
  parish?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  shortAddress?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  street2?: Maybe<Scalars['String']>;
  streetType?: Maybe<Scalars['String']>;
  taxIdentificationNumber?: Maybe<Scalars['String']>;
  terytCode?: Maybe<Scalars['String']>;
  type?: Maybe<AddressType>;
  ubigeo?: Maybe<Scalars['String']>;
  zoneName?: Maybe<Scalars['String']>;
  zoneType?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  accommodationZone?: InputMaybe<Scalars['String']>;
  apartmentNumber?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  descriptiveNumber?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  formattedFullAddress?: InputMaybe<Scalars['String']>;
  formattedShortAddress?: InputMaybe<Scalars['String']>;
  fullAddress?: InputMaybe<Scalars['String']>;
  governName?: InputMaybe<Scalars['String']>;
  governType?: InputMaybe<Scalars['String']>;
  guideNumber?: InputMaybe<Scalars['String']>;
  houseType?: InputMaybe<Scalars['String']>;
  kilometer?: InputMaybe<Scalars['String']>;
  lot?: InputMaybe<Scalars['String']>;
  manzana?: InputMaybe<Scalars['String']>;
  parish?: InputMaybe<Scalars['String']>;
  postCode?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  reference?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  sector?: InputMaybe<Scalars['String']>;
  shortAddress?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
  streetType?: InputMaybe<Scalars['String']>;
  ubigeo?: InputMaybe<Scalars['String']>;
  zoneName?: InputMaybe<Scalars['String']>;
  zoneType?: InputMaybe<Scalars['String']>;
};

export enum AddressType {
  Billing = 'BILLING',
  Contact = 'CONTACT'
}

export type AssignCaseToMeInput = {
  caseId: Scalars['UUID'];
  message?: InputMaybe<Scalars['String']>;
};

export type AuditLog = {
  __typename?: 'AuditLog';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  extra?: Maybe<Scalars['JSONObject']>;
  id: Scalars['Int'];
  targetEntityId?: Maybe<Scalars['String']>;
  targetEntityType?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type AuditLogsResult = {
  __typename?: 'AuditLogsResult';
  data?: Maybe<Array<Maybe<AuditLog>>>;
  meta?: Maybe<PageInfo>;
};

export type AvailableDoctor = {
  __typename?: 'AvailableDoctor';
  city?: Maybe<Scalars['String']>;
  clkId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  lastName?: Maybe<Scalars['String']>;
  salutationAfter?: Maybe<Scalars['String']>;
  salutationBefore?: Maybe<Scalars['String']>;
};

export type AvailableDoctorsResult = {
  __typename?: 'AvailableDoctorsResult';
  data?: Maybe<Array<Maybe<AvailableDoctor>>>;
  meta?: Maybe<PageInfo>;
};

export type Badge = {
  __typename?: 'Badge';
  backgroundColor?: Maybe<Scalars['String']>;
  theme?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type BioScanHistoriesResult = {
  __typename?: 'BioScanHistoriesResult';
  data?: Maybe<Array<Maybe<BioScanHistory>>>;
  meta?: Maybe<PageInfo>;
};

export type BioScanHistory = {
  __typename?: 'BioScanHistory';
  age?: Maybe<Scalars['String']>;
  breathingRateConfidence?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  heartRateConfidence?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['UUID']>;
  items?: Maybe<Array<Maybe<HealthDataItem>>>;
  weight?: Maybe<Scalars['String']>;
};

export type BulkUserHealthCategoryPermissionInput = {
  items?: InputMaybe<Array<InputMaybe<UserHealthCategoryPermissionInput>>>;
};

export type Calendar = {
  __typename?: 'Calendar';
  id: Scalars['UUID'];
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type CancelDrMaxReservationInput = {
  reservationId: Scalars['String'];
};

export type CancelDrMaxReservationResult = {
  __typename?: 'CancelDrMaxReservationResult';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Case = {
  __typename?: 'Case';
  caseChatPreview?: Maybe<Scalars['Boolean']>;
  caseEntries?: Maybe<Array<Maybe<CaseEntry>>>;
  caseStatus?: Maybe<Scalars['JSONObject']>;
  caseStatusValue?: Maybe<CaseStatus>;
  caseType?: Maybe<CaseType>;
  caseTypeId?: Maybe<Scalars['UUID']>;
  child?: Maybe<User>;
  childId?: Maybe<Scalars['UUID']>;
  code?: Maybe<Scalars['String']>;
  contactSpecialist?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  descriptionExtra?: Maybe<Scalars['JSONObject']>;
  diagnosis?: Maybe<Scalars['String']>;
  doctor?: Maybe<User>;
  doctorId?: Maybe<Scalars['UUID']>;
  event?: Maybe<Event>;
  eventId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['UUID']>;
  isAssigned?: Maybe<Scalars['Boolean']>;
  isChatActive?: Maybe<Scalars['Boolean']>;
  isImmediate?: Maybe<Scalars['JSONObject']>;
  isMeddi?: Maybe<Scalars['Boolean']>;
  isMyCase?: Maybe<Scalars['Boolean']>;
  isNew?: Maybe<Scalars['Boolean']>;
  lastCaseEntry?: Maybe<CaseEntry>;
  lastNote?: Maybe<Note>;
  medicalReport?: Maybe<MedicalReport>;
  medicalReports?: Maybe<Array<Maybe<MedicalReport>>>;
  medicationLasted?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  meta?: Maybe<Array<Maybe<Meta>>>;
  patient?: Maybe<User>;
  patientDescription?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['UUID']>;
  patientParent?: Maybe<User>;
  paymentMethod?: Maybe<Scalars['String']>;
  priority?: Maybe<TermItem>;
  priorityId?: Maybe<Scalars['UUID']>;
  reassignedFrom?: Maybe<WorkplaceMember>;
  solveTo?: Maybe<Scalars['DateTime']>;
  solved?: Maybe<Scalars['Boolean']>;
  solvedAt?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  titleShort?: Maybe<Scalars['String']>;
  totalUnreadCaseEntries?: Maybe<Scalars['Int']>;
  transportMethod?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibleAt?: Maybe<Scalars['DateTime']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};


export type CaseMetaArgs = {
  key?: InputMaybe<Scalars['String']>;
};

export type CaseContact = {
  __typename?: 'CaseContact';
  iconUrl?: Maybe<Scalars['String']>;
  textRow1?: Maybe<Scalars['String']>;
  textRow2?: Maybe<Scalars['String']>;
  textRow3?: Maybe<Scalars['String']>;
  type?: Maybe<CaseContactType>;
  userId?: Maybe<Scalars['String']>;
  workplaceId?: Maybe<Scalars['String']>;
  workplaceMemberId?: Maybe<Scalars['String']>;
  workplaceMemberUserRelation?: Maybe<UserRelation>;
};


export type CaseContactWorkplaceMemberUserRelationArgs = {
  type?: InputMaybe<UserRelationType>;
};

export enum CaseContactType {
  Workplace = 'WORKPLACE',
  WorkplaceMember = 'WORKPLACE_MEMBER'
}

export type CaseContactsResult = {
  __typename?: 'CaseContactsResult';
  data?: Maybe<Array<Maybe<CaseContact>>>;
  meta?: Maybe<PageInfo>;
};

export enum CaseCreateDay {
  Before_1 = 'BEFORE_1',
  Before_3 = 'BEFORE_3',
  Before_7 = 'BEFORE_7',
  DateRange = 'DATE_RANGE'
}

export type CaseDoctor = {
  __typename?: 'CaseDoctor';
  id: Scalars['UUID'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  userRelation?: Maybe<UserRelation>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type CaseDoctorsResult = {
  __typename?: 'CaseDoctorsResult';
  data?: Maybe<Array<Maybe<CaseDoctor>>>;
  meta?: Maybe<PageInfo>;
};

export type CaseEntriesResult = {
  __typename?: 'CaseEntriesResult';
  data?: Maybe<Array<Maybe<CaseEntry>>>;
  meta?: Maybe<PageInfo>;
};

export type CaseEntry = {
  __typename?: 'CaseEntry';
  avResult?: Maybe<Scalars['String']>;
  case?: Maybe<Case>;
  caseEntryMembers?: Maybe<Array<Maybe<CaseEntryMember>>>;
  caseId?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extra?: Maybe<Scalars['JSONObject']>;
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['Int']>;
  inDocumentation?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  sender?: Maybe<User>;
  senderId?: Maybe<Scalars['UUID']>;
  thumb?: Maybe<Scalars['Boolean']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<Scalars['String']>;
};

export type CaseEntryMember = {
  __typename?: 'CaseEntryMember';
  caseEntry?: Maybe<CaseEntry>;
  caseEntryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  seen?: Maybe<Scalars['Boolean']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export enum CaseSolvedMonth {
  Before_1 = 'BEFORE_1',
  Before_3 = 'BEFORE_3'
}

export enum CaseStatus {
  InProgress = 'IN_PROGRESS',
  New = 'NEW'
}

export type CaseType = {
  __typename?: 'CaseType';
  canBookOnSite?: Maybe<Scalars['Boolean']>;
  canBookOnline?: Maybe<Scalars['Boolean']>;
  canOrderImmediate?: Maybe<Scalars['Boolean']>;
  caseTypeItems?: Maybe<Array<Maybe<CaseTypeItem>>>;
  categoryTypeId?: Maybe<Scalars['UUID']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  descriptionKey?: Maybe<Scalars['String']>;
  eventInterval?: Maybe<Scalars['Int']>;
  fullPath?: Maybe<Scalars['String']>;
  hiddenForPatient?: Maybe<Scalars['Boolean']>;
  iconUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  isEditable?: Maybe<Scalars['Boolean']>;
  isSystem?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  labelKey?: Maybe<Scalars['String']>;
  module?: Maybe<Scalars['String']>;
  notificationBook?: Maybe<Scalars['Boolean']>;
  notificationCase?: Maybe<Scalars['Boolean']>;
  parentCaseTypeId?: Maybe<Scalars['UUID']>;
  price?: Maybe<Price>;
  priceId?: Maybe<Scalars['UUID']>;
  rank?: Maybe<Scalars['Int']>;
  rootCaseType?: Maybe<CaseType>;
  type?: Maybe<Scalars['String']>;
};

export type CaseTypeItem = {
  __typename?: 'CaseTypeItem';
  caseType?: Maybe<CaseType>;
  caseTypeId?: Maybe<Scalars['UUID']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  key?: Maybe<Scalars['String']>;
  parentCaseTypeItemId?: Maybe<Scalars['UUID']>;
  position?: Maybe<Scalars['Int']>;
  rank?: Maybe<Scalars['Int']>;
  settings?: Maybe<Scalars['JSONObject']>;
  subtype?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum CaseTypeType {
  CaseType = 'CASE_TYPE',
  Folder = 'FOLDER'
}

export type CasesResult = {
  __typename?: 'CasesResult';
  data?: Maybe<Array<Maybe<Case>>>;
  meta?: Maybe<PageInfo>;
};

export type Certificate = {
  __typename?: 'Certificate';
  expires?: Maybe<Scalars['DateTime']>;
  fileId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['UUID']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['UUID']>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type CertificatesResult = {
  __typename?: 'CertificatesResult';
  data?: Maybe<Array<Maybe<Certificate>>>;
  meta?: Maybe<PageInfo>;
};

export type ChangePaymentMethodUrl = {
  __typename?: 'ChangePaymentMethodUrl';
  url?: Maybe<Scalars['String']>;
};

export type ChargeStatus = {
  __typename?: 'ChargeStatus';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ChargeSubscriptionInput = {
  paymentMethod?: InputMaybe<Scalars['String']>;
  userSubscriptionId?: InputMaybe<Scalars['String']>;
};

export type Conversation = {
  __typename?: 'Conversation';
  conversationMembers?: Maybe<Array<Maybe<ConversationMember>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extra?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  lastMessage?: Maybe<Message>;
  messages?: Maybe<Array<Maybe<Message>>>;
  myUnreadMessages?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  singleRecipient?: Maybe<ConversationMember>;
  totalRecipients?: Maybe<Scalars['Int']>;
  type?: Maybe<ConversationType>;
};


export type ConversationConversationMembersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type ConversationMessagesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export enum ConversationFolderEnum {
  Inbox = 'INBOX',
  Sent = 'SENT'
}

export type ConversationMember = {
  __typename?: 'ConversationMember';
  conversation?: Maybe<Conversation>;
  conversationId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['UUID']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type ConversationMemberResult = {
  __typename?: 'ConversationMemberResult';
  data?: Maybe<Array<Maybe<ConversationMember>>>;
  meta?: Maybe<PageInfo>;
};

export enum ConversationType {
  HealthPlan = 'HEALTH_PLAN',
  Normal = 'NORMAL',
  Notification = 'NOTIFICATION',
  WorkflowChatbot = 'WORKFLOW_CHATBOT'
}

export type ConversationsResult = {
  __typename?: 'ConversationsResult';
  data?: Maybe<Array<Maybe<Conversation>>>;
  meta?: Maybe<PageInfo>;
};

export enum CreateCaseTarget {
  Workplace = 'WORKPLACE',
  WorkplaceMember = 'WORKPLACE_MEMBER'
}

export type CreateDrMaxPrescriptionReservationInput = {
  drmaxPickupPlaceId: Scalars['UUID'];
  prescriptionId: Scalars['UUID'];
  userId?: InputMaybe<Scalars['UUID']>;
};

export type CreateEventInput = {
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
  eventMembers?: InputMaybe<Array<InputMaybe<CreateEventMemberInput>>>;
  type: EventType;
};

export type CreateEventMemberInput = {
  user?: InputMaybe<CreateEventMemberUserInput>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type CreateEventMemberUserInput = {
  birthNumber?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['EmailAddress']>;
  contactPhoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
  firstName?: InputMaybe<Scalars['String']>;
  insuranceCompanyTermItemId?: InputMaybe<Scalars['UUID']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type CreateGroupInput = {
  name: Scalars['String'];
};

export type CreateHealthPlanInput = {
  active: Scalars['Boolean'];
  code: Scalars['String'];
  initialQuestionnaireCode?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  settings?: InputMaybe<Scalars['JSONObject']>;
};

export type CreateHealthPlanUserFromDataInput = {
  addToPatientECard?: InputMaybe<Scalars['Boolean']>;
  healthPlanId: Scalars['UUID'];
  ingestion?: InputMaybe<Scalars['JSONArray']>;
  questionnaire?: InputMaybe<Scalars['JSONObject']>;
  userId: Scalars['UUID'];
};

export type CreateHealthPlanUserInput = {
  healthPlanId: Scalars['UUID'];
  questionnaireResultId?: InputMaybe<Scalars['UUID']>;
  userId: Scalars['UUID'];
};

export type CreateHealthPlanWorkplaceInput = {
  healthPlanId: Scalars['UUID'];
  workplaceId: Scalars['UUID'];
};

export type CreateInsuranceReportExportFiles = {
  insuranceCompanyCode: Scalars['String'];
  month: Scalars['Int'];
  rootWorkplaceId: Scalars['UUID'];
  type?: InputMaybe<InsuranceReportType>;
  year: Scalars['Int'];
};

export type CreateInsuranceReportInput = {
  birthNumber?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['Int']>;
  diagnosis?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['UUID']>;
  extra?: InputMaybe<Scalars['JSON']>;
  insuranceId: Scalars['UUID'];
  operationId: Scalars['UUID'];
  patientId: Scalars['UUID'];
  points?: InputMaybe<Scalars['Int']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type CreateLaboratoryInput = {
  address?: InputMaybe<AddressInput>;
  code: Scalars['String'];
  icl?: InputMaybe<Scalars['String']>;
  ico?: InputMaybe<Scalars['String']>;
  icp?: InputMaybe<Scalars['String']>;
  icz?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateLaboratoryRequisitionWorkplaceInput = {
  laboratoryRequisitionId: Scalars['UUID'];
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type CreateLaboratoryWizardInput = {
  laboratoryId: Scalars['UUID'];
  type?: InputMaybe<LaboratoryWizardType>;
  wizardId: Scalars['UUID'];
};

export type CreateLaboratoryWorkplaceInput = {
  laboratoryId: Scalars['UUID'];
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type CreateNoteInput = {
  caseId?: InputMaybe<Scalars['UUID']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  text: Scalars['String'];
};

export type CreateOperationReportInput = {
  code: Scalars['String'];
  extra?: InputMaybe<Scalars['JSON']>;
  insuranceId: Scalars['UUID'];
  ncziCode: Scalars['String'];
  points: Scalars['Int'];
  pricePerPoint?: InputMaybe<Scalars['Float']>;
  title: Scalars['String'];
  workplaceId: Scalars['UUID'];
};

export type CreateOrUpdateQuestionnaireResultMemberInput = {
  hidden?: InputMaybe<Scalars['Boolean']>;
  questionnaireResultId: Scalars['UUID'];
  seen?: InputMaybe<Scalars['Boolean']>;
};

export type CreateP1PrescriptionInput = {
  patientId: Scalars['UUID'];
  prescriptionMedicaments?: InputMaybe<Array<InputMaybe<CreateP1PrescriptionMedicamentsInput>>>;
};

export type CreateP1PrescriptionMedicamentsInput = {
  amountOfPackages: Scalars['Int'];
  applicationDescription?: InputMaybe<Scalars['String']>;
  applicationFrequency?: InputMaybe<Scalars['Int']>;
  applicationFrequencyAmount?: InputMaybe<Scalars['Int']>;
  dosageCount: Scalars['Int'];
  dosageInterval: Scalars['Int'];
  id: Scalars['UUID'];
  medicamentChange: Scalars['Boolean'];
  paymentCoverage: Scalars['String'];
  recipeRepeat?: InputMaybe<Scalars['Int']>;
  validFrom?: InputMaybe<Scalars['Date']>;
};

export type CreatePhraseInput = {
  name?: InputMaybe<Scalars['String']>;
  rank?: InputMaybe<Scalars['Int']>;
  type: PhraseType;
  value: Scalars['String'];
};

export type CreatePriceInput = {
  currency?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Decimal']>;
  priceWithVat?: InputMaybe<Scalars['Decimal']>;
  vatRate?: InputMaybe<Scalars['Float']>;
};

export type CreateProfileInput = {
  birthNumber?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['EmailAddress']>;
  contactPhoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
  firstName?: InputMaybe<Scalars['String']>;
  insuranceCompanyTermItemId?: InputMaybe<Scalars['UUID']>;
  lastName?: InputMaybe<Scalars['String']>;
  salutationAfter?: InputMaybe<Scalars['String']>;
  salutationBefore?: InputMaybe<Scalars['String']>;
};

export type CreateRatingInput = {
  caseId?: InputMaybe<Scalars['UUID']>;
  stars?: InputMaybe<Scalars['Float']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<RatingType>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type CreateSubscriptionGroup = {
  key: Scalars['String'];
};

export type CreateSubscriptionInput = {
  buyable?: InputMaybe<Scalars['Boolean']>;
  code: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  descriptionShort?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  items?: InputMaybe<Array<InputMaybe<CreateSubscriptionItemInput>>>;
  name: Scalars['String'];
  nameAdmin?: InputMaybe<Scalars['String']>;
  partner?: InputMaybe<Scalars['Int']>;
  periods?: InputMaybe<Array<InputMaybe<CreateSubscriptionPeriodInput>>>;
  redeemCodeRequired?: InputMaybe<Scalars['Boolean']>;
  theme?: InputMaybe<ThemeEnum>;
};

export type CreateSubscriptionItemInput = {
  extra?: InputMaybe<Scalars['JSONObject']>;
  type: SubscriptionItemType;
};

export type CreateSubscriptionPeriodInput = {
  period?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<CreatePriceInput>;
  type: SubscriptionPeriodType;
  value?: InputMaybe<Scalars['String']>;
};

export type CreateSubscriptionRedeemCodeInput = {
  code: Scalars['String'];
  subscriptionCode?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['UUID']>;
  subscriptionPeriodId?: InputMaybe<Scalars['UUID']>;
};

export type CreateTokenInput = {
  type: TokenType;
};

export type CreateUserInput = {
  email?: InputMaybe<Scalars['EmailAddress']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<CreateProfileInput>;
};

export type CreateUserMedicationLastedInput = {
  data?: InputMaybe<Scalars['JSON']>;
  prescriptionId?: InputMaybe<Scalars['UUID']>;
  prescriptionMedicamentData?: InputMaybe<Scalars['JSON']>;
  prescriptionMedicamentId?: InputMaybe<Scalars['UUID']>;
  userId: Scalars['UUID'];
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type CreateUserSubscriptionMemberInput = {
  userId?: InputMaybe<Scalars['UUID']>;
  userSubscriptionId: Scalars['UUID'];
};

export type CreateWizardResultInput = {
  userId?: InputMaybe<Scalars['UUID']>;
  wizardId: Scalars['UUID'];
  wizardResultItems?: InputMaybe<Array<CreateWizardResultItemInput>>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type CreateWizardResultItemInput = {
  key: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSONObject']>;
};

export type CreateWorkplaceMemberAbsenceInput = {
  allowContactInAbsence?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  end: Scalars['DateTime'];
  fullday?: InputMaybe<Scalars['Boolean']>;
  start: Scalars['DateTime'];
  workplaceMemberIds: Array<InputMaybe<Scalars['UUID']>>;
};

export type CreateWorkplacePresetInput = {
  memberType: WorkplacePresetMemberType;
  name: Scalars['String'];
  type: WorkplacePresetType;
};

export type DashboardLayoutItem = {
  __typename?: 'DashboardLayoutItem';
  background?: Maybe<Scalars['JSONObject']>;
  badge?: Maybe<Scalars['JSONObject']>;
  children?: Maybe<Array<Maybe<DashboardLayoutItem>>>;
  extra?: Maybe<Scalars['JSONObject']>;
  settings?: Maybe<Scalars['JSONObject']>;
  template?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  titleParts?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Scalars['String']>;
};

export type DashboardTile = {
  __typename?: 'DashboardTile';
  action?: Maybe<Action>;
  badge?: Maybe<Scalars['JSONObject']>;
  button?: Maybe<Scalars['JSONObject']>;
  buttonText?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleUpper?: Maybe<Scalars['JSONObject']>;
  type?: Maybe<Scalars['String']>;
  upperTitle?: Maybe<Scalars['String']>;
};

export type DateFilter = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export enum DayShortEnum {
  Fri = 'FRI',
  Mon = 'MON',
  Sat = 'SAT',
  Sun = 'SUN',
  Thu = 'THU',
  Tue = 'TUE',
  Wed = 'WED'
}

export type DeleteDocumentationFolderInput = {
  transferDocumentationFolderId?: InputMaybe<Scalars['UUID']>;
};

export type DeleteLaboratoryRequisitionWorkplaceInput = {
  id?: InputMaybe<Scalars['UUID']>;
  laboratoryRequisitionId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type DeleteLaboratoryWorkplaceInput = {
  id?: InputMaybe<Scalars['UUID']>;
  laboratoryId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type DeleteTokenInput = {
  id: Scalars['Int'];
};

export type DeleteWizardResultInput = {
  id: Scalars['UUID'];
};

export type DeleteWorkplaceMemberInput = {
  dateOfDeath?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['UUID']>;
  reason?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type Document = {
  __typename?: 'Document';
  content?: Maybe<DocumentItem>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  file?: Maybe<File>;
  id: Scalars['UUID'];
  item?: Maybe<DocumentItem>;
  items?: Maybe<Array<Maybe<DocumentItem>>>;
  previousVersionDocument?: Maybe<Document>;
  previousVersionDocumentId?: Maybe<Scalars['UUID']>;
  sync?: Maybe<SyncStatus>;
  title?: Maybe<DocumentItem>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  workplace?: Maybe<User>;
  workplaceId?: Maybe<Scalars['UUID']>;
};


export type DocumentItemArgs = {
  type?: InputMaybe<Scalars['String']>;
};


export type DocumentItemsArgs = {
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DocumentItem = {
  __typename?: 'DocumentItem';
  createdAt?: Maybe<Scalars['DateTime']>;
  extra?: Maybe<Scalars['JSONObject']>;
  id: Scalars['UUID'];
  type?: Maybe<Scalars['String']>;
};

export type DocumentTransferInput = {
  documentId: Scalars['UUID'];
  documentName?: InputMaybe<Scalars['String']>;
  targetFolder: Scalars['UUID'];
  targetUserId?: InputMaybe<Scalars['UUID']>;
};

export enum DocumentType {
  Dekurz = 'DEKURZ',
  DekurzDraft = 'DEKURZ_DRAFT',
  DekurzDraftVersion = 'DEKURZ_DRAFT_VERSION',
  DekurzTemplate = 'DEKURZ_TEMPLATE',
  MedicalHistory = 'MEDICAL_HISTORY',
  MedicalReport = 'MEDICAL_REPORT',
  MedicalRequestForm = 'MEDICAL_REQUEST_FORM'
}

export type DocumentWhereInput = {
  id?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<DocumentType>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type DocumentationFile = {
  __typename?: 'DocumentationFile';
  avResult?: Maybe<Scalars['String']>;
  avResultExpectedTimeToComplete?: Maybe<Scalars['Int']>;
  avResultText?: Maybe<Scalars['String']>;
  canBeShared?: Maybe<Scalars['Boolean']>;
  canBeSigned?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdByName?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  extension?: Maybe<Scalars['String']>;
  file?: Maybe<File>;
  fileGroupId?: Maybe<Scalars['String']>;
  fileTransfers?: Maybe<Meta>;
  fileUrl?: Maybe<Scalars['String']>;
  folder?: Maybe<DocumentationFolder>;
  folderId?: Maybe<Scalars['UUID']>;
  groupFiles?: Maybe<Array<Maybe<DocumentationFile>>>;
  groupFilesCount?: Maybe<Scalars['Int']>;
  hasThumb?: Maybe<Scalars['Boolean']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isEditable?: Maybe<Scalars['Boolean']>;
  isNew?: Maybe<Scalars['Boolean']>;
  isSeen?: Maybe<Scalars['Boolean']>;
  isSeenMarkedBy?: Maybe<User>;
  isSeenMarkedById?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  thumbUrl?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  virtualUser?: Maybe<User>;
  virtualUserId?: Maybe<Scalars['UUID']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};


export type DocumentationFileGroupFilesArgs = {
  onlyPatientFiles?: InputMaybe<Scalars['Boolean']>;
};

export type DocumentationFilesResult = {
  __typename?: 'DocumentationFilesResult';
  data: Array<DocumentationFile>;
  meta?: Maybe<PageInfo>;
};

export type DocumentationFolder = {
  __typename?: 'DocumentationFolder';
  accessType?: Maybe<Scalars['String']>;
  canCreateFile?: Maybe<Scalars['Boolean']>;
  canSearchFile?: Maybe<Scalars['Boolean']>;
  canSwitchView?: Maybe<Scalars['Boolean']>;
  filesCount?: Maybe<Scalars['Int']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isEditable?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  parentDocumentationFolder?: Maybe<DocumentationFolder>;
  parentDocumentationFolderId?: Maybe<Scalars['UUID']>;
  permissionUsers?: Maybe<Array<Maybe<DocumentationFolderUser>>>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type DocumentationFolderUser = {
  __typename?: 'DocumentationFolderUser';
  folder?: Maybe<DocumentationFolder>;
  folderId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type DocumentationFolderWhereInput = {
  id?: InputMaybe<Scalars['UUID']>;
};

export type DocumentationFoldersResult = {
  __typename?: 'DocumentationFoldersResult';
  data: Array<DocumentationFolder>;
  meta?: Maybe<PageInfo>;
};

export type DocumentsResult = {
  __typename?: 'DocumentsResult';
  data?: Maybe<Array<Document>>;
  meta?: Maybe<PageInfo>;
};

export type DocumentsTransferInput = {
  documentIds: Array<Scalars['UUID']>;
  documentName?: InputMaybe<Scalars['String']>;
  grouped?: InputMaybe<Scalars['Boolean']>;
  targetFolder: Scalars['UUID'];
  targetUserId?: InputMaybe<Scalars['UUID']>;
};

export type DoneEventInput = {
  eventId?: InputMaybe<Scalars['UUID']>;
};

export type DoveraCheckItem = {
  __typename?: 'DoveraCheckItem';
  birthNumber: Scalars['String'];
};

export type DrMaxOpeningHour = {
  __typename?: 'DrMaxOpeningHour';
  from?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  open?: Maybe<Scalars['Boolean']>;
  to?: Maybe<Scalars['DateTime']>;
};

export type DrMaxOpeningHourItem = {
  __typename?: 'DrMaxOpeningHourItem';
  date?: Maybe<Scalars['DateTime']>;
  hours?: Maybe<Array<Maybe<DrMaxOpeningHour>>>;
  nonstop?: Maybe<Scalars['Boolean']>;
  open?: Maybe<Scalars['Boolean']>;
};

export type DrMaxPickupPlace = {
  __typename?: 'DrMaxPickupPlace';
  distance?: Maybe<Scalars['Float']>;
  distanceFormatted?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  isOpen?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  openingHours?: Maybe<Array<Maybe<DrMaxOpeningHourItem>>>;
  productsInStock?: Maybe<Array<Maybe<DrMaxProductsInStock>>>;
};

export type DrMaxPickupPlacesResult = {
  __typename?: 'DrMaxPickupPlacesResult';
  data?: Maybe<Array<Maybe<DrMaxPickupPlace>>>;
  meta?: Maybe<PageInfo>;
};

export type DrMaxPrescriptionMedicament = {
  __typename?: 'DrMaxPrescriptionMedicament';
  formattedApproximatePrice?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  inStock?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};


export type DrMaxPrescriptionMedicamentFormattedApproximatePriceArgs = {
  drmaxPickupPlaceId?: InputMaybe<Scalars['UUID']>;
};


export type DrMaxPrescriptionMedicamentInStockArgs = {
  drmaxPickupPlaceId?: InputMaybe<Scalars['UUID']>;
};

export type DrMaxPrescriptionMedicamentsResult = {
  __typename?: 'DrMaxPrescriptionMedicamentsResult';
  data?: Maybe<Array<Maybe<DrMaxPrescriptionMedicament>>>;
  meta?: Maybe<PageInfo>;
};

export type DrMaxPrescriptionReservation = {
  __typename?: 'DrMaxPrescriptionReservation';
  incrementId?: Maybe<Scalars['String']>;
};

export type DrMaxProductsInStock = {
  __typename?: 'DrMaxProductsInStock';
  inStock?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type EducationMaterial = {
  __typename?: 'EducationMaterial';
  category?: Maybe<Scalars['String']>;
  educationMaterialFolder?: Maybe<EducationMaterialFolder>;
  educationMaterialFolderId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  key?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  module?: Maybe<EducationMaterialModule>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  seen?: Maybe<Scalars['Boolean']>;
  seenAt?: Maybe<Scalars['DateTime']>;
  send?: Maybe<Scalars['Boolean']>;
  sendAt?: Maybe<Scalars['DateTime']>;
  subtype?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};


export type EducationMaterialSeenArgs = {
  userId?: InputMaybe<Scalars['UUID']>;
};


export type EducationMaterialSeenAtArgs = {
  userId?: InputMaybe<Scalars['UUID']>;
};


export type EducationMaterialSendArgs = {
  userId?: InputMaybe<Scalars['UUID']>;
};


export type EducationMaterialSendAtArgs = {
  userId?: InputMaybe<Scalars['UUID']>;
};

export type EducationMaterialFolder = {
  __typename?: 'EducationMaterialFolder';
  educationMaterials?: Maybe<Array<Maybe<EducationMaterial>>>;
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
};


export type EducationMaterialFolderEducationMaterialsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
};

export type EducationMaterialFoldersResult = {
  __typename?: 'EducationMaterialFoldersResult';
  data?: Maybe<Array<Maybe<EducationMaterialFolder>>>;
  meta?: Maybe<PageInfo>;
};

export enum EducationMaterialModule {
  Baby = 'BABY',
  Diabetes = 'DIABETES',
  Therapist = 'THERAPIST'
}

export type EducationMaterialsResult = {
  __typename?: 'EducationMaterialsResult';
  data?: Maybe<Array<Maybe<EducationMaterial>>>;
  meta?: Maybe<PageInfo>;
};

export type EndHealthPlanUserInput = {
  healthPlanUserId: Scalars['UUID'];
  questionnaireResultId?: InputMaybe<Scalars['UUID']>;
};

export type Event = {
  __typename?: 'Event';
  address?: Maybe<Address>;
  addressDescription?: Maybe<Scalars['String']>;
  calendar?: Maybe<Calendar>;
  calendarId?: Maybe<Scalars['ID']>;
  case?: Maybe<Case>;
  caseId?: Maybe<Scalars['UUID']>;
  createdBy?: Maybe<User>;
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  eventMembers?: Maybe<Array<Maybe<EventMember>>>;
  hidden?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isDoctor?: Maybe<Scalars['Boolean']>;
  layout?: Maybe<Scalars['JSONObject']>;
  meta?: Maybe<Array<Maybe<Meta>>>;
  note?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  tagsTermItems?: Maybe<Array<Maybe<TermItem>>>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};


export type EventMetaArgs = {
  key?: InputMaybe<Scalars['String']>;
};

export type EventMember = {
  __typename?: 'EventMember';
  event?: Maybe<Event>;
  eventId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  role?: Maybe<Scalars['Int']>;
  state?: Maybe<EventMemberState>;
  status?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export enum EventMemberState {
  Confirmed = 'CONFIRMED',
  NotSent = 'NOT_SENT',
  Rejected = 'REJECTED',
  Sent = 'SENT'
}

export enum EventType {
  Absence = 'ABSENCE',
  Block = 'BLOCK',
  Default = 'DEFAULT',
  Reservation = 'RESERVATION'
}

export type EventsResult = {
  __typename?: 'EventsResult';
  data?: Maybe<Array<Maybe<Event>>>;
  meta?: Maybe<PageInfo>;
};

export type ExportLog = {
  __typename?: 'ExportLog';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  extra?: Maybe<Scalars['JSON']>;
  fileId?: Maybe<Scalars['UUID']>;
  format?: Maybe<ExportLogFormat>;
  id?: Maybe<Scalars['UUID']>;
  status?: Maybe<ExportLogStatus>;
  type?: Maybe<ExportLogType>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export enum ExportLogFormat {
  Isdoc = 'ISDOC',
  Pdf = 'PDF',
  Pohoda = 'POHODA'
}

export enum ExportLogStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export enum ExportLogType {
  Documentation = 'DOCUMENTATION',
  Invoicing = 'INVOICING'
}

export type ExportLogsResult = {
  __typename?: 'ExportLogsResult';
  data: Array<Maybe<ExportLog>>;
  meta: PageInfo;
};

export type ExportLogsWhereInput = {
  createdById?: InputMaybe<Scalars['UUID']>;
  format?: InputMaybe<ExportLogFormat>;
  status?: InputMaybe<ExportLogStatus>;
  type?: InputMaybe<ExportLogType>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type FamilyMember = {
  __typename?: 'FamilyMember';
  canBeDeleted: Scalars['Boolean'];
  canBeShared: Scalars['Boolean'];
  id: Scalars['Int'];
  isAdmin: Scalars['Boolean'];
  role: FamilyMemberRole;
  user: User;
  userId: Scalars['UUID'];
};

export type FamilyMemberRelationInput = {
  relatedUserId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export enum FamilyMemberRole {
  Adult = 'ADULT',
  Child = 'CHILD',
  Invitation = 'INVITATION',
  Me = 'ME',
  Partner = 'PARTNER'
}

export type FamilyMemberWhereInput = {
  id?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type FamilyMembersResult = {
  __typename?: 'FamilyMembersResult';
  data?: Maybe<Array<Maybe<FamilyMember>>>;
  meta?: Maybe<PageInfo>;
};

export type File = {
  __typename?: 'File';
  avResult?: Maybe<Scalars['Int']>;
  avResultText?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  extension?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['String']>;
};

export type GenerateSubscriptionRedeemCodeAlphabetInput = {
  charactersCount?: InputMaybe<Scalars['Int']>;
  code: Scalars['String'];
  count: Scalars['Int'];
  subscriptionCode?: InputMaybe<Scalars['String']>;
  subscriptionId: Scalars['UUID'];
  subscriptionPeriodId?: InputMaybe<Scalars['UUID']>;
};

export type GenerateSubscriptionRedeemCodeAlphabetResult = {
  __typename?: 'GenerateSubscriptionRedeemCodeAlphabetResult';
  unsuccessfulCount?: Maybe<Scalars['Int']>;
};

export type GenerateSubscriptionRedeemCodeInput = {
  code: Scalars['String'];
  count: Scalars['Int'];
  numbersCount?: InputMaybe<Scalars['Int']>;
  subscriptionCode?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['UUID']>;
  subscriptionPeriodId?: InputMaybe<Scalars['UUID']>;
};

export type Group = {
  __typename?: 'Group';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByLog?: Maybe<AuditLog>;
  description?: Maybe<Scalars['String']>;
  groupMembers?: Maybe<GroupMembersResult>;
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  totalMembers?: Maybe<Scalars['Int']>;
  updatedByLog?: Maybe<AuditLog>;
  workplaceId?: Maybe<Scalars['UUID']>;
};


export type GroupGroupMembersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type GroupMember = {
  __typename?: 'GroupMember';
  group?: Maybe<Group>;
  groupId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type GroupMembersResult = {
  __typename?: 'GroupMembersResult';
  data?: Maybe<Array<Maybe<GroupMember>>>;
  meta?: Maybe<PageInfo>;
};

export type GroupsResult = {
  __typename?: 'GroupsResult';
  data?: Maybe<Array<Maybe<Group>>>;
  meta?: Maybe<PageInfo>;
};

export type HealthCard = {
  __typename?: 'HealthCard';
  allergies?: Maybe<Scalars['String']>;
  allergiesOther?: Maybe<Scalars['String']>;
  anamnesisFamily?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  job?: Maybe<Scalars['String']>;
  operations?: Maybe<Scalars['String']>;
  sickness?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  weight?: Maybe<Scalars['Int']>;
};

export type HealthDataDashboardCategory = {
  __typename?: 'HealthDataDashboardCategory';
  extra?: Maybe<Scalars['JSONObject']>;
  iconUrl?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  title: Scalars['String'];
  trend?: Maybe<HealthDataDashboardCategoryTrend>;
  type?: Maybe<HealthDataDashboardCategoryType>;
  value: Scalars['String'];
};

export enum HealthDataDashboardCategoryTrend {
  Down = 'DOWN',
  None = 'NONE',
  Up = 'UP'
}

export enum HealthDataDashboardCategoryType {
  BioScan = 'BIO_SCAN',
  Category = 'CATEGORY'
}

export type HealthDataItem = {
  __typename?: 'HealthDataItem';
  key?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  meta?: Maybe<Array<Maybe<HealthDataItemMeta>>>;
  time?: Maybe<Scalars['DateTime']>;
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

export type HealthDataItemMeta = {
  __typename?: 'HealthDataItemMeta';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type HealthDataResult = {
  __typename?: 'HealthDataResult';
  data?: Maybe<Array<Maybe<HealthDataItem>>>;
  meta?: Maybe<PageInfo>;
};

export type HealthPlan = {
  __typename?: 'HealthPlan';
  active?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  doctorInitialQuestionnaireCode?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  initialQuestionnaireCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  public?: Maybe<Scalars['Boolean']>;
  settings?: Maybe<Scalars['JSONObject']>;
  structure?: Maybe<HealthPlanStructure>;
  totalMonths?: Maybe<Scalars['Int']>;
};

export type HealthPlanBabyPregnancy = {
  __typename?: 'HealthPlanBabyPregnancy';
  dateOfDelivery?: Maybe<Scalars['Date']>;
  gestationalAgeFUM?: Maybe<Scalars['String']>;
};

export enum HealthPlanCodeEnum {
  Diabetes = 'DIABETES',
  Kdar = 'KDAR',
  Meddibaby = 'MEDDIBABY',
  Obesity = 'OBESITY',
  ObesityTherapist = 'OBESITY_THERAPIST',
  Oncology = 'ONCOLOGY',
  Palliative = 'PALLIATIVE',
  Therapist = 'THERAPIST'
}

export type HealthPlanPeriod = {
  __typename?: 'HealthPlanPeriod';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  price?: Maybe<Price>;
  sale?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type HealthPlanStructure = {
  __typename?: 'HealthPlanStructure';
  name: Scalars['String'];
  settings?: Maybe<Scalars['JSONObject']>;
  steps?: Maybe<Array<Maybe<HealthPlanStructureStep>>>;
};

export type HealthPlanStructureStep = {
  __typename?: 'HealthPlanStructureStep';
  key: Scalars['String'];
  name: Scalars['String'];
  settings?: Maybe<Scalars['JSONObject']>;
  type?: Maybe<HealthPlanStructureStepTypeEnum>;
};

export enum HealthPlanStructureStepTypeEnum {
  EducationMaterials = 'EDUCATION_MATERIALS',
  Form = 'FORM',
  Questionnaires = 'QUESTIONNAIRES',
  Requirements = 'REQUIREMENTS'
}

export type HealthPlanUser = {
  __typename?: 'HealthPlanUser';
  activatedAt?: Maybe<Scalars['DateTime']>;
  activeFrom?: Maybe<Scalars['DateTime']>;
  activeMonth?: Maybe<Scalars['Int']>;
  activeTo?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<User>;
  doctorId?: Maybe<Scalars['UUID']>;
  endAt?: Maybe<Scalars['DateTime']>;
  hasEnded?: Maybe<Scalars['Boolean']>;
  healthPlan?: Maybe<HealthPlan>;
  healthPlanId?: Maybe<Scalars['UUID']>;
  healthPlanUserBaby?: Maybe<HealthPlanUserBaby>;
  id: Scalars['UUID'];
  initialQuestionnaireResult?: Maybe<QuestionnaireResult>;
  initialQuestionnaireResultId?: Maybe<Scalars['UUID']>;
  isActive?: Maybe<Scalars['Boolean']>;
  offerContent?: Maybe<Scalars['String']>;
  periods?: Maybe<Array<Maybe<HealthPlanPeriod>>>;
  plannedActiveFrom?: Maybe<Scalars['DateTime']>;
  price?: Maybe<Price>;
  priceSale?: Maybe<Price>;
  pricing?: Maybe<HealthPlanUserPricing>;
  ready?: Maybe<Scalars['Boolean']>;
  settings?: Maybe<HealthPlanUserSettings>;
  status?: Maybe<HealthPlanUserItem>;
  statusText?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};


export type HealthPlanUserPriceSaleArgs = {
  period: HealthPlanUserPricePeriod;
};

export type HealthPlanUserBaby = {
  __typename?: 'HealthPlanUserBaby';
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  gestionalAge?: Maybe<Scalars['String']>;
};

export type HealthPlanUserItem = {
  __typename?: 'HealthPlanUserItem';
  extra?: Maybe<Scalars['JSON']>;
  healthPlanUser?: Maybe<HealthPlanUser>;
  healthPlanUserId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['UUID']>;
  subtype?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type HealthPlanUserItemResult = {
  __typename?: 'HealthPlanUserItemResult';
  data?: Maybe<Array<Maybe<HealthPlanUserItem>>>;
  meta?: Maybe<PageInfo>;
};

export type HealthPlanUserItemWhereInput = {
  healthPlanUserId: Scalars['UUID'];
  subtype?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type HealthPlanUserPaymentInput = {
  activateHealthPlan?: InputMaybe<Scalars['Boolean']>;
  amount: Scalars['Decimal'];
  currency: Scalars['String'];
  healthPlanUserId: Scalars['UUID'];
  paymentMethod: HealthPlanUserPricingPaymentMethod;
  paymentPeriod: HealthPlanUserPricePeriod;
};

export enum HealthPlanUserPricePeriod {
  HalfYear = 'HALF_YEAR',
  Month = 'MONTH',
  Year = 'YEAR'
}

export type HealthPlanUserPricing = {
  __typename?: 'HealthPlanUserPricing';
  creditPerDay?: Maybe<Scalars['Float']>;
  nextPayment?: Maybe<Price>;
  nextPaymentAt?: Maybe<Scalars['DateTime']>;
  payNow?: Maybe<Price>;
  paymentMethod?: Maybe<HealthPlanUserPricingPaymentMethod>;
  remainsToPay?: Maybe<Price>;
  totalPrice?: Maybe<Price>;
};

export enum HealthPlanUserPricingPaymentMethod {
  Card = 'CARD',
  Cash = 'CASH'
}

export type HealthPlanUserSettings = {
  __typename?: 'HealthPlanUserSettings';
  continueToPayment?: Maybe<Scalars['String']>;
  healthPlanContains?: Maybe<Scalars['String']>;
  healthPlanPreparedByDoctor?: Maybe<Scalars['String']>;
  hello?: Maybe<Scalars['String']>;
  howYouWannaPay?: Maybe<Scalars['String']>;
  priceContains?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  topBarTitle?: Maybe<Scalars['String']>;
};

export type HealthPlanUsersResult = {
  __typename?: 'HealthPlanUsersResult';
  data?: Maybe<Array<Maybe<HealthPlanUser>>>;
  meta?: Maybe<PageInfo>;
};

export type HealthPlanWorkplace = {
  __typename?: 'HealthPlanWorkplace';
  healthPlanId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['UUID']>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type HealthPlansResult = {
  __typename?: 'HealthPlansResult';
  data?: Maybe<Array<Maybe<HealthPlan>>>;
  meta?: Maybe<PageInfo>;
};

export type HiddenWorkplaceMetaInput = {
  userId: Scalars['UUID'];
  workplaceId: Scalars['UUID'];
};

export type HideSeenLaboratoryResultsInput = {
  all?: InputMaybe<Scalars['Boolean']>;
  isSeen: Scalars['Boolean'];
  laboratoryResultIds?: InputMaybe<Array<Scalars['UUID']>>;
};

export type HideSeenQuestionnaireResult = {
  __typename?: 'HideSeenQuestionnaireResult';
  success?: Maybe<Scalars['Boolean']>;
};

export type InsuranceBatch = {
  __typename?: 'InsuranceBatch';
  batchType?: Maybe<InsuranceReportType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  insuranceCompanyCode?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<InsuranceReportBatch>>>;
  periodMonth: Scalars['Int'];
  periodYear: Scalars['Int'];
  sequenceNumber: Scalars['Int'];
  totalNumber: Scalars['Int'];
  type?: Maybe<Scalars['String']>;
  workplace?: Maybe<Workplace>;
  workplaceId: Scalars['UUID'];
};

export type InsuranceBatchsResult = {
  __typename?: 'InsuranceBatchsResult';
  data: Array<InsuranceBatch>;
  meta?: Maybe<PageInfo>;
};

export type InsuranceOperation = {
  __typename?: 'InsuranceOperation';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extra?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  insurance?: Maybe<TermItem>;
  insuranceId?: Maybe<Scalars['UUID']>;
  ncziCode?: Maybe<Scalars['String']>;
  points?: Maybe<Scalars['Int']>;
  pricePerPoint?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type InsuranceOperationResult = {
  __typename?: 'InsuranceOperationResult';
  data?: Maybe<Array<Maybe<InsuranceOperation>>>;
  meta?: Maybe<PageInfo>;
};

export type InsuranceOperationsWhereInput = {
  insuranceId?: InputMaybe<Scalars['UUID']>;
  ncziCode?: InputMaybe<Scalars['String']>;
  workplaceId: Scalars['UUID'];
};

export type InsuranceReport = {
  __typename?: 'InsuranceReport';
  birthNumber?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  diagnosis?: Maybe<Scalars['String']>;
  doctor?: Maybe<User>;
  doctorId?: Maybe<Scalars['UUID']>;
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['UUID']>;
  extra?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  insurance?: Maybe<TermItem>;
  insuranceId?: Maybe<Scalars['UUID']>;
  operation?: Maybe<InsuranceOperation>;
  operationId?: Maybe<Scalars['UUID']>;
  patient?: Maybe<User>;
  patientId: Scalars['UUID'];
  points?: Maybe<Scalars['Int']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type InsuranceReportBatch = {
  __typename?: 'InsuranceReportBatch';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  insuranceBatch?: Maybe<InsuranceBatch>;
  insuranceBatchId: Scalars['UUID'];
  insuranceReport?: Maybe<InsuranceReport>;
  insuranceReportId: Scalars['UUID'];
  note?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export enum InsuranceReportType {
  Additional = 'ADDITIONAL',
  Correction = 'CORRECTION',
  New = 'NEW'
}

export type InsuranceReportsResult = {
  __typename?: 'InsuranceReportsResult';
  data?: Maybe<Array<Maybe<InsuranceReport>>>;
  meta?: Maybe<PageInfo>;
};

export type InsuranceReportsWhereInput = {
  doctorId?: InputMaybe<Scalars['UUID']>;
  documentId?: InputMaybe<Scalars['UUID']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  rootWorkplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  id?: Maybe<Scalars['UUID']>;
  number?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Iot = {
  __typename?: 'Iot';
  extra?: Maybe<Scalars['JSONObject']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  iotUser?: Maybe<IotUser>;
  name?: Maybe<Scalars['String']>;
  topped?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};


export type IotIotUserArgs = {
  userId?: InputMaybe<Scalars['UUID']>;
};

export type IotUser = {
  __typename?: 'IotUser';
  active?: Maybe<Scalars['Boolean']>;
  extra?: Maybe<Scalars['JSONObject']>;
  id: Scalars['UUID'];
  ingestionUrl?: Maybe<Scalars['String']>;
  iot?: Maybe<Iot>;
  iotId?: Maybe<Scalars['UUID']>;
  synchronizationNeeded?: Maybe<Scalars['Boolean']>;
  synchronizedAt?: Maybe<Scalars['DateTime']>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type IotsResult = {
  __typename?: 'IotsResult';
  data?: Maybe<Array<Maybe<Iot>>>;
  meta?: Maybe<PageInfo>;
};

export type LaboratoriesWhereInput = {
  fulltext?: InputMaybe<Scalars['String']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type Laboratory = {
  __typename?: 'Laboratory';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['UUID']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  icl?: Maybe<Scalars['String']>;
  ico?: Maybe<Scalars['String']>;
  icp?: Maybe<Scalars['String']>;
  icz?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
};

export type LaboratoryDataInput = {
  value: Scalars['String'];
  wizardItemId: Scalars['UUID'];
};

export type LaboratoryDocumentInput = {
  date?: InputMaybe<Scalars['Date']>;
  primarySampleType: Scalars['String'];
  sampleTakenBy?: InputMaybe<Scalars['String']>;
  selfPaid: Scalars['Boolean'];
  statim: Scalars['Boolean'];
  statimPhoneNumber?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['Time']>;
};

export type LaboratoryDocumentType = {
  __typename?: 'LaboratoryDocumentType';
  primarySampleType?: Maybe<Scalars['String']>;
  selfPaid?: Maybe<Scalars['Boolean']>;
  statim?: Maybe<Scalars['Boolean']>;
};

export type LaboratoryPatientInput = {
  address?: InputMaybe<AddressInput>;
  birthDate: Scalars['Date'];
  diagnosisTermItemValue: Scalars['String'];
  firstName: Scalars['String'];
  genderTermItemId: Scalars['UUID'];
  insuranceCompanyTermItemId?: InputMaybe<Scalars['UUID']>;
  insuranceNumber: Scalars['String'];
  lastName: Scalars['String'];
};

export type LaboratoryRequisition = {
  __typename?: 'LaboratoryRequisition';
  allowed?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  laboratory: Laboratory;
  laboratoryId: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type LaboratoryRequisitionForm = {
  __typename?: 'LaboratoryRequisitionForm';
  children?: Maybe<Scalars['JSON']>;
  samples?: Maybe<Array<Maybe<LaboratoryRequisitionSample>>>;
  settings?: Maybe<Scalars['JSON']>;
};

export type LaboratoryRequisitionFormResult = {
  __typename?: 'LaboratoryRequisitionFormResult';
  form?: Maybe<LaboratoryRequisitionForm>;
  requisition?: Maybe<LaboratoryRequisition>;
};

export type LaboratoryRequisitionFormWhereInput = {
  id: Scalars['UUID'];
};

export type LaboratoryRequisitionPatient = {
  __typename?: 'LaboratoryRequisitionPatient';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['UUID']>;
  age?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  birthNumber?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactPhoneNumber?: Maybe<Scalars['String']>;
  diagnosis?: Maybe<TermItem>;
  diagnosisTermItemId?: Maybe<Scalars['UUID']>;
  fatherLastName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formattedBirthNumber?: Maybe<Scalars['String']>;
  formattedGender?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  genderTermItem?: Maybe<TermItem>;
  genderTermItemId?: Maybe<Scalars['UUID']>;
  hasInsurance?: Maybe<Scalars['Boolean']>;
  insuranceCompanyTermItem?: Maybe<TermItem>;
  insuranceCompanyTermItemId?: Maybe<Scalars['UUID']>;
  insuranceNumber?: Maybe<Scalars['String']>;
  languageFormatted?: Maybe<Scalars['String']>;
  languageIso?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  motherLastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nationalityOther?: Maybe<Scalars['String']>;
  nationalityTermItem?: Maybe<TermItem>;
  nationalityTermItemId?: Maybe<Scalars['UUID']>;
  salutation?: Maybe<Scalars['String']>;
  salutationAfter?: Maybe<Scalars['String']>;
  salutationBefore?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

export type LaboratoryRequisitionResult = {
  __typename?: 'LaboratoryRequisitionResult';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  document?: Maybe<LaboratoryDocumentType>;
  id: Scalars['UUID'];
  laboratoryExaminationRequest?: Maybe<DocumentationFile>;
  laboratoryExaminationRequestId?: Maybe<Scalars['UUID']>;
  laboratoryExaminationRequestPatient?: Maybe<DocumentationFile>;
  laboratoryExaminationRequestPatientId?: Maybe<Scalars['UUID']>;
  patient: LaboratoryRequisitionPatient;
  requisition?: Maybe<LaboratoryRequisition>;
  result?: Maybe<Array<Maybe<LaboratoryResultType>>>;
  user: User;
  workplace: Workplace;
};

export type LaboratoryRequisitionResultWhereInput = {
  id: Scalars['UUID'];
};

export type LaboratoryRequisitionResultsResult = {
  __typename?: 'LaboratoryRequisitionResultsResult';
  data?: Maybe<Array<Maybe<LaboratoryRequisitionResult>>>;
  meta?: Maybe<PageInfo>;
};

export type LaboratoryRequisitionResultsWhereInput = {
  requisitionId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type LaboratoryRequisitionSample = {
  __typename?: 'LaboratoryRequisitionSample';
  key: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type LaboratoryRequisitionWorkplace = {
  __typename?: 'LaboratoryRequisitionWorkplace';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  createdById: Scalars['UUID'];
  id: Scalars['UUID'];
  laboratoryRequisition?: Maybe<LaboratoryRequisition>;
  laboratoryRequisitionId: Scalars['UUID'];
  workplace?: Maybe<Workplace>;
  workplaceId: Scalars['UUID'];
};

export type LaboratoryRequisitionsResult = {
  __typename?: 'LaboratoryRequisitionsResult';
  data: Array<LaboratoryRequisition>;
  meta?: Maybe<PageInfo>;
};

export type LaboratoryRequisitionsWhereInput = {
  laboratoryId: Scalars['UUID'];
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type LaboratoryResult = {
  __typename?: 'LaboratoryResult';
  data?: Maybe<Array<Maybe<Laboratory>>>;
  meta?: Maybe<PageInfo>;
};

export type LaboratoryResultItem = {
  __typename?: 'LaboratoryResultItem';
  acceptedAt?: Maybe<Scalars['DateTime']>;
  acceptedBy?: Maybe<Scalars['String']>;
  chart?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  evaluation?: Maybe<LaboratoryResultItemEvaluation>;
  id: Scalars['UUID'];
  laboratoryResult?: Maybe<LaboratoryResultResult>;
  lowerReferenceValue?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  processedAt?: Maybe<Scalars['DateTime']>;
  processedBy?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
  upperReferenceValue?: Maybe<Scalars['Float']>;
};

export type LaboratoryResultItemEvaluation = {
  __typename?: 'LaboratoryResultItemEvaluation';
  color?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type LaboratoryResultResult = {
  __typename?: 'LaboratoryResultResult';
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  isSeen?: Maybe<Scalars['Boolean']>;
  isSeenMarkedBy?: Maybe<User>;
  isSeenMarkedById?: Maybe<Scalars['UUID']>;
  laboratory?: Maybe<Laboratory>;
  laboratoryId?: Maybe<Scalars['UUID']>;
  laboratoryResultItems: Array<LaboratoryResultItem>;
  user: User;
  userId: Scalars['UUID'];
  workplace: Workplace;
  workplaceId: Scalars['UUID'];
};

export type LaboratoryResultType = {
  __typename?: 'LaboratoryResultType';
  value: Scalars['String'];
  wizardItemId: Scalars['UUID'];
};

export type LaboratoryResultWhereInput = {
  id: Scalars['UUID'];
};

export type LaboratoryResultsResult = {
  __typename?: 'LaboratoryResultsResult';
  data: Array<LaboratoryResultResult>;
  meta?: Maybe<PageInfo>;
};

export type LaboratoryResultsWhereInput = {
  laboratoryId?: InputMaybe<Scalars['UUID']>;
  seen?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type LaboratoryWizard = {
  __typename?: 'LaboratoryWizard';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['UUID']>;
  laboratory?: Maybe<Laboratory>;
  laboratoryId?: Maybe<Scalars['UUID']>;
  type?: Maybe<LaboratoryWizardType>;
  wizard?: Maybe<Wizard>;
  wizardId?: Maybe<Scalars['UUID']>;
};

export enum LaboratoryWizardType {
  Document = 'DOCUMENT',
  MedicalRequest = 'MEDICAL_REQUEST'
}

export type LaboratoryWizardsResult = {
  __typename?: 'LaboratoryWizardsResult';
  data?: Maybe<Array<Maybe<LaboratoryWizard>>>;
  meta?: Maybe<PageInfo>;
};

export type LaboratoryWizardsWhereInput = {
  laboratoryId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<LaboratoryWizardType>;
};

export type LaboratoryWorkplace = {
  __typename?: 'LaboratoryWorkplace';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  createdById: Scalars['UUID'];
  id: Scalars['UUID'];
  laboratory?: Maybe<Laboratory>;
  laboratoryId: Scalars['UUID'];
  workplace?: Maybe<Workplace>;
  workplaceId: Scalars['UUID'];
};

export type LaboratoryWorkplacesResult = {
  __typename?: 'LaboratoryWorkplacesResult';
  data: Array<LaboratoryWorkplace>;
  meta?: Maybe<PageInfo>;
};

export type LaboratoryWorkplacesWhereInput = {
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type MarkAsSeenUserNotificationsResult = {
  __typename?: 'MarkAsSeenUserNotificationsResult';
  success?: Maybe<Scalars['Boolean']>;
};

export type MeddiAccount = {
  __typename?: 'MeddiAccount';
  balance?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['UUID']>;
  members?: Maybe<Array<Maybe<MeddiAccountMember>>>;
  type?: Maybe<MeddiAccountType>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type MeddiAccountMember = {
  __typename?: 'MeddiAccountMember';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['UUID']>;
  role?: Maybe<MeddiAccountMemberRole>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export enum MeddiAccountMemberRole {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export type MeddiAccountResult = {
  __typename?: 'MeddiAccountResult';
  data?: Maybe<Array<Maybe<MeddiAccount>>>;
  meta?: Maybe<PageInfo>;
};

export type MeddiAccountTransactionResult = {
  __typename?: 'MeddiAccountTransactionResult';
  data?: Maybe<Array<Maybe<MeddiTransaction>>>;
  meta?: Maybe<PageInfo>;
};

export type MeddiAccountTransactionsWhereInput = {
  meddiAccountId?: InputMaybe<Scalars['UUID']>;
  meddiAccountType?: InputMaybe<MeddiAccountType>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export enum MeddiAccountType {
  Company = 'COMPANY',
  Default = 'DEFAULT'
}

export type MeddiAccountsWhereInput = {
  type?: InputMaybe<MeddiAccountType>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type MeddiSettings = {
  __typename?: 'MeddiSettings';
  id: Scalars['UUID'];
  key?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

export type MeddiTransaction = {
  __typename?: 'MeddiTransaction';
  amount?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extra?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['UUID']>;
  meddiAccount?: Maybe<MeddiAccount>;
  meddiAccountId?: Maybe<Scalars['UUID']>;
  order?: Maybe<TransactionOrder>;
  orderId?: Maybe<Scalars['UUID']>;
  type?: Maybe<Scalars['String']>;
};

export type MedicalReport = {
  __typename?: 'MedicalReport';
  case?: Maybe<Case>;
  caseId?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  diagnosis?: Maybe<Scalars['String']>;
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['UUID']>;
  fileId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  printed?: Maybe<Scalars['Boolean']>;
  treatment?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  workplaceId?: Maybe<Scalars['String']>;
};

export type MedicalRequestForm = {
  __typename?: 'MedicalRequestForm';
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  wizardKey?: Maybe<Scalars['String']>;
};

export type MedicalRequestFormsResult = {
  __typename?: 'MedicalRequestFormsResult';
  data?: Maybe<Array<Maybe<MedicalRequestForm>>>;
  meta?: Maybe<PageInfo>;
};

export type Medium = {
  __typename?: 'Medium';
  artwork?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  metadata?: Maybe<MetadataType>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['JSONObject']>;
  url?: Maybe<Scalars['String']>;
};

export type Message = {
  __typename?: 'Message';
  content?: Maybe<Scalars['JSONObject']>;
  conversation?: Maybe<Conversation>;
  conversationId?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  messageAttachments?: Maybe<Array<Maybe<MessageAttachment>>>;
  messageMembers?: Maybe<Array<Maybe<MessageMember>>>;
  myMessageMember?: Maybe<MessageMember>;
  sender?: Maybe<MessageMember>;
  singleRecipient?: Maybe<MessageMember>;
  totalRecipients?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};


export type MessageMessageAttachmentsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type MessageMessageMembersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type MessageAttachment = {
  __typename?: 'MessageAttachment';
  documentationFile?: Maybe<DocumentationFile>;
  documentationFileId?: Maybe<Scalars['UUID']>;
  educationMaterial?: Maybe<EducationMaterial>;
  educationMaterialId?: Maybe<Scalars['UUID']>;
  event?: Maybe<Event>;
  eventId?: Maybe<Scalars['UUID']>;
  extra?: Maybe<Scalars['JSON']>;
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  message?: Maybe<Message>;
  messageId?: Maybe<Scalars['UUID']>;
  questionnaire?: Maybe<Questionnaire>;
  questionnaireId?: Maybe<Scalars['UUID']>;
  type?: Maybe<MessageAttachmentType>;
};

export enum MessageAttachmentType {
  DocumentationFile = 'DOCUMENTATION_FILE',
  EducationMaterial = 'EDUCATION_MATERIAL',
  Event = 'EVENT',
  File = 'FILE',
  Form = 'FORM',
  Questionnaire = 'QUESTIONNAIRE'
}

export type MessageAttachmentsResult = {
  __typename?: 'MessageAttachmentsResult';
  data?: Maybe<Array<Maybe<MessageAttachment>>>;
  meta?: Maybe<PageInfo>;
};

export type MessageMember = {
  __typename?: 'MessageMember';
  id: Scalars['UUID'];
  message?: Maybe<Message>;
  messageId?: Maybe<Scalars['UUID']>;
  seen?: Maybe<Scalars['Boolean']>;
  sender?: Maybe<Scalars['Boolean']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type MessageMembersResult = {
  __typename?: 'MessageMembersResult';
  data?: Maybe<Array<Maybe<MessageMember>>>;
  meta?: Maybe<PageInfo>;
};

export type MessagesResult = {
  __typename?: 'MessagesResult';
  data?: Maybe<Array<Maybe<Message>>>;
  meta?: Maybe<PageInfo>;
};

export type Meta = {
  __typename?: 'Meta';
  formattedValue?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type MetaTranslation = {
  __typename?: 'MetaTranslation';
  id?: Maybe<Scalars['UUID']>;
  key?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

export type MetadataType = {
  __typename?: 'MetadataType';
  album?: Maybe<Scalars['String']>;
  artist?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  genre?: Maybe<Scalars['String']>;
};

export type MetasResult = {
  __typename?: 'MetasResult';
  data?: Maybe<Array<Maybe<WorkplaceCaseType>>>;
  meta?: Maybe<PageInfo>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateUserSubscriptionByRedeemCode?: Maybe<UserSubscription>;
  addLaboratoryRequisitionToPatient?: Maybe<DocumentationFile>;
  assignCase?: Maybe<Case>;
  assignCaseToMe?: Maybe<Case>;
  bulkUserHealthCategoryPermission?: Maybe<Array<Maybe<UserHealthCategoryPermission>>>;
  cancelDrMaxReservation?: Maybe<CancelDrMaxReservationResult>;
  createDrMaxPrescriptionReservation?: Maybe<DrMaxPrescriptionReservation>;
  createEvent?: Maybe<Event>;
  createGroup?: Maybe<Group>;
  createHealthPlan?: Maybe<HealthPlan>;
  createHealthPlanUser?: Maybe<HealthPlanUser>;
  createHealthPlanUserFromData?: Maybe<HealthPlanUser>;
  createHealthPlanUserPayment?: Maybe<HealthPlanUser>;
  createHealthPlanWorkplace?: Maybe<HealthPlanWorkplace>;
  createInsuranceOperation?: Maybe<InsuranceOperation>;
  createInsuranceReport?: Maybe<InsuranceReport>;
  createInsuranceReportExportFiles?: Maybe<Scalars['UUID']>;
  createLaboratory?: Maybe<Laboratory>;
  createLaboratoryRequisitionWorkplace?: Maybe<LaboratoryRequisitionWorkplace>;
  createLaboratoryWizard?: Maybe<LaboratoryWizard>;
  createLaboratoryWorkplace?: Maybe<LaboratoryWorkplace>;
  createNote?: Maybe<Note>;
  createOrUpdateQuestionnaireResultMember?: Maybe<QuestionnaireResultMember>;
  createP1Prescription?: Maybe<Prescription>;
  createPhrase?: Maybe<Phrase>;
  createPlaylist?: Maybe<Playlist>;
  createPlaylistMedium?: Maybe<PlaylistMedium>;
  createRating?: Maybe<Rating>;
  createSubscription?: Maybe<Subscription>;
  createSubscriptionGroup?: Maybe<SubscriptionGroup>;
  createSubscriptionRedeemCode?: Maybe<SubscriptionRedeemCode>;
  createToken?: Maybe<Token>;
  createUserMedicationLasted?: Maybe<Array<Maybe<UserMedicationLasted>>>;
  createUserMetaTranslation?: Maybe<User>;
  createUserSubscriptionMember?: Maybe<UserSubscriptionMember>;
  createWizardResult?: Maybe<WizardResult>;
  createWorkplaceMemberAbsence?: Maybe<EventsResult>;
  createWorkplacePreset?: Maybe<WorkplacePreset>;
  deleteDocumentationFolder?: Maybe<MutationResult>;
  deleteHealthPlanWorkplace?: Maybe<HealthPlanWorkplace>;
  deleteHiddenWorkplace?: Maybe<Meta>;
  deleteInsuranceOperation?: Maybe<MutationResult>;
  deleteInsuranceReport?: Maybe<MutationResult>;
  deleteLaboratoryRequisitionWorkplace?: Maybe<Scalars['UUID']>;
  deleteLaboratoryWorkplace?: Maybe<Scalars['UUID']>;
  deletePhrase?: Maybe<MutationResult>;
  deleteToken?: Maybe<Token>;
  deleteUserMedicationLasted?: Maybe<MutationResult>;
  deleteWizardResult?: Maybe<MutationResult>;
  deleteWorkplaceMember?: Maybe<MutationResult>;
  doneEvent?: Maybe<Event>;
  endHealthPlanUser?: Maybe<HealthPlanUser>;
  familyMemberRelation?: Maybe<FamilyMember>;
  generateSubscriptionRedeemCodes?: Maybe<Array<Maybe<SubscriptionRedeemCode>>>;
  generateSubscriptionRedeemCodesAlphabet?: Maybe<GenerateSubscriptionRedeemCodeAlphabetResult>;
  hideMembersWorkplace?: Maybe<Meta>;
  hideSeenLaboratoryResults?: Maybe<Array<Maybe<LaboratoryResultResult>>>;
  hideSeenQuestionnaireResults?: Maybe<HideSeenQuestionnaireResult>;
  markAsSeenUserNotifications?: Maybe<MarkAsSeenUserNotificationsResult>;
  orderSubscription?: Maybe<SubscriptionOrder>;
  priorityCase?: Maybe<Case>;
  purchaseProduct?: Maybe<ProductOrder>;
  reAssignCase?: Maybe<Case>;
  reactivateExpiredSubscription?: Maybe<SubscriptionOrder>;
  readDashboardMessage?: Maybe<Message>;
  refreshSettings?: Maybe<MutationResult>;
  removeUserSubscriptionMember?: Maybe<UserSubscriptionMember>;
  requestPaymentHealthPlanUser?: Maybe<HealthPlanUser>;
  saveLaboratoryRequisitionResult?: Maybe<LaboratoryRequisitionResult>;
  saveNcziDoveraResult?: Maybe<MutationResult>;
  saveUserFilter?: Maybe<Meta>;
  setUserNotificationSetting?: Maybe<UserNotificationSetting>;
  submitQuestionnaireResult?: Maybe<QuestionnaireResult>;
  submitWizard?: Maybe<SubmitWizardResult>;
  subscriptionChangePaymentMethod?: Maybe<ChangePaymentMethodUrl>;
  transferDocument?: Maybe<DocumentationFile>;
  transferDocuments?: Maybe<Array<Maybe<DocumentationFile>>>;
  tryChargeExpiredSubscription?: Maybe<ChargeStatus>;
  updateDocumentationFolder?: Maybe<DocumentationFolder>;
  updateInsuranceReport?: Maybe<InsuranceReport>;
  updateNote?: Maybe<Note>;
  updatePhrase?: Maybe<Phrase>;
  updateUserConsent?: Maybe<UserConsent>;
  updateUserMedicationLasted?: Maybe<UserMedicationLasted>;
  updateWorkplaceMembers?: Maybe<Array<Maybe<WorkplaceMember>>>;
  userSubscriptionCancel?: Maybe<MutationResult>;
  workplacePatientDocumentationFilesMarkAsSeen?: Maybe<MutationResult>;
};


export type MutationActivateUserSubscriptionByRedeemCodeArgs = {
  input?: InputMaybe<ActivateUserSubscriptionByRedeemCode>;
};


export type MutationAddLaboratoryRequisitionToPatientArgs = {
  input: AddLaboratoryRequisitionToPatientInput;
};


export type MutationAssignCaseArgs = {
  input?: InputMaybe<ReAssignCaseInput>;
};


export type MutationAssignCaseToMeArgs = {
  input?: InputMaybe<AssignCaseToMeInput>;
};


export type MutationBulkUserHealthCategoryPermissionArgs = {
  input?: InputMaybe<BulkUserHealthCategoryPermissionInput>;
};


export type MutationCancelDrMaxReservationArgs = {
  input?: InputMaybe<CancelDrMaxReservationInput>;
};


export type MutationCreateDrMaxPrescriptionReservationArgs = {
  input?: InputMaybe<CreateDrMaxPrescriptionReservationInput>;
};


export type MutationCreateEventArgs = {
  input?: InputMaybe<CreateEventInput>;
};


export type MutationCreateGroupArgs = {
  input?: InputMaybe<CreateGroupInput>;
};


export type MutationCreateHealthPlanArgs = {
  input?: InputMaybe<CreateHealthPlanInput>;
};


export type MutationCreateHealthPlanUserArgs = {
  input?: InputMaybe<CreateHealthPlanUserInput>;
};


export type MutationCreateHealthPlanUserFromDataArgs = {
  input?: InputMaybe<CreateHealthPlanUserFromDataInput>;
};


export type MutationCreateHealthPlanUserPaymentArgs = {
  input?: InputMaybe<HealthPlanUserPaymentInput>;
};


export type MutationCreateHealthPlanWorkplaceArgs = {
  input?: InputMaybe<CreateHealthPlanWorkplaceInput>;
};


export type MutationCreateInsuranceOperationArgs = {
  input?: InputMaybe<CreateOperationReportInput>;
};


export type MutationCreateInsuranceReportArgs = {
  input?: InputMaybe<CreateInsuranceReportInput>;
};


export type MutationCreateInsuranceReportExportFilesArgs = {
  input: CreateInsuranceReportExportFiles;
};


export type MutationCreateLaboratoryArgs = {
  input?: InputMaybe<CreateLaboratoryInput>;
};


export type MutationCreateLaboratoryRequisitionWorkplaceArgs = {
  input: CreateLaboratoryRequisitionWorkplaceInput;
};


export type MutationCreateLaboratoryWizardArgs = {
  input?: InputMaybe<CreateLaboratoryWizardInput>;
};


export type MutationCreateLaboratoryWorkplaceArgs = {
  input: CreateLaboratoryWorkplaceInput;
};


export type MutationCreateNoteArgs = {
  input?: InputMaybe<CreateNoteInput>;
};


export type MutationCreateOrUpdateQuestionnaireResultMemberArgs = {
  input?: InputMaybe<CreateOrUpdateQuestionnaireResultMemberInput>;
};


export type MutationCreateP1PrescriptionArgs = {
  input: CreateP1PrescriptionInput;
};


export type MutationCreatePhraseArgs = {
  input: CreatePhraseInput;
};


export type MutationCreatePlaylistArgs = {
  input?: InputMaybe<PlaylistInput>;
};


export type MutationCreatePlaylistMediumArgs = {
  input?: InputMaybe<PlaylistMediumInput>;
};


export type MutationCreateRatingArgs = {
  input?: InputMaybe<CreateRatingInput>;
};


export type MutationCreateSubscriptionArgs = {
  input?: InputMaybe<CreateSubscriptionInput>;
};


export type MutationCreateSubscriptionGroupArgs = {
  input?: InputMaybe<CreateSubscriptionGroup>;
};


export type MutationCreateSubscriptionRedeemCodeArgs = {
  input?: InputMaybe<CreateSubscriptionRedeemCodeInput>;
};


export type MutationCreateTokenArgs = {
  input?: InputMaybe<CreateTokenInput>;
};


export type MutationCreateUserMedicationLastedArgs = {
  input: CreateUserMedicationLastedInput;
};


export type MutationCreateUserMetaTranslationArgs = {
  input?: InputMaybe<Array<InputMaybe<UserMetaTranslationInput>>>;
};


export type MutationCreateUserSubscriptionMemberArgs = {
  input?: InputMaybe<CreateUserSubscriptionMemberInput>;
};


export type MutationCreateWizardResultArgs = {
  input: CreateWizardResultInput;
};


export type MutationCreateWorkplaceMemberAbsenceArgs = {
  input?: InputMaybe<CreateWorkplaceMemberAbsenceInput>;
};


export type MutationCreateWorkplacePresetArgs = {
  input?: InputMaybe<CreateWorkplacePresetInput>;
};


export type MutationDeleteDocumentationFolderArgs = {
  data?: InputMaybe<DeleteDocumentationFolderInput>;
  where?: InputMaybe<DocumentationFolderWhereInput>;
};


export type MutationDeleteHealthPlanWorkplaceArgs = {
  input?: InputMaybe<RemoveHealthPlanWorkplaceInput>;
};


export type MutationDeleteHiddenWorkplaceArgs = {
  input?: InputMaybe<HiddenWorkplaceMetaInput>;
};


export type MutationDeleteInsuranceOperationArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteInsuranceReportArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteLaboratoryRequisitionWorkplaceArgs = {
  input: DeleteLaboratoryRequisitionWorkplaceInput;
};


export type MutationDeleteLaboratoryWorkplaceArgs = {
  input: DeleteLaboratoryWorkplaceInput;
};


export type MutationDeletePhraseArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteTokenArgs = {
  input?: InputMaybe<DeleteTokenInput>;
};


export type MutationDeleteUserMedicationLastedArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteWizardResultArgs = {
  input: DeleteWizardResultInput;
};


export type MutationDeleteWorkplaceMemberArgs = {
  input?: InputMaybe<DeleteWorkplaceMemberInput>;
};


export type MutationDoneEventArgs = {
  input?: InputMaybe<DoneEventInput>;
};


export type MutationEndHealthPlanUserArgs = {
  input?: InputMaybe<EndHealthPlanUserInput>;
};


export type MutationFamilyMemberRelationArgs = {
  input?: InputMaybe<FamilyMemberRelationInput>;
};


export type MutationGenerateSubscriptionRedeemCodesArgs = {
  input?: InputMaybe<GenerateSubscriptionRedeemCodeInput>;
};


export type MutationGenerateSubscriptionRedeemCodesAlphabetArgs = {
  input?: InputMaybe<GenerateSubscriptionRedeemCodeAlphabetInput>;
};


export type MutationHideMembersWorkplaceArgs = {
  input?: InputMaybe<HiddenWorkplaceMetaInput>;
};


export type MutationHideSeenLaboratoryResultsArgs = {
  input: HideSeenLaboratoryResultsInput;
};


export type MutationOrderSubscriptionArgs = {
  input?: InputMaybe<OrderSubscriptionInput>;
};


export type MutationPriorityCaseArgs = {
  input?: InputMaybe<PriorityCaseInput>;
};


export type MutationPurchaseProductArgs = {
  input?: InputMaybe<PurchaseProductInput>;
};


export type MutationReAssignCaseArgs = {
  input?: InputMaybe<ReAssignCaseInput>;
};


export type MutationReactivateExpiredSubscriptionArgs = {
  input?: InputMaybe<ReactivateSubscriptionInput>;
};


export type MutationReadDashboardMessageArgs = {
  input?: InputMaybe<ReadDashboardMessageInput>;
};


export type MutationRemoveUserSubscriptionMemberArgs = {
  input?: InputMaybe<RemoveUserSubscriptionMemberInput>;
};


export type MutationRequestPaymentHealthPlanUserArgs = {
  input?: InputMaybe<RequestPaymentHealthPlanUserInput>;
};


export type MutationSaveLaboratoryRequisitionResultArgs = {
  input: SaveLaboratoryRequisitionResultInput;
};


export type MutationSaveNcziDoveraResultArgs = {
  input: SaveNcziDoveraResultInput;
};


export type MutationSaveUserFilterArgs = {
  input?: InputMaybe<UserFilterInput>;
};


export type MutationSetUserNotificationSettingArgs = {
  input: SetUserNotificationSettingInput;
};


export type MutationSubmitQuestionnaireResultArgs = {
  input?: InputMaybe<SubmitQuestionnaireResultInput>;
};


export type MutationSubmitWizardArgs = {
  input?: InputMaybe<WizardResultInput>;
};


export type MutationSubscriptionChangePaymentMethodArgs = {
  input?: InputMaybe<SubscriptionChangePaymentMethodInput>;
};


export type MutationTransferDocumentArgs = {
  input?: InputMaybe<DocumentTransferInput>;
};


export type MutationTransferDocumentsArgs = {
  input: DocumentsTransferInput;
};


export type MutationTryChargeExpiredSubscriptionArgs = {
  input?: InputMaybe<ChargeSubscriptionInput>;
};


export type MutationUpdateDocumentationFolderArgs = {
  data?: InputMaybe<UpdateDocumentationFolderInput>;
  where?: InputMaybe<DocumentationFolderWhereInput>;
};


export type MutationUpdateInsuranceReportArgs = {
  id: Scalars['UUID'];
  input: UpdateInsuranceReportInput;
};


export type MutationUpdateNoteArgs = {
  input?: InputMaybe<UpdateNoteInput>;
};


export type MutationUpdatePhraseArgs = {
  input: UpdatePhraseInput;
  where: PhrasesWhereUnique;
};


export type MutationUpdateUserConsentArgs = {
  data?: InputMaybe<UpdateUserConsentInput>;
  where?: InputMaybe<UserConsentsWhereInput>;
};


export type MutationUpdateUserMedicationLastedArgs = {
  data?: InputMaybe<UpdateUserMedicationLastedDataInput>;
  where?: InputMaybe<UpdateUserMedicationLastedWhereInput>;
};


export type MutationUpdateWorkplaceMembersArgs = {
  input?: InputMaybe<UpdateWorkplaceMembersInput>;
};


export type MutationUserSubscriptionCancelArgs = {
  input?: InputMaybe<UserSubscriptionCancelInput>;
};

export type MutationResult = {
  __typename?: 'MutationResult';
  status?: Maybe<Scalars['Boolean']>;
};

export type MyFamily = {
  __typename?: 'MyFamily';
  familyMembers?: Maybe<Array<Maybe<MyFamilyMember>>>;
  id: Scalars['UUID'];
};

export type MyFamilyMember = {
  __typename?: 'MyFamilyMember';
  familyId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  isAdmin?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type MyFamilyMembersResult = {
  __typename?: 'MyFamilyMembersResult';
  data?: Maybe<Array<Maybe<MyFamilyMember>>>;
  meta?: Maybe<PageInfo>;
};

export type MyPhrasesWhereInput = {
  type?: InputMaybe<PhraseType>;
};

export type MyWorkplacesWhereInput = {
  type?: InputMaybe<Array<InputMaybe<WorkplaceType>>>;
};

export type NcziCodingScheme = {
  __typename?: 'NcziCodingScheme';
  oid: Scalars['String'];
};

export type NcziCodingSchemeVersioned = {
  __typename?: 'NcziCodingSchemeVersioned';
  oid: Scalars['String'];
  version: Scalars['String'];
};

export type NcziDiagnosisItem = {
  __typename?: 'NcziDiagnosisItem';
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  enum: NcziEnum;
  name: Scalars['String'];
  ncziCode: Scalars['String'];
  params?: Maybe<Scalars['JSON']>;
};

export type NcziDiagnosisItemsResult = {
  __typename?: 'NcziDiagnosisItemsResult';
  data?: Maybe<Array<Maybe<NcziDiagnosisItem>>>;
  meta?: Maybe<PageInfo>;
};

export type NcziDoveraListResult = {
  __typename?: 'NcziDoveraListResult';
  data?: Maybe<Array<Maybe<DoveraCheckItem>>>;
  meta?: Maybe<PageInfo>;
};

export type NcziEnum = {
  __typename?: 'NcziEnum';
  extraAttr?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  oid: Scalars['String'];
  type: Scalars['String'];
  version: Scalars['String'];
};

export type NcziEnumItem = {
  __typename?: 'NcziEnumItem';
  abbreviation?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  enum: NcziEnum;
  name: Scalars['String'];
  params?: Maybe<Scalars['JSON']>;
};

export type NcziEnumItemsByCodeResult = {
  __typename?: 'NcziEnumItemsByCodeResult';
  enum?: Maybe<NcziEnum>;
  enumItems?: Maybe<Array<Maybe<NcziEnumItem>>>;
};

export type NcziEnumItemsResult = {
  __typename?: 'NcziEnumItemsResult';
  data?: Maybe<Array<Maybe<NcziEnumItem>>>;
  meta?: Maybe<PageInfo>;
};

export type NcziEnumsResult = {
  __typename?: 'NcziEnumsResult';
  data?: Maybe<Array<Maybe<NcziEnum>>>;
};

export type NcziExtension = {
  __typename?: 'NcziExtension';
  name: Scalars['String'];
  oid: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type NcziExtensionItem = {
  __typename?: 'NcziExtensionItem';
  abbreviation?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  extension: NcziExtension;
  name: Scalars['String'];
  params?: Maybe<Scalars['JSON']>;
};

export type NcziExtensionItemsResult = {
  __typename?: 'NcziExtensionItemsResult';
  data?: Maybe<Array<Maybe<NcziExtensionItem>>>;
  meta?: Maybe<PageInfo>;
};

export type NcziMedicamentItem = {
  __typename?: 'NcziMedicamentItem';
  additionalName: Scalars['String'];
  antibioticsChemotherapy: Scalars['Boolean'];
  atc?: Maybe<NcziReference>;
  code: Scalars['String'];
  form?: Maybe<NcziReference>;
  genericPrescription: Scalars['Boolean'];
  indicationGroup?: Maybe<NcziReference>;
  multiplePrescription: Scalars['Boolean'];
  name: Scalars['String'];
  ncziCode: Scalars['String'];
  opl: Scalars['Boolean'];
  packageSize?: Maybe<NcziQuantity>;
  prescriptionValidity?: Maybe<NcziQuantity>;
  submissionPath?: Maybe<NcziReference>;
  vaccination: Scalars['Boolean'];
};

export type NcziMedicamentItemsResult = {
  __typename?: 'NcziMedicamentItemsResult';
  data?: Maybe<Array<Maybe<NcziMedicamentItem>>>;
  meta?: Maybe<PageInfo>;
};

export type NcziMessage = {
  __typename?: 'NcziMessage';
  createdAt?: Maybe<Scalars['String']>;
  extraParams?: Maybe<Scalars['JSON']>;
  finished?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  lastState?: Maybe<Scalars['String']>;
  resultCode?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId: Scalars['UUID'];
};

export type NcziNExtension = {
  __typename?: 'NcziNExtension';
  code: Scalars['String'];
  scheme: NcziCodingScheme;
  valid?: Maybe<NcziValidity>;
};

export type NcziOupZsItem = {
  __typename?: 'NcziOUPZsItem';
  code: Scalars['String'];
  extension?: Maybe<NcziNExtension>;
  name: Scalars['String'];
  provider?: Maybe<NcziPzsProvider>;
  specialization?: Maybe<Array<Maybe<NcziZPrSpecialization>>>;
};

export type NcziPzsProvider = {
  __typename?: 'NcziPZSProvider';
  code: Scalars['String'];
  extension?: Maybe<NcziNExtension>;
  name: Scalars['String'];
};

export type NcziProductItem = {
  __typename?: 'NcziProductItem';
  additionalName?: Maybe<Scalars['String']>;
  antibioticsChemotherapy?: Maybe<Scalars['Boolean']>;
  atc?: Maybe<NcziReference>;
  atcAddon?: Maybe<Scalars['String']>;
  atcCode?: Maybe<Scalars['String']>;
  atcName?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  ioNeeded?: Maybe<Scalars['Boolean']>;
  ioOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Scalars['String'];
  opl?: Maybe<Scalars['Boolean']>;
  quantityLimit?: Maybe<Array<Maybe<Scalars['String']>>>;
  tailored?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
  ventilator?: Maybe<Scalars['Boolean']>;
};

export type NcziProductItemsResult = {
  __typename?: 'NcziProductItemsResult';
  data?: Maybe<Array<Maybe<NcziProductItem>>>;
  meta?: Maybe<PageInfo>;
};

export type NcziQuantity = {
  __typename?: 'NcziQuantity';
  amount?: Maybe<Scalars['String']>;
  unit?: Maybe<NcziReference>;
};

export type NcziQueueResult = {
  __typename?: 'NcziQueueResult';
  data?: Maybe<Array<Maybe<NcziMessage>>>;
  meta?: Maybe<PageInfo>;
};

export type NcziReference = {
  __typename?: 'NcziReference';
  code: Scalars['String'];
  displayName: Scalars['String'];
  scheme: NcziCodingSchemeVersioned;
};

export type NcziValidity = {
  __typename?: 'NcziValidity';
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type NcziZPrSpecialization = {
  __typename?: 'NcziZPrSpecialization';
  ZPrCode: Scalars['String'];
  specialization: NcziReference;
};

export type Note = {
  __typename?: 'Note';
  id?: Maybe<Scalars['UUID']>;
  text?: Maybe<Scalars['String']>;
};

export enum OnlineOrderTarget {
  Workplace = 'WORKPLACE',
  WorkplaceMember = 'WORKPLACE_MEMBER'
}

export type Order = {
  __typename?: 'Order';
  commission?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  issueDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  orderItems?: Maybe<Array<Maybe<OrderItem>>>;
  orderLog?: Maybe<OrderLog>;
  orderLogs?: Maybe<Array<Maybe<OrderLog>>>;
  orderMembers?: Maybe<Array<Maybe<OrderMember>>>;
  paymentMethod?: Maybe<OrderPaymentMethod>;
  price?: Maybe<TransactionPrice>;
  priceInvoicing?: Maybe<Scalars['String']>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Price>;
};

export type OrderLog = {
  __typename?: 'OrderLog';
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type OrderMember = {
  __typename?: 'OrderMember';
  type?: Maybe<OrderMemberType>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export enum OrderMemberType {
  Issuer = 'Issuer',
  Payer = 'Payer'
}

export enum OrderPaymentMethod {
  Apay = 'APAY',
  Crd = 'CRD',
  Edenred = 'EDENRED',
  Gpay = 'GPAY',
  MeddiCredit = 'MEDDI_CREDIT',
  Paypal = 'PAYPAL',
  Sodexo = 'SODEXO'
}

export type OrderStatistics = {
  __typename?: 'OrderStatistics';
  currency?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  totalCommission?: Maybe<Scalars['Float']>;
  totalInvoiced?: Maybe<Scalars['Float']>;
};

export type OrderStatisticsResult = {
  __typename?: 'OrderStatisticsResult';
  data?: Maybe<Array<Maybe<OrderStatistics>>>;
};

export type OrderStatisticsWhereInput = {
  from: Scalars['DateTime'];
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  orderMembers?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  sendEmpty?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<OrderStatus>;
  to: Scalars['DateTime'];
  workplaceId?: InputMaybe<Scalars['String']>;
};

export type OrderStats = {
  __typename?: 'OrderStats';
  commissionTotal?: Maybe<Scalars['Decimal']>;
  commissionTotalFormatted?: Maybe<Scalars['String']>;
  invoicedTotal?: Maybe<Scalars['Decimal']>;
  invoicedTotalFormatted?: Maybe<Scalars['String']>;
};

export enum OrderStatus {
  Created = 'CREATED',
  Paid = 'PAID'
}

export type OrderSubscriptionInput = {
  paymentMethod?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['String']>;
  subscriptionPeriodId?: InputMaybe<Scalars['String']>;
};

export type OrdersFilter = {
  from?: InputMaybe<Scalars['DateTime']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  orderMembers?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  status?: InputMaybe<OrderStatus>;
  to?: InputMaybe<Scalars['DateTime']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type OrdersResult = {
  __typename?: 'OrdersResult';
  data?: Maybe<Array<Maybe<Order>>>;
  meta?: Maybe<PageInfo>;
  stats?: Maybe<OrderStats>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  count?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  next?: Maybe<Scalars['JSONObject']>;
  page?: Maybe<Scalars['Int']>;
  params?: Maybe<Scalars['JSONObject']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type PaginationInput = {
  after?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<PaginationInputOrder>;
  page?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type PaginationInputOrder = {
  how?: InputMaybe<PaginationOrderHow>;
  key?: InputMaybe<Scalars['String']>;
};

export enum PaginationOrderHow {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PatientCalculator = {
  __typename?: 'PatientCalculator';
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  wizardKey: Scalars['String'];
};

export type PatientCalculatorsResult = {
  __typename?: 'PatientCalculatorsResult';
  data?: Maybe<Array<Maybe<PatientCalculator>>>;
  meta?: Maybe<PageInfo>;
};

export type PaySubscriptionInput = {
  subscriptionId?: InputMaybe<Scalars['String']>;
  subscriptionPeriodId?: InputMaybe<Scalars['String']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  icon?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type Phrase = {
  __typename?: 'Phrase';
  id?: Maybe<Scalars['UUID']>;
  meta?: Maybe<Array<Maybe<Meta>>>;
  name?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['Int']>;
  type?: Maybe<PhraseType>;
  userId?: Maybe<Scalars['UUID']>;
  value?: Maybe<Scalars['String']>;
};


export type PhraseMetaArgs = {
  key?: InputMaybe<Scalars['String']>;
};

export enum PhraseType {
  Chat = 'CHAT',
  Discourse = 'DISCOURSE'
}

export type PhrasesResult = {
  __typename?: 'PhrasesResult';
  data: Array<Maybe<Phrase>>;
  meta: PageInfo;
};

export type PhrasesWhereUnique = {
  id: Scalars['UUID'];
};

export type Playlist = {
  __typename?: 'Playlist';
  code?: Maybe<PlaylistCode>;
  id: Scalars['UUID'];
  mediums?: Maybe<Array<Maybe<Medium>>>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<PlaylistType>;
};

export enum PlaylistCode {
  Medditation = 'MEDDITATION'
}

export type PlaylistInput = {
  code: PlaylistCode;
  name: Scalars['String'];
  type: PlaylistType;
};

export type PlaylistMedium = {
  __typename?: 'PlaylistMedium';
  id: Scalars['UUID'];
  mediumId?: Maybe<Scalars['UUID']>;
  playlistId?: Maybe<Scalars['UUID']>;
};

export type PlaylistMediumInput = {
  mediumId: Scalars['UUID'];
  playlistId: Scalars['UUID'];
};

export enum PlaylistType {
  Default = 'DEFAULT'
}

export type PlaylistsResult = {
  __typename?: 'PlaylistsResult';
  data?: Maybe<Array<Maybe<Playlist>>>;
  meta?: Maybe<PageInfo>;
};

export type Post = {
  __typename?: 'Post';
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  imageUrl?: Maybe<Scalars['String']>;
  isNew?: Maybe<Scalars['Boolean']>;
  link?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type PostsResult = {
  __typename?: 'PostsResult';
  data?: Maybe<Array<Maybe<Post>>>;
  meta?: Maybe<PageInfo>;
};

export type Prescription = {
  __typename?: 'Prescription';
  canBeReserved?: Maybe<Scalars['Boolean']>;
  canDrmax?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  createdByName?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSONObject']>;
  drMaxPickupPlace?: Maybe<DrMaxPickupPlace>;
  id: Scalars['UUID'];
  items?: Maybe<Array<Maybe<PrescriptionItem>>>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  validUntil?: Maybe<Scalars['DateTime']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type PrescriptionItem = {
  __typename?: 'PrescriptionItem';
  childPrescriptionItems?: Maybe<Array<Maybe<PrescriptionItem>>>;
  extra?: Maybe<Scalars['JSONObject']>;
  id: Scalars['UUID'];
  parentPrescriptionItem?: Maybe<PrescriptionItem>;
  parentPrescriptionItemId?: Maybe<Scalars['UUID']>;
  prescription?: Maybe<Prescription>;
  prescriptionId?: Maybe<Scalars['UUID']>;
  prescriptionMedicament?: Maybe<PrescriptionMedicament>;
  prescriptionMedicamentId?: Maybe<Scalars['UUID']>;
  quantity?: Maybe<Scalars['Decimal']>;
};

export type PrescriptionItemsResult = {
  __typename?: 'PrescriptionItemsResult';
  data?: Maybe<Array<Maybe<PrescriptionItem>>>;
  meta?: Maybe<PageInfo>;
};

export type PrescriptionMedicament = {
  __typename?: 'PrescriptionMedicament';
  addition?: Maybe<Scalars['String']>;
  atc?: Maybe<Scalars['String']>;
  authorizationNumber?: Maybe<Scalars['String']>;
  availabilityCategory?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  dispensing?: Maybe<Scalars['String']>;
  dispensingTermItem?: Maybe<TermItem>;
  doping?: Maybe<Scalars['String']>;
  dopingTermItem?: Maybe<TermItem>;
  form?: Maybe<Scalars['String']>;
  gtin?: Maybe<Scalars['String']>;
  hasIndicationLimitations?: Maybe<Scalars['Boolean']>;
  hasLimitations?: Maybe<Scalars['Boolean']>;
  hasSpecialityLimitations?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  indicationLimitations?: Maybe<Scalars['String']>;
  internationalName?: Maybe<Scalars['String']>;
  lim?: Maybe<Scalars['String']>;
  limTermItem?: Maybe<TermItem>;
  marketingAuthorizationHolder?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  packageCount?: Maybe<Scalars['String']>;
  packageDivisible?: Maybe<Scalars['Boolean']>;
  packageType?: Maybe<Scalars['String']>;
  packaging?: Maybe<Scalars['String']>;
  packagingCapacity?: Maybe<Scalars['String']>;
  packagingCapacityUnit?: Maybe<Scalars['String']>;
  priceExtraFormatted?: Maybe<Scalars['String']>;
  priceInsuranceCompanyRawFormatted?: Maybe<Scalars['String']>;
  priceRawFormatted?: Maybe<Scalars['String']>;
  procedureType?: Maybe<Scalars['String']>;
  rationalPrescription?: Maybe<Scalars['String']>;
  routeOfAdministration?: Maybe<Scalars['String']>;
  specialityLimitationTermItems?: Maybe<Array<Maybe<TermItem>>>;
  specialityLimitations?: Maybe<Scalars['String']>;
  statusType?: Maybe<Scalars['String']>;
  strength?: Maybe<Scalars['String']>;
};

export type PrescriptionMedicamentsResult = {
  __typename?: 'PrescriptionMedicamentsResult';
  data?: Maybe<Array<Maybe<PrescriptionMedicament>>>;
  meta?: Maybe<PageInfo>;
};

export enum PrescriptionType {
  Default = 'DEFAULT',
  Sukl = 'SUKL'
}

export type PrescriptionsResult = {
  __typename?: 'PrescriptionsResult';
  data?: Maybe<Array<Maybe<Prescription>>>;
  meta?: Maybe<PageInfo>;
};

export type Price = {
  __typename?: 'Price';
  currency: Scalars['String'];
  formattedPrice?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  price?: Maybe<Scalars['Decimal']>;
  priceWithVat?: Maybe<Scalars['Decimal']>;
  priceWithVatRaw?: Maybe<Scalars['String']>;
  vatRate: Scalars['Float'];
};

export type PriceDiscount = {
  __typename?: 'PriceDiscount';
  absoluteDiscountFormatted?: Maybe<Scalars['String']>;
  price?: Maybe<Price>;
  relativeDiscount?: Maybe<Scalars['Decimal']>;
};

export type PriorityCaseInput = {
  caseId: Scalars['UUID'];
  priorityId?: InputMaybe<Scalars['UUID']>;
};

export type Product = {
  __typename?: 'Product';
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  formattedPrice?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  price?: Maybe<ProductPrice>;
  productGroup?: Maybe<Scalars['String']>;
  purchaseButton?: Maybe<ProductPurchaseButton>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ProductItem = {
  __typename?: 'ProductItem';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  productId: Scalars['UUID'];
  quantity?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type ProductOrder = {
  __typename?: 'ProductOrder';
  id: Scalars['UUID'];
  number?: Maybe<Scalars['Int']>;
  orderId?: Maybe<Scalars['UUID']>;
  orderItems?: Maybe<Array<Maybe<ProductOrderItem>>>;
  price?: Maybe<ProductOrderPrice>;
  redirectUrl?: Maybe<Scalars['String']>;
};

export type ProductOrderItem = {
  __typename?: 'ProductOrderItem';
  code?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
};

export type ProductOrderPrice = {
  __typename?: 'ProductOrderPrice';
  currency?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  price?: Maybe<Scalars['Float']>;
  pricePiece?: Maybe<Scalars['Int']>;
  priceWithVat?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  vatRate?: Maybe<Scalars['Float']>;
};

export type ProductPrice = {
  __typename?: 'ProductPrice';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  pricePieceWithVat?: Maybe<Scalars['Float']>;
  productId: Scalars['UUID'];
  vatRate?: Maybe<Scalars['Float']>;
};

export type ProductPurchaseButton = {
  __typename?: 'ProductPurchaseButton';
  description?: Maybe<Scalars['String']>;
  theme?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Profile = {
  __typename?: 'Profile';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['UUID']>;
  age?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  birthNumber?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactPhoneNumber?: Maybe<Scalars['String']>;
  fatherLastName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formattedBirthNumber?: Maybe<Scalars['String']>;
  formattedGender?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  genderTermItem?: Maybe<TermItem>;
  genderTermItemId?: Maybe<Scalars['UUID']>;
  hasInsurance?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  insuranceCompanyTermItem?: Maybe<TermItem>;
  insuranceCompanyTermItemId?: Maybe<Scalars['UUID']>;
  insuranceNumber?: Maybe<Scalars['String']>;
  languageFormatted?: Maybe<Scalars['String']>;
  languageIso?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  motherLastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nationalityOther?: Maybe<Scalars['String']>;
  nationalityTermItem?: Maybe<TermItem>;
  nationalityTermItemId?: Maybe<Scalars['UUID']>;
  salutation?: Maybe<Scalars['String']>;
  salutationAfter?: Maybe<Scalars['String']>;
  salutationBefore?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

export type PurchaseProductInput = {
  paymentMethod: Scalars['String'];
  productCode: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  activeCases?: Maybe<CasesResult>;
  auditLogs?: Maybe<AuditLogsResult>;
  availableDoctors?: Maybe<AvailableDoctorsResult>;
  bioScanHistories?: Maybe<BioScanHistoriesResult>;
  case?: Maybe<Case>;
  caseDoctors?: Maybe<CaseDoctorsResult>;
  caseEntries?: Maybe<CaseEntriesResult>;
  cases?: Maybe<CasesResult>;
  casesAssigned?: Maybe<CasesResult>;
  certificates?: Maybe<CertificatesResult>;
  conversation?: Maybe<Conversation>;
  conversations?: Maybe<ConversationsResult>;
  dashboardLayout?: Maybe<Array<Maybe<DashboardLayoutItem>>>;
  dashboardMessage?: Maybe<Message>;
  dashboardMessages?: Maybe<Array<Maybe<Message>>>;
  dashboardTiles?: Maybe<Array<Maybe<DashboardTile>>>;
  doctors?: Maybe<UsersResult>;
  document?: Maybe<Document>;
  documentVersions?: Maybe<DocumentsResult>;
  documentationFiles?: Maybe<DocumentationFilesResult>;
  documentationFolder?: Maybe<DocumentationFolder>;
  documentationFolders?: Maybe<DocumentationFoldersResult>;
  documents?: Maybe<DocumentsResult>;
  drmaxPickupPlaces?: Maybe<DrMaxPickupPlacesResult>;
  drmaxPrescriptionMedicaments?: Maybe<DrMaxPrescriptionMedicamentsResult>;
  educationMaterial?: Maybe<EducationMaterial>;
  educationMaterialFolders?: Maybe<EducationMaterialFoldersResult>;
  educationMaterials?: Maybe<EducationMaterialsResult>;
  event?: Maybe<Event>;
  events?: Maybe<EventsResult>;
  exportLogs?: Maybe<ExportLogsResult>;
  familyMember?: Maybe<FamilyMember>;
  familyMemberShareList?: Maybe<FamilyMembersResult>;
  familyMembers?: Maybe<FamilyMembersResult>;
  familyMembersAvailableForCaseCreate?: Maybe<UsersResult>;
  filterCaseContacts?: Maybe<CaseContactsResult>;
  group?: Maybe<Group>;
  groupMembers?: Maybe<GroupMembersResult>;
  groups?: Maybe<GroupsResult>;
  healthData?: Maybe<HealthDataResult>;
  healthDataDashboardCategories?: Maybe<Array<Maybe<HealthDataDashboardCategory>>>;
  healthDataLastValues?: Maybe<HealthDataResult>;
  healthPlan?: Maybe<HealthPlan>;
  healthPlanBabyPregnancy?: Maybe<HealthPlanBabyPregnancy>;
  healthPlanUser?: Maybe<HealthPlanUser>;
  healthPlanUserItem?: Maybe<HealthPlanUserItem>;
  healthPlanUserItems?: Maybe<HealthPlanUserItemResult>;
  healthPlanUsers?: Maybe<HealthPlanUsersResult>;
  healthPlans?: Maybe<HealthPlansResult>;
  insuranceOperation?: Maybe<InsuranceOperation>;
  insuranceOperations?: Maybe<InsuranceOperationResult>;
  insuranceReport?: Maybe<InsuranceReport>;
  insuranceReports?: Maybe<InsuranceReportsResult>;
  iots?: Maybe<IotsResult>;
  laboratories?: Maybe<LaboratoryResult>;
  laboratory?: Maybe<Laboratory>;
  laboratoryRequisitionForm?: Maybe<LaboratoryRequisitionFormResult>;
  laboratoryRequisitionResult?: Maybe<LaboratoryRequisitionResult>;
  laboratoryRequisitionResults?: Maybe<LaboratoryRequisitionResultsResult>;
  laboratoryRequisitions?: Maybe<LaboratoryRequisitionsResult>;
  laboratoryResult?: Maybe<LaboratoryResultResult>;
  laboratoryResults?: Maybe<LaboratoryResultsResult>;
  laboratoryWizards?: Maybe<LaboratoryWizardsResult>;
  laboratoryWorkplaces?: Maybe<LaboratoryWorkplacesResult>;
  me?: Maybe<User>;
  meddiAccount?: Maybe<MeddiAccount>;
  meddiAccountTransactions?: Maybe<MeddiAccountTransactionResult>;
  meddiAccounts?: Maybe<MeddiAccountResult>;
  medicalRequestForm?: Maybe<MedicalRequestForm>;
  medicalRequestForms?: Maybe<MedicalRequestFormsResult>;
  message?: Maybe<Message>;
  messageMembers?: Maybe<Array<Maybe<MessageMembersResult>>>;
  messages?: Maybe<MessagesResult>;
  messagesByConversation?: Maybe<MessagesResult>;
  meta?: Maybe<Meta>;
  metaMy?: Maybe<Meta>;
  metas?: Maybe<MetasResult>;
  monitoringCentreCases?: Maybe<CasesResult>;
  myActiveCases?: Maybe<CasesResult>;
  myActiveSubscriptions?: Maybe<UserSubscriptionsResult>;
  myEvents?: Maybe<EventsResult>;
  myFamily?: Maybe<MyFamily>;
  myFamilyMembers?: Maybe<MyFamilyMembersResult>;
  myPhrases?: Maybe<PhrasesResult>;
  myWorkplaces?: Maybe<WorkplacesResult>;
  ncziDoveraList?: Maybe<NcziDoveraListResult>;
  ncziEnumItem?: Maybe<NcziEnumItem>;
  ncziEnumItemByAbbr?: Maybe<NcziEnumItem>;
  ncziEnumItems?: Maybe<NcziEnumItemsByCodeResult>;
  ncziExtensionItem?: Maybe<NcziExtensionItem>;
  ncziExtensionItemByAbbr?: Maybe<NcziExtensionItem>;
  ncziListDiagnosis?: Maybe<NcziDiagnosisItemsResult>;
  ncziListEnumItems?: Maybe<NcziEnumItemsResult>;
  ncziListEnums?: Maybe<NcziEnumsResult>;
  ncziListExtensionItems?: Maybe<NcziExtensionItemsResult>;
  ncziListMedicamentItems?: Maybe<NcziMedicamentItemsResult>;
  ncziListProductItems?: Maybe<NcziProductItemsResult>;
  ncziListQueue?: Maybe<NcziQueueResult>;
  ncziMedicamentItem?: Maybe<NcziMedicamentItem>;
  ncziOUPZsByPZSCode?: Maybe<Array<Maybe<NcziOupZsItem>>>;
  ncziProductItem?: Maybe<NcziProductItem>;
  notifications?: Maybe<MessagesResult>;
  nurseCases?: Maybe<CasesResult>;
  orderStatistics?: Maybe<OrderStatisticsResult>;
  orders?: Maybe<OrdersResult>;
  patient?: Maybe<User>;
  patientCalculators?: Maybe<PatientCalculatorsResult>;
  patients?: Maybe<UsersResult>;
  playlist?: Maybe<Playlist>;
  playlists?: Maybe<PlaylistsResult>;
  posts?: Maybe<PostsResult>;
  prescription?: Maybe<Prescription>;
  prescriptionItems?: Maybe<PrescriptionItemsResult>;
  prescriptionMedicament?: Maybe<PrescriptionMedicament>;
  prescriptionMedicaments?: Maybe<PrescriptionMedicamentsResult>;
  prescriptions?: Maybe<PrescriptionsResult>;
  product?: Maybe<Product>;
  products?: Maybe<Array<Maybe<Product>>>;
  questionnaire?: Maybe<Questionnaire>;
  questionnaireResultItems?: Maybe<QuestionnaireResultItemsResult>;
  questionnaireResults?: Maybe<QuestionnaireResultsResult>;
  questionnaireSchedule?: Maybe<QuestionnaireSchedule>;
  questionnaireSchedules?: Maybe<QuestionnaireSchedulesResult>;
  questionnaires?: Maybe<QuestionnairesResult>;
  rating?: Maybe<Rating>;
  ratings?: Maybe<RatingsResult>;
  rootWorkplaceDoctors?: Maybe<WorkplaceMembersResult>;
  rootWorkplacesPatient?: Maybe<WorkplaceMembersResult>;
  serviceSchedules?: Maybe<ServiceSchedulesResult>;
  subscription?: Maybe<Subscription>;
  subscriptionOffers?: Maybe<SubscriptionOffersResult>;
  subscriptionPaymentMethods?: Maybe<Array<Maybe<PaymentMethod>>>;
  subscriptions?: Maybe<SubscriptionsResult>;
  termItem?: Maybe<TermItem>;
  termItemByValue?: Maybe<TermItem>;
  termItems?: Maybe<TermItemsResult>;
  terms?: Maybe<TermsResult>;
  token?: Maybe<Token>;
  tokens?: Maybe<TokensResult>;
  transmiseList?: Maybe<TransmiseListResult>;
  user?: Maybe<User>;
  userConsents?: Maybe<UserConsentsResult>;
  userDekurzes?: Maybe<UserDekurzesResult>;
  userFilter?: Maybe<Meta>;
  userHealthCategories?: Maybe<UserHealthCategoriesResult>;
  userHealthCategoryPermissions?: Maybe<UserHealthCategoryPermissionsResult>;
  userMedicationLasted?: Maybe<UserMedicationLastedResult>;
  userNotice?: Maybe<UserNotice>;
  userNotificationSettings?: Maybe<UserNotificationSettingsResult>;
  users?: Maybe<UsersResult>;
  wizard?: Maybe<Wizard>;
  wizardItem?: Maybe<WizardItem>;
  wizardItems?: Maybe<WizardItemsResult>;
  wizardResult?: Maybe<WizardResult>;
  wizardResultItems?: Maybe<WizardResultItemsResult>;
  wizardResults?: Maybe<WizardResultsResult>;
  wizardTree?: Maybe<Array<Maybe<WizardItem>>>;
  wizards?: Maybe<WizardsResult>;
  workplace?: Maybe<Workplace>;
  workplaceAclRoles?: Maybe<AclRoleResult>;
  workplaceAddress?: Maybe<Address>;
  workplaceCaseType?: Maybe<WorkplaceCaseType>;
  workplaceCaseTypes?: Maybe<WorkplaceCaseTypesResult>;
  workplaceCaseTypesDoctor?: Maybe<WorkplaceCaseTypesResult>;
  workplaceCases?: Maybe<CasesResult>;
  workplaceCasesArchived?: Maybe<CasesResult>;
  workplaceCertificates?: Maybe<WorkplaceCertificatesResult>;
  workplaceDoctors?: Maybe<WorkplaceMembersResult>;
  workplaceEvents?: Maybe<EventsResult>;
  workplaceHealthPlans?: Maybe<HealthPlansResult>;
  workplaceInsuranceBatchs?: Maybe<InsuranceBatchsResult>;
  workplaceMember?: Maybe<WorkplaceMember>;
  workplaceMembers?: Maybe<WorkplaceMembersResult>;
  workplacePatientDocumentationFiles?: Maybe<DocumentationFilesResult>;
  workplacePatientPending?: Maybe<WorkplaceMembersResult>;
  workplacePatients?: Maybe<WorkplaceMembersResult>;
  workplacePresets?: Maybe<Array<Maybe<WorkplacePreset>>>;
  workplaces?: Maybe<WorkplacesResult>;
};


export type QueryActiveCasesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
};


export type QueryAuditLogsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  targetEntityId?: InputMaybe<Scalars['String']>;
  targetEntityType?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryAvailableDoctorsArgs = {
  nurse: Scalars['Boolean'];
  pagination?: InputMaybe<PaginationInput>;
  pattern: Scalars['String'];
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryBioScanHistoriesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCaseArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryCaseDoctorsArgs = {
  caseTypeCode?: InputMaybe<Scalars['String']>;
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  roleKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryCaseEntriesArgs = {
  caseId?: InputMaybe<Scalars['UUID']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCasesArgs = {
  caseStatusValue?: InputMaybe<Scalars['String']>;
  caseTypeId?: InputMaybe<Scalars['UUID']>;
  caseTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdFrom?: InputMaybe<Scalars['DateTime']>;
  createdTo?: InputMaybe<Scalars['DateTime']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  doctorIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCasesAssignedArgs = {
  caseStatusValue?: InputMaybe<Scalars['String']>;
  caseTypeId?: InputMaybe<Scalars['UUID']>;
  caseTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdFrom?: InputMaybe<Scalars['DateTime']>;
  createdTo?: InputMaybe<Scalars['DateTime']>;
  doctor?: InputMaybe<Scalars['String']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  doctorIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  onlyVisible?: InputMaybe<Scalars['Boolean']>;
  patient?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCertificatesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryConversationArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryConversationsArgs = {
  folder?: InputMaybe<ConversationFolderEnum>;
  pagination?: InputMaybe<PaginationInput>;
  type?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<InputMaybe<ConversationType>>>;
};


export type QueryDashboardMessageArgs = {
  userId: Scalars['UUID'];
};


export type QueryDoctorsArgs = {
  excludeRoleKey?: InputMaybe<Scalars['String']>;
  fulltext?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeNurses?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  roleKey?: InputMaybe<Scalars['String']>;
  rootWorkplaceId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryDocumentArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<DocumentType>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryDocumentVersionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<DocumentWhereInput>;
};


export type QueryDocumentationFilesArgs = {
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderId?: InputMaybe<Scalars['UUID']>;
  fulltext?: InputMaybe<Scalars['String']>;
  grouped?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  unprocessed?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryDocumentationFolderArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryDocumentationFoldersArgs = {
  folderId?: InputMaybe<Scalars['UUID']>;
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryDocumentsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  types?: InputMaybe<Array<InputMaybe<DocumentType>>>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryDrmaxPickupPlacesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  prescriptionId?: InputMaybe<Scalars['UUID']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryDrmaxPrescriptionMedicamentsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  pharmacyId?: InputMaybe<Scalars['Int']>;
  prescriptionId: Scalars['UUID'];
};


export type QueryEducationMaterialArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryEducationMaterialFoldersArgs = {
  module?: InputMaybe<EducationMaterialModule>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryEducationMaterialsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  module?: InputMaybe<EducationMaterialModule>;
  pagination?: InputMaybe<PaginationInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryEventArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryEventsArgs = {
  approaching?: InputMaybe<Scalars['Boolean']>;
  end?: InputMaybe<Scalars['DateTime']>;
  eventMemberId?: InputMaybe<Scalars['UUID']>;
  eventMemberIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  familyView?: InputMaybe<Scalars['Boolean']>;
  future?: InputMaybe<Scalars['Boolean']>;
  metaKey?: InputMaybe<Scalars['String']>;
  metaKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pagination?: InputMaybe<PaginationInput>;
  start?: InputMaybe<Scalars['DateTime']>;
  types?: InputMaybe<Array<InputMaybe<EventType>>>;
  userId?: InputMaybe<Scalars['UUID']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryExportLogsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: ExportLogsWhereInput;
};


export type QueryFamilyMemberArgs = {
  where?: InputMaybe<FamilyMemberWhereInput>;
};


export type QueryFamilyMemberShareListArgs = {
  childId?: InputMaybe<Scalars['UUID']>;
};


export type QueryFamilyMembersArgs = {
  pagination?: InputMaybe<PaginationInput>;
  role?: InputMaybe<FamilyMemberRole>;
};


export type QueryFamilyMembersAvailableForCaseCreateArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFilterCaseContactsArgs = {
  caseTypeCode?: InputMaybe<Scalars['String']>;
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
  roleKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryGroupArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryGroupMembersArgs = {
  groupId?: InputMaybe<Scalars['UUID']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGroupsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryHealthDataArgs = {
  from?: InputMaybe<Scalars['DateTime']>;
  groupId?: InputMaybe<Scalars['String']>;
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pagination?: InputMaybe<PaginationInput>;
  to?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryHealthDataLastValuesArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryHealthPlanArgs = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryHealthPlanBabyPregnancyArgs = {
  patientId: Scalars['UUID'];
};


export type QueryHealthPlanUserArgs = {
  healthPlanCode?: InputMaybe<Scalars['String']>;
  healthPlanId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryHealthPlanUserItemArgs = {
  healthPlanUserId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  subtype?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryHealthPlanUserItemsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<HealthPlanUserItemWhereInput>;
};


export type QueryHealthPlanUsersArgs = {
  doctorId?: InputMaybe<Scalars['UUID']>;
  fulltext?: InputMaybe<Scalars['String']>;
  healthPlanCode?: InputMaybe<HealthPlanCodeEnum>;
  pagination?: InputMaybe<PaginationInput>;
  tag?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryHealthPlansArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryInsuranceOperationArgs = {
  id: Scalars['UUID'];
};


export type QueryInsuranceOperationsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: InsuranceOperationsWhereInput;
};


export type QueryInsuranceReportArgs = {
  id: Scalars['UUID'];
};


export type QueryInsuranceReportsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: InsuranceReportsWhereInput;
};


export type QueryIotsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryLaboratoriesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<LaboratoriesWhereInput>;
};


export type QueryLaboratoryArgs = {
  id: Scalars['UUID'];
};


export type QueryLaboratoryRequisitionFormArgs = {
  where: LaboratoryRequisitionFormWhereInput;
};


export type QueryLaboratoryRequisitionResultArgs = {
  where: LaboratoryRequisitionResultWhereInput;
};


export type QueryLaboratoryRequisitionResultsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: LaboratoryRequisitionResultsWhereInput;
};


export type QueryLaboratoryRequisitionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: LaboratoryRequisitionsWhereInput;
};


export type QueryLaboratoryResultArgs = {
  where: LaboratoryResultWhereInput;
};


export type QueryLaboratoryResultsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: LaboratoryResultsWhereInput;
};


export type QueryLaboratoryWizardsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<LaboratoryWizardsWhereInput>;
};


export type QueryLaboratoryWorkplacesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: LaboratoryWorkplacesWhereInput;
};


export type QueryMeddiAccountArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryMeddiAccountTransactionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<MeddiAccountTransactionsWhereInput>;
};


export type QueryMeddiAccountsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<MeddiAccountsWhereInput>;
};


export type QueryMedicalRequestFormArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryMedicalRequestFormsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryMessageArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryMessageMembersArgs = {
  messageId?: InputMaybe<Scalars['UUID']>;
};


export type QueryMessagesArgs = {
  conversationId?: InputMaybe<Scalars['UUID']>;
  conversationType?: InputMaybe<ConversationType>;
  folder?: InputMaybe<ConversationFolderEnum>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMessagesByConversationArgs = {
  conversationType?: InputMaybe<ConversationType>;
  folder?: InputMaybe<ConversationFolderEnum>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMetaArgs = {
  key?: InputMaybe<Scalars['String']>;
  useOriginalId?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryMetaMyArgs = {
  key: Scalars['String'];
};


export type QueryMetasArgs = {
  key?: InputMaybe<Scalars['String']>;
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pagination?: InputMaybe<PaginationInput>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryMonitoringCentreCasesArgs = {
  attendingDoctorId?: InputMaybe<Scalars['UUID']>;
  caseStatusValue?: InputMaybe<Scalars['String']>;
  caseTypeCode?: InputMaybe<Scalars['String']>;
  caseTypeId?: InputMaybe<Scalars['UUID']>;
  caseTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<CaseCreateDay>;
  createdAtRange?: InputMaybe<DateFilter>;
  date?: InputMaybe<Scalars['Date']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  pagination?: InputMaybe<PaginationInput>;
  parentCaseTypeId?: InputMaybe<Scalars['UUID']>;
  patient?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  priorityId?: InputMaybe<Scalars['UUID']>;
  solved?: InputMaybe<Scalars['Boolean']>;
  solvedAtRange?: InputMaybe<DateFilter>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryMyActiveCasesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryMyActiveSubscriptionsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<SubscriptionType>;
};


export type QueryMyEventsArgs = {
  approaching?: InputMaybe<Scalars['Boolean']>;
  end?: InputMaybe<Scalars['DateTime']>;
  pagination?: InputMaybe<PaginationInput>;
  start?: InputMaybe<Scalars['DateTime']>;
};


export type QueryMyPhrasesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<MyPhrasesWhereInput>;
};


export type QueryMyWorkplacesArgs = {
  where?: InputMaybe<MyWorkplacesWhereInput>;
};


export type QueryNcziDoveraListArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryNcziEnumItemArgs = {
  code: Scalars['String'];
  oid: Scalars['String'];
};


export type QueryNcziEnumItemByAbbrArgs = {
  abbr: Scalars['String'];
  oid: Scalars['String'];
};


export type QueryNcziEnumItemsArgs = {
  code: Array<Scalars['String']>;
  oid: Scalars['String'];
};


export type QueryNcziExtensionItemArgs = {
  code: Scalars['String'];
  oid: Scalars['String'];
};


export type QueryNcziExtensionItemByAbbrArgs = {
  abbr: Scalars['String'];
  oid: Scalars['String'];
};


export type QueryNcziListDiagnosisArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryNcziListEnumItemsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  oid: Scalars['String'];
  pagination?: InputMaybe<PaginationInput>;
  version?: InputMaybe<Scalars['String']>;
  withParams?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNcziListExtensionItemsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  oid: Scalars['String'];
  pagination?: InputMaybe<PaginationInput>;
  vaccination?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNcziListMedicamentItemsArgs = {
  antibioticsChemotherapy?: InputMaybe<Scalars['Boolean']>;
  fulltext?: InputMaybe<Scalars['String']>;
  genericPrescription?: InputMaybe<Scalars['Boolean']>;
  multiplePrescription?: InputMaybe<Scalars['Boolean']>;
  opl?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  vaccination?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNcziListProductItemsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryNcziListQueueArgs = {
  userId: Scalars['String'];
};


export type QueryNcziMedicamentItemArgs = {
  code: Scalars['String'];
};


export type QueryNcziOupZsByPzsCodeArgs = {
  pzsCode: Scalars['String'];
};


export type QueryNcziProductItemArgs = {
  code: Scalars['String'];
};


export type QueryNotificationsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryNurseCasesArgs = {
  caseStatusValue?: InputMaybe<Scalars['String']>;
  caseTypeId?: InputMaybe<Scalars['UUID']>;
  caseTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  created?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdFrom?: InputMaybe<Scalars['DateTime']>;
  createdTo?: InputMaybe<Scalars['DateTime']>;
  doctor?: InputMaybe<Scalars['String']>;
  doctorId?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  patient?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryOrderStatisticsArgs = {
  where?: InputMaybe<OrderStatisticsWhereInput>;
};


export type QueryOrdersArgs = {
  filter?: InputMaybe<OrdersFilter>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryPatientArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryPatientCalculatorsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryPatientsArgs = {
  doctor?: InputMaybe<Scalars['String']>;
  fulltext?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootWorkplaceId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryPlaylistArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryPlaylistsArgs = {
  code?: InputMaybe<PlaylistCode>;
  pagination?: InputMaybe<PaginationInput>;
  type?: InputMaybe<PlaylistType>;
};


export type QueryPostsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryPrescriptionArgs = {
  id: Scalars['UUID'];
};


export type QueryPrescriptionItemsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  prescriptionId?: InputMaybe<Scalars['UUID']>;
};


export type QueryPrescriptionMedicamentArgs = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};


export type QueryPrescriptionMedicamentsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  tradeable?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPrescriptionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryProductArgs = {
  code: Scalars['String'];
};


export type QueryProductsArgs = {
  productGroup: Scalars['String'];
};


export type QueryQuestionnaireArgs = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  userSubscriptionId?: InputMaybe<Scalars['UUID']>;
};


export type QueryQuestionnaireResultItemsArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
  questionKey?: InputMaybe<Scalars['String']>;
  questionKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  questionnaireCode?: InputMaybe<Scalars['String']>;
  questionnaireId?: InputMaybe<Scalars['UUID']>;
  questionnaireResultId?: InputMaybe<Scalars['UUID']>;
};


export type QueryQuestionnaireResultsArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  doctorIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  excludeQuestionnaireCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fulltext?: InputMaybe<Scalars['String']>;
  hideMemberHidden?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  module?: InputMaybe<QuestionnaireModule>;
  onlyPatient?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
  questionnaire?: InputMaybe<Scalars['String']>;
  questionnaireCode?: InputMaybe<Scalars['String']>;
  questionnaireCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  questionnaireId?: InputMaybe<Scalars['UUID']>;
  result?: InputMaybe<QuestionnaireResultResult>;
  scheduledById?: InputMaybe<Scalars['UUID']>;
  scheduledByIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  seen?: InputMaybe<Scalars['Boolean']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryQuestionnaireScheduleArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  questionnaireId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryQuestionnaireSchedulesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  parentQuestionnaireCode?: InputMaybe<Scalars['String']>;
  parentQuestionnaireScheduleId?: InputMaybe<Scalars['UUID']>;
  questionnaire?: InputMaybe<Scalars['String']>;
  questionnaireId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryQuestionnairesArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  module?: InputMaybe<QuestionnaireModule>;
  parentQuestionnaireId?: InputMaybe<Scalars['UUID']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryRatingArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryRatingsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<RatingsWhereInput>;
};


export type QueryRootWorkplaceDoctorsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  includeNurses?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryRootWorkplacesPatientArgs = {
  originalId?: InputMaybe<Scalars['UUID']>;
  pagination?: InputMaybe<PaginationInput>;
  rootWorkplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryServiceSchedulesArgs = {
  from?: InputMaybe<Scalars['DateTime']>;
  includeOccurrences?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  to?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<ServiceScheduleType>;
  types?: InputMaybe<Array<InputMaybe<ServiceScheduleType>>>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QuerySubscriptionArgs = {
  id?: InputMaybe<Scalars['ID']>;
  redeemCode?: InputMaybe<Scalars['String']>;
  subscriptionOfferId?: InputMaybe<Scalars['UUID']>;
};


export type QuerySubscriptionOffersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QuerySubscriptionPaymentMethodsArgs = {
  subscriptionOrder?: InputMaybe<PaySubscriptionInput>;
};


export type QuerySubscriptionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryTermItemArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryTermItemByValueArgs = {
  termType: Scalars['String'];
  value: Scalars['String'];
};


export type QueryTermItemsArgs = {
  filter?: InputMaybe<TermItemsFilter>;
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  termType?: InputMaybe<Scalars['String']>;
};


export type QueryTermsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryTokenArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryTokensArgs = {
  pagination?: InputMaybe<PaginationInput>;
  type?: InputMaybe<TokenType>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryTransmiseListArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: TransmiseListWhereInput;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryUserConsentsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<UserConsentsWhereInput>;
};


export type QueryUserDekurzesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryUserFilterArgs = {
  key: Scalars['String'];
};


export type QueryUserHealthCategoriesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryUserHealthCategoryPermissionsArgs = {
  healthCategoryId?: InputMaybe<Scalars['UUID']>;
  pagination?: InputMaybe<PaginationInput>;
  permissionId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryUserMedicationLastedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: UserMedicationLastedWhereInput;
};


export type QueryUserNotificationSettingsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: UserNotificationSettingsWhereInput;
};


export type QueryUsersArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryWizardArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  key?: InputMaybe<Scalars['String']>;
};


export type QueryWizardItemArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  key?: InputMaybe<Scalars['String']>;
};


export type QueryWizardItemsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  wizardKey?: InputMaybe<Scalars['String']>;
};


export type QueryWizardResultArgs = {
  where?: InputMaybe<WizardResultWhereInput>;
};


export type QueryWizardResultItemsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<WizardResultItemsWhereInput>;
};


export type QueryWizardResultsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<WizardResultsWhereInput>;
};


export type QueryWizardTreeArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  key?: InputMaybe<Scalars['String']>;
};


export type QueryWizardsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryWorkplaceArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryWorkplaceAclRolesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<WorkplaceAclRoleWhereInput>;
};


export type QueryWorkplaceAddressArgs = {
  where?: InputMaybe<WorkplaceAddressWhereInput>;
};


export type QueryWorkplaceCaseTypeArgs = {
  caseTypeCode?: InputMaybe<Scalars['String']>;
  caseTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryWorkplaceCaseTypesArgs = {
  caseTypeTypes?: InputMaybe<Array<InputMaybe<CaseTypeType>>>;
  fulltext?: InputMaybe<Scalars['String']>;
  hiddenForPatient?: InputMaybe<Scalars['Boolean']>;
  onlyRootCaseTypes?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  parentCaseTypeId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryWorkplaceCaseTypesDoctorArgs = {
  caseTypeTypes?: InputMaybe<Array<InputMaybe<CaseTypeType>>>;
  pagination?: InputMaybe<PaginationInput>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryWorkplaceCasesArgs = {
  caseTypeId?: InputMaybe<Scalars['UUID']>;
  caseTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdFrom?: InputMaybe<Scalars['DateTime']>;
  createdTo?: InputMaybe<Scalars['DateTime']>;
  doctorNull?: InputMaybe<Scalars['Boolean']>;
  onlyVisible?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  patient?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryWorkplaceCasesArchivedArgs = {
  caseTypeId?: InputMaybe<Scalars['UUID']>;
  caseTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  solvedAt?: InputMaybe<CaseSolvedMonth>;
  solvedAtRange?: InputMaybe<DateFilter>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryWorkplaceCertificatesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: WorkplaceCertificatesWhereInput;
};


export type QueryWorkplaceDoctorsArgs = {
  approved?: InputMaybe<Scalars['Boolean']>;
  doctorIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fulltext?: InputMaybe<Scalars['String']>;
  healthPlanCode?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  roleKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryWorkplaceEventsArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  pagination?: InputMaybe<PaginationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
  take?: InputMaybe<Scalars['Int']>;
  types?: InputMaybe<Array<InputMaybe<EventType>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryWorkplaceHealthPlansArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryWorkplaceInsuranceBatchsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: WorkplaceInsuranceBatchsWhereInput;
};


export type QueryWorkplaceMemberArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryWorkplaceMembersArgs = {
  approved?: InputMaybe<Scalars['Boolean']>;
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootWorkplaceId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryWorkplacePatientDocumentationFilesArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  fulltext?: InputMaybe<Scalars['String']>;
  grouped?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
  seen?: InputMaybe<Scalars['Boolean']>;
  unprocessed?: InputMaybe<Scalars['Boolean']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryWorkplacePatientPendingArgs = {
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
};


export type QueryWorkplacePatientsArgs = {
  doctor?: InputMaybe<Scalars['String']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  fulltext?: InputMaybe<Scalars['String']>;
  healthPlanIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  insuranceCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  insuranceCompanyName?: InputMaybe<Scalars['String']>;
  insuranceType?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  status?: InputMaybe<WorkplacePatientStatus>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryWorkplacesArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  hideHidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  managed?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
  rootWorkplaceId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

export type Questionnaire = {
  __typename?: 'Questionnaire';
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mainQuestionnaireId?: Maybe<Scalars['UUID']>;
  module?: Maybe<QuestionnaireModule>;
  partnerId?: Maybe<Scalars['Int']>;
  questionnaireItems?: Maybe<Array<Maybe<QuestionnaireItem>>>;
  settings?: Maybe<Scalars['JSONObject']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type QuestionnaireItem = {
  __typename?: 'QuestionnaireItem';
  childQuestionnaireItems?: Maybe<Array<Maybe<QuestionnaireItem>>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  parentQuestionnaireItem?: Maybe<QuestionnaireItem>;
  placeholder?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  questionnaire?: Maybe<Questionnaire>;
  questionnaireId?: Maybe<Scalars['ID']>;
  subtitle?: Maybe<Scalars['String']>;
  subtype?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<QuestionnaireItemType>;
  value?: Maybe<Scalars['String']>;
};

export enum QuestionnaireItemSubtype {
  Checkbox = 'CHECKBOX',
  CheckboxList = 'CHECKBOX_LIST',
  Radio = 'RADIO',
  RadioList = 'RADIO_LIST',
  ScaleList = 'SCALE_LIST',
  Text = 'TEXT',
  Textarea = 'TEXTAREA'
}

export enum QuestionnaireItemType {
  Answer = 'ANSWER',
  Item = 'ITEM',
  OnSelect = 'ON_SELECT',
  OnSubmit = 'ON_SUBMIT',
  Question = 'QUESTION',
  Rule = 'RULE'
}

export enum QuestionnaireModule {
  Diabetes = 'DIABETES',
  Kdar = 'KDAR',
  Meddibaby = 'MEDDIBABY',
  Oncology = 'ONCOLOGY',
  Palliative = 'PALLIATIVE',
  Therapist = 'THERAPIST'
}

export type QuestionnaireResult = {
  __typename?: 'QuestionnaireResult';
  createdAt?: Maybe<Scalars['DateTime']>;
  healthPlan?: Maybe<HealthPlan>;
  healthPlanId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  isHidden?: Maybe<Scalars['Boolean']>;
  isSeen?: Maybe<Scalars['Boolean']>;
  isSeenMarkedBy?: Maybe<User>;
  isSeenMarkedById?: Maybe<Scalars['UUID']>;
  questionnaire?: Maybe<Questionnaire>;
  questionnaireId?: Maybe<Scalars['UUID']>;
  questionnaireResultItems?: Maybe<Array<Maybe<QuestionnaireResultItem>>>;
  result?: Maybe<Scalars['JSONObject']>;
  scheduledBy?: Maybe<User>;
  scheduledById?: Maybe<Scalars['UUID']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type QuestionnaireResultItem = {
  __typename?: 'QuestionnaireResultItem';
  answer?: Maybe<QuestionnaireItem>;
  answerId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  question?: Maybe<QuestionnaireItem>;
  questionId?: Maybe<Scalars['UUID']>;
  questionnaireResult?: Maybe<QuestionnaireResult>;
  questionnaireResultId?: Maybe<Scalars['UUID']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  valueJson?: Maybe<Scalars['JSONObject']>;
};

export type QuestionnaireResultItemsResult = {
  __typename?: 'QuestionnaireResultItemsResult';
  data?: Maybe<Array<Maybe<QuestionnaireResultItem>>>;
  meta?: Maybe<PageInfo>;
};

export type QuestionnaireResultMember = {
  __typename?: 'QuestionnaireResultMember';
  hidden?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  questionnaireResultId?: Maybe<Scalars['UUID']>;
  seen?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['UUID']>;
};

export enum QuestionnaireResultResult {
  NoRisk = 'NO_RISK',
  NoRiskOfMentalDecompensation = 'NO_RISK_OF_MENTAL_DECOMPENSATION',
  SignificantRisk = 'SIGNIFICANT_RISK',
  SignificantRiskOfMentalDecompensation = 'SIGNIFICANT_RISK_OF_MENTAL_DECOMPENSATION',
  SignificantRiskOfSuicide = 'SIGNIFICANT_RISK_OF_SUICIDE'
}

export type QuestionnaireResultsResult = {
  __typename?: 'QuestionnaireResultsResult';
  data?: Maybe<Array<Maybe<QuestionnaireResult>>>;
  meta?: Maybe<PageInfo>;
};

export type QuestionnaireSchedule = {
  __typename?: 'QuestionnaireSchedule';
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  frequencyText?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  questionnaire?: Maybe<Questionnaire>;
  questionnaireId?: Maybe<Scalars['UUID']>;
  questionnaireItem?: Maybe<QuestionnaireItem>;
  repeatHours?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type QuestionnaireSchedulesResult = {
  __typename?: 'QuestionnaireSchedulesResult';
  data?: Maybe<Array<Maybe<QuestionnaireSchedule>>>;
  meta?: Maybe<PageInfo>;
};

export type QuestionnairesResult = {
  __typename?: 'QuestionnairesResult';
  data?: Maybe<Array<Maybe<Questionnaire>>>;
  meta?: Maybe<PageInfo>;
};

export type Rating = {
  __typename?: 'Rating';
  case?: Maybe<Case>;
  caseId?: Maybe<Scalars['UUID']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  stars?: Maybe<Scalars['Float']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<RatingType>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export enum RatingType {
  Default = 'DEFAULT',
  Stars = 'STARS'
}

export type RatingsResult = {
  __typename?: 'RatingsResult';
  data?: Maybe<Array<Maybe<Rating>>>;
  meta?: Maybe<PageInfo>;
};

export type RatingsWhereInput = {
  type?: InputMaybe<RatingType>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type ReAssignCaseInput = {
  caseId: Scalars['UUID'];
  note?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceMemberId?: InputMaybe<Scalars['UUID']>;
};

export type ReactivateSubscriptionInput = {
  paymentMethod?: InputMaybe<Scalars['String']>;
  userSubscriptionId?: InputMaybe<Scalars['String']>;
};

export type ReadDashboardMessageInput = {
  messageId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

export type RemoveHealthPlanWorkplaceInput = {
  healthPlanId: Scalars['UUID'];
  workplaceId: Scalars['UUID'];
};

export type RemoveUserSubscriptionMemberInput = {
  id?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  userSubscriptionId?: InputMaybe<Scalars['UUID']>;
};

export type RequestPaymentHealthPlanUserInput = {
  healthPlanUserId: Scalars['UUID'];
};

export type SaveLaboratoryRequisitionResultInput = {
  addToPatientECard: Scalars['Boolean'];
  data: Array<LaboratoryDataInput>;
  document: LaboratoryDocumentInput;
  patient: LaboratoryPatientInput;
  requisitionId: Scalars['UUID'];
  userId: Scalars['UUID'];
  workplaceId: Scalars['UUID'];
};

export type SaveNcziDoveraResultInput = {
  birthNumber: Scalars['String'];
  verified: Scalars['Boolean'];
};

export type ServiceSchedule = {
  __typename?: 'ServiceSchedule';
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  note?: Maybe<Scalars['String']>;
  serviceScheduleItems?: Maybe<Array<Maybe<ServiceScheduleItem>>>;
  type?: Maybe<ServiceScheduleType>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type ServiceScheduleItem = {
  __typename?: 'ServiceScheduleItem';
  canBook?: Maybe<Scalars['Boolean']>;
  canBookOnSite?: Maybe<Scalars['Boolean']>;
  canBookOnline?: Maybe<Scalars['Boolean']>;
  canOrderImmediate?: Maybe<Scalars['Boolean']>;
  day?: Maybe<DayShortEnum>;
  id: Scalars['UUID'];
  interval?: Maybe<Scalars['Int']>;
  occurrences?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  price?: Maybe<Price>;
  priceId?: Maybe<Scalars['UUID']>;
  repeatable?: Maybe<Scalars['Boolean']>;
  serviceSchedule?: Maybe<ServiceSchedule>;
  serviceScheduleId?: Maybe<Scalars['UUID']>;
  serviceScheduleItemCaseTypes?: Maybe<Array<Maybe<ServiceScheduleItemCaseType>>>;
  serviceScheduleItemMembers?: Maybe<Array<Maybe<ServiceScheduleItemMember>>>;
  timeFrom?: Maybe<Scalars['Time']>;
  timeTo?: Maybe<Scalars['Time']>;
};


export type ServiceScheduleItemOccurrencesArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export type ServiceScheduleItemCaseType = {
  __typename?: 'ServiceScheduleItemCaseType';
  id?: Maybe<Scalars['UUID']>;
  serviceScheduleItem?: Maybe<ServiceScheduleItem>;
  serviceScheduleItemId?: Maybe<Scalars['UUID']>;
  workplaceCaseType?: Maybe<WorkplaceCaseType>;
  workplaceCaseTypeId?: Maybe<Scalars['UUID']>;
};

export type ServiceScheduleItemMember = {
  __typename?: 'ServiceScheduleItemMember';
  id?: Maybe<Scalars['UUID']>;
  serviceScheduleItem?: Maybe<ServiceScheduleItem>;
  serviceScheduleItemId?: Maybe<Scalars['UUID']>;
  workplaceMember?: Maybe<WorkplaceMember>;
  workplaceMemberId?: Maybe<Scalars['UUID']>;
};

export type ServiceScheduleItemsResult = {
  __typename?: 'ServiceScheduleItemsResult';
  data?: Maybe<Array<Maybe<ServiceScheduleItem>>>;
  meta?: Maybe<PageInfo>;
};

export enum ServiceScheduleType {
  Default = 'DEFAULT',
  OnlineConnect = 'ONLINE_CONNECT',
  OnlineOrder = 'ONLINE_ORDER',
  Shift = 'SHIFT',
  ShiftExtra = 'SHIFT_EXTRA'
}

export type ServiceSchedulesResult = {
  __typename?: 'ServiceSchedulesResult';
  data?: Maybe<Array<Maybe<ServiceSchedule>>>;
  meta?: Maybe<PageInfo>;
};

export type SetUserNotificationSettingInput = {
  sending: Scalars['Boolean'];
  typeTermItemId: Scalars['UUID'];
};

export type SubmitQuestionnaireResultInput = {
  addToPatientECard?: InputMaybe<Scalars['Boolean']>;
  data?: InputMaybe<Scalars['JSONObject']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  ingestion?: InputMaybe<Scalars['JSONArray']>;
  questionnaireCode?: InputMaybe<Scalars['String']>;
  questionnaireId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  values?: InputMaybe<Array<InputMaybe<SubmitQuestionnaireResultValueInput>>>;
};

export type SubmitQuestionnaireResultValueInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
  valueJson?: InputMaybe<Scalars['JSONObject']>;
};

export type SubmitWizardResult = {
  __typename?: 'SubmitWizardResult';
  id?: Maybe<Scalars['UUID']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  descriptionShort?: Maybe<Scalars['String']>;
  featuredImage?: Maybe<Scalars['String']>;
  featuredLogo?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isFamily?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  nameShort?: Maybe<Scalars['String']>;
  redeemCodeRequired?: Maybe<Scalars['Boolean']>;
  subscriptionItems?: Maybe<Array<Maybe<SubscriptionItem>>>;
  subscriptionPeriods?: Maybe<Array<Maybe<SubscriptionPeriod>>>;
  theme?: Maybe<Scalars['String']>;
};

export type SubscriptionChangePaymentMethodInput = {
  paymentMethod: OrderPaymentMethod;
  userSubscriptionId: Scalars['UUID'];
};

export type SubscriptionGroup = {
  __typename?: 'SubscriptionGroup';
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
};

export type SubscriptionItem = {
  __typename?: 'SubscriptionItem';
  extra?: Maybe<Scalars['JSONObject']>;
  id: Scalars['ID'];
  type: SubscriptionItemType;
};

export enum SubscriptionItemType {
  Acl = 'ACL',
  ActivateSubscriptionRedeemCode = 'ACTIVATE_SUBSCRIPTION_REDEEM_CODE',
  AddMeddiCredit = 'ADD_MEDDI_CREDIT',
  AdultCount = 'ADULT_COUNT',
  AutoSyncFamily = 'AUTO_SYNC_FAMILY',
  BioScanPlus = 'BIO_SCAN_PLUS',
  BioScanPlusToken = 'BIO_SCAN_PLUS_TOKEN',
  BioScanPlusTokenUnlimited = 'BIO_SCAN_PLUS_TOKEN_UNLIMITED',
  BioScanToken = 'BIO_SCAN_TOKEN',
  BioScanTokenRefresh = 'BIO_SCAN_TOKEN_REFRESH',
  BioScanTokenUnlimited = 'BIO_SCAN_TOKEN_UNLIMITED',
  CaseWorkplaceDoctor = 'CASE_WORKPLACE_DOCTOR',
  ChildCount = 'CHILD_COUNT',
  ConnectDoctor = 'CONNECT_DOCTOR',
  CreateCaseImmediatePay = 'CREATE_CASE_IMMEDIATE_PAY',
  CreateCaseImmediatePayToken = 'CREATE_CASE_IMMEDIATE_PAY_TOKEN',
  CreateCaseWizard = 'CREATE_CASE_WIZARD',
  CreateRequiredUserAction = 'CREATE_REQUIRED_USER_ACTION',
  CreateWorkplaceMember = 'CREATE_WORKPLACE_MEMBER',
  Description = 'DESCRIPTION',
  EmailVerified = 'EMAIL_VERIFIED',
  FamilyAddChild = 'FAMILY_ADD_CHILD',
  FirstMonthFree = 'FIRST_MONTH_FREE',
  HealthPlanFree = 'HEALTH_PLAN_FREE',
  ImmediatePayCustom = 'IMMEDIATE_PAY_CUSTOM',
  ImmediatePayFreeSubscription = 'IMMEDIATE_PAY_FREE_SUBSCRIPTION',
  IsFamily = 'IS_FAMILY',
  ProductBioscanToken = 'PRODUCT_BIOSCAN_TOKEN',
  ProductBioscanTokenSale = 'PRODUCT_BIOSCAN_TOKEN_SALE',
  RemoveProduct = 'REMOVE_PRODUCT',
  RemoveUserSubscriptions = 'REMOVE_USER_SUBSCRIPTIONS',
  SetPartner = 'SET_PARTNER',
  SkipCanCreateCase = 'SKIP_CAN_CREATE_CASE',
  SubscriptionAvailability = 'SUBSCRIPTION_AVAILABILITY',
  SubscriptionSale = 'SUBSCRIPTION_SALE',
  WellbeingConnectDoctorToken = 'WELLBEING_CONNECT_DOCTOR_TOKEN'
}

export type SubscriptionOffer = {
  __typename?: 'SubscriptionOffer';
  description?: Maybe<Scalars['String']>;
  extra?: Maybe<Scalars['JSONObject']>;
  id?: Maybe<Scalars['UUID']>;
  imageUrl?: Maybe<Scalars['String']>;
  price?: Maybe<Price>;
  priceSale?: Maybe<Price>;
  priceSuffix?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<SubscriptionOfferType>;
};

export enum SubscriptionOfferType {
  BioScan = 'BIO_SCAN',
  Subscription = 'SUBSCRIPTION'
}

export type SubscriptionOffersResult = {
  __typename?: 'SubscriptionOffersResult';
  data?: Maybe<Array<Maybe<SubscriptionOffer>>>;
  meta?: Maybe<PageInfo>;
};

export type SubscriptionOrder = {
  __typename?: 'SubscriptionOrder';
  redirectUrl?: Maybe<Scalars['String']>;
};

export type SubscriptionPeriod = {
  __typename?: 'SubscriptionPeriod';
  discount?: Maybe<PriceDiscount>;
  id: Scalars['ID'];
  period?: Maybe<Scalars['Int']>;
  price?: Maybe<Price>;
  translations?: Maybe<Scalars['JSONObject']>;
  type: SubscriptionPeriodType;
};

export enum SubscriptionPeriodType {
  Day = 'DAY',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Sixmonths = 'SIXMONTHS',
  Unlimited = 'UNLIMITED',
  UntilDate = 'UNTIL_DATE',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type SubscriptionRedeemCode = {
  __typename?: 'SubscriptionRedeemCode';
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  subscription?: Maybe<Subscription>;
  subscriptionId?: Maybe<Scalars['UUID']>;
};

export enum SubscriptionType {
  RedeemCode = 'REDEEM_CODE',
  Subscription = 'SUBSCRIPTION'
}

export type SubscriptionsResult = {
  __typename?: 'SubscriptionsResult';
  data?: Maybe<Array<Maybe<Subscription>>>;
  meta?: Maybe<PageInfo>;
};

export type SyncStatus = {
  __typename?: 'SyncStatus';
  createdAt?: Maybe<Scalars['DateTime']>;
  resourceType?: Maybe<Scalars['String']>;
  state?: Maybe<SyncStatusState>;
};

export enum SyncStatusState {
  Error = 'ERROR',
  Finished = 'FINISHED',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN'
}

export type Term = {
  __typename?: 'Term';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  termItems?: Maybe<Array<Maybe<TermItem>>>;
  type?: Maybe<Scalars['String']>;
};

export type TermItem = {
  __typename?: 'TermItem';
  data?: Maybe<Scalars['JSONObject']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  term?: Maybe<Term>;
  termId?: Maybe<Scalars['ID']>;
  value?: Maybe<Scalars['String']>;
  value2?: Maybe<Scalars['String']>;
  value3?: Maybe<Scalars['String']>;
};

export type TermItemsFilter = {
  value2?: InputMaybe<Scalars['String']>;
};

export type TermItemsResult = {
  __typename?: 'TermItemsResult';
  data?: Maybe<Array<Maybe<TermItem>>>;
  meta?: Maybe<PageInfo>;
};

export type TermsResult = {
  __typename?: 'TermsResult';
  data?: Maybe<Array<Maybe<Term>>>;
  meta?: Maybe<PageInfo>;
};

export enum ThemeEnum {
  Blue = 'blue',
  Bronze = 'bronze',
  Orange = 'orange'
}

export type Token = {
  __typename?: 'Token';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<TokenType>;
  userId?: Maybe<Scalars['UUID']>;
};

export enum TokenType {
  Api = 'API',
  EmailVerification = 'EMAIL_VERIFICATION',
  Ingestion = 'INGESTION'
}

export type TokensResult = {
  __typename?: 'TokensResult';
  data?: Maybe<Array<Maybe<Token>>>;
  meta?: Maybe<PageInfo>;
};

export type TransactionOrder = {
  __typename?: 'TransactionOrder';
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  issueDate?: Maybe<Scalars['DateTime']>;
  items?: Maybe<Array<Maybe<TransactionOrderItem>>>;
  paymentMethod?: Maybe<OrderPaymentMethod>;
  status?: Maybe<Scalars['String']>;
  totalPrice?: Maybe<TransactionPrice>;
};

export type TransactionOrderItem = {
  __typename?: 'TransactionOrderItem';
  price?: Maybe<TransactionPrice>;
  priceVat?: Maybe<TransactionPrice>;
  priceWithoutVat?: Maybe<TransactionPrice>;
  quantity?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
};

export type TransactionPrice = {
  __typename?: 'TransactionPrice';
  currency?: Maybe<Scalars['String']>;
  decimals?: Maybe<Scalars['Int']>;
  formattedPrice?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Decimal']>;
  priceWithVat?: Maybe<Scalars['Decimal']>;
  priceWithVatRaw?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
  vatRate?: Maybe<Scalars['Int']>;
};

export type Translation = {
  __typename?: 'Translation';
  key?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type TransmiseDocument = {
  __typename?: 'TransmiseDocument';
  date?: Maybe<Scalars['DateTime']>;
  diagnosis?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  workplace?: Maybe<Scalars['String']>;
};

export type TransmiseListResult = {
  __typename?: 'TransmiseListResult';
  data?: Maybe<Array<Maybe<TransmiseDocument>>>;
  meta?: Maybe<PageInfo>;
};

export type TransmiseListWhereInput = {
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  doctorId?: InputMaybe<Scalars['UUID']>;
  userId: Scalars['UUID'];
  workplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

export type UpdateDocumentationFolderInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateInsuranceReportInput = {
  birthNumber?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['Int']>;
  diagnosis?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['UUID']>;
  extra?: InputMaybe<Scalars['JSON']>;
  insuranceId?: InputMaybe<Scalars['UUID']>;
  operationId?: InputMaybe<Scalars['UUID']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  points?: InputMaybe<Scalars['Int']>;
};

export type UpdateNoteInput = {
  id: Scalars['UUID'];
  text: Scalars['String'];
};

export type UpdatePhraseInput = {
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PhraseType>;
  value?: InputMaybe<Scalars['String']>;
};

export type UpdateUserConsentInput = {
  value: UserConsentValue;
};

export type UpdateUserMedicationLastedDataInput = {
  data: Scalars['JSON'];
};

export type UpdateUserMedicationLastedWhereInput = {
  id: Scalars['UUID'];
};

export type UpdateWorkplaceMemberInput = {
  id?: InputMaybe<Scalars['UUID']>;
  isSpecialist?: InputMaybe<Scalars['Boolean']>;
  memberSearchableOutside?: InputMaybe<Scalars['Boolean']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateWorkplaceMembersInput = {
  workplaceMembers?: InputMaybe<Array<InputMaybe<UpdateWorkplaceMemberInput>>>;
};

export type User = {
  __typename?: 'User';
  approved?: Maybe<Scalars['Boolean']>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  avatarFile?: Maybe<File>;
  avatarUrl?: Maybe<Scalars['String']>;
  badge?: Maybe<Badge>;
  certificates?: Maybe<Array<Maybe<Certificate>>>;
  consentProvider?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  csszResult?: Maybe<Scalars['JSONObject']>;
  details?: Maybe<UserDetails>;
  email?: Maybe<Scalars['String']>;
  events?: Maybe<Array<Maybe<Event>>>;
  expiredSubscriptions?: Maybe<Array<Maybe<UserSubscription>>>;
  firstLogin?: Maybe<Scalars['Boolean']>;
  formattedGender?: Maybe<Scalars['String']>;
  formattedPhoneNumber?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  hasMeddi?: Maybe<Scalars['Boolean']>;
  healthCard?: Maybe<HealthCard>;
  id: Scalars['ID'];
  ingestionUrl?: Maybe<Scalars['String']>;
  insuranceCardBackThumbnailUrl?: Maybe<Scalars['String']>;
  insuranceCardBackUrl?: Maybe<Scalars['String']>;
  insuranceCardFrontThumbnailUrl?: Maybe<Scalars['String']>;
  insuranceCardFrontUrl?: Maybe<Scalars['String']>;
  invitations?: Maybe<Array<Maybe<UserInvitation>>>;
  isChild?: Maybe<Scalars['Boolean']>;
  isDoctor?: Maybe<Scalars['Boolean']>;
  isPatient?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  localCitizenship?: Maybe<Scalars['Boolean']>;
  memberOf?: Maybe<Array<Maybe<Badge>>>;
  memberOfDoctor?: Maybe<Array<Maybe<Badge>>>;
  meta?: Maybe<Array<Maybe<Meta>>>;
  metaTranslation?: Maybe<Array<Maybe<MetaTranslation>>>;
  nickname?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  originalId?: Maybe<Scalars['UUID']>;
  originalUser?: Maybe<User>;
  parents?: Maybe<Array<Maybe<User>>>;
  partner?: Maybe<Scalars['String']>;
  partnerIdentifier?: Maybe<Scalars['String']>;
  partnerTag?: Maybe<UserPartnerTag>;
  phoneNumber?: Maybe<Scalars['String']>;
  profile?: Maybe<Profile>;
  profileImageUrl?: Maybe<Scalars['String']>;
  rootWorkplace?: Maybe<Workplace>;
  rootWorkplaceMemberStatus?: Maybe<Scalars['String']>;
  termItems?: Maybe<Array<Maybe<TermItem>>>;
  userConsent?: Maybe<UserConsent>;
  userNumber?: Maybe<UserNumber>;
  userRating?: Maybe<UserRating>;
  userRelations?: Maybe<Array<Maybe<UserRelation>>>;
  vzpRegisteredDoctorsResult?: Maybe<Scalars['JSONObject']>;
  vzpResult?: Maybe<Scalars['JSONObject']>;
  workplace?: Maybe<Workplace>;
  workplaceMember?: Maybe<WorkplaceMember>;
  workplaceMembers?: Maybe<Array<Maybe<WorkplaceMember>>>;
};


export type UserEventsArgs = {
  metaKey?: InputMaybe<Scalars['String']>;
  metaKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useOriginalId?: InputMaybe<Scalars['Boolean']>;
};


export type UserMetaArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useOriginalId?: InputMaybe<Scalars['Boolean']>;
};


export type UserMetaTranslationArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UserUserNumberArgs = {
  by?: InputMaybe<UserNumberBy>;
};


export type UserUserRelationsArgs = {
  type?: InputMaybe<UserRelationType>;
  useOriginalId?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type UserWorkplaceMemberArgs = {
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type UserConsent = {
  __typename?: 'UserConsent';
  canceledAt?: Maybe<Scalars['DateTime']>;
  confirmedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  documentationFile?: Maybe<DocumentationFile>;
  extra?: Maybe<Scalars['JSON']>;
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  type: UserConsentType;
  userId: Scalars['UUID'];
  value: UserConsentValue;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export enum UserConsentType {
  InformedConsent = 'INFORMED_CONSENT'
}

export enum UserConsentValue {
  Canceled = 'CANCELED',
  Confirmed = 'CONFIRMED',
  Sent = 'SENT'
}

export type UserConsentsResult = {
  __typename?: 'UserConsentsResult';
  data?: Maybe<Array<Maybe<UserConsent>>>;
  meta?: Maybe<PageInfo>;
};

export type UserConsentsWhereInput = {
  id?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<UserConsentType>;
  userId?: InputMaybe<Scalars['UUID']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type UserDekurz = {
  __typename?: 'UserDekurz';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  user?: Maybe<User>;
  userDekurzItems?: Maybe<Array<Maybe<UserDekurzItem>>>;
  userId?: Maybe<Scalars['UUID']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type UserDekurzItem = {
  __typename?: 'UserDekurzItem';
  id: Scalars['UUID'];
  medicalReport?: Maybe<MedicalReport>;
  medicalReportId?: Maybe<Scalars['UUID']>;
  type?: Maybe<UserDekurzItemType>;
  userDekurz?: Maybe<UserDekurz>;
  userDekurzId?: Maybe<Scalars['UUID']>;
};

export enum UserDekurzItemType {
  MedicalReport = 'MEDICAL_REPORT'
}

export type UserDekurzesResult = {
  __typename?: 'UserDekurzesResult';
  data?: Maybe<Array<Maybe<UserDekurz>>>;
  meta?: Maybe<PageInfo>;
};

export type UserDetails = {
  __typename?: 'UserDetails';
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  salutationAfter?: Maybe<Scalars['String']>;
  salutationBefore?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserFilterInput = {
  data: Scalars['JSONObject'];
  key: Scalars['String'];
};

export type UserHealthCategoriesResult = {
  __typename?: 'UserHealthCategoriesResult';
  data?: Maybe<Array<Maybe<UserHealthCategory>>>;
  meta?: Maybe<PageInfo>;
};

export type UserHealthCategory = {
  __typename?: 'UserHealthCategory';
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type UserHealthCategoryPermission = {
  __typename?: 'UserHealthCategoryPermission';
  healthCategory?: Maybe<UserHealthCategory>;
  healthCategoryId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['UUID']>;
  permission?: Maybe<TermItem>;
  permissionId?: Maybe<Scalars['UUID']>;
};

export type UserHealthCategoryPermissionInput = {
  healthCategoryId?: InputMaybe<Scalars['UUID']>;
  permissionId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type UserHealthCategoryPermissionsResult = {
  __typename?: 'UserHealthCategoryPermissionsResult';
  data?: Maybe<Array<Maybe<UserHealthCategoryPermission>>>;
  meta?: Maybe<PageInfo>;
};

export type UserInvitation = {
  __typename?: 'UserInvitation';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  declinedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<UserInvitationStatus>;
  used?: Maybe<Scalars['Boolean']>;
};

export enum UserInvitationStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type UserMedicationLasted = {
  __typename?: 'UserMedicationLasted';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  data: Scalars['JSON'];
  id: Scalars['UUID'];
  user?: Maybe<User>;
  userId: Scalars['UUID'];
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type UserMedicationLastedResult = {
  __typename?: 'UserMedicationLastedResult';
  data: Array<UserMedicationLasted>;
  meta?: Maybe<PageInfo>;
};

export type UserMedicationLastedWhereInput = {
  userId: Scalars['UUID'];
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type UserMetaTranslationInput = {
  key?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

export type UserNotice = {
  __typename?: 'UserNotice';
  activeCasesCount?: Maybe<Scalars['Int']>;
  futureEventsCount?: Maybe<Scalars['Int']>;
  openQuestionnairesCount?: Maybe<Scalars['Int']>;
  unreadCaseEntries?: Maybe<Scalars['Int']>;
  unreadEducationMaterialsCount?: Maybe<Scalars['Int']>;
  unreadNotifications?: Maybe<Scalars['Int']>;
  unreadPrescriptions?: Maybe<Scalars['Int']>;
};

export type UserNotificationSetting = {
  __typename?: 'UserNotificationSetting';
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  sending: Scalars['Boolean'];
  typeTermItem?: Maybe<TermItem>;
  typeTermItemId: Scalars['UUID'];
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

export type UserNotificationSettingsResult = {
  __typename?: 'UserNotificationSettingsResult';
  data?: Maybe<Array<Maybe<UserNotificationSetting>>>;
  meta?: Maybe<PageInfo>;
};

export type UserNotificationSettingsWhereInput = {
  userId?: InputMaybe<Scalars['UUID']>;
};

export type UserNumber = {
  __typename?: 'UserNumber';
  birthNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['UUID']>;
};

export enum UserNumberBy {
  BirthNumber = 'BIRTH_NUMBER',
  Number = 'NUMBER'
}

export type UserPartnerTag = {
  __typename?: 'UserPartnerTag';
  title?: Maybe<Scalars['String']>;
};

export type UserRating = {
  __typename?: 'UserRating';
  avgStar?: Maybe<Scalars['Float']>;
};

export type UserRelation = {
  __typename?: 'UserRelation';
  id?: Maybe<Scalars['Int']>;
  relationUser?: Maybe<User>;
  relationUserId?: Maybe<Scalars['UUID']>;
  type?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export enum UserRelationType {
  PatientDoctor = 'PATIENT_DOCTOR'
}

export type UserSubscription = {
  __typename?: 'UserSubscription';
  activeFrom: Scalars['DateTime'];
  activeTo?: Maybe<Scalars['DateTime']>;
  availability?: Maybe<UserSubscriptionAvailability>;
  canAddMember?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isOwner?: Maybe<Scalars['Boolean']>;
  members?: Maybe<Array<Maybe<UserSubscriptionMember>>>;
  price?: Maybe<Price>;
  redeemCode?: Maybe<Scalars['String']>;
  subscription?: Maybe<Subscription>;
  subscriptionPeriod?: Maybe<SubscriptionPeriod>;
};

export type UserSubscriptionAvailability = {
  __typename?: 'UserSubscriptionAvailability';
  addAdultMember?: Maybe<Scalars['Boolean']>;
  addChildMember?: Maybe<Scalars['Boolean']>;
  addMember?: Maybe<Scalars['Boolean']>;
  canCreateAdultFamilyMember?: Maybe<Scalars['Boolean']>;
  canCreateChildFamilyMember?: Maybe<Scalars['Boolean']>;
  canCreateFamilyMember?: Maybe<Scalars['Boolean']>;
  canUpdatePaymentMethod?: Maybe<Scalars['Boolean']>;
  manage?: Maybe<Scalars['Boolean']>;
};

export type UserSubscriptionCancelInput = {
  id: Scalars['UUID'];
};

export type UserSubscriptionMember = {
  __typename?: 'UserSubscriptionMember';
  id: Scalars['ID'];
  isOwner?: Maybe<Scalars['Boolean']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  userSubscription?: Maybe<UserSubscription>;
  userSubscriptionId?: Maybe<Scalars['UUID']>;
};

export type UserSubscriptionsResult = {
  __typename?: 'UserSubscriptionsResult';
  data?: Maybe<Array<Maybe<UserSubscription>>>;
  meta?: Maybe<PageInfo>;
};

export type UsersResult = {
  __typename?: 'UsersResult';
  data?: Maybe<Array<Maybe<User>>>;
  meta?: Maybe<PageInfo>;
};

export type Wizard = {
  __typename?: 'Wizard';
  id: Scalars['UUID'];
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['JSONObject']>;
  wizardItems?: Maybe<Array<Maybe<WizardItem>>>;
};

export type WizardItem = {
  __typename?: 'WizardItem';
  childWizardItems?: Maybe<Array<Maybe<WizardItem>>>;
  id: Scalars['UUID'];
  key?: Maybe<Scalars['String']>;
  parentWizardItem?: Maybe<WizardItem>;
  parentWizardItemId?: Maybe<Scalars['UUID']>;
  rank?: Maybe<Scalars['Int']>;
  settings?: Maybe<Scalars['JSONObject']>;
  wizard?: Maybe<Wizard>;
  wizardId?: Maybe<Scalars['UUID']>;
};

export type WizardItemsResult = {
  __typename?: 'WizardItemsResult';
  data?: Maybe<Array<Maybe<WizardItem>>>;
  meta?: Maybe<PageInfo>;
};

export type WizardResult = {
  __typename?: 'WizardResult';
  createdAt: Scalars['DateTime'];
  hidden: Scalars['Boolean'];
  id: Scalars['UUID'];
  user?: Maybe<User>;
  userId: Scalars['UUID'];
  wizard?: Maybe<Wizard>;
  wizardId: Scalars['UUID'];
  wizardResultItems: Array<WizardResultItem>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};


export type WizardResultWizardResultItemsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<WizardResultItemsWhereInput>;
};

export type WizardResultInput = {
  addToPatientECard?: InputMaybe<Scalars['Boolean']>;
  caseId?: InputMaybe<Scalars['UUID']>;
  items?: InputMaybe<Array<InputMaybe<WizardResultItemInput>>>;
  userId: Scalars['UUID'];
  wizardId?: InputMaybe<Scalars['UUID']>;
  wizardKey?: InputMaybe<Scalars['String']>;
};

export type WizardResultItem = {
  __typename?: 'WizardResultItem';
  createdAt: Scalars['DateTime'];
  formattedValue?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  key: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSONObject']>;
  wizardResult: WizardResult;
  wizardResultId: Scalars['UUID'];
};

export type WizardResultItemInput = {
  data?: InputMaybe<Scalars['JSONObject']>;
  wizardItemId: Scalars['UUID'];
};

export type WizardResultItemsResult = {
  __typename?: 'WizardResultItemsResult';
  data?: Maybe<Array<Maybe<WizardResultItem>>>;
  meta?: Maybe<PageInfo>;
};

export type WizardResultItemsWhereInput = {
  showSystemKeys?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['UUID']>;
  wizardKey?: InputMaybe<Scalars['String']>;
  wizardResultId?: InputMaybe<Scalars['UUID']>;
};

export type WizardResultWhereInput = {
  id: Scalars['UUID'];
};

export type WizardResultsResult = {
  __typename?: 'WizardResultsResult';
  data?: Maybe<Array<Maybe<WizardResult>>>;
  meta?: Maybe<PageInfo>;
  settings?: Maybe<Scalars['JSONObject']>;
};

export type WizardResultsWhereInput = {
  userId?: InputMaybe<Scalars['UUID']>;
  wizardId?: InputMaybe<Scalars['UUID']>;
  wizardKey?: InputMaybe<Scalars['String']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type WizardsResult = {
  __typename?: 'WizardsResult';
  data?: Maybe<Array<Maybe<Wizard>>>;
  meta?: Maybe<PageInfo>;
};

export type Workplace = {
  __typename?: 'Workplace';
  address?: Maybe<Address>;
  approved?: Maybe<Scalars['Boolean']>;
  billingAddress?: Maybe<Address>;
  calendarEmailNotification?: Maybe<Scalars['Boolean']>;
  caseDoctorDescription?: Maybe<Scalars['String']>;
  codeName?: Maybe<Scalars['String']>;
  createCaseTarget?: Maybe<CreateCaseTarget>;
  defaultDoctor?: Maybe<User>;
  defaultDoctorId?: Maybe<Scalars['UUID']>;
  defaultInvitation?: Maybe<Scalars['Boolean']>;
  doctorDisplayName?: Maybe<Scalars['String']>;
  firstSetup?: Maybe<Scalars['Boolean']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internalName?: Maybe<Scalars['String']>;
  invitationCode?: Maybe<Scalars['String']>;
  logo?: Maybe<File>;
  logoUrl?: Maybe<Scalars['String']>;
  memberSearchableOutside?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Array<Maybe<Meta>>>;
  metaSuklCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  onlineOrderTarget?: Maybe<OnlineOrderTarget>;
  parentWorkplace?: Maybe<Workplace>;
  parentWorkplaceId?: Maybe<Scalars['UUID']>;
  partnerId?: Maybe<Scalars['String']>;
  patientDisplayName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  privateAmbulance?: Maybe<Scalars['Boolean']>;
  rootBilling?: Maybe<Scalars['Boolean']>;
  rootPatient?: Maybe<Scalars['Boolean']>;
  rootWorkplace?: Maybe<Workplace>;
  rootWorkplaceId?: Maybe<Scalars['UUID']>;
  termItems?: Maybe<Array<Maybe<TermItem>>>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  workplaceMembers?: Maybe<Array<Maybe<WorkplaceMember>>>;
  workplaceSearchableOutside?: Maybe<Scalars['Boolean']>;
};


export type WorkplaceMetaArgs = {
  key?: InputMaybe<Scalars['String']>;
  strict?: InputMaybe<Scalars['Boolean']>;
};

export type WorkplaceAddressWhereInput = {
  type: AddressType;
  workplaceId: Scalars['UUID'];
};

export type WorkplaceCaseType = {
  __typename?: 'WorkplaceCaseType';
  canSearchDoctor?: Maybe<Scalars['Boolean']>;
  canSelectTransport?: Maybe<Scalars['Boolean']>;
  canSendToAmbulance?: Maybe<Scalars['Boolean']>;
  caseType?: Maybe<CaseType>;
  caseTypeId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  labelTranslations?: Maybe<Array<Maybe<Translation>>>;
  workplace?: Maybe<Workplace>;
  workplaceDefaultCaseType?: Maybe<Scalars['Boolean']>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type WorkplaceCaseTypesResult = {
  __typename?: 'WorkplaceCaseTypesResult';
  data?: Maybe<Array<Maybe<WorkplaceCaseType>>>;
  meta?: Maybe<PageInfo>;
};

export type WorkplaceCertificate = {
  __typename?: 'WorkplaceCertificate';
  certificate?: Maybe<Certificate>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: WorkplaceCertificateType;
};

export enum WorkplaceCertificateType {
  Commercial = 'COMMERCIAL',
  Sukl = 'SUKL'
}

export type WorkplaceCertificatesResult = {
  __typename?: 'WorkplaceCertificatesResult';
  data?: Maybe<Array<Maybe<WorkplaceCertificate>>>;
  meta?: Maybe<PageInfo>;
};

export type WorkplaceCertificatesWhereInput = {
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type WorkplaceInsuranceBatchsWhereInput = {
  workplaceId: Scalars['UUID'];
};

export type WorkplaceMember = {
  __typename?: 'WorkplaceMember';
  archivedAt?: Maybe<Scalars['DateTime']>;
  archivedBy?: Maybe<User>;
  archivedById?: Maybe<Scalars['UUID']>;
  archivedReason?: Maybe<TermItem>;
  canCreateCase?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  dateOfDeath?: Maybe<Scalars['Date']>;
  hasShiftNow?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isSpecialist?: Maybe<Scalars['Boolean']>;
  memberSearchableOutside?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Array<Maybe<Meta>>>;
  role?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
  userRelation?: Maybe<UserRelation>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['ID']>;
  workplaceMemberRoles?: Maybe<Array<Maybe<WorkplaceMemberRole>>>;
};


export type WorkplaceMemberMetaArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useOriginalId?: InputMaybe<Scalars['Boolean']>;
};


export type WorkplaceMemberUserRelationArgs = {
  type?: InputMaybe<UserRelationType>;
};

export type WorkplaceMemberRole = {
  __typename?: 'WorkplaceMemberRole';
  id: Scalars['ID'];
  role?: Maybe<AclRole>;
  roleId: Scalars['ID'];
  workplaceMember?: Maybe<WorkplaceMember>;
  workplaceMemberId: Scalars['ID'];
};

export type WorkplaceMembersResult = {
  __typename?: 'WorkplaceMembersResult';
  data?: Maybe<Array<Maybe<WorkplaceMember>>>;
  meta?: Maybe<PageInfo>;
};

export enum WorkplacePatientStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  ArchivedByPatient = 'ARCHIVED_BY_PATIENT',
  ArchivedByWorkplace = 'ARCHIVED_BY_WORKPLACE',
  Declined = 'DECLINED',
  HealthPlanActive = 'HEALTH_PLAN_ACTIVE',
  HealthPlanCreated = 'HEALTH_PLAN_CREATED',
  HealthPlanNotPaid = 'HEALTH_PLAN_NOT_PAID',
  Pending = 'PENDING',
  Virtual = 'VIRTUAL'
}

export type WorkplacePreset = {
  __typename?: 'WorkplacePreset';
  id?: Maybe<Scalars['UUID']>;
  memberType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum WorkplacePresetMemberType {
  Child = 'CHILD',
  Patient = 'PATIENT'
}

export enum WorkplacePresetType {
  Pediatr = 'PEDIATR',
  Praktik = 'PRAKTIK',
  Terapeut = 'TERAPEUT',
  Zubar = 'ZUBAR'
}

export enum WorkplaceType {
  Main = 'MAIN',
  Normal = 'NORMAL'
}

export type WorkplacesResult = {
  __typename?: 'WorkplacesResult';
  data?: Maybe<Array<Maybe<Workplace>>>;
  meta?: Maybe<PageInfo>;
};

export type WorkplaceAclRoleWhereInput = {
  excludeRoleKeys?: InputMaybe<Array<InputMaybe<AclRoleKey>>>;
};

export type CaseChatEntriesQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CaseChatEntriesQuery = { __typename?: 'Query', caseEntries?: { __typename?: 'CaseEntriesResult', data?: Array<{ __typename?: 'CaseEntry', id?: number | null, caseId?: string | null, message?: string | null, type?: string | null, time?: any | null, createdAt?: any | null, senderId?: string | null, extra?: any | null, thumb?: boolean | null, inDocumentation?: boolean | null, avResult?: string | null, fileId?: string | null, file?: { __typename?: 'File', id: string, name?: string | null, extension?: string | null } | null, order?: { __typename?: 'Order', id?: string | null, number?: string | null, price?: { __typename?: 'TransactionPrice', priceWithVatRaw?: string | null, formattedPrice?: string | null, currency?: string | null } | null, orderLog?: { __typename?: 'OrderLog', type?: string | null, value?: string | null } | null, orderItems?: Array<{ __typename?: 'OrderItem', id?: string | null, name?: string | null, price?: { __typename?: 'Price', priceWithVatRaw?: string | null, formattedPrice?: string | null, currency: string } | null } | null> | null } | null, sender?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null } | null, avatarFile?: { __typename?: 'File', createdAt?: any | null } | null } | null, caseEntryMembers?: Array<{ __typename?: 'CaseEntryMember', seen?: boolean | null, user?: { __typename?: 'User', id: string, isPatient?: boolean | null } | null } | null> | null } | null> | null } | null };

export type CreateHealthPlanUserPaymentMutationVariables = Exact<{
  input?: InputMaybe<HealthPlanUserPaymentInput>;
}>;


export type CreateHealthPlanUserPaymentMutation = { __typename?: 'Mutation', createHealthPlanUserPayment?: { __typename?: 'HealthPlanUser', id: string } | null };

export type WorkplaceBillingAddressQueryVariables = Exact<{
  where?: InputMaybe<WorkplaceAddressWhereInput>;
}>;


export type WorkplaceBillingAddressQuery = { __typename?: 'Query', workplaceAddress?: { __typename?: 'Address', id: string, street?: string | null, street2?: string | null, city?: string | null, postCode?: string | null, descriptiveNumber?: string | null, guideNumber?: string | null, floor?: string | null, accommodationZone?: string | null, apartmentNumber?: string | null, district?: string | null, region?: string | null, province?: string | null, country?: string | null, streetType?: string | null, zoneType?: string | null, zoneName?: string | null, sector?: string | null, manzana?: string | null, parish?: string | null, department?: string | null, departmentNumber?: string | null, lot?: string | null, houseType?: string | null, kilometer?: string | null, governType?: string | null, governName?: string | null, reference?: string | null, ubigeo?: string | null, identificationNumber?: string | null, taxIdentificationNumber?: string | null, invoiceNumber?: string | null, type?: AddressType | null, billingEmail?: any | null } | null };

export type WorkplaceUseCustomBillingAddressQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type WorkplaceUseCustomBillingAddressQuery = { __typename?: 'Query', workplace?: { __typename?: 'Workplace', rootBilling?: boolean | null } | null };

export type PatientConsentQueryVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type PatientConsentQuery = { __typename?: 'Query', user?: { __typename?: 'User', consentProvider?: boolean | null, userConsent?: { __typename?: 'UserConsent', value: UserConsentValue, createdAt: any } | null } | null };

export type PatientProfileDataQueryVariables = Exact<{
  userId: Scalars['UUID'];
  useOriginalId?: InputMaybe<Scalars['Boolean']>;
}>;


export type PatientProfileDataQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null, isDoctor?: boolean | null, isChild?: boolean | null, partnerIdentifier?: string | null, partner?: string | null, profileImageUrl?: string | null, originalId?: string | null, insuranceCardFrontThumbnailUrl?: string | null, insuranceCardBackThumbnailUrl?: string | null, csszResult?: any | null, vzpResult?: any | null, vzpRegisteredDoctorsResult?: any | null, createdAt?: any | null, note?: string | null, healthCard?: { __typename: 'HealthCard', height?: number | null, weight?: number | null, operations?: string | null, job?: string | null, sickness?: string | null, anamnesisFamily?: string | null, allergies?: string | null, allergiesOther?: string | null } | null, meta?: Array<{ __typename?: 'Meta', key?: string | null, value?: any | null } | null> | null, memberOf?: Array<{ __typename?: 'Badge', title?: string | null, theme?: string | null } | null> | null, parents?: Array<{ __typename?: 'User', id: string, formattedPhoneNumber?: string | null, email?: string | null, profile?: { __typename?: 'Profile', fullName?: string | null, firstName?: string | null, lastName?: string | null, contactEmail?: string | null } | null } | null> | null, badge?: { __typename?: 'Badge', title?: string | null, theme?: string | null } | null, avatarFile?: { __typename?: 'File', createdAt?: any | null } | null, userRelations?: Array<{ __typename?: 'UserRelation', id?: number | null, type?: number | null, workplace?: { __typename?: 'Workplace', id: string, name?: string | null } | null, user?: { __typename?: 'User', id: string } | null, relationUser?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null, firstName?: string | null, lastName?: string | null } | null } | null } | null> | null, profile?: { __typename?: 'Profile', age?: string | null, birthNumber?: string | null, formattedBirthNumber?: string | null, birthDate?: string | null, insuranceNumber?: string | null, gender?: string | null, formattedGender?: string | null, timezone?: string | null, languageFormatted?: string | null, languageIso?: string | null, nationalityOther?: string | null, fullName?: string | null, firstName?: string | null, lastName?: string | null, middleName?: string | null, fatherLastName?: string | null, motherLastName?: string | null, name?: string | null, salutationBefore?: string | null, salutationAfter?: string | null, contactEmail?: string | null, nationalityTermItem?: { __typename?: 'TermItem', id: string, name?: string | null, value?: string | null } | null, address?: { __typename?: 'Address', id: string, street?: string | null, street2?: string | null, city?: string | null, postCode?: string | null, fullAddress?: string | null, shortAddress?: string | null, formattedFullAddress?: string | null, formattedShortAddress?: string | null, descriptiveNumber?: string | null, guideNumber?: string | null, floor?: string | null, accommodationZone?: string | null, apartmentNumber?: string | null, district?: string | null, region?: string | null, province?: string | null, country?: string | null, streetType?: string | null, zoneType?: string | null, zoneName?: string | null, sector?: string | null, manzana?: string | null, parish?: string | null, department?: string | null, departmentNumber?: string | null, lot?: string | null, houseType?: string | null, kilometer?: string | null, governType?: string | null, governName?: string | null, reference?: string | null, ubigeo?: string | null, terytCode?: string | null } | null, insuranceCompanyTermItem?: { __typename?: 'TermItem', id: string, name?: string | null, value?: string | null, value2?: string | null } | null } | null, rootWorkplace?: { __typename?: 'Workplace', name?: string | null } | null, workplace?: { __typename?: 'Workplace', name?: string | null } | null, invitations?: Array<{ __typename?: 'UserInvitation', code?: string | null, createdAt?: any | null, declinedAt?: any | null, used?: boolean | null } | null> | null, userNumber?: { __typename: 'UserNumber', id?: number | null, number?: string | null, birthNumber?: string | null } | null, workplaceMember?: { __typename?: 'WorkplaceMember', status?: string | null, dateOfDeath?: any | null, archivedAt?: any | null, archivedBy?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null } | null };

export type PatientUserRelationsQueryVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type PatientUserRelationsQuery = { __typename?: 'Query', user?: { __typename?: 'User', userRelations?: Array<{ __typename?: 'UserRelation', id?: number | null, type?: number | null, workplace?: { __typename?: 'Workplace', id: string, name?: string | null } | null, user?: { __typename?: 'User', id: string } | null, relationUser?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null, firstName?: string | null, lastName?: string | null } | null } | null } | null> | null } | null };

export type WorkplaceMemberDetailsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
}>;


export type WorkplaceMemberDetailsQuery = { __typename?: 'Query', workplaceMember?: { __typename?: 'WorkplaceMember', id: string, user?: { __typename?: 'User', id: string, email?: string | null, phoneNumber?: string | null, profile?: { __typename?: 'Profile', id: string, firstName?: string | null, lastName?: string | null } | null } | null } | null };

export type ConversationDetailQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type ConversationDetailQuery = { __typename?: 'Query', conversation?: { __typename?: 'Conversation', id: string, name?: string | null, totalRecipients?: number | null, singleRecipient?: { __typename?: 'ConversationMember', id?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null, lastMessage?: { __typename?: 'Message', id: string, type?: string | null, content?: any | null, createdAt?: any | null, sender?: { __typename?: 'MessageMember', user?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null, messageAttachments?: Array<{ __typename?: 'MessageAttachment', id: string, type?: MessageAttachmentType | null, extra?: any | null, educationMaterial?: { __typename?: 'EducationMaterial', id: string, name?: string | null, value?: any | null, subtype?: string | null, link?: string | null } | null, questionnaire?: { __typename?: 'Questionnaire', id: string, title?: string | null } | null, file?: { __typename?: 'File', id: string, name?: string | null, type?: string | null, extension?: string | null, createdAt?: any | null } | null, documentationFile?: { __typename?: 'DocumentationFile', id: string, userId?: string | null, folderId?: string | null, name?: string | null, avResult?: string | null, hasThumb?: boolean | null, thumbUrl?: string | null, fileUrl?: string | null, extension?: string | null } | null } | null> | null } | null } | null };

export type ConversationMessagesQueryVariables = Exact<{
  conversationId?: InputMaybe<Scalars['UUID']>;
  folder?: InputMaybe<ConversationFolderEnum>;
  conversationType?: InputMaybe<ConversationType>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ConversationMessagesQuery = { __typename?: 'Query', messages?: { __typename?: 'MessagesResult', meta?: { __typename?: 'PageInfo', count?: number | null } | null, data?: Array<{ __typename?: 'Message', id: string, type?: string | null, content?: any | null, createdAt?: any | null, sender?: { __typename?: 'MessageMember', user?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null, messageAttachments?: Array<{ __typename?: 'MessageAttachment', id: string, type?: MessageAttachmentType | null, extra?: any | null, educationMaterial?: { __typename?: 'EducationMaterial', id: string, name?: string | null, value?: any | null, subtype?: string | null, link?: string | null } | null, questionnaire?: { __typename?: 'Questionnaire', id: string, title?: string | null } | null, file?: { __typename?: 'File', id: string, name?: string | null, type?: string | null, extension?: string | null, createdAt?: any | null } | null, documentationFile?: { __typename?: 'DocumentationFile', id: string, userId?: string | null, folderId?: string | null, name?: string | null, avResult?: string | null, hasThumb?: boolean | null, thumbUrl?: string | null, fileUrl?: string | null, extension?: string | null } | null } | null> | null } | null> | null } | null };

export type MessagesByConversationQueryVariables = Exact<{
  conversationType?: InputMaybe<ConversationType>;
  pagination?: InputMaybe<PaginationInput>;
  folder?: InputMaybe<ConversationFolderEnum>;
}>;


export type MessagesByConversationQuery = { __typename?: 'Query', messagesByConversation?: { __typename?: 'MessagesResult', meta?: { __typename?: 'PageInfo', count?: number | null, page?: number | null, totalPages?: number | null } | null, data?: Array<{ __typename?: 'Message', id: string, createdAt?: any | null, content?: any | null, totalRecipients?: number | null, singleRecipient?: { __typename?: 'MessageMember', user?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null, messageAttachments?: Array<{ __typename?: 'MessageAttachment', id: string, type?: MessageAttachmentType | null, questionnaire?: { __typename?: 'Questionnaire', id: string, title?: string | null } | null } | null> | null, conversation?: { __typename?: 'Conversation', id: string, name?: string | null, createdAt?: any | null } | null, myMessageMember?: { __typename?: 'MessageMember', seen?: boolean | null } | null, sender?: { __typename?: 'MessageMember', user?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null } | null> | null } | null };

export type DoctorsSearchQueryVariables = Exact<{
  fulltext?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type DoctorsSearchQuery = { __typename?: 'Query', doctors?: { __typename?: 'UsersResult', meta?: { __typename?: 'PageInfo', count?: number | null } | null, data?: Array<{ __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null> | null } | null };

export type GetGridFilterQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type GetGridFilterQuery = { __typename?: 'Query', userFilter?: { __typename?: 'Meta', id: string, key?: string | null, value?: any | null } | null };

export type SaveGridFilterMutationVariables = Exact<{
  input?: InputMaybe<UserFilterInput>;
}>;


export type SaveGridFilterMutation = { __typename?: 'Mutation', saveUserFilter?: { __typename?: 'Meta', id: string, key?: string | null, value?: any | null } | null };

export type GroupsSearchQueryVariables = Exact<{
  fulltext?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GroupsSearchQuery = { __typename?: 'Query', groups?: { __typename?: 'GroupsResult', meta?: { __typename?: 'PageInfo', count?: number | null } | null, data?: Array<{ __typename?: 'Group', id: string, name?: string | null, description?: string | null } | null> | null } | null };

export type NonDoctorsSearchQueryVariables = Exact<{
  fulltext?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type NonDoctorsSearchQuery = { __typename?: 'Query', doctors?: { __typename?: 'UsersResult', meta?: { __typename?: 'PageInfo', count?: number | null } | null, data?: Array<{ __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null> | null } | null };

export type PatientsSearchQueryVariables = Exact<{
  fulltext?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type PatientsSearchQuery = { __typename?: 'Query', patients?: { __typename?: 'UsersResult', meta?: { __typename?: 'PageInfo', count?: number | null } | null, data?: Array<{ __typename?: 'User', id: string, formattedPhoneNumber?: string | null, profile?: { __typename?: 'Profile', fullName?: string | null, birthNumber?: string | null, age?: string | null, address?: { __typename?: 'Address', fullAddress?: string | null } | null } | null, userRelations?: Array<{ __typename?: 'UserRelation', id?: number | null, type?: number | null, relationUser?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null, workplace?: { __typename?: 'Workplace', id: string, name?: string | null } | null } | null> | null } | null> | null } | null };

export type RootWorkplaceDoctorsQueryVariables = Exact<{
  fulltext?: InputMaybe<Scalars['String']>;
  includeNurses?: InputMaybe<Scalars['Boolean']>;
}>;


export type RootWorkplaceDoctorsQuery = { __typename?: 'Query', rootWorkplaceDoctors?: { __typename?: 'WorkplaceMembersResult', data?: Array<{ __typename?: 'WorkplaceMember', id: string, hasShiftNow?: boolean | null, workplace?: { __typename?: 'Workplace', id: string, doctorDisplayName?: string | null, rootWorkplace?: { __typename?: 'Workplace', id: string, doctorDisplayName?: string | null } | null } | null, user?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null> | null } | null };

export type SimpleWorkplacesQueryVariables = Exact<{
  fulltext?: InputMaybe<Scalars['String']>;
}>;


export type SimpleWorkplacesQuery = { __typename?: 'Query', workplaces?: { __typename?: 'WorkplacesResult', data?: Array<{ __typename?: 'Workplace', id: string, doctorDisplayName?: string | null, type?: string | null, rootWorkplace?: { __typename?: 'Workplace', id: string, doctorDisplayName?: string | null } | null } | null> | null } | null };

export type WorkplaceRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkplaceRolesQuery = { __typename?: 'Query', workplaceAclRoles?: { __typename?: 'AclRoleResult', data?: Array<{ __typename?: 'AclRole', id?: string | null, name?: string | null, key?: string | null } | null> | null } | null };

export type CreateWorkplaceMemberAbsenceMutationVariables = Exact<{
  input: CreateWorkplaceMemberAbsenceInput;
}>;


export type CreateWorkplaceMemberAbsenceMutation = { __typename?: 'Mutation', createWorkplaceMemberAbsence?: { __typename?: 'EventsResult', data?: Array<{ __typename?: 'Event', id: string } | null> | null } | null };

export type DoneEventMutationVariables = Exact<{
  input?: InputMaybe<DoneEventInput>;
}>;


export type DoneEventMutation = { __typename?: 'Mutation', doneEvent?: { __typename?: 'Event', id: string, meta?: Array<{ __typename?: 'Meta', key?: string | null, value?: any | null } | null> | null } | null };

export type AssignCaseToMeMutationVariables = Exact<{
  input?: InputMaybe<AssignCaseToMeInput>;
}>;


export type AssignCaseToMeMutation = { __typename?: 'Mutation', assignCaseToMe?: { __typename?: 'Case', id?: string | null } | null };

export type CaseMedicalReportsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type CaseMedicalReportsQuery = { __typename?: 'Query', case?: { __typename?: 'Case', medicalReports?: Array<{ __typename?: 'MedicalReport', id?: number | null, workplaceId?: string | null } | null> | null } | null };

export type CasesAssignedQueryVariables = Exact<{
  caseTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  caseStatusValue?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  onlyVisible?: InputMaybe<Scalars['Boolean']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type CasesAssignedQuery = { __typename?: 'Query', casesAssigned?: { __typename?: 'CasesResult', meta?: { __typename?: 'PageInfo', totalPages?: number | null, page?: number | null } | null, data?: Array<{ __typename?: 'Case', id?: string | null, code?: string | null, title?: string | null, isNew?: boolean | null, isMyCase?: boolean | null, isImmediate?: any | null, createdAt?: any | null, solveTo?: any | null, patientDescription?: string | null, totalUnreadCaseEntries?: number | null, caseChatPreview?: boolean | null, medicationLasted?: Array<any | null> | null, priority?: { __typename?: 'TermItem', id: string, name?: string | null, value?: string | null, value2?: string | null, value3?: string | null } | null, createdBy?: { __typename?: 'User', id: string, isPatient?: boolean | null } | null, lastNote?: { __typename?: 'Note', id?: string | null, text?: string | null } | null, lastCaseEntry?: { __typename?: 'CaseEntry', time?: any | null, message?: string | null, createdAt?: any | null } | null, patient?: { __typename?: 'User', id: string, profileImageUrl?: string | null, isDoctor?: boolean | null, profile?: { __typename?: 'Profile', fullName?: string | null, age?: string | null, insuranceNumber?: string | null, birthNumber?: string | null, languageFormatted?: string | null, address?: { __typename?: 'Address', city?: string | null, region?: string | null } | null, insuranceCompanyTermItem?: { __typename?: 'TermItem', name?: string | null, value?: string | null } | null } | null, userRelations?: Array<{ __typename?: 'UserRelation', id?: number | null, type?: number | null, relationUser?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null> | null, avatarFile?: { __typename?: 'File', createdAt?: any | null } | null, meta?: Array<{ __typename?: 'Meta', id: string, key?: string | null, value?: any | null } | null> | null, partnerTag?: { __typename?: 'UserPartnerTag', title?: string | null } | null } | null, patientParent?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null, workplace?: { __typename?: 'Workplace', id: string, name?: string | null, doctorDisplayName?: string | null } | null, doctor?: { __typename?: 'User', id: string, profileImageUrl?: string | null, profile?: { __typename?: 'Profile', age?: string | null, fullName?: string | null } | null } | null, child?: { __typename?: 'User', id: string } | null, medicalReports?: Array<{ __typename?: 'MedicalReport', id?: number | null, diagnosis?: string | null, treatment?: string | null, note?: string | null, createdAt?: any | null, documentId?: string | null, type?: string | null, document?: { __typename?: 'Document', id: string, type?: string | null, title?: { __typename?: 'DocumentItem', extra?: any | null } | null } | null } | null> | null, reassignedFrom?: { __typename?: 'WorkplaceMember', id: string, workplace?: { __typename?: 'Workplace', doctorDisplayName?: string | null } | null, user?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null, event?: { __typename?: 'Event', id: string } | null, caseType?: { __typename?: 'CaseType', code?: string | null } | null } | null> | null } | null };

export type IsMyCaseQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type IsMyCaseQuery = { __typename?: 'Query', case?: { __typename?: 'Case', isMyCase?: boolean | null } | null };

export type CreateNoteMutationVariables = Exact<{
  caseId?: InputMaybe<Scalars['UUID']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  text: Scalars['String'];
}>;


export type CreateNoteMutation = { __typename?: 'Mutation', createNote?: { __typename?: 'Note', id?: string | null } | null };

export type UpdateNoteMutationVariables = Exact<{
  id: Scalars['UUID'];
  text: Scalars['String'];
}>;


export type UpdateNoteMutation = { __typename?: 'Mutation', updateNote?: { __typename?: 'Note', id?: string | null } | null };

export type NurseCasesQueryVariables = Exact<{
  caseTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  doctorId?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  caseStatusValue?: InputMaybe<Scalars['String']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  created?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  patient?: InputMaybe<Scalars['String']>;
}>;


export type NurseCasesQuery = { __typename?: 'Query', nurseCases?: { __typename?: 'CasesResult', meta?: { __typename?: 'PageInfo', totalPages?: number | null, page?: number | null } | null, data?: Array<{ __typename?: 'Case', id?: string | null, code?: string | null, title?: string | null, isNew?: boolean | null, isMyCase?: boolean | null, isImmediate?: any | null, isAssigned?: boolean | null, createdAt?: any | null, solveTo?: any | null, patientDescription?: string | null, totalUnreadCaseEntries?: number | null, priority?: { __typename?: 'TermItem', id: string, name?: string | null, value?: string | null, value2?: string | null, value3?: string | null } | null, createdBy?: { __typename?: 'User', id: string, isPatient?: boolean | null } | null, lastNote?: { __typename?: 'Note', id?: string | null, text?: string | null } | null, lastCaseEntry?: { __typename?: 'CaseEntry', time?: any | null, message?: string | null, createdAt?: any | null } | null, patient?: { __typename?: 'User', id: string, profileImageUrl?: string | null, profile?: { __typename?: 'Profile', fullName?: string | null, age?: string | null, formattedBirthNumber?: string | null, languageFormatted?: string | null, address?: { __typename?: 'Address', city?: string | null } | null, insuranceCompanyTermItem?: { __typename?: 'TermItem', name?: string | null, value?: string | null } | null } | null, userRelations?: Array<{ __typename?: 'UserRelation', id?: number | null, type?: number | null, relationUser?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null> | null, avatarFile?: { __typename?: 'File', createdAt?: any | null } | null, meta?: Array<{ __typename?: 'Meta', id: string, key?: string | null, value?: any | null } | null> | null, partnerTag?: { __typename?: 'UserPartnerTag', title?: string | null } | null } | null, patientParent?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null, workplace?: { __typename?: 'Workplace', id: string, name?: string | null, doctorDisplayName?: string | null } | null, doctor?: { __typename?: 'User', id: string, profileImageUrl?: string | null, profile?: { __typename?: 'Profile', age?: string | null, fullName?: string | null } | null } | null, medicalReports?: Array<{ __typename?: 'MedicalReport', id?: number | null, diagnosis?: string | null, treatment?: string | null, note?: string | null, createdAt?: any | null, documentId?: string | null, type?: string | null, document?: { __typename?: 'Document', id: string, type?: string | null, title?: { __typename?: 'DocumentItem', extra?: any | null } | null } | null } | null> | null, event?: { __typename?: 'Event', id: string } | null } | null> | null } | null };

export type ReAssignCaseMutationVariables = Exact<{
  caseId: Scalars['UUID'];
  workplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceMemberId?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
}>;


export type ReAssignCaseMutation = { __typename?: 'Mutation', reAssignCase?: { __typename?: 'Case', id?: string | null } | null };

export type WorkplaceCasesQueryVariables = Exact<{
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  patientId?: InputMaybe<Scalars['UUID']>;
  doctorNull?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type WorkplaceCasesQuery = { __typename?: 'Query', workplaceCases?: { __typename?: 'CasesResult', meta?: { __typename?: 'PageInfo', totalPages?: number | null, page?: number | null } | null, data?: Array<{ __typename?: 'Case', id?: string | null, code?: string | null, title?: string | null, isNew?: boolean | null, isMyCase?: boolean | null, isImmediate?: any | null, createdAt?: any | null, solveTo?: any | null, patientDescription?: string | null, totalUnreadCaseEntries?: number | null, priority?: { __typename?: 'TermItem', id: string, name?: string | null, value?: string | null, value2?: string | null, value3?: string | null } | null, createdBy?: { __typename?: 'User', id: string, isPatient?: boolean | null } | null, lastNote?: { __typename?: 'Note', id?: string | null, text?: string | null } | null, lastCaseEntry?: { __typename?: 'CaseEntry', time?: any | null, message?: string | null, createdAt?: any | null } | null, patient?: { __typename?: 'User', id: string, profileImageUrl?: string | null, profile?: { __typename?: 'Profile', fullName?: string | null, age?: string | null, insuranceNumber?: string | null, birthNumber?: string | null, languageFormatted?: string | null, address?: { __typename?: 'Address', city?: string | null } | null, insuranceCompanyTermItem?: { __typename?: 'TermItem', name?: string | null, value?: string | null } | null } | null, userRelations?: Array<{ __typename?: 'UserRelation', id?: number | null, type?: number | null, relationUser?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null> | null, avatarFile?: { __typename?: 'File', createdAt?: any | null } | null, meta?: Array<{ __typename?: 'Meta', id: string, key?: string | null, value?: any | null } | null> | null, partnerTag?: { __typename?: 'UserPartnerTag', title?: string | null } | null } | null, patientParent?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null, workplace?: { __typename?: 'Workplace', id: string, name?: string | null, doctorDisplayName?: string | null } | null, doctor?: { __typename?: 'User', id: string, profileImageUrl?: string | null, profile?: { __typename?: 'Profile', age?: string | null, fullName?: string | null } | null } | null, child?: { __typename?: 'User', id: string } | null, medicalReports?: Array<{ __typename?: 'MedicalReport', id?: number | null, diagnosis?: string | null, treatment?: string | null, note?: string | null, createdAt?: any | null, documentId?: string | null, type?: string | null, document?: { __typename?: 'Document', id: string, type?: string | null, title?: { __typename?: 'DocumentItem', extra?: any | null } | null } | null } | null> | null, reassignedFrom?: { __typename?: 'WorkplaceMember', id: string, workplace?: { __typename?: 'Workplace', doctorDisplayName?: string | null } | null, user?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null, event?: { __typename?: 'Event', id: string } | null } | null> | null } | null };

export type WorkplaceCasesArchivedQueryVariables = Exact<{
  patientId?: InputMaybe<Scalars['UUID']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  caseTypeId?: InputMaybe<Scalars['UUID']>;
  caseTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  solvedAt?: InputMaybe<CaseSolvedMonth>;
  solvedAtRange?: InputMaybe<DateFilter>;
}>;


export type WorkplaceCasesArchivedQuery = { __typename?: 'Query', workplaceCasesArchived?: { __typename?: 'CasesResult', meta?: { __typename?: 'PageInfo', totalPages?: number | null, page?: number | null, count?: number | null } | null, data?: Array<{ __typename?: 'Case', id?: string | null, code?: string | null, title?: string | null, isNew?: boolean | null, isMyCase?: boolean | null, isImmediate?: any | null, createdAt?: any | null, solveTo?: any | null, solvedAt?: any | null, patientDescription?: string | null, totalUnreadCaseEntries?: number | null, priority?: { __typename?: 'TermItem', id: string, name?: string | null, value?: string | null, value2?: string | null, value3?: string | null } | null, createdBy?: { __typename?: 'User', id: string, isPatient?: boolean | null } | null, lastNote?: { __typename?: 'Note', id?: string | null, text?: string | null } | null, lastCaseEntry?: { __typename?: 'CaseEntry', time?: any | null, message?: string | null, createdAt?: any | null } | null, patient?: { __typename?: 'User', id: string, profileImageUrl?: string | null, profile?: { __typename?: 'Profile', fullName?: string | null, age?: string | null, insuranceNumber?: string | null, birthNumber?: string | null, languageFormatted?: string | null, address?: { __typename?: 'Address', city?: string | null } | null, insuranceCompanyTermItem?: { __typename?: 'TermItem', name?: string | null, value?: string | null } | null } | null, userRelations?: Array<{ __typename?: 'UserRelation', id?: number | null, type?: number | null, relationUser?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null> | null, avatarFile?: { __typename?: 'File', createdAt?: any | null } | null, meta?: Array<{ __typename?: 'Meta', id: string, key?: string | null, value?: any | null } | null> | null, partnerTag?: { __typename?: 'UserPartnerTag', title?: string | null } | null } | null, patientParent?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null, workplace?: { __typename?: 'Workplace', id: string, name?: string | null, doctorDisplayName?: string | null } | null, doctor?: { __typename?: 'User', id: string, profileImageUrl?: string | null, profile?: { __typename?: 'Profile', age?: string | null, fullName?: string | null } | null } | null, child?: { __typename?: 'User', id: string } | null, medicalReports?: Array<{ __typename?: 'MedicalReport', id?: number | null, diagnosis?: string | null, treatment?: string | null, note?: string | null, createdAt?: any | null, documentId?: string | null, type?: string | null, printed?: boolean | null, fileId?: string | null, document?: { __typename?: 'Document', id: string, type?: string | null, title?: { __typename?: 'DocumentItem', extra?: any | null } | null, sync?: { __typename?: 'SyncStatus', state?: SyncStatusState | null } | null } | null } | null> | null, reassignedFrom?: { __typename?: 'WorkplaceMember', id: string, workplace?: { __typename?: 'Workplace', doctorDisplayName?: string | null } | null, user?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null, event?: { __typename?: 'Event', id: string } | null } | null> | null } | null };

export type FullWorkplaceCaseTypesQueryVariables = Exact<{
  workplaceId?: InputMaybe<Scalars['UUID']>;
  caseTypeTypes?: InputMaybe<Array<InputMaybe<CaseTypeType>> | InputMaybe<CaseTypeType>>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type FullWorkplaceCaseTypesQuery = { __typename?: 'Query', workplaceCaseTypes?: { __typename?: 'WorkplaceCaseTypesResult', data?: Array<{ __typename?: 'WorkplaceCaseType', id: string, workplaceId?: string | null, canSearchDoctor?: boolean | null, canSendToAmbulance?: boolean | null, canSelectTransport?: boolean | null, workplaceDefaultCaseType?: boolean | null, caseType?: { __typename?: 'CaseType', id?: string | null, rank?: number | null, canBookOnline?: boolean | null, canBookOnSite?: boolean | null, canOrderImmediate?: boolean | null, priceId?: string | null, code?: string | null, label?: string | null, parentCaseTypeId?: string | null, hiddenForPatient?: boolean | null, eventInterval?: number | null, price?: { __typename?: 'Price', id?: string | null, priceWithVat?: any | null, priceWithVatRaw?: string | null, vatRate: number } | null, caseTypeItems?: Array<{ __typename?: 'CaseTypeItem', id: string, rank?: number | null, title?: string | null, description?: string | null, settings?: any | null, key?: string | null, type?: string | null, subtype?: string | null } | null> | null } | null } | null> | null } | null };

export type WorkplaceRootCaseTypesQueryVariables = Exact<{
  workplaceId?: InputMaybe<Scalars['UUID']>;
  caseTypeTypes?: InputMaybe<Array<InputMaybe<CaseTypeType>> | InputMaybe<CaseTypeType>>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
}>;


export type WorkplaceRootCaseTypesQuery = { __typename?: 'Query', workplaceCaseTypes?: { __typename?: 'WorkplaceCaseTypesResult', data?: Array<{ __typename?: 'WorkplaceCaseType', id: string, caseType?: { __typename?: 'CaseType', id?: string | null, label?: string | null, type?: string | null, eventInterval?: number | null, code?: string | null } | null } | null> | null } | null };

export type RootWorkplacesPatientQueryVariables = Exact<{
  originalId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
}>;


export type RootWorkplacesPatientQuery = { __typename?: 'Query', rootWorkplacesPatient?: { __typename?: 'WorkplaceMembersResult', data?: Array<{ __typename?: 'WorkplaceMember', id: string, status?: string | null, user?: { __typename?: 'User', id: string } | null, workplace?: { __typename?: 'Workplace', id: string, name?: string | null } | null } | null> | null } | null };

export type CertificatesQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type CertificatesQuery = { __typename?: 'Query', certificates?: { __typename?: 'CertificatesResult', meta?: { __typename?: 'PageInfo', count?: number | null } | null, data?: Array<{ __typename?: 'Certificate', id?: string | null, workplaceId?: string | null, userId?: string | null, fileId?: string | null, type?: string | null, isExpired?: boolean | null } | null> | null } | null };

export type AttachmentDetailQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type AttachmentDetailQuery = { __typename?: 'Query', document?: { __typename?: 'Document', id: string, items?: Array<{ __typename?: 'DocumentItem', id: string, type?: string | null, extra?: any | null } | null> | null } | null };

export type DiscourseQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type DiscourseQuery = { __typename?: 'Query', document?: { __typename?: 'Document', id: string, items?: Array<{ __typename?: 'DocumentItem', id: string, type?: string | null, extra?: any | null } | null> | null } | null };

export type DraftDiscourseQueryVariables = Exact<{
  patientId?: InputMaybe<Scalars['UUID']>;
}>;


export type DraftDiscourseQuery = { __typename?: 'Query', document?: { __typename?: 'Document', id: string, items?: Array<{ __typename?: 'DocumentItem', id: string, type?: string | null, extra?: any | null } | null> | null } | null };

export type DoctorBasicInfoQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type DoctorBasicInfoQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', id: string, fullName?: string | null } | null } | null };

export type WorkplaceDoctorsQueryVariables = Exact<{
  fulltext?: InputMaybe<Scalars['String']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  roleKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  take?: InputMaybe<Scalars['Int']>;
  approved?: InputMaybe<Scalars['Boolean']>;
}>;


export type WorkplaceDoctorsQuery = { __typename?: 'Query', workplaceDoctors?: { __typename?: 'WorkplaceMembersResult', data?: Array<{ __typename: 'WorkplaceMember', id: string, user?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', id: string, fullName?: string | null } | null } | null, workplaceMemberRoles?: Array<{ __typename?: 'WorkplaceMemberRole', role?: { __typename?: 'AclRole', key?: string | null } | null } | null> | null } | null> | null } | null };

export type DocumentQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DocumentQuery = { __typename?: 'Query', document?: { __typename?: 'Document', id: string, type?: string | null, createdAt?: any | null, title?: { __typename?: 'DocumentItem', id: string, type?: string | null, extra?: any | null, createdAt?: any | null } | null, content?: { __typename?: 'DocumentItem', id: string, type?: string | null, extra?: any | null, createdAt?: any | null } | null, createdBy?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null, items?: Array<{ __typename?: 'DocumentItem', id: string, type?: string | null, extra?: any | null, createdAt?: any | null } | null> | null } | null };

export type DocumentsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  types?: InputMaybe<Array<InputMaybe<DocumentType>> | InputMaybe<DocumentType>>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type DocumentsQuery = { __typename?: 'Query', documents?: { __typename?: 'DocumentsResult', meta?: { __typename?: 'PageInfo', page?: number | null, totalPages?: number | null } | null, data?: Array<{ __typename?: 'Document', id: string, type?: string | null, createdAt?: any | null, title?: { __typename?: 'DocumentItem', id: string, type?: string | null, extra?: any | null, createdAt?: any | null } | null, content?: { __typename?: 'DocumentItem', id: string, type?: string | null, extra?: any | null, createdAt?: any | null } | null, createdBy?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null, items?: Array<{ __typename?: 'DocumentItem', id: string, type?: string | null, extra?: any | null, createdAt?: any | null } | null> | null, file?: { __typename?: 'File', avResultText?: string | null } | null }> | null } | null };

export type WorkplaceCaseTargetQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type WorkplaceCaseTargetQuery = { __typename?: 'Query', workplace?: { __typename?: 'Workplace', createCaseTarget?: CreateCaseTarget | null } | null };

export type WorkplaceCodeQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type WorkplaceCodeQuery = { __typename?: 'Query', workplace?: { __typename?: 'Workplace', invitationCode?: string | null } | null };

export type EArchiveWorkplacePatientsQueryVariables = Exact<{
  workplaceId?: InputMaybe<Scalars['UUID']>;
  healthPlanIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  patientId?: InputMaybe<Scalars['UUID']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<WorkplacePatientStatus>;
  insuranceCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type EArchiveWorkplacePatientsQuery = { __typename?: 'Query', workplacePatients?: { __typename?: 'WorkplaceMembersResult', meta?: { __typename?: 'PageInfo', count?: number | null, totalPages?: number | null, page?: number | null } | null, data?: Array<{ __typename?: 'WorkplaceMember', id: string, createdAt?: any | null, status?: string | null, user?: { __typename?: 'User', id: string, originalId?: string | null, vzpResult?: any | null, csszResult?: any | null, hasMeddi?: boolean | null, phoneNumber?: string | null, email?: string | null, formattedPhoneNumber?: string | null, isChild?: boolean | null, profileImageUrl?: string | null, archivedAt?: any | null, parents?: Array<{ __typename?: 'User', formattedPhoneNumber?: string | null, email?: string | null, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null> | null, profile?: { __typename?: 'Profile', firstName?: string | null, lastName?: string | null, fullName?: string | null, birthNumber?: string | null, formattedBirthNumber?: string | null, birthDate?: string | null, age?: string | null, contactEmail?: string | null, contactPhoneNumber?: string | null, insuranceCompanyTermItem?: { __typename?: 'TermItem', id: string, value?: string | null, value2?: string | null } | null, address?: { __typename?: 'Address', fullAddress?: string | null, city?: string | null, street?: string | null, descriptiveNumber?: string | null, guideNumber?: string | null, postCode?: string | null } | null } | null, workplaceMember?: { __typename?: 'WorkplaceMember', dateOfDeath?: any | null } | null, meta?: Array<{ __typename?: 'Meta', key?: string | null, value?: any | null } | null> | null } | null } | null> | null } | null };

export type CreateUserMedicationLastedMutationVariables = Exact<{
  input: CreateUserMedicationLastedInput;
}>;


export type CreateUserMedicationLastedMutation = { __typename?: 'Mutation', createUserMedicationLasted?: Array<{ __typename?: 'UserMedicationLasted', id: string } | null> | null };

export type DeleteUserMedicationLastedMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteUserMedicationLastedMutation = { __typename?: 'Mutation', deleteUserMedicationLasted?: { __typename?: 'MutationResult', status?: boolean | null } | null };

export type PatientInformationQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type PatientInformationQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, email?: string | null, formattedPhoneNumber?: string | null, vzpResult?: any | null, healthCard?: { __typename?: 'HealthCard', weight?: number | null } | null, profile?: { __typename?: 'Profile', id: string, firstName?: string | null, lastName?: string | null, birthDate?: string | null, contactPhoneNumber?: string | null, contactEmail?: string | null, insuranceNumber?: string | null, insuranceCompanyTermItemId?: string | null, gender?: string | null, address?: { __typename?: 'Address', street?: string | null, guideNumber?: string | null, descriptiveNumber?: string | null, postCode?: string | null, country?: string | null, region?: string | null, city?: string | null, district?: string | null } | null, insuranceCompanyTermItem?: { __typename?: 'TermItem', id: string, value?: string | null, value2?: string | null, name?: string | null } | null } | null } | null };

export type UpdateUserMedicationLastedMutationVariables = Exact<{
  where: UpdateUserMedicationLastedWhereInput;
  data: UpdateUserMedicationLastedDataInput;
}>;


export type UpdateUserMedicationLastedMutation = { __typename?: 'Mutation', updateUserMedicationLasted?: { __typename?: 'UserMedicationLasted', id: string } | null };

export type UserMedicationLastedQueryVariables = Exact<{
  where: UserMedicationLastedWhereInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type UserMedicationLastedQuery = { __typename?: 'Query', userMedicationLasted?: { __typename?: 'UserMedicationLastedResult', meta?: { __typename?: 'PageInfo', page?: number | null, totalPages?: number | null, count?: number | null } | null, data: Array<{ __typename?: 'UserMedicationLasted', id: string, data: any }> } | null };

export type DocumentationFilesQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  folderId?: InputMaybe<Scalars['UUID']>;
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  fulltext?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type DocumentationFilesQuery = { __typename?: 'Query', documentationFiles?: { __typename?: 'DocumentationFilesResult', meta?: { __typename?: 'PageInfo', page?: number | null, totalPages?: number | null } | null, data: Array<{ __typename?: 'DocumentationFile', id: string, name?: string | null, extension?: string | null, displayName?: string | null, folderId?: string | null, hasThumb?: boolean | null, userId?: string | null, thumbUrl?: string | null, avResult?: string | null, createdAt?: any | null, fileGroupId?: string | null, file?: { __typename?: 'File', id: string, name?: string | null, extension?: string | null } | null, createdBy?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null, workplace?: { __typename?: 'Workplace', id: string, name?: string | null } | null, fileTransfers?: { __typename?: 'Meta', value?: any | null } | null, groupFiles?: Array<{ __typename?: 'DocumentationFile', id: string, name?: string | null, displayName?: string | null, createdAt?: any | null, thumbUrl?: string | null, userId?: string | null, folderId?: string | null, file?: { __typename?: 'File', id: string, name?: string | null, extension?: string | null } | null } | null> | null }> } | null };

export type DocumentationFilesCountQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  fulltext?: InputMaybe<Scalars['String']>;
}>;


export type DocumentationFilesCountQuery = { __typename?: 'Query', documentationFiles?: { __typename?: 'DocumentationFilesResult', meta?: { __typename?: 'PageInfo', count?: number | null } | null } | null };

export type DocumentationFoldersQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type DocumentationFoldersQuery = { __typename?: 'Query', documentationFolders?: { __typename?: 'DocumentationFoldersResult', data: Array<{ __typename?: 'DocumentationFolder', id: string, name?: string | null, icon?: string | null, type?: string | null, filesCount?: number | null, userId?: string | null }> } | null };

export type DocumentationFolderQueryVariables = Exact<{
  folderId?: InputMaybe<Scalars['UUID']>;
}>;


export type DocumentationFolderQuery = { __typename?: 'Query', documentationFolder?: { __typename?: 'DocumentationFolder', id: string, name?: string | null, icon?: string | null, type?: string | null, filesCount?: number | null, userId?: string | null } | null };

export type ECardNewFilesQueryVariables = Exact<{
  workplaceId?: InputMaybe<Scalars['UUID']>;
  pagination?: InputMaybe<PaginationInput>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  seen?: InputMaybe<Scalars['Boolean']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  patientId?: InputMaybe<Scalars['UUID']>;
}>;


export type ECardNewFilesQuery = { __typename?: 'Query', workplacePatientDocumentationFiles?: { __typename?: 'DocumentationFilesResult', meta?: { __typename?: 'PageInfo', page?: number | null, totalPages?: number | null } | null, data: Array<{ __typename?: 'DocumentationFile', id: string, name?: string | null, displayName?: string | null, folderId?: string | null, userId?: string | null, avResult?: string | null, createdAt?: any | null, virtualUserId?: string | null, isSeen?: boolean | null, fileGroupId?: string | null, folder?: { __typename?: 'DocumentationFolder', name?: string | null } | null, file?: { __typename?: 'File', id: string, name?: string | null, extension?: string | null } | null, virtualUser?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null, formattedBirthNumber?: string | null } | null } | null, isSeenMarkedBy?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null, user?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null, formattedBirthNumber?: string | null } | null, userRelations?: Array<{ __typename?: 'UserRelation', id?: number | null, type?: number | null, relationUser?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null> | null } | null, createdBy?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null, fileTransfers?: { __typename?: 'Meta', value?: any | null } | null, groupFiles?: Array<{ __typename?: 'DocumentationFile', id: string, name?: string | null, displayName?: string | null, createdAt?: any | null, thumbUrl?: string | null, userId?: string | null, folderId?: string | null, file?: { __typename?: 'File', id: string, name?: string | null, extension?: string | null } | null } | null> | null }> } | null };

export type TransferDocumentMutationVariables = Exact<{
  input?: InputMaybe<DocumentTransferInput>;
}>;


export type TransferDocumentMutation = { __typename?: 'Mutation', transferDocument?: { __typename?: 'DocumentationFile', id: string } | null };

export type TransferDocumentsMutationVariables = Exact<{
  input: DocumentsTransferInput;
}>;


export type TransferDocumentsMutation = { __typename?: 'Mutation', transferDocuments?: Array<{ __typename?: 'DocumentationFile', id: string } | null> | null };

export type GetUserOriginalIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetUserOriginalIdQuery = { __typename?: 'Query', user?: { __typename?: 'User', originalId?: string | null } | null };

export type WorkplacePatientDocumentationFilesMarkAsSeenMutationVariables = Exact<{ [key: string]: never; }>;


export type WorkplacePatientDocumentationFilesMarkAsSeenMutation = { __typename?: 'Mutation', workplacePatientDocumentationFilesMarkAsSeen?: { __typename?: 'MutationResult', status?: boolean | null } | null };

export type EducationMaterialsQueryVariables = Exact<{
  workplaceId?: InputMaybe<Scalars['UUID']>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type EducationMaterialsQuery = { __typename?: 'Query', educationMaterials?: { __typename?: 'EducationMaterialsResult', data?: Array<{ __typename?: 'EducationMaterial', id: string, name?: string | null } | null> | null } | null };

export type EventQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type EventQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, title?: string | null, dateFrom?: any | null, dateTo?: any | null, description?: string | null } | null };

export type EventsQueryVariables = Exact<{
  start?: InputMaybe<Scalars['DateTime']>;
  end?: InputMaybe<Scalars['DateTime']>;
  types?: InputMaybe<Array<InputMaybe<EventType>> | InputMaybe<EventType>>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  metaKey?: InputMaybe<Scalars['String']>;
}>;


export type EventsQuery = { __typename?: 'Query', events?: { __typename?: 'EventsResult', data?: Array<{ __typename?: 'Event', id: string, title?: string | null, dateFrom?: any | null, dateTo?: any | null, description?: string | null, type?: string | null, caseId?: string | null, layout?: any | null, calendar?: { __typename?: 'Calendar', workplaceId?: string | null, workplace?: { __typename?: 'Workplace', name?: string | null, doctorDisplayName?: string | null } | null } | null, eventMembers?: Array<{ __typename?: 'EventMember', id: string, userId?: string | null, status?: number | null, role?: number | null, user?: { __typename?: 'User', id: string, isPatient?: boolean | null, isDoctor?: boolean | null, formattedPhoneNumber?: string | null, profile?: { __typename?: 'Profile', fullName?: string | null, birthNumber?: string | null, age?: string | null } | null } | null } | null> | null, meta?: Array<{ __typename?: 'Meta', key?: string | null, value?: any | null } | null> | null } | null> | null } | null };

export type WorkplaceEventsQueryVariables = Exact<{
  start?: InputMaybe<Scalars['DateTime']>;
  end?: InputMaybe<Scalars['DateTime']>;
  types?: InputMaybe<Array<InputMaybe<EventType>> | InputMaybe<EventType>>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
}>;


export type WorkplaceEventsQuery = { __typename?: 'Query', workplaceEvents?: { __typename?: 'EventsResult', data?: Array<{ __typename?: 'Event', id: string, title?: string | null, dateFrom?: any | null, dateTo?: any | null, description?: string | null, type?: string | null, caseId?: string | null, layout?: any | null, calendar?: { __typename?: 'Calendar', workplaceId?: string | null, workplace?: { __typename?: 'Workplace', name?: string | null, doctorDisplayName?: string | null } | null } | null, eventMembers?: Array<{ __typename?: 'EventMember', id: string, userId?: string | null, state?: EventMemberState | null, status?: number | null, role?: number | null, user?: { __typename?: 'User', id: string, isPatient?: boolean | null, isDoctor?: boolean | null, isChild?: boolean | null, formattedPhoneNumber?: string | null, profile?: { __typename?: 'Profile', fullName?: string | null, birthNumber?: string | null, age?: string | null } | null } | null } | null> | null, meta?: Array<{ __typename?: 'Meta', key?: string | null, value?: any | null } | null> | null, createdBy?: { __typename?: 'User', isPatient?: boolean | null, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null> | null } | null };

export type GetOrdersQueryVariables = Exact<{
  filter?: InputMaybe<OrdersFilter>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetOrdersQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersResult', meta?: { __typename?: 'PageInfo', count?: number | null, page?: number | null, limit?: number | null, totalPages?: number | null } | null, data?: Array<{ __typename?: 'Order', id?: string | null, issueDate?: any | null, number?: string | null, priceInvoicing?: string | null, commission?: string | null, name?: string | null, invoices?: Array<{ __typename?: 'Invoice', id?: string | null, url?: string | null, number?: string | null } | null> | null, orderLogs?: Array<{ __typename?: 'OrderLog', type?: string | null } | null> | null, orderMembers?: Array<{ __typename?: 'OrderMember', userId?: string | null, type?: OrderMemberType | null, user?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null> | null } | null> | null } | null };

export type OrderStatisticsQueryVariables = Exact<{
  where?: InputMaybe<OrderStatisticsWhereInput>;
}>;


export type OrderStatisticsQuery = { __typename?: 'Query', orderStatistics?: { __typename?: 'OrderStatisticsResult', data?: Array<{ __typename?: 'OrderStatistics', label?: string | null, totalInvoiced?: number | null, totalCommission?: number | null, currency?: string | null } | null> | null } | null };

export type HealthPlanBabyPregnancyQueryVariables = Exact<{
  patientId: Scalars['UUID'];
}>;


export type HealthPlanBabyPregnancyQuery = { __typename?: 'Query', healthPlanBabyPregnancy?: { __typename?: 'HealthPlanBabyPregnancy', gestationalAgeFUM?: string | null, dateOfDelivery?: any | null } | null };

export type SubmitQuestionnaireResultMutationVariables = Exact<{
  input?: InputMaybe<SubmitQuestionnaireResultInput>;
}>;


export type SubmitQuestionnaireResultMutation = { __typename?: 'Mutation', submitQuestionnaireResult?: { __typename?: 'QuestionnaireResult', id: string, questionnaire?: { __typename?: 'Questionnaire', id: string, questionnaireItems?: Array<{ __typename?: 'QuestionnaireItem', id: string } | null> | null } | null } | null };

export type EndHealthPlanUserMutationVariables = Exact<{
  healthPlanUserId: Scalars['UUID'];
  questionnaireResultId?: InputMaybe<Scalars['UUID']>;
}>;


export type EndHealthPlanUserMutation = { __typename?: 'Mutation', endHealthPlanUser?: { __typename?: 'HealthPlanUser', id: string } | null };

export type CreateHealthPlanUserFromDataMutationVariables = Exact<{
  input?: InputMaybe<CreateHealthPlanUserFromDataInput>;
}>;


export type CreateHealthPlanUserFromDataMutation = { __typename?: 'Mutation', createHealthPlanUserFromData?: { __typename?: 'HealthPlanUser', id: string } | null };

export type HealthPlanUserInformationQueryVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type HealthPlanUserInformationQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, email?: string | null, meta?: Array<{ __typename?: 'Meta', key?: string | null, value?: any | null } | null> | null } | null };

export type HealthPlanUserItemIdQueryVariables = Exact<{
  healthPlanUserId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<Scalars['String']>;
  subtype?: InputMaybe<Scalars['String']>;
}>;


export type HealthPlanUserItemIdQuery = { __typename?: 'Query', healthPlanUserItem?: { __typename?: 'HealthPlanUserItem', id?: string | null } | null };

export type HealthPlanUserQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  healthPlanCode?: InputMaybe<Scalars['String']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
}>;


export type HealthPlanUserQuery = { __typename?: 'Query', healthPlanUser?: { __typename?: 'HealthPlanUser', id: string, healthPlanId?: string | null, activeMonth?: number | null, doctorId?: string | null, offerContent?: string | null, statusText?: string | null, isActive?: boolean | null, ready?: boolean | null, activeFrom?: any | null, activeTo?: any | null, doctor?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null, price?: { __typename?: 'Price', priceWithVat?: any | null, formattedPrice?: string | null } | null, pricing?: { __typename?: 'HealthPlanUserPricing', paymentMethod?: HealthPlanUserPricingPaymentMethod | null, totalPrice?: { __typename?: 'Price', id?: string | null, priceWithVat?: any | null, currency: string, formattedPrice?: string | null } | null, remainsToPay?: { __typename?: 'Price', id?: string | null, priceWithVat?: any | null, currency: string, formattedPrice?: string | null } | null } | null, healthPlan?: { __typename?: 'HealthPlan', code?: string | null, name?: string | null, totalMonths?: number | null } | null, periods?: Array<{ __typename?: 'HealthPlanPeriod', label?: string | null, value?: string | null, sale?: number | null, id: string } | null> | null } | null };

export type HealthPlanIdQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']>;
}>;


export type HealthPlanIdQuery = { __typename?: 'Query', healthPlan?: { __typename?: 'HealthPlan', id: string } | null };

export type HealthPlanDetailsQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']>;
}>;


export type HealthPlanDetailsQuery = { __typename?: 'Query', healthPlan?: { __typename?: 'HealthPlan', id: string, doctorInitialQuestionnaireCode?: string | null } | null };

export type CreateHealthPlanUserMutationVariables = Exact<{
  healthPlanId: Scalars['UUID'];
  userId: Scalars['UUID'];
  questionnaireResultId?: InputMaybe<Scalars['UUID']>;
}>;


export type CreateHealthPlanUserMutation = { __typename?: 'Mutation', createHealthPlanUser?: { __typename?: 'HealthPlanUser', id: string } | null };

export type HealthPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type HealthPlansQuery = { __typename?: 'Query', healthPlans?: { __typename?: 'HealthPlansResult', meta?: { __typename?: 'PageInfo', count?: number | null } | null, data?: Array<{ __typename?: 'HealthPlan', id: string, name?: string | null, code?: string | null } | null> | null } | null };

export type RequestPaymentHealthPlanUserMutationVariables = Exact<{
  input?: InputMaybe<RequestPaymentHealthPlanUserInput>;
}>;


export type RequestPaymentHealthPlanUserMutation = { __typename?: 'Mutation', requestPaymentHealthPlanUser?: { __typename?: 'HealthPlanUser', id: string } | null };

export type HealthPlanRequirementsQueryVariables = Exact<{
  where?: InputMaybe<HealthPlanUserItemWhereInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type HealthPlanRequirementsQuery = { __typename?: 'Query', healthPlanUserItems?: { __typename?: 'HealthPlanUserItemResult', meta?: { __typename?: 'PageInfo', page?: number | null, totalPages?: number | null } | null, data?: Array<{ __typename?: 'HealthPlanUserItem', id?: string | null, type?: string | null, extra?: any | null } | null> | null } | null };

export type HealthPlanUserIdQueryVariables = Exact<{
  patientId?: InputMaybe<Scalars['UUID']>;
  healthPlanCode?: InputMaybe<Scalars['String']>;
}>;


export type HealthPlanUserIdQuery = { __typename?: 'Query', healthPlanUser?: { __typename?: 'HealthPlanUser', id: string, healthPlanId?: string | null } | null };

export type HealthPlanUsersQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  healthPlanCode?: InputMaybe<HealthPlanCodeEnum>;
}>;


export type HealthPlanUsersQuery = { __typename?: 'Query', healthPlanUsers?: { __typename?: 'HealthPlanUsersResult', data?: Array<{ __typename?: 'HealthPlanUser', id: string, healthPlanId?: string | null, activeMonth?: number | null, doctorId?: string | null, offerContent?: string | null, statusText?: string | null, isActive?: boolean | null, ready?: boolean | null, activeFrom?: any | null, activeTo?: any | null, doctor?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null, price?: { __typename?: 'Price', priceWithVat?: any | null, formattedPrice?: string | null } | null, pricing?: { __typename?: 'HealthPlanUserPricing', paymentMethod?: HealthPlanUserPricingPaymentMethod | null, totalPrice?: { __typename?: 'Price', id?: string | null, priceWithVat?: any | null, currency: string, formattedPrice?: string | null } | null, remainsToPay?: { __typename?: 'Price', id?: string | null, priceWithVat?: any | null, currency: string, formattedPrice?: string | null } | null } | null, healthPlan?: { __typename?: 'HealthPlan', code?: string | null, name?: string | null, totalMonths?: number | null } | null, periods?: Array<{ __typename?: 'HealthPlanPeriod', label?: string | null, value?: string | null, sale?: number | null, id: string } | null> | null } | null> | null } | null };

export type HealthPlanUserBabyQueryVariables = Exact<{
  patientId: Scalars['UUID'];
}>;


export type HealthPlanUserBabyQuery = { __typename?: 'Query', healthPlanUser?: { __typename?: 'HealthPlanUser', healthPlanUserBaby?: { __typename?: 'HealthPlanUserBaby', gestionalAge?: string | null, dateOfBirth?: any | null } | null } | null };

export type InitialQuestionnaireResultQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  healthPlanCode?: InputMaybe<Scalars['String']>;
}>;


export type InitialQuestionnaireResultQuery = { __typename?: 'Query', healthPlanUser?: { __typename?: 'HealthPlanUser', id: string, initialQuestionnaireResult?: { __typename?: 'QuestionnaireResult', questionnaireResultItems?: Array<{ __typename?: 'QuestionnaireResultItem', valueJson?: any | null, question?: { __typename?: 'QuestionnaireItem', key?: string | null } | null } | null> | null } | null } | null };

export type QuestionnaireResultItemsQueryVariables = Exact<{
  questionnaireId?: InputMaybe<Scalars['UUID']>;
  questionnaireCode?: InputMaybe<Scalars['String']>;
  questionKey?: InputMaybe<Scalars['String']>;
  questionKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  patientId?: InputMaybe<Scalars['UUID']>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type QuestionnaireResultItemsQuery = { __typename?: 'Query', questionnaireResultItems?: { __typename?: 'QuestionnaireResultItemsResult', data?: Array<{ __typename?: 'QuestionnaireResultItem', id: string, value?: string | null, valueJson?: any | null, questionnaireResult?: { __typename?: 'QuestionnaireResult', id: string, createdAt?: any | null } | null, question?: { __typename?: 'QuestionnaireItem', id: string, key?: string | null, title?: string | null, questionnaire?: { __typename?: 'Questionnaire', id: string, code?: string | null, partnerId?: number | null } | null, parentQuestionnaireItem?: { __typename?: 'QuestionnaireItem', id: string } | null } | null, answer?: { __typename?: 'QuestionnaireItem', id: string, value?: string | null, title?: string | null, subtitle?: string | null, childQuestionnaireItems?: Array<{ __typename?: 'QuestionnaireItem', id: string, title?: string | null, subtitle?: string | null, value?: string | null } | null> | null } | null } | null> | null } | null };

export type QuestionnaireIdQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']>;
}>;


export type QuestionnaireIdQuery = { __typename?: 'Query', questionnaire?: { __typename?: 'Questionnaire', id: string } | null };

export type WorkplaceHealthPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkplaceHealthPlansQuery = { __typename?: 'Query', workplaceHealthPlans?: { __typename?: 'HealthPlansResult', meta?: { __typename?: 'PageInfo', count?: number | null } | null, data?: Array<{ __typename?: 'HealthPlan', id: string, name?: string | null, code?: string | null, structure?: { __typename?: 'HealthPlanStructure', name: string, settings?: any | null, steps?: Array<{ __typename?: 'HealthPlanStructureStep', key: string, name: string, type?: HealthPlanStructureStepTypeEnum | null, settings?: any | null } | null> | null } | null } | null> | null } | null };

export type CreateInsuranceReportExportFilesMutationVariables = Exact<{
  input: CreateInsuranceReportExportFiles;
}>;


export type CreateInsuranceReportExportFilesMutation = { __typename?: 'Mutation', createInsuranceReportExportFiles?: string | null };

export type DeleteInsuranceReportMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteInsuranceReportMutation = { __typename?: 'Mutation', deleteInsuranceReport?: { __typename?: 'MutationResult', status?: boolean | null } | null };

export type InsuranceOperationCreateMutationVariables = Exact<{
  input?: InputMaybe<CreateOperationReportInput>;
}>;


export type InsuranceOperationCreateMutation = { __typename?: 'Mutation', createInsuranceOperation?: { __typename?: 'InsuranceOperation', id: string } | null };

export type InsuranceOperationDeleteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type InsuranceOperationDeleteMutation = { __typename?: 'Mutation', deleteInsuranceOperation?: { __typename?: 'MutationResult', status?: boolean | null } | null };

export type InsuranceOperationsQueryVariables = Exact<{
  where: InsuranceOperationsWhereInput;
}>;


export type InsuranceOperationsQuery = { __typename?: 'Query', insuranceOperations?: { __typename?: 'InsuranceOperationResult', data?: Array<{ __typename?: 'InsuranceOperation', id: string, code?: string | null, title?: string | null, points?: number | null, pricePerPoint?: number | null } | null> | null } | null };

export type InsuranceReportQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type InsuranceReportQuery = { __typename?: 'Query', insuranceReport?: { __typename?: 'InsuranceReport', id: string, createdAt?: any | null, birthNumber?: string | null, diagnosis?: string | null, count?: number | null, points?: number | null, operation?: { __typename?: 'InsuranceOperation', id: string, title?: string | null } | null } | null };

export type InsuranceReportCreateMutationVariables = Exact<{
  input: CreateInsuranceReportInput;
}>;


export type InsuranceReportCreateMutation = { __typename?: 'Mutation', createInsuranceReport?: { __typename?: 'InsuranceReport', id: string } | null };

export type InsuranceReportUserDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type InsuranceReportUserDataQuery = { __typename?: 'Query', user?: { __typename?: 'User', profile?: { __typename?: 'Profile', birthNumber?: string | null, insuranceCompanyTermItemId?: string | null } | null } | null };

export type InsuranceReportsQueryVariables = Exact<{
  where: InsuranceReportsWhereInput;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type InsuranceReportsQuery = { __typename?: 'Query', insuranceReports?: { __typename?: 'InsuranceReportsResult', meta?: { __typename?: 'PageInfo', page?: number | null, totalPages?: number | null } | null, data?: Array<{ __typename?: 'InsuranceReport', id: string, createdAt?: any | null, birthNumber?: string | null, diagnosis?: string | null, count?: number | null, points?: number | null, operation?: { __typename?: 'InsuranceOperation', id: string, title?: string | null } | null } | null> | null } | null };

export type AddLaboratoryRequisitionToPatientMutationVariables = Exact<{
  input: AddLaboratoryRequisitionToPatientInput;
}>;


export type AddLaboratoryRequisitionToPatientMutation = { __typename?: 'Mutation', addLaboratoryRequisitionToPatient?: { __typename?: 'DocumentationFile', id: string } | null };

export type CreateLaboratoryWorkplaceMutationVariables = Exact<{
  input: CreateLaboratoryWorkplaceInput;
}>;


export type CreateLaboratoryWorkplaceMutation = { __typename?: 'Mutation', createLaboratoryWorkplace?: { __typename?: 'LaboratoryWorkplace', id: string } | null };

export type CreateLaboratoryRequisitionWorkplaceMutationVariables = Exact<{
  input: CreateLaboratoryRequisitionWorkplaceInput;
}>;


export type CreateLaboratoryRequisitionWorkplaceMutation = { __typename?: 'Mutation', createLaboratoryRequisitionWorkplace?: { __typename?: 'LaboratoryRequisitionWorkplace', id: string, workplaceId: string, laboratoryRequisition?: { __typename?: 'LaboratoryRequisition', id: string, name?: string | null } | null } | null };

export type DeleteLaboratoryRequisitionWorkplaceMutationVariables = Exact<{
  input: DeleteLaboratoryRequisitionWorkplaceInput;
}>;


export type DeleteLaboratoryRequisitionWorkplaceMutation = { __typename?: 'Mutation', deleteLaboratoryRequisitionWorkplace?: string | null };

export type DeleteLaboratoryWorkplaceMutationVariables = Exact<{
  input: DeleteLaboratoryWorkplaceInput;
}>;


export type DeleteLaboratoryWorkplaceMutation = { __typename?: 'Mutation', deleteLaboratoryWorkplace?: string | null };

export type HideSeenLaboratoryResultsMutationVariables = Exact<{
  input: HideSeenLaboratoryResultsInput;
}>;


export type HideSeenLaboratoryResultsMutation = { __typename?: 'Mutation', hideSeenLaboratoryResults?: Array<{ __typename?: 'LaboratoryResultResult', id: string } | null> | null };

export type IssuedLaboratoryRequestsQueryVariables = Exact<{
  where: LaboratoryRequisitionResultsWhereInput;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationInputOrder>;
}>;


export type IssuedLaboratoryRequestsQuery = { __typename?: 'Query', laboratoryRequisitionResults?: { __typename?: 'LaboratoryRequisitionResultsResult', meta?: { __typename?: 'PageInfo', totalPages?: number | null, page?: number | null } | null, data?: Array<{ __typename?: 'LaboratoryRequisitionResult', id: string, createdAt: any, laboratoryExaminationRequestPatientId?: string | null, requisition?: { __typename?: 'LaboratoryRequisition', name?: string | null, laboratory: { __typename?: 'Laboratory', name: string } } | null, laboratoryExaminationRequest?: { __typename?: 'DocumentationFile', id: string, name?: string | null, folderId?: string | null, userId?: string | null, createdAt?: any | null, file?: { __typename?: 'File', id: string, name?: string | null, extension?: string | null } | null } | null } | null> | null } | null };

export type LaboratoriesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type LaboratoriesQuery = { __typename?: 'Query', laboratories?: { __typename?: 'LaboratoryResult', data?: Array<{ __typename?: 'Laboratory', id: string, name: string, code: string } | null> | null } | null };

export type LaboratoryRequestCreateMutationVariables = Exact<{
  input: SaveLaboratoryRequisitionResultInput;
}>;


export type LaboratoryRequestCreateMutation = { __typename?: 'Mutation', saveLaboratoryRequisitionResult?: { __typename?: 'LaboratoryRequisitionResult', id: string } | null };

export type LaboratoryRequestFormQueryVariables = Exact<{
  where: LaboratoryRequisitionFormWhereInput;
}>;


export type LaboratoryRequestFormQuery = { __typename?: 'Query', laboratoryRequisitionForm?: { __typename?: 'LaboratoryRequisitionFormResult', requisition?: { __typename?: 'LaboratoryRequisition', name?: string | null, laboratory: { __typename?: 'Laboratory', name: string } } | null, form?: { __typename?: 'LaboratoryRequisitionForm', settings?: any | null, children?: any | null, samples?: Array<{ __typename?: 'LaboratoryRequisitionSample', key: string, name?: string | null } | null> | null } | null } | null };

export type LaboratoryRequestsQueryVariables = Exact<{
  where: LaboratoryRequisitionsWhereInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type LaboratoryRequestsQuery = { __typename?: 'Query', laboratoryRequisitions?: { __typename?: 'LaboratoryRequisitionsResult', data: Array<{ __typename?: 'LaboratoryRequisition', id: string, name?: string | null, createdAt?: any | null, allowed?: boolean | null, laboratory: { __typename?: 'Laboratory', name: string } }> } | null };

export type LaboratoryResultsQueryVariables = Exact<{
  where: LaboratoryResultsWhereInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type LaboratoryResultsQuery = { __typename?: 'Query', laboratoryResults?: { __typename?: 'LaboratoryResultsResult', meta?: { __typename?: 'PageInfo', page?: number | null, totalPages?: number | null } | null, data: Array<{ __typename?: 'LaboratoryResultResult', id: string, createdAt: any, isSeen?: boolean | null, user: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null } | null }, laboratory?: { __typename?: 'Laboratory', name: string } | null, laboratoryResultItems: Array<{ __typename?: 'LaboratoryResultItem', id: string, createdAt: any, name?: string | null, result?: number | null, chart?: string | null, unit?: string | null, lowerReferenceValue?: number | null, upperReferenceValue?: number | null, acceptedAt?: any | null, acceptedBy?: string | null, processedAt?: any | null, processedBy?: string | null, evaluation?: { __typename?: 'LaboratoryResultItemEvaluation', value?: number | null, type?: string | null, color?: string | null } | null }>, isSeenMarkedBy?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null }> } | null };

export type LaboratoryWorkplacesQueryVariables = Exact<{
  where: LaboratoryWorkplacesWhereInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type LaboratoryWorkplacesQuery = { __typename?: 'Query', laboratoryWorkplaces?: { __typename?: 'LaboratoryWorkplacesResult', data: Array<{ __typename?: 'LaboratoryWorkplace', id: string, laboratory?: { __typename?: 'Laboratory', id: string, name: string } | null }> } | null };

export type AllCertificatesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCertificatesQuery = { __typename?: 'Query', termItems?: { __typename?: 'TermItemsResult', data?: Array<{ __typename?: 'TermItem', id: string, value?: string | null, name?: string | null } | null> | null } | null };

export type AllHealthPlansQueryVariables = Exact<{
  all?: InputMaybe<Scalars['Boolean']>;
}>;


export type AllHealthPlansQuery = { __typename?: 'Query', healthPlans?: { __typename?: 'HealthPlansResult', data?: Array<{ __typename?: 'HealthPlan', id: string, name?: string | null, code?: string | null, active?: boolean | null, description?: string | null, settings?: any | null } | null> | null } | null };

export type AvailableServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableServicesQuery = { __typename?: 'Query', termItems?: { __typename?: 'TermItemsResult', data?: Array<{ __typename?: 'TermItem', id: string, value?: string | null } | null> | null } | null };

export type CreateHealthPlanWorkplaceMutationVariables = Exact<{
  input?: InputMaybe<CreateHealthPlanWorkplaceInput>;
}>;


export type CreateHealthPlanWorkplaceMutation = { __typename?: 'Mutation', createHealthPlanWorkplace?: { __typename?: 'HealthPlanWorkplace', id?: string | null } | null };

export type DeleteHealthPlanWorkplaceMutationVariables = Exact<{
  input?: InputMaybe<RemoveHealthPlanWorkplaceInput>;
}>;


export type DeleteHealthPlanWorkplaceMutation = { __typename?: 'Mutation', deleteHealthPlanWorkplace?: { __typename?: 'HealthPlanWorkplace', id?: string | null } | null };

export type SimpleWorkerInformationQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type SimpleWorkerInformationQuery = { __typename?: 'Query', user?: { __typename?: 'User', profileImageUrl?: string | null, formattedPhoneNumber?: string | null, email?: string | null, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null };

export type UpdateWorkplaceMemberMutationVariables = Exact<{
  input?: InputMaybe<UpdateWorkplaceMembersInput>;
}>;


export type UpdateWorkplaceMemberMutation = { __typename?: 'Mutation', updateWorkplaceMembers?: Array<{ __typename?: 'WorkplaceMember', id: string } | null> | null };

export type WorkerInformationQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type WorkerInformationQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', nationalityTermItem?: { __typename?: 'TermItem', id: string, name?: string | null, value?: string | null } | null } | null, meta?: Array<{ __typename?: 'Meta', key?: string | null, value?: any | null } | null> | null } | null };

export type WorkerWorkplacesQueryVariables = Exact<{
  rootWorkplaceId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type WorkerWorkplacesQuery = { __typename?: 'Query', workplaceMembers?: { __typename?: 'WorkplaceMembersResult', data?: Array<{ __typename?: 'WorkplaceMember', id: string, code?: string | null, memberSearchableOutside?: boolean | null, workplace?: { __typename?: 'Workplace', id: string, name?: string | null } | null, workplaceMemberRoles?: Array<{ __typename?: 'WorkplaceMemberRole', role?: { __typename?: 'AclRole', id?: string | null, name?: string | null, key?: string | null } | null } | null> | null } | null> | null } | null };

export type WorkplaceBasicDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type WorkplaceBasicDataQuery = { __typename?: 'Query', workplace?: { __typename?: 'Workplace', id: string, parentWorkplaceId?: string | null, name?: string | null, codeName?: string | null, phone?: string | null, calendarEmailNotification?: boolean | null, memberSearchableOutside?: boolean | null, workplaceSearchableOutside?: boolean | null, createCaseTarget?: CreateCaseTarget | null, onlineOrderTarget?: OnlineOrderTarget | null, defaultDoctorId?: string | null, defaultInvitation?: boolean | null, parentWorkplace?: { __typename?: 'Workplace', id: string, doctorDisplayName?: string | null } | null, address?: { __typename?: 'Address', street?: string | null, descriptiveNumber?: string | null, guideNumber?: string | null, city?: string | null, postCode?: string | null } | null, termItems?: Array<{ __typename?: 'TermItem', id: string, value?: string | null, term?: { __typename?: 'Term', type?: string | null, name?: string | null } | null } | null> | null, meta?: Array<{ __typename?: 'Meta', id: string, key?: string | null, value?: any | null } | null> | null } | null };

export type FullWorkplaceCaseTypeQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type FullWorkplaceCaseTypeQuery = { __typename?: 'Query', workplaceCaseType?: { __typename?: 'WorkplaceCaseType', id: string, workplaceId?: string | null, canSearchDoctor?: boolean | null, canSendToAmbulance?: boolean | null, canSelectTransport?: boolean | null, workplaceDefaultCaseType?: boolean | null, labelTranslations?: Array<{ __typename?: 'Translation', key?: string | null, language?: string | null, value?: string | null } | null> | null, caseType?: { __typename?: 'CaseType', id?: string | null, rank?: number | null, canBookOnline?: boolean | null, canBookOnSite?: boolean | null, canOrderImmediate?: boolean | null, priceId?: string | null, code?: string | null, label?: string | null, parentCaseTypeId?: string | null, hiddenForPatient?: boolean | null, eventInterval?: number | null, notificationCase?: boolean | null, notificationBook?: boolean | null, isEditable?: boolean | null, price?: { __typename?: 'Price', id?: string | null, priceWithVat?: any | null, priceWithVatRaw?: string | null, vatRate: number } | null, caseTypeItems?: Array<{ __typename?: 'CaseTypeItem', id: string, rank?: number | null, title?: string | null, description?: string | null, settings?: any | null, key?: string | null, type?: string | null, subtype?: string | null } | null> | null } | null } | null };

export type WorkplaceCertificatesQueryVariables = Exact<{
  where: WorkplaceCertificatesWhereInput;
}>;


export type WorkplaceCertificatesQuery = { __typename?: 'Query', workplaceCertificates?: { __typename?: 'WorkplaceCertificatesResult', data?: Array<{ __typename?: 'WorkplaceCertificate', name: string, description?: string | null, type: WorkplaceCertificateType, certificate?: { __typename?: 'Certificate', id?: string | null, type?: string | null, expires?: any | null, isExpired?: boolean | null } | null } | null> | null } | null };

export type WorkplaceWorkersListQueryVariables = Exact<{
  rootWorkplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  fulltext?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type WorkplaceWorkersListQuery = { __typename?: 'Query', doctors?: { __typename?: 'UsersResult', meta?: { __typename?: 'PageInfo', count?: number | null, page?: number | null, totalPages?: number | null } | null, data?: Array<{ __typename?: 'User', id: string, email?: string | null, profileImageUrl?: string | null, rootWorkplaceMemberStatus?: string | null, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null> | null } | null };

export type WorkplacesCsszQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkplacesCsszQuery = { __typename?: 'Query', workplaces?: { __typename?: 'WorkplacesResult', data?: Array<{ __typename?: 'Workplace', id: string, name?: string | null, meta?: Array<{ __typename?: 'Meta', id: string, key?: string | null, value?: any | null } | null> | null } | null> | null } | null };

export type WorkplacesSuklCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkplacesSuklCodeQuery = { __typename?: 'Query', workplaces?: { __typename?: 'WorkplacesResult', data?: Array<{ __typename?: 'Workplace', id: string, name?: string | null, meta?: Array<{ __typename?: 'Meta', id: string, key?: string | null, value?: any | null } | null> | null } | null> | null } | null };

export type MedicalRequestFormsQueryVariables = Exact<{ [key: string]: never; }>;


export type MedicalRequestFormsQuery = { __typename?: 'Query', medicalRequestForms?: { __typename?: 'MedicalRequestFormsResult', data?: Array<{ __typename?: 'MedicalRequestForm', id: string, name?: string | null, type?: string | null, wizardKey?: string | null } | null> | null } | null };

export type CreateUserMetaTranslationMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<UserMetaTranslationInput>> | InputMaybe<UserMetaTranslationInput>>;
}>;


export type CreateUserMetaTranslationMutation = { __typename?: 'Mutation', createUserMetaTranslation?: { __typename?: 'User', id: string } | null };

export type MetaQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  key: Scalars['String'];
  useOriginalId?: InputMaybe<Scalars['Boolean']>;
}>;


export type MetaQuery = { __typename?: 'Query', meta?: { __typename?: 'Meta', id: string, value?: any | null, key?: string | null } | null };

export type MyMetaQueryVariables = Exact<{ [key: string]: never; }>;


export type MyMetaQuery = { __typename?: 'Query', me?: { __typename?: 'User', meta?: Array<{ __typename?: 'Meta', key?: string | null, value?: any | null } | null> | null } | null };

export type AssignCaseMutationVariables = Exact<{
  caseId: Scalars['UUID'];
  workplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceMemberId?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
}>;


export type AssignCaseMutation = { __typename?: 'Mutation', assignCase?: { __typename?: 'Case', id?: string | null } | null };

export type MonitoringCentreCasesQueryVariables = Exact<{
  caseTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  priorityId?: InputMaybe<Scalars['UUID']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  date?: InputMaybe<Scalars['Date']>;
  caseStatusValue?: InputMaybe<Scalars['String']>;
  parentCaseTypeId?: InputMaybe<Scalars['UUID']>;
  caseTypeCode?: InputMaybe<Scalars['String']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  attendingDoctorId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  solved?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<CaseCreateDay>;
  code?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  solvedAtRange?: InputMaybe<DateFilter>;
  createdAtRange?: InputMaybe<DateFilter>;
  patient?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<PaginationInputOrder>;
}>;


export type MonitoringCentreCasesQuery = { __typename?: 'Query', monitoringCentreCases?: { __typename?: 'CasesResult', meta?: { __typename?: 'PageInfo', totalPages?: number | null, page?: number | null, count?: number | null } | null, data?: Array<{ __typename?: 'Case', id?: string | null, title?: string | null, isNew?: boolean | null, isAssigned?: boolean | null, isMyCase?: boolean | null, isImmediate?: any | null, createdAt?: any | null, solveTo?: any | null, patientDescription?: string | null, diagnosis?: string | null, totalUnreadCaseEntries?: number | null, code?: string | null, updatedAt?: any | null, medicationLasted?: Array<any | null> | null, lastNote?: { __typename?: 'Note', id?: string | null, text?: string | null } | null, patient?: { __typename?: 'User', id: string, profileImageUrl?: string | null, originalId?: string | null, profile?: { __typename?: 'Profile', fullName?: string | null, age?: string | null, formattedBirthNumber?: string | null, address?: { __typename?: 'Address', city?: string | null } | null, insuranceCompanyTermItem?: { __typename?: 'TermItem', name?: string | null, value?: string | null } | null } | null, userRelations?: Array<{ __typename?: 'UserRelation', id?: number | null, relationUser?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null, salutationBefore?: string | null, lastName?: string | null } | null } | null } | null> | null, avatarFile?: { __typename?: 'File', createdAt?: any | null } | null } | null, patientParent?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null, workplace?: { __typename?: 'Workplace', id: string, name?: string | null, doctorDisplayName?: string | null, codeName?: string | null } | null, doctor?: { __typename?: 'User', id: string, profileImageUrl?: string | null, profile?: { __typename?: 'Profile', age?: string | null, fullName?: string | null, salutationBefore?: string | null, lastName?: string | null } | null } | null, lastCaseEntry?: { __typename?: 'CaseEntry', message?: string | null, createdAt?: any | null } | null, medicalReports?: Array<{ __typename?: 'MedicalReport', id?: number | null, diagnosis?: string | null, treatment?: string | null, note?: string | null, createdAt?: any | null, documentId?: string | null, type?: string | null, document?: { __typename?: 'Document', id: string, type?: string | null, title?: { __typename?: 'DocumentItem', extra?: any | null } | null } | null } | null> | null, priority?: { __typename?: 'TermItem', id: string, name?: string | null, value?: string | null, value2?: string | null, value3?: string | null } | null, caseType?: { __typename?: 'CaseType', id?: string | null, label?: string | null, type?: string | null, code?: string | null, rootCaseType?: { __typename?: 'CaseType', id?: string | null, label?: string | null, type?: string | null } | null } | null } | null> | null } | null };

export type PriorityCaseMutationVariables = Exact<{
  input?: InputMaybe<PriorityCaseInput>;
}>;


export type PriorityCaseMutation = { __typename?: 'Mutation', priorityCase?: { __typename?: 'Case', id?: string | null, priorityId?: string | null, priority?: { __typename?: 'TermItem', name?: string | null, value?: string | null, value2?: string | null } | null } | null };

export type CasesAssignedCountQueryVariables = Exact<{ [key: string]: never; }>;


export type CasesAssignedCountQuery = { __typename?: 'Query', casesAssigned?: { __typename?: 'CasesResult', meta?: { __typename?: 'PageInfo', count?: number | null } | null } | null };

export type QuestionnaireResultsCountQueryVariables = Exact<{
  type?: InputMaybe<QuestionnaireResultResult>;
  seen?: InputMaybe<Scalars['Boolean']>;
  questionnaireCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  doctorId?: InputMaybe<Scalars['UUID']>;
}>;


export type QuestionnaireResultsCountQuery = { __typename?: 'Query', questionnaireResults?: { __typename?: 'QuestionnaireResultsResult', meta?: { __typename?: 'PageInfo', count?: number | null } | null } | null };

export type WorkplaceCasesCountQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkplaceCasesCountQuery = { __typename?: 'Query', workplaceCases?: { __typename?: 'CasesResult', meta?: { __typename?: 'PageInfo', count?: number | null } | null } | null };

export type WorkplacePatientDocumentationFilesCountQueryVariables = Exact<{
  workplaceId?: InputMaybe<Scalars['UUID']>;
}>;


export type WorkplacePatientDocumentationFilesCountQuery = { __typename?: 'Query', workplacePatientDocumentationFiles?: { __typename?: 'DocumentationFilesResult', meta?: { __typename?: 'PageInfo', count?: number | null } | null } | null };

export type NcziListDiagnosisItemsQueryVariables = Exact<{
  fulltext?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type NcziListDiagnosisItemsQuery = { __typename?: 'Query', items?: { __typename?: 'NcziDiagnosisItemsResult', meta?: { __typename?: 'PageInfo', count?: number | null, page?: number | null, limit?: number | null, totalPages?: number | null } | null, data?: Array<{ __typename?: 'NcziDiagnosisItem', code: string, ncziCode: string, name: string, enum: { __typename?: 'NcziEnum', oid: string, version: string } } | null> | null } | null };

export type NcziListEnumItemsQueryVariables = Exact<{
  oid: Scalars['String'];
  fulltext?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type NcziListEnumItemsQuery = { __typename?: 'Query', items?: { __typename?: 'NcziEnumItemsResult', meta?: { __typename?: 'PageInfo', count?: number | null, page?: number | null, limit?: number | null, totalPages?: number | null } | null, data?: Array<{ __typename?: 'NcziEnumItem', code: string, name: string, abbreviation?: string | null, description?: string | null, enum: { __typename?: 'NcziEnum', oid: string, version: string } } | null> | null } | null };

export type NcziRefrenceItemQueryVariables = Exact<{
  oid: Scalars['String'];
  code: Scalars['String'];
}>;


export type NcziRefrenceItemQuery = { __typename?: 'Query', item?: { __typename?: 'NcziEnumItem', code: string, name: string, abbreviation?: string | null, description?: string | null, params?: any | null, enum: { __typename?: 'NcziEnum', oid: string, version: string } } | null };

export type NcziRefrenceItemsByCodeQueryVariables = Exact<{
  oid: Scalars['String'];
  code: Array<Scalars['String']> | Scalars['String'];
}>;


export type NcziRefrenceItemsByCodeQuery = { __typename?: 'Query', items?: { __typename?: 'NcziEnumItemsByCodeResult', enumItems?: Array<{ __typename?: 'NcziEnumItem', code: string, name: string, abbreviation?: string | null, description?: string | null } | null> | null } | null };

export type NcziRefrenceItemByAbbrQueryVariables = Exact<{
  oid: Scalars['String'];
  abbr: Scalars['String'];
}>;


export type NcziRefrenceItemByAbbrQuery = { __typename?: 'Query', item?: { __typename?: 'NcziEnumItem', code: string, name: string, abbreviation?: string | null, description?: string | null, params?: any | null, enum: { __typename?: 'NcziEnum', oid: string, version: string } } | null };

export type NcziListEnumsQueryVariables = Exact<{ [key: string]: never; }>;


export type NcziListEnumsQuery = { __typename?: 'Query', result?: { __typename?: 'NcziEnumsResult', data?: Array<{ __typename?: 'NcziEnum', name: string, oid: string, version: string, type: string } | null> | null } | null };

export type NcziListExtensionItemsQueryVariables = Exact<{
  oid: Scalars['String'];
  fulltext?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  vaccination?: InputMaybe<Scalars['Boolean']>;
}>;


export type NcziListExtensionItemsQuery = { __typename?: 'Query', items?: { __typename?: 'NcziExtensionItemsResult', meta?: { __typename?: 'PageInfo', count?: number | null, page?: number | null, limit?: number | null, totalPages?: number | null } | null, data?: Array<{ __typename?: 'NcziExtensionItem', code: string, name: string, abbreviation?: string | null, params?: any | null, extension: { __typename?: 'NcziExtension', name: string, oid: string } } | null> | null } | null };

export type NcziExtensionItemQueryVariables = Exact<{
  oid: Scalars['String'];
  code: Scalars['String'];
}>;


export type NcziExtensionItemQuery = { __typename?: 'Query', item?: { __typename?: 'NcziExtensionItem', code: string, name: string, abbreviation?: string | null, params?: any | null, extension: { __typename?: 'NcziExtension', name: string, oid: string } } | null };

export type NcziExtensionItemByAbbrQueryVariables = Exact<{
  oid: Scalars['String'];
  abbr: Scalars['String'];
}>;


export type NcziExtensionItemByAbbrQuery = { __typename?: 'Query', item?: { __typename?: 'NcziExtensionItem', code: string, name: string, abbreviation?: string | null, params?: any | null, extension: { __typename?: 'NcziExtension', name: string, oid: string } } | null };

export type NcziMedicamentQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type NcziMedicamentQuery = { __typename?: 'Query', medicament?: { __typename?: 'NcziMedicamentItem', code: string, name: string, additionalName: string, opl: boolean, multiplePrescription: boolean, antibioticsChemotherapy: boolean } | null };

export type FindOupzsQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type FindOupzsQuery = { __typename?: 'Query', items?: Array<{ __typename?: 'NcziOUPZsItem', code: string, name: string, extension?: { __typename?: 'NcziNExtension', code: string, scheme: { __typename?: 'NcziCodingScheme', oid: string } } | null, provider?: { __typename?: 'NcziPZSProvider', code: string, name: string, extension?: { __typename?: 'NcziNExtension', code: string, scheme: { __typename?: 'NcziCodingScheme', oid: string } } | null } | null, specialization?: Array<{ __typename?: 'NcziZPrSpecialization', ZPrCode: string, specialization: { __typename?: 'NcziReference', displayName: string, code: string, scheme: { __typename?: 'NcziCodingSchemeVersioned', oid: string, version: string } } } | null> | null } | null> | null };

export type NcziProductListQueryVariables = Exact<{
  fulltext?: InputMaybe<Scalars['String']>;
}>;


export type NcziProductListQuery = { __typename?: 'Query', items?: { __typename?: 'NcziProductItemsResult', data?: Array<{ __typename?: 'NcziProductItem', code: string, name: string, additionalName?: string | null, opl?: boolean | null, antibioticsChemotherapy?: boolean | null, type: string, tailored?: boolean | null, atcCode?: string | null, atcName?: string | null, atcAddon?: string | null, ioNeeded?: boolean | null, ioOptions?: Array<string | null> | null, ventilator?: boolean | null, quantityLimit?: Array<string | null> | null } | null> | null } | null };

export type NcziProductQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type NcziProductQuery = { __typename?: 'Query', product?: { __typename?: 'NcziProductItem', code: string, name: string, additionalName?: string | null, opl?: boolean | null, antibioticsChemotherapy?: boolean | null, type: string, tailored?: boolean | null, atcCode?: string | null, atcName?: string | null, atcAddon?: string | null, ioNeeded?: boolean | null, ioOptions?: Array<string | null> | null, ventilator?: boolean | null, quantityLimit?: Array<string | null> | null } | null };

export type NcziQueueQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type NcziQueueQuery = { __typename?: 'Query', items?: { __typename?: 'NcziQueueResult', data?: Array<{ __typename?: 'NcziMessage', id: string, userId: string, type?: string | null, lastState?: string | null, createdAt?: string | null, updatedAt?: string | null, finished?: boolean | null } | null> | null, meta?: { __typename?: 'PageInfo', count?: number | null } | null } | null };

export type UserBirthNumberQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type UserBirthNumberQuery = { __typename?: 'Query', user?: { __typename?: 'User', profile?: { __typename?: 'Profile', birthNumber?: string | null } | null } | null };

export type UserNcziProfileQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type UserNcziProfileQuery = { __typename?: 'Query', user?: { __typename?: 'User', profile?: { __typename?: 'Profile', birthNumber?: string | null, insuranceCompanyTermItem?: { __typename?: 'TermItem', name?: string | null, value?: string | null, value2?: string | null, value3?: string | null } | null } | null } | null };

export type MarkAllNotificationsAsSeenMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllNotificationsAsSeenMutation = { __typename?: 'Mutation', markAsSeenUserNotifications?: { __typename?: 'MarkAsSeenUserNotificationsResult', success?: boolean | null } | null };

export type ConversationMessageQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type ConversationMessageQuery = { __typename?: 'Query', message?: { __typename?: 'Message', id: string, conversationId?: string | null, content?: any | null, createdAt?: any | null } | null };

export type NotificationConversationQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type NotificationConversationQuery = { __typename?: 'Query', conversation?: { __typename?: 'Conversation', id: string, name?: string | null, type?: ConversationType | null, createdAt?: any | null, conversationMembers?: Array<{ __typename?: 'ConversationMember', userId?: string | null, user?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null> | null, lastMessage?: { __typename?: 'Message', id: string, content?: any | null, type?: string | null, sender?: { __typename?: 'MessageMember', user?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null, messageAttachments?: Array<{ __typename?: 'MessageAttachment', id: string, type?: MessageAttachmentType | null, questionnaireId?: string | null, educationMaterialId?: string | null, message?: { __typename?: 'Message', content?: any | null } | null, questionnaire?: { __typename?: 'Questionnaire', title?: string | null } | null, educationMaterial?: { __typename?: 'EducationMaterial', name?: string | null } | null } | null> | null } | null } | null };

export type ListNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListNotificationsQuery = { __typename?: 'Query', items?: { __typename?: 'MessagesResult', data?: Array<{ __typename: 'Message', id: string, type?: string | null, createdAt?: any | null, content?: any | null, conversationId?: string | null, myMessageMember?: { __typename?: 'MessageMember', id: string, seen?: boolean | null } | null, sender?: { __typename?: 'MessageMember', id: string, user?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', id: string, fullName?: string | null } | null } | null } | null } | null> | null, meta?: { __typename?: 'PageInfo', count?: number | null, page?: number | null, totalPages?: number | null } | null } | null };

export type UnreadNotificationQueryVariables = Exact<{ [key: string]: never; }>;


export type UnreadNotificationQuery = { __typename?: 'Query', userNotice?: { __typename?: 'UserNotice', unreadNotifications?: number | null } | null };

export type SetUserNotificationSettingsMutationVariables = Exact<{
  input: SetUserNotificationSettingInput;
}>;


export type SetUserNotificationSettingsMutation = { __typename?: 'Mutation', setUserNotificationSetting?: { __typename?: 'UserNotificationSetting', id: string } | null };

export type UserNotificationSettingsQueryVariables = Exact<{
  where: UserNotificationSettingsWhereInput;
}>;


export type UserNotificationSettingsQuery = { __typename?: 'Query', userNotificationSettings?: { __typename?: 'UserNotificationSettingsResult', data?: Array<{ __typename?: 'UserNotificationSetting', id: string, sending: boolean, typeTermItemId: string } | null> | null } | null };

export type ArchiveWorkplaceMemberMutationVariables = Exact<{
  input?: InputMaybe<DeleteWorkplaceMemberInput>;
}>;


export type ArchiveWorkplaceMemberMutation = { __typename?: 'Mutation', deleteWorkplaceMember?: { __typename?: 'MutationResult', status?: boolean | null } | null };

export type PatientDataQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type PatientDataQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, isChild?: boolean | null, profile?: { __typename?: 'Profile', id: string, firstName?: string | null, lastName?: string | null, birthDate?: string | null, address?: { __typename?: 'Address', id: string, street?: string | null, descriptiveNumber?: string | null, guideNumber?: string | null, city?: string | null, postCode?: string | null } | null } | null } | null };

export type PatientMetaQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type PatientMetaQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, meta?: Array<{ __typename?: 'Meta', id: string, key?: string | null, value?: any | null, workplaceId?: string | null } | null> | null } | null };

export type PatientBasicInfoQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type PatientBasicInfoQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', birthNumber?: string | null, id: string, fullName?: string | null } | null } | null };

export type WorkplacePatientsQueryVariables = Exact<{
  fulltext?: InputMaybe<Scalars['String']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
}>;


export type WorkplacePatientsQuery = { __typename?: 'Query', workplacePatients?: { __typename?: 'WorkplaceMembersResult', data?: Array<{ __typename: 'WorkplaceMember', id: string, user?: { __typename?: 'User', id: string, originalId?: string | null, profile?: { __typename?: 'Profile', id: string, fullName?: string | null, timezone?: string | null, formattedBirthNumber?: string | null, birthDate?: string | null, birthNumber?: string | null, address?: { __typename?: 'Address', fullAddress?: string | null } | null } | null } | null } | null> | null } | null };

export type GroupMembersQueryVariables = Exact<{
  groupId?: InputMaybe<Scalars['UUID']>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GroupMembersQuery = { __typename?: 'Query', groupMembers?: { __typename?: 'GroupMembersResult', meta?: { __typename?: 'PageInfo', count?: number | null, page?: number | null, totalPages?: number | null } | null, data?: Array<{ __typename?: 'GroupMember', id: string, user?: { __typename?: 'User', formattedPhoneNumber?: string | null, profileImageUrl?: string | null, isDoctor?: boolean | null, profile?: { __typename?: 'Profile', fullName?: string | null, birthNumber?: string | null, age?: string | null, address?: { __typename?: 'Address', fullAddress?: string | null } | null } | null, avatarFile?: { __typename?: 'File', createdAt?: any | null } | null, userRelations?: Array<{ __typename?: 'UserRelation', user?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null, workplace?: { __typename?: 'Workplace', name?: string | null } | null } | null> | null } | null } | null> | null } | null };

export type GroupAuditLogsQueryVariables = Exact<{
  targetEntityId?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GroupAuditLogsQuery = { __typename?: 'Query', auditLogs?: { __typename?: 'AuditLogsResult', meta?: { __typename?: 'PageInfo', count?: number | null, page?: number | null, totalPages?: number | null } | null, data?: Array<{ __typename?: 'AuditLog', id: number, type?: string | null, targetEntityType?: string | null, text?: string | null, createdAt?: any | null, createdBy?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null> | null } | null };

export type GroupsQueryVariables = Exact<{
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GroupsQuery = { __typename?: 'Query', groups?: { __typename?: 'GroupsResult', meta?: { __typename?: 'PageInfo', count?: number | null, page?: number | null, totalPages?: number | null } | null, data?: Array<{ __typename?: 'Group', id: string, name?: string | null, createdAt?: any | null, totalMembers?: number | null, description?: string | null, createdByLog?: { __typename?: 'AuditLog', createdAt?: any | null, createdBy?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null, updatedByLog?: { __typename?: 'AuditLog', createdAt?: any | null, createdBy?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null } | null> | null } | null };

export type MassFindQueryVariables = Exact<{
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type MassFindQuery = { __typename?: 'Query', groups?: { __typename?: 'GroupsResult', meta?: { __typename?: 'PageInfo', count?: number | null, page?: number | null, totalPages?: number | null } | null, data?: Array<{ __typename?: 'Group', id: string, name?: string | null, createdAt?: any | null, totalMembers?: number | null, description?: string | null, createdByLog?: { __typename?: 'AuditLog', createdAt?: any | null, createdBy?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null, updatedByLog?: { __typename?: 'AuditLog', createdAt?: any | null, createdBy?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null } | null> | null } | null, workplaceDoctors?: { __typename?: 'WorkplaceMembersResult', meta?: { __typename?: 'PageInfo', count?: number | null } | null, data?: Array<{ __typename?: 'WorkplaceMember', id: string, workplaceMemberRoles?: Array<{ __typename?: 'WorkplaceMemberRole', role?: { __typename?: 'AclRole', key?: string | null } | null } | null> | null, user?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null> | null } | null, workplacePatients?: { __typename?: 'WorkplaceMembersResult', meta?: { __typename?: 'PageInfo', count?: number | null } | null, data?: Array<{ __typename?: 'WorkplaceMember', id: string, user?: { __typename?: 'User', id: string, formattedPhoneNumber?: string | null, profile?: { __typename?: 'Profile', fullName?: string | null, birthNumber?: string | null, age?: string | null, address?: { __typename?: 'Address', fullAddress?: string | null } | null } | null, userRelations?: Array<{ __typename?: 'UserRelation', id?: number | null, type?: number | null, relationUser?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null, workplace?: { __typename?: 'Workplace', id: string, name?: string | null } | null } | null> | null } | null } | null> | null } | null };

export type CreatePhraseMutationVariables = Exact<{
  input: CreatePhraseInput;
}>;


export type CreatePhraseMutation = { __typename?: 'Mutation', createPhrase?: { __typename?: 'Phrase', id?: string | null } | null };

export type DeletePhraseMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeletePhraseMutation = { __typename?: 'Mutation', deletePhrase?: { __typename?: 'MutationResult', status?: boolean | null } | null };

export type MyPhrasesQueryVariables = Exact<{
  where?: InputMaybe<MyPhrasesWhereInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type MyPhrasesQuery = { __typename?: 'Query', myPhrases?: { __typename?: 'PhrasesResult', meta: { __typename?: 'PageInfo', count?: number | null, page?: number | null, totalPages?: number | null }, data: Array<{ __typename?: 'Phrase', id?: string | null, rank?: number | null, value?: string | null, type?: PhraseType | null, name?: string | null, meta?: Array<{ __typename?: 'Meta', id: string, key?: string | null, value?: any | null, formattedValue?: any | null } | null> | null } | null> } | null };

export type UpdatePhraseMutationVariables = Exact<{
  input: UpdatePhraseInput;
  where: PhrasesWhereUnique;
}>;


export type UpdatePhraseMutation = { __typename?: 'Mutation', updatePhrase?: { __typename?: 'Phrase', id?: string | null } | null };

export type CreateP1PrescriptionMutationVariables = Exact<{
  input: CreateP1PrescriptionInput;
}>;


export type CreateP1PrescriptionMutation = { __typename?: 'Mutation', createP1Prescription?: { __typename?: 'Prescription', id: string } | null };

export type PrescriptionMedicamentQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type PrescriptionMedicamentQuery = { __typename?: 'Query', prescriptionMedicaments?: { __typename?: 'PrescriptionMedicamentsResult', data?: Array<{ __typename?: 'PrescriptionMedicament', id?: string | null, name?: string | null, code?: string | null, indicationLimitations?: string | null, specialityLimitations?: string | null, hasLimitations?: boolean | null, hasIndicationLimitations?: boolean | null, hasSpecialityLimitations?: boolean | null, strength?: string | null, packaging?: string | null, form?: string | null, lim?: string | null, priceRawFormatted?: string | null, priceInsuranceCompanyRawFormatted?: string | null, priceExtraFormatted?: string | null, rationalPrescription?: string | null, addition?: string | null, doping?: string | null, dispensing?: string | null, specialityLimitationTermItems?: Array<{ __typename?: 'TermItem', name?: string | null, value?: string | null } | null> | null, limTermItem?: { __typename?: 'TermItem', name?: string | null, value?: string | null, value2?: string | null } | null, dopingTermItem?: { __typename?: 'TermItem', name?: string | null, value?: string | null } | null, dispensingTermItem?: { __typename?: 'TermItem', name?: string | null, value?: string | null } | null } | null> | null } | null };

export type PrescriptionsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type PrescriptionsQuery = { __typename?: 'Query', prescriptions?: { __typename?: 'PrescriptionsResult', meta?: { __typename?: 'PageInfo', count?: number | null, totalPages?: number | null, page?: number | null } | null, data?: Array<{ __typename?: 'Prescription', id: string, userId?: string | null, code?: string | null, type?: string | null, createdById?: string | null, createdAt?: any | null, validUntil?: any | null, data?: any | null, items?: Array<{ __typename?: 'PrescriptionItem', id: string, extra?: any | null, quantity?: any | null, prescriptionMedicament?: { __typename?: 'PrescriptionMedicament', id?: string | null, code?: string | null, name?: string | null, strength?: string | null, form?: string | null, atc?: string | null, packaging?: string | null, indicationLimitations?: string | null, hasIndicationLimitations?: boolean | null, specialityLimitations?: string | null, hasSpecialityLimitations?: boolean | null, hasLimitations?: boolean | null, lim?: string | null, rationalPrescription?: string | null, routeOfAdministration?: string | null, priceRawFormatted?: string | null, priceInsuranceCompanyRawFormatted?: string | null, priceExtraFormatted?: string | null, addition?: string | null, dispensing?: string | null, doping?: string | null, specialityLimitationTermItems?: Array<{ __typename?: 'TermItem', id: string, termId?: string | null, name?: string | null, value?: string | null, value2?: string | null, value3?: string | null, data?: any | null } | null> | null, limTermItem?: { __typename?: 'TermItem', id: string, termId?: string | null, name?: string | null, value?: string | null, value2?: string | null, value3?: string | null, data?: any | null } | null, dispensingTermItem?: { __typename?: 'TermItem', id: string, termId?: string | null, name?: string | null, value?: string | null, value2?: string | null, value3?: string | null, data?: any | null } | null, dopingTermItem?: { __typename?: 'TermItem', id: string, termId?: string | null, name?: string | null, value?: string | null, value2?: string | null, value3?: string | null, data?: any | null } | null } | null } | null> | null } | null> | null } | null };

export type SingleQuestionnaireResultItemsQueryVariables = Exact<{
  questionnaireResultId?: InputMaybe<Scalars['UUID']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type SingleQuestionnaireResultItemsQuery = { __typename?: 'Query', questionnaireResultItems?: { __typename?: 'QuestionnaireResultItemsResult', data?: Array<{ __typename?: 'QuestionnaireResultItem', id: string, value?: string | null, valueJson?: any | null, questionnaireResult?: { __typename?: 'QuestionnaireResult', id: string, createdAt?: any | null } | null, question?: { __typename?: 'QuestionnaireItem', id: string, key?: string | null, title?: string | null, questionnaire?: { __typename?: 'Questionnaire', id: string, code?: string | null, partnerId?: number | null } | null, parentQuestionnaireItem?: { __typename?: 'QuestionnaireItem', id: string } | null } | null, answer?: { __typename?: 'QuestionnaireItem', id: string, value?: string | null, key?: string | null } | null } | null> | null } | null };

export type QuestionnaireSearchQueryVariables = Exact<{
  fulltext?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
}>;


export type QuestionnaireSearchQuery = { __typename?: 'Query', questionnaires?: { __typename?: 'QuestionnairesResult', data?: Array<{ __typename?: 'Questionnaire', id: string, code?: string | null, title?: string | null } | null> | null } | null };

export type QuestionnaireSearchByCodeQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']>;
}>;


export type QuestionnaireSearchByCodeQuery = { __typename?: 'Query', questionnaire?: { __typename?: 'Questionnaire', id: string, title?: string | null } | null };

export type QuestionnaireBasicInfoQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type QuestionnaireBasicInfoQuery = { __typename?: 'Query', questionnaire?: { __typename?: 'Questionnaire', id: string, title?: string | null, code?: string | null, mainQuestionnaireId?: string | null } | null };

export type QuestionnaireSchedulesByParentScheduleQueryVariables = Exact<{
  parentQuestionnaireScheduleId?: InputMaybe<Scalars['UUID']>;
}>;


export type QuestionnaireSchedulesByParentScheduleQuery = { __typename?: 'Query', questionnaireSchedules?: { __typename?: 'QuestionnaireSchedulesResult', data?: Array<{ __typename?: 'QuestionnaireSchedule', id: string, userId?: string | null, dateFrom?: any | null, repeatHours?: number | null, type?: string | null, questionnaire?: { __typename?: 'Questionnaire', id: string, title?: string | null, code?: string | null, type?: string | null } | null, questionnaireItem?: { __typename?: 'QuestionnaireItem', title?: string | null, id: string } | null } | null> | null } | null };

export type QuestionnaireScheduleQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type QuestionnaireScheduleQuery = { __typename?: 'Query', questionnaireSchedule?: { __typename?: 'QuestionnaireSchedule', id: string, userId?: string | null, dateFrom?: any | null, dateTo?: any | null, frequencyText?: string | null, repeatHours?: number | null, type?: string | null, questionnaireId?: string | null, createdBy?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null, user?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null, questionnaire?: { __typename?: 'Questionnaire', id: string, title?: string | null, code?: string | null, type?: string | null } | null } | null };

export type QuestionnaireDetailQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']>;
}>;


export type QuestionnaireDetailQuery = { __typename?: 'Query', questionnaire?: { __typename?: 'Questionnaire', id: string, title?: string | null } | null };

export type QuestionnaireResultsQueryVariables = Exact<{
  fulltext?: InputMaybe<Scalars['String']>;
  onlyPatient?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  seen?: InputMaybe<Scalars['Boolean']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  scheduledById?: InputMaybe<Scalars['UUID']>;
  questionnaireId?: InputMaybe<Scalars['UUID']>;
  questionnaireCode?: InputMaybe<Scalars['String']>;
  questionnaire?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<QuestionnaireResultResult>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  excludeQuestionnaireCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  module?: InputMaybe<QuestionnaireModule>;
  scheduledByIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
}>;


export type QuestionnaireResultsQuery = { __typename?: 'Query', questionnaireResults?: { __typename?: 'QuestionnaireResultsResult', meta?: { __typename?: 'PageInfo', count?: number | null, page?: number | null, totalPages?: number | null } | null, data?: Array<{ __typename?: 'QuestionnaireResult', id: string, createdAt?: any | null, result?: any | null, isSeen?: boolean | null, user?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null, formattedBirthNumber?: string | null } | null } | null, scheduledBy?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null, questionnaire?: { __typename?: 'Questionnaire', id: string, title?: string | null, code?: string | null } | null, isSeenMarkedBy?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null> | null } | null };

export type QuestionnaireSchedulesQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  questionnaireId?: InputMaybe<Scalars['UUID']>;
}>;


export type QuestionnaireSchedulesQuery = { __typename?: 'Query', questionnaireSchedules?: { __typename?: 'QuestionnaireSchedulesResult', data?: Array<{ __typename?: 'QuestionnaireSchedule', id: string, userId?: string | null, dateFrom?: any | null, dateTo?: any | null, frequencyText?: string | null, repeatHours?: number | null, type?: string | null, createdBy?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null, user?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null, questionnaire?: { __typename?: 'Questionnaire', id: string, title?: string | null, code?: string | null, type?: string | null } | null } | null> | null } | null };

export type QuestionnairesQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  module?: InputMaybe<QuestionnaireModule>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
}>;


export type QuestionnairesQuery = { __typename?: 'Query', questionnaires?: { __typename?: 'QuestionnairesResult', meta?: { __typename?: 'PageInfo', count?: number | null, totalPages?: number | null, page?: number | null } | null, data?: Array<{ __typename?: 'Questionnaire', id: string, title?: string | null, code?: string | null, type?: string | null } | null> | null } | null };

export type RequirementFileQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type RequirementFileQuery = { __typename?: 'Query', documentationFiles?: { __typename?: 'DocumentationFilesResult', data: Array<{ __typename?: 'DocumentationFile', id: string, name?: string | null, userId?: string | null, folderId?: string | null, file?: { __typename?: 'File', id: string, extension?: string | null } | null }> } | null };

export type TermItemsQueryVariables = Exact<{
  termType?: InputMaybe<Scalars['String']>;
  fullText?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TermItemsFilter>;
  take?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type TermItemsQuery = { __typename?: 'Query', termItems?: { __typename?: 'TermItemsResult', data?: Array<{ __typename?: 'TermItem', id: string, termId?: string | null, name?: string | null, value?: string | null, value2?: string | null, value3?: string | null, data?: any | null } | null> | null } | null };

export type TermItemByValueQueryVariables = Exact<{
  termType: Scalars['String'];
  value: Scalars['String'];
}>;


export type TermItemByValueQuery = { __typename?: 'Query', termItem?: { __typename?: 'TermItem', id: string, name?: string | null, value?: string | null } | null };

export type UserMetaTranslationsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type UserMetaTranslationsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, metaTranslation?: Array<{ __typename?: 'MetaTranslation', id?: string | null, key?: string | null, value?: any | null, language?: string | null } | null> | null } | null };

export type TransmiseListQueryVariables = Exact<{
  where: TransmiseListWhereInput;
}>;


export type TransmiseListQuery = { __typename?: 'Query', transmiseList?: { __typename?: 'TransmiseListResult', meta?: { __typename?: 'PageInfo', page?: number | null, totalPages?: number | null } | null, data?: Array<{ __typename?: 'TransmiseDocument', id?: string | null, name?: string | null, date?: any | null, workplace?: string | null, diagnosis?: string | null, link?: string | null } | null> | null } | null };

export type FullUserInfoQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type FullUserInfoQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null, isDoctor?: boolean | null, isChild?: boolean | null, partnerIdentifier?: string | null, partner?: string | null, profileImageUrl?: string | null, csszResult?: any | null, vzpResult?: any | null, meta?: Array<{ __typename?: 'Meta', key?: string | null, value?: any | null } | null> | null, memberOf?: Array<{ __typename?: 'Badge', title?: string | null, theme?: string | null } | null> | null, parents?: Array<{ __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null, firstName?: string | null, lastName?: string | null } | null } | null> | null, badge?: { __typename?: 'Badge', title?: string | null, theme?: string | null } | null, avatarFile?: { __typename?: 'File', createdAt?: any | null } | null, profile?: { __typename?: 'Profile', age?: string | null, birthNumber?: string | null, formattedBirthNumber?: string | null, birthDate?: string | null, insuranceNumber?: string | null, gender?: string | null, formattedGender?: string | null, timezone?: string | null, nationalityOther?: string | null, fullName?: string | null, firstName?: string | null, lastName?: string | null, nationalityTermItem?: { __typename?: 'TermItem', id: string, name?: string | null, value?: string | null } | null, address?: { __typename?: 'Address', fullAddress?: string | null, shortAddress?: string | null, formattedFullAddress?: string | null, formattedShortAddress?: string | null, street?: string | null, postCode?: string | null, descriptiveNumber?: string | null, guideNumber?: string | null, city?: string | null, province?: string | null, street2?: string | null, floor?: string | null, district?: string | null, accommodationZone?: string | null, country?: string | null, region?: string | null, apartmentNumber?: string | null } | null, insuranceCompanyTermItem?: { __typename?: 'TermItem', name?: string | null, value?: string | null, value2?: string | null } | null } | null, rootWorkplace?: { __typename?: 'Workplace', name?: string | null, address?: { __typename?: 'Address', fullAddress?: string | null } | null } | null, workplace?: { __typename?: 'Workplace', name?: string | null, address?: { __typename?: 'Address', fullAddress?: string | null } | null } | null, invitations?: Array<{ __typename?: 'UserInvitation', code?: string | null, used?: boolean | null } | null> | null } | null };

export type UserEmailQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type UserEmailQuery = { __typename?: 'Query', user?: { __typename?: 'User', email?: string | null } | null };

export type UserHasMeddiQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type UserHasMeddiQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, hasMeddi?: boolean | null } | null };

export type UserMetaQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
  useOriginalId?: InputMaybe<Scalars['Boolean']>;
}>;


export type UserMetaQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, meta?: Array<{ __typename?: 'Meta', id: string, key?: string | null, value?: any | null } | null> | null } | null };

export type UserParentsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type UserParentsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, parents?: Array<{ __typename?: 'User', id: string, hasMeddi?: boolean | null } | null> | null } | null };

export type UserProfileImageQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type UserProfileImageQuery = { __typename?: 'Query', user?: { __typename?: 'User', profileImageUrl?: string | null } | null };

export type UserRelationsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  useOriginalId?: InputMaybe<Scalars['Boolean']>;
}>;


export type UserRelationsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, userRelations?: Array<{ __typename?: 'UserRelation', userId?: string | null, relationUserId?: string | null, type?: number | null } | null> | null } | null };

export type UserTermItemsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type UserTermItemsQuery = { __typename?: 'Query', user?: { __typename?: 'User', termItems?: Array<{ __typename?: 'TermItem', id: string, name?: string | null, value?: string | null, value2?: string | null, value3?: string | null, term?: { __typename?: 'Term', type?: string | null } | null } | null> | null } | null };

export type SubmitWizardMutationVariables = Exact<{
  input?: InputMaybe<WizardResultInput>;
}>;


export type SubmitWizardMutation = { __typename?: 'Mutation', submitWizard?: { __typename?: 'SubmitWizardResult', id?: string | null } | null };

export type RootWorkplaceByChildQueryVariables = Exact<{
  workplaceId?: InputMaybe<Scalars['UUID']>;
}>;


export type RootWorkplaceByChildQuery = { __typename?: 'Query', workplace?: { __typename?: 'Workplace', id: string, name?: string | null, address?: { __typename?: 'Address', fullAddress?: string | null } | null, rootWorkplace?: { __typename?: 'Workplace', id: string, partnerId?: string | null, name?: string | null, fullName?: string | null, address?: { __typename?: 'Address', fullAddress?: string | null } | null } | null } | null };

export type WorkplaceMemberRoleQueryVariables = Exact<{
  workplaceId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type WorkplaceMemberRoleQuery = { __typename?: 'Query', workplaceMember?: { __typename?: 'WorkplaceMember', id: string, workplaceMemberRoles?: Array<{ __typename?: 'WorkplaceMemberRole', role?: { __typename?: 'AclRole', key?: string | null } | null } | null> | null } | null };

export type WorkplacesQueryVariables = Exact<{
  fulltext?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
}>;


export type WorkplacesQuery = { __typename?: 'Query', workplaces?: { __typename?: 'WorkplacesResult', data?: Array<{ __typename?: 'Workplace', id: string, doctorDisplayName?: string | null, rootWorkplace?: { __typename?: 'Workplace', id: string, doctorDisplayName?: string | null } | null } | null> | null } | null };

export type WorkplacesForSelectQueryVariables = Exact<{
  fulltext?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  rootWorkplaceId?: InputMaybe<Scalars['UUID']>;
  managed?: InputMaybe<Scalars['Boolean']>;
}>;


export type WorkplacesForSelectQuery = { __typename?: 'Query', workplaces?: { __typename?: 'WorkplacesResult', data?: Array<{ __typename?: 'Workplace', id: string, doctorDisplayName?: string | null, type?: string | null } | null> | null } | null };

export type NormalWorkplacesQueryVariables = Exact<{
  fulltext?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  rootWorkplaceId?: InputMaybe<Scalars['UUID']>;
  managed?: InputMaybe<Scalars['Boolean']>;
}>;


export type NormalWorkplacesQuery = { __typename?: 'Query', workplaces?: { __typename?: 'WorkplacesResult', data?: Array<{ __typename?: 'Workplace', id: string, doctorDisplayName?: string | null, rootWorkplace?: { __typename?: 'Workplace', id: string, doctorDisplayName?: string | null } | null, address?: { __typename?: 'Address', fullAddress?: string | null } | null } | null> | null } | null };

export type WorkplaceMetaQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type WorkplaceMetaQuery = { __typename?: 'Query', workplace?: { __typename?: 'Workplace', meta?: Array<{ __typename?: 'Meta', id: string, key?: string | null, value?: any | null } | null> | null } | null };

export type WorkplacePrivateQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type WorkplacePrivateQuery = { __typename?: 'Query', workplace?: { __typename?: 'Workplace', privateAmbulance?: boolean | null } | null };

export type WorkplaceNameQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type WorkplaceNameQuery = { __typename?: 'Query', workplace?: { __typename?: 'Workplace', name?: string | null } | null };

export type WorkplaceCaseTypeQueryVariables = Exact<{
  workplaceId?: InputMaybe<Scalars['UUID']>;
  caseTypeCode?: InputMaybe<Scalars['String']>;
}>;


export type WorkplaceCaseTypeQuery = { __typename?: 'Query', workplaceCaseType?: { __typename?: 'WorkplaceCaseType', id: string, caseType?: { __typename?: 'CaseType', label?: string | null, type?: string | null, eventInterval?: number | null } | null } | null };

export type WorkplaceCaseTypesQueryVariables = Exact<{
  workplaceId?: InputMaybe<Scalars['UUID']>;
  caseTypeTypes?: InputMaybe<Array<InputMaybe<CaseTypeType>> | InputMaybe<CaseTypeType>>;
}>;


export type WorkplaceCaseTypesQuery = { __typename?: 'Query', workplaceCaseTypes?: { __typename?: 'WorkplaceCaseTypesResult', data?: Array<{ __typename?: 'WorkplaceCaseType', id: string, caseType?: { __typename?: 'CaseType', id?: string | null, label?: string | null, type?: string | null, eventInterval?: number | null } | null } | null> | null } | null };

export type WorkplaceMemberIdQueryVariables = Exact<{
  workplaceId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type WorkplaceMemberIdQuery = { __typename?: 'Query', workplaceMember?: { __typename?: 'WorkplaceMember', id: string, code?: string | null } | null };

export type SimpleWorkplaceMemberQueryVariables = Exact<{
  workplaceId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type SimpleWorkplaceMemberQuery = { __typename?: 'Query', workplaceMember?: { __typename?: 'WorkplaceMember', id: string, user?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null };

export type WorkplacePartnerQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type WorkplacePartnerQuery = { __typename?: 'Query', workplace?: { __typename?: 'Workplace', partnerId?: string | null } | null };

export type WorkplaceServiceScheduleQueryVariables = Exact<{
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  type?: InputMaybe<ServiceScheduleType>;
  types?: InputMaybe<Array<InputMaybe<ServiceScheduleType>> | InputMaybe<ServiceScheduleType>>;
  pagination?: InputMaybe<PaginationInput>;
  includeOccurrences?: InputMaybe<Scalars['Boolean']>;
}>;


export type WorkplaceServiceScheduleQuery = { __typename?: 'Query', serviceSchedules?: { __typename?: 'ServiceSchedulesResult', data?: Array<{ __typename?: 'ServiceSchedule', id: string, dateFrom?: any | null, dateTo?: any | null, type?: ServiceScheduleType | null, workplaceId?: string | null, workplace?: { __typename?: 'Workplace', name?: string | null, doctorDisplayName?: string | null } | null, serviceScheduleItems?: Array<{ __typename?: 'ServiceScheduleItem', id: string, day?: DayShortEnum | null, timeFrom?: any | null, timeTo?: any | null, interval?: number | null, occurrences?: Array<any | null> | null, repeatable?: boolean | null, price?: { __typename?: 'Price', id?: string | null, price?: any | null, priceWithVatRaw?: string | null } | null, serviceScheduleItemMembers?: Array<{ __typename?: 'ServiceScheduleItemMember', workplaceMemberId?: string | null, workplaceMember?: { __typename?: 'WorkplaceMember', workplaceMemberRoles?: Array<{ __typename?: 'WorkplaceMemberRole', role?: { __typename?: 'AclRole', name?: string | null, key?: string | null } | null } | null> | null, user?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null } | null> | null, serviceScheduleItemCaseTypes?: Array<{ __typename?: 'ServiceScheduleItemCaseType', workplaceCaseTypeId?: string | null, workplaceCaseType?: { __typename?: 'WorkplaceCaseType', id: string, caseType?: { __typename?: 'CaseType', label?: string | null, eventInterval?: number | null } | null } | null } | null> | null } | null> | null } | null> | null } | null };

export type WorkplaceMemberMetaQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
}>;


export type WorkplaceMemberMetaQuery = { __typename?: 'Query', workplaceMember?: { __typename?: 'WorkplaceMember', meta?: Array<{ __typename?: 'Meta', id: string, key?: string | null, value?: any | null } | null> | null } | null };

export type WorkplaceMembersQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
}>;


export type WorkplaceMembersQuery = { __typename?: 'Query', workplaceMembers?: { __typename?: 'WorkplaceMembersResult', data?: Array<{ __typename?: 'WorkplaceMember', id: string, workplace?: { __typename?: 'Workplace', id: string, doctorDisplayName?: string | null } | null } | null> | null } | null };

export type FilterCaseContactsQueryVariables = Exact<{
  fulltext?: InputMaybe<Scalars['String']>;
  caseTypeCode?: InputMaybe<Scalars['String']>;
  roleKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type FilterCaseContactsQuery = { __typename?: 'Query', filterCaseContacts?: { __typename?: 'CaseContactsResult', data?: Array<{ __typename?: 'CaseContact', userId?: string | null, workplaceMemberId?: string | null, workplaceId?: string | null, textRow1?: string | null, textRow2?: string | null, textRow3?: string | null, type?: CaseContactType | null, iconUrl?: string | null, workplaceMemberUserRelation?: { __typename?: 'UserRelation', id?: number | null, userId?: string | null, user?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null } | null> | null } | null };

export type WorkplaceMemberQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
}>;


export type WorkplaceMemberQuery = { __typename?: 'Query', workplaceMember?: { __typename?: 'WorkplaceMember', id: string, status?: string | null } | null };


export const CaseChatEntriesDocument = `
    query CaseChatEntries($id: UUID!) {
  caseEntries(
    caseId: $id
    pagination: {take: 9999, order: {how: ASC, key: "created_at"}}
  ) {
    data {
      id
      caseId
      message
      type
      time
      createdAt
      senderId
      extra
      thumb
      inDocumentation
      file {
        id
        name
        extension
      }
      avResult
      fileId
      order {
        id
        number
        price {
          priceWithVatRaw
          formattedPrice
          currency
        }
        orderLog {
          type
          value
        }
        orderItems {
          id
          name
          price {
            priceWithVatRaw
            formattedPrice
            currency
          }
        }
      }
      sender {
        id
        profile {
          fullName
        }
        avatarFile {
          createdAt
        }
      }
      caseEntryMembers {
        seen
        user {
          id
          isPatient
        }
      }
    }
  }
}
    `;
export const CreateHealthPlanUserPaymentDocument = `
    mutation CreateHealthPlanUserPayment($input: HealthPlanUserPaymentInput) {
  createHealthPlanUserPayment(input: $input) {
    id
  }
}
    `;
export const WorkplaceBillingAddressDocument = `
    query WorkplaceBillingAddress($where: WorkplaceAddressWhereInput) {
  workplaceAddress(where: $where) {
    id
    street
    street2
    city
    postCode
    descriptiveNumber
    guideNumber
    floor
    accommodationZone
    apartmentNumber
    district
    region
    province
    country
    streetType
    zoneType
    zoneName
    sector
    manzana
    parish
    department
    departmentNumber
    lot
    houseType
    kilometer
    governType
    governName
    reference
    ubigeo
    identificationNumber
    taxIdentificationNumber
    invoiceNumber
    type
    billingEmail
  }
}
    `;
export const WorkplaceUseCustomBillingAddressDocument = `
    query WorkplaceUseCustomBillingAddress($id: UUID) {
  workplace(id: $id) {
    rootBilling
  }
}
    `;
export const PatientConsentDocument = `
    query PatientConsent($userId: UUID!) {
  user(id: $userId) {
    consentProvider
    userConsent {
      value
      createdAt
    }
  }
}
    `;
export const PatientProfileDataDocument = `
    query PatientProfileData($userId: UUID!, $useOriginalId: Boolean) {
  user(id: $userId) {
    id
    email
    phoneNumber
    formattedPhoneNumber
    isDoctor
    isChild
    partnerIdentifier
    partner
    profileImageUrl
    originalId
    healthCard {
      __typename
      height
      weight
      operations
      job
      sickness
      anamnesisFamily
      allergies
      allergiesOther
    }
    insuranceCardFrontThumbnailUrl
    insuranceCardBackThumbnailUrl
    meta {
      key
      value
    }
    memberOf {
      title
      theme
    }
    parents {
      id
      profile {
        fullName
        firstName
        lastName
        contactEmail
      }
      formattedPhoneNumber
      email
    }
    csszResult
    vzpResult
    vzpRegisteredDoctorsResult
    badge {
      title
      theme
    }
    avatarFile {
      createdAt
    }
    userRelations(useOriginalId: $useOriginalId) {
      id
      type
      workplace {
        id
        name
      }
      user {
        id
      }
      relationUser {
        id
        profile {
          fullName
          firstName
          lastName
        }
      }
    }
    profile {
      age
      birthNumber
      formattedBirthNumber
      birthDate
      insuranceNumber
      gender
      formattedGender
      timezone
      languageFormatted
      languageIso
      nationalityTermItem {
        id
        name
        value
      }
      nationalityOther
      fullName
      firstName
      lastName
      middleName
      fatherLastName
      motherLastName
      name
      salutationBefore
      salutationAfter
      address {
        id
        street
        street2
        city
        postCode
        fullAddress
        shortAddress
        formattedFullAddress
        formattedShortAddress
        descriptiveNumber
        guideNumber
        floor
        accommodationZone
        apartmentNumber
        district
        region
        province
        country
        streetType
        zoneType
        zoneName
        sector
        manzana
        parish
        department
        departmentNumber
        lot
        houseType
        kilometer
        governType
        governName
        reference
        ubigeo
        terytCode
      }
      insuranceCompanyTermItem {
        id
        name
        value
        value2
      }
      contactEmail
    }
    rootWorkplace {
      name
    }
    workplace {
      name
    }
    invitations {
      code
      createdAt
      declinedAt
      used
    }
    userNumber(by: NUMBER) {
      id
      number
      birthNumber
      __typename
    }
    workplaceMember {
      status
      dateOfDeath
      archivedAt
      archivedBy {
        profile {
          fullName
        }
      }
    }
    createdAt
    note
  }
}
    `;
export const PatientUserRelationsDocument = `
    query PatientUserRelations($userId: UUID!) {
  user(id: $userId) {
    userRelations(useOriginalId: true) {
      id
      type
      workplace {
        id
        name
      }
      user {
        id
      }
      relationUser {
        id
        profile {
          fullName
          firstName
          lastName
        }
      }
    }
  }
}
    `;
export const WorkplaceMemberDetailsDocument = `
    query WorkplaceMemberDetails($userId: UUID, $workplaceId: UUID) {
  workplaceMember(userId: $userId, workplaceId: $workplaceId) {
    id
    user {
      id
      email
      profile {
        id
        firstName
        lastName
      }
      phoneNumber
    }
  }
}
    `;
export const ConversationDetailDocument = `
    query ConversationDetail($id: UUID) {
  conversation(id: $id) {
    id
    name
    singleRecipient {
      id
      user {
        id
        email
        profile {
          fullName
        }
      }
    }
    totalRecipients
    lastMessage {
      id
      type
      content
      createdAt
      sender {
        user {
          id
          profile {
            fullName
          }
        }
      }
      messageAttachments {
        id
        type
        extra
        educationMaterial {
          id
          name
          value
          subtype
          link
        }
        questionnaire {
          id
          title
        }
        file {
          id
          name
          type
          extension
          createdAt
        }
        documentationFile {
          id
          userId
          folderId
          name
          avResult
          hasThumb
          thumbUrl
          fileUrl
          extension
        }
      }
    }
  }
}
    `;
export const ConversationMessagesDocument = `
    query ConversationMessages($conversationId: UUID, $folder: ConversationFolderEnum, $conversationType: ConversationType, $pagination: PaginationInput) {
  messages(
    conversationId: $conversationId
    folder: $folder
    conversationType: $conversationType
    pagination: $pagination
  ) {
    meta {
      count
    }
    data {
      id
      type
      content
      createdAt
      sender {
        user {
          id
          profile {
            fullName
          }
        }
      }
      messageAttachments {
        id
        type
        extra
        educationMaterial {
          id
          name
          value
          subtype
          link
        }
        questionnaire {
          id
          title
        }
        file {
          id
          name
          type
          extension
          createdAt
        }
        documentationFile {
          id
          userId
          folderId
          name
          avResult
          hasThumb
          thumbUrl
          fileUrl
          extension
        }
      }
    }
  }
}
    `;
export const MessagesByConversationDocument = `
    query MessagesByConversation($conversationType: ConversationType, $pagination: PaginationInput, $folder: ConversationFolderEnum) {
  messagesByConversation(
    conversationType: $conversationType
    pagination: $pagination
    folder: $folder
  ) {
    meta {
      count
      page
      totalPages
    }
    data {
      id
      createdAt
      content
      totalRecipients
      singleRecipient {
        user {
          id
          profile {
            fullName
          }
        }
      }
      messageAttachments {
        id
        type
        questionnaire {
          id
          title
        }
      }
      conversation {
        id
        name
        createdAt
      }
      myMessageMember {
        seen
      }
      sender {
        user {
          profile {
            fullName
          }
        }
      }
    }
  }
}
    `;
export const DoctorsSearchDocument = `
    query DoctorsSearch($fulltext: String, $take: Int = 10) {
  doctors(fulltext: $fulltext, roleKey: "doctor", take: $take) {
    meta {
      count
    }
    data {
      id
      profile {
        fullName
      }
    }
  }
}
    `;
export const GetGridFilterDocument = `
    query GetGridFilter($key: String!) {
  userFilter(key: $key) {
    id
    key
    value
  }
}
    `;
export const SaveGridFilterDocument = `
    mutation saveGridFilter($input: UserFilterInput) {
  saveUserFilter(input: $input) {
    id
    key
    value
  }
}
    `;
export const GroupsSearchDocument = `
    query GroupsSearch($fulltext: String, $take: Int = 10) {
  groups(fulltext: $fulltext, pagination: {take: $take}) {
    meta {
      count
    }
    data {
      id
      name
      description
    }
  }
}
    `;
export const NonDoctorsSearchDocument = `
    query NonDoctorsSearch($fulltext: String, $take: Int = 10) {
  doctors(
    fulltext: $fulltext
    excludeRoleKey: "doctor"
    includeNurses: true
    take: $take
  ) {
    meta {
      count
    }
    data {
      id
      profile {
        fullName
      }
    }
  }
}
    `;
export const PatientsSearchDocument = `
    query PatientsSearch($fulltext: String, $take: Int = 10) {
  patients(fulltext: $fulltext, take: $take) {
    meta {
      count
    }
    data {
      id
      formattedPhoneNumber
      profile {
        fullName
        birthNumber
        age
        address {
          fullAddress
        }
      }
      userRelations(useOriginalId: true) {
        id
        type
        relationUser {
          profile {
            fullName
          }
        }
        workplace {
          id
          name
        }
      }
    }
  }
}
    `;
export const RootWorkplaceDoctorsDocument = `
    query RootWorkplaceDoctors($fulltext: String, $includeNurses: Boolean) {
  rootWorkplaceDoctors(fulltext: $fulltext, includeNurses: $includeNurses) {
    data {
      id
      workplace {
        id
        doctorDisplayName
        rootWorkplace {
          id
          doctorDisplayName
        }
      }
      user {
        id
        profile {
          fullName
        }
      }
      hasShiftNow
    }
  }
}
    `;
export const SimpleWorkplacesDocument = `
    query SimpleWorkplaces($fulltext: String) {
  workplaces(fulltext: $fulltext) {
    data {
      id
      doctorDisplayName
      rootWorkplace {
        id
        doctorDisplayName
      }
      type
    }
  }
}
    `;
export const WorkplaceRolesDocument = `
    query WorkplaceRoles {
  workplaceAclRoles(pagination: {take: 999}) {
    data {
      id
      name
      key
    }
  }
}
    `;
export const CreateWorkplaceMemberAbsenceDocument = `
    mutation CreateWorkplaceMemberAbsence($input: CreateWorkplaceMemberAbsenceInput!) {
  createWorkplaceMemberAbsence(input: $input) {
    data {
      id
    }
  }
}
    `;
export const DoneEventDocument = `
    mutation DoneEvent($input: DoneEventInput) {
  doneEvent(input: $input) {
    id
    meta {
      key
      value
    }
  }
}
    `;
export const AssignCaseToMeDocument = `
    mutation AssignCaseToMe($input: AssignCaseToMeInput) {
  assignCaseToMe(input: $input) {
    id
  }
}
    `;
export const CaseMedicalReportsDocument = `
    query CaseMedicalReports($id: UUID) {
  case(id: $id) {
    medicalReports {
      id
      workplaceId
    }
  }
}
    `;
export const CasesAssignedDocument = `
    query CasesAssigned($caseTypeIds: [UUID], $caseStatusValue: String, $patientId: UUID, $doctorId: UUID, $createdAt: Date, $onlyVisible: Boolean, $workplaceId: UUID, $take: Int = 20, $skip: Int) {
  casesAssigned(
    caseTypeIds: $caseTypeIds
    caseStatusValue: $caseStatusValue
    patientId: $patientId
    doctorId: $doctorId
    createdAt: $createdAt
    onlyVisible: $onlyVisible
    take: $take
    skip: $skip
  ) {
    meta {
      totalPages
      page
    }
    data {
      id
      priority {
        id
        name
        value
        value2
        value3
      }
      code
      title
      isNew
      isMyCase
      isImmediate
      createdAt
      createdBy {
        id
        isPatient
      }
      solveTo
      patientDescription
      lastNote {
        id
        text
      }
      lastCaseEntry {
        time
      }
      patient {
        id
        profileImageUrl
        isDoctor
        profile {
          fullName
          age
          address {
            city
            region
          }
          insuranceCompanyTermItem {
            name
            value
          }
          insuranceNumber
          birthNumber
          languageFormatted
        }
        userRelations(workplaceId: $workplaceId, useOriginalId: true) {
          id
          relationUser {
            profile {
              fullName
            }
          }
          type
        }
        avatarFile {
          createdAt
        }
        meta {
          id
          key
          value
        }
        partnerTag {
          title
        }
      }
      patientParent {
        profile {
          fullName
        }
      }
      workplace {
        id
        name
        doctorDisplayName
      }
      doctor {
        id
        profileImageUrl
        profile {
          age
          fullName
        }
      }
      lastCaseEntry {
        message
        createdAt
      }
      child {
        id
      }
      medicalReports {
        id
        diagnosis
        treatment
        note
        createdAt
        documentId
        type
        document {
          id
          type
          title {
            extra
          }
        }
      }
      totalUnreadCaseEntries
      reassignedFrom {
        id
        workplace {
          doctorDisplayName
        }
        user {
          profile {
            fullName
          }
        }
      }
      caseChatPreview
      event {
        id
      }
      caseType {
        code
      }
      medicationLasted
    }
  }
}
    `;
export const IsMyCaseDocument = `
    query IsMyCase($id: UUID) {
  case(id: $id) {
    isMyCase
  }
}
    `;
export const CreateNoteDocument = `
    mutation CreateNote($caseId: UUID, $patientId: UUID, $text: String!) {
  createNote(input: {caseId: $caseId, patientId: $patientId, text: $text}) {
    id
  }
}
    `;
export const UpdateNoteDocument = `
    mutation UpdateNote($id: UUID!, $text: String!) {
  updateNote(input: {id: $id, text: $text}) {
    id
  }
}
    `;
export const NurseCasesDocument = `
    query NurseCases($caseTypeIds: [UUID], $doctorId: [UUID], $caseStatusValue: String, $workplaceId: UUID, $created: String, $take: Int = 20, $skip: Int, $patient: String) {
  nurseCases(
    caseTypeIds: $caseTypeIds
    doctorId: $doctorId
    caseStatusValue: $caseStatusValue
    created: $created
    take: $take
    skip: $skip
    patient: $patient
  ) {
    meta {
      totalPages
      page
    }
    data {
      id
      priority {
        id
        name
        value
        value2
        value3
      }
      code
      title
      isNew
      isMyCase
      isImmediate
      isAssigned
      createdAt
      createdBy {
        id
        isPatient
      }
      solveTo
      patientDescription
      lastNote {
        id
        text
      }
      lastCaseEntry {
        time
      }
      patient {
        id
        profileImageUrl
        profile {
          fullName
          age
          address {
            city
          }
          insuranceCompanyTermItem {
            name
            value
          }
          formattedBirthNumber
          languageFormatted
        }
        userRelations(workplaceId: $workplaceId, useOriginalId: true) {
          id
          relationUser {
            profile {
              fullName
            }
          }
          type
        }
        avatarFile {
          createdAt
        }
        meta {
          id
          key
          value
        }
        partnerTag {
          title
        }
      }
      patientParent {
        profile {
          fullName
        }
      }
      workplace {
        id
        name
        doctorDisplayName
      }
      doctor {
        id
        profileImageUrl
        profile {
          age
          fullName
        }
      }
      lastCaseEntry {
        message
        createdAt
      }
      medicalReports {
        id
        diagnosis
        treatment
        note
        createdAt
        documentId
        type
        document {
          id
          type
          title {
            extra
          }
        }
      }
      totalUnreadCaseEntries
      event {
        id
      }
    }
  }
}
    `;
export const ReAssignCaseDocument = `
    mutation ReAssignCase($caseId: UUID!, $workplaceId: UUID, $workplaceMemberId: UUID, $note: String) {
  reAssignCase(
    input: {caseId: $caseId, workplaceId: $workplaceId, workplaceMemberId: $workplaceMemberId, note: $note}
  ) {
    id
  }
}
    `;
export const WorkplaceCasesDocument = `
    query WorkplaceCases($workplaceIds: [UUID], $patientId: UUID, $doctorNull: Boolean, $createdAt: Date, $workplaceId: UUID, $take: Int = 20, $skip: Int) {
  workplaceCases(
    workplaceIds: $workplaceIds
    patientId: $patientId
    doctorNull: $doctorNull
    createdAt: $createdAt
    pagination: {take: $take, skip: $skip}
  ) {
    meta {
      totalPages
      page
    }
    data {
      id
      priority {
        id
        name
        value
        value2
        value3
      }
      code
      title
      isNew
      isMyCase
      isImmediate
      createdAt
      createdBy {
        id
        isPatient
      }
      solveTo
      patientDescription
      lastNote {
        id
        text
      }
      lastCaseEntry {
        time
      }
      patient {
        id
        profileImageUrl
        profile {
          fullName
          age
          address {
            city
          }
          insuranceCompanyTermItem {
            name
            value
          }
          insuranceNumber
          birthNumber
          languageFormatted
        }
        userRelations(workplaceId: $workplaceId, useOriginalId: true) {
          id
          relationUser {
            profile {
              fullName
            }
          }
          type
        }
        avatarFile {
          createdAt
        }
        meta {
          id
          key
          value
        }
        partnerTag {
          title
        }
      }
      patientParent {
        profile {
          fullName
        }
      }
      workplace {
        id
        name
        doctorDisplayName
      }
      doctor {
        id
        profileImageUrl
        profile {
          age
          fullName
        }
      }
      lastCaseEntry {
        message
        createdAt
      }
      child {
        id
      }
      medicalReports {
        id
        diagnosis
        treatment
        note
        createdAt
        documentId
        type
        document {
          id
          type
          title {
            extra
          }
        }
      }
      totalUnreadCaseEntries
      reassignedFrom {
        id
        workplace {
          doctorDisplayName
        }
        user {
          profile {
            fullName
          }
        }
      }
      event {
        id
      }
    }
  }
}
    `;
export const WorkplaceCasesArchivedDocument = `
    query WorkplaceCasesArchived($patientId: UUID, $doctorId: UUID, $caseTypeId: UUID, $caseTypeIds: [UUID], $workplaceId: UUID, $take: Int = 20, $skip: Int, $solvedAt: CaseSolvedMonth, $solvedAtRange: DateFilter) {
  workplaceCasesArchived(
    patientId: $patientId
    doctorId: $doctorId
    caseTypeId: $caseTypeId
    caseTypeIds: $caseTypeIds
    take: $take
    skip: $skip
    solvedAt: $solvedAt
    solvedAtRange: $solvedAtRange
  ) {
    meta {
      totalPages
      page
      count
    }
    data {
      id
      priority {
        id
        name
        value
        value2
        value3
      }
      code
      title
      isNew
      isMyCase
      isImmediate
      createdAt
      createdBy {
        id
        isPatient
      }
      solveTo
      solvedAt
      patientDescription
      lastNote {
        id
        text
      }
      lastCaseEntry {
        time
      }
      patient {
        id
        profileImageUrl
        profile {
          fullName
          age
          address {
            city
          }
          insuranceCompanyTermItem {
            name
            value
          }
          insuranceNumber
          birthNumber
          languageFormatted
        }
        userRelations(workplaceId: $workplaceId) {
          id
          relationUser {
            profile {
              fullName
            }
          }
          type
        }
        avatarFile {
          createdAt
        }
        meta {
          id
          key
          value
        }
        partnerTag {
          title
        }
      }
      patientParent {
        profile {
          fullName
        }
      }
      workplace {
        id
        name
        doctorDisplayName
      }
      doctor {
        id
        profileImageUrl
        profile {
          age
          fullName
        }
      }
      lastCaseEntry {
        message
        createdAt
      }
      child {
        id
      }
      medicalReports {
        id
        diagnosis
        treatment
        note
        createdAt
        documentId
        type
        printed
        fileId
        document {
          id
          type
          title {
            extra
          }
          sync {
            state
          }
        }
      }
      totalUnreadCaseEntries
      reassignedFrom {
        id
        workplace {
          doctorDisplayName
        }
        user {
          profile {
            fullName
          }
        }
      }
      event {
        id
      }
    }
  }
}
    `;
export const FullWorkplaceCaseTypesDocument = `
    query FullWorkplaceCaseTypes($workplaceId: UUID, $caseTypeTypes: [CaseTypeType], $take: Int) {
  workplaceCaseTypes(
    workplaceId: $workplaceId
    caseTypeTypes: $caseTypeTypes
    pagination: {take: $take}
  ) {
    data {
      id
      workplaceId
      canSearchDoctor
      canSendToAmbulance
      canSelectTransport
      workplaceDefaultCaseType
      caseType {
        id
        rank
        canBookOnline
        canBookOnSite
        canOrderImmediate
        priceId
        code
        label
        parentCaseTypeId
        hiddenForPatient
        eventInterval
        price {
          id
          priceWithVat
          priceWithVatRaw
          vatRate
        }
        caseTypeItems {
          id
          rank
          title
          description
          settings
          key
          type
          subtype
        }
      }
    }
  }
}
    `;
export const WorkplaceRootCaseTypesDocument = `
    query WorkplaceRootCaseTypes($workplaceId: UUID, $caseTypeTypes: [CaseTypeType], $workplaceIds: [UUID]) {
  workplaceCaseTypes(
    workplaceId: $workplaceId
    caseTypeTypes: $caseTypeTypes
    onlyRootCaseTypes: true
    workplaceIds: $workplaceIds
    take: 9999
  ) {
    data {
      id
      caseType {
        id
        label
        type
        eventInterval
        code
      }
    }
  }
}
    `;
export const RootWorkplacesPatientDocument = `
    query RootWorkplacesPatient($originalId: UUID, $workplaceId: UUID) {
  rootWorkplacesPatient(originalId: $originalId, workplaceId: $workplaceId) {
    data {
      id
      user {
        id
      }
      workplace {
        id
        name
      }
      status
    }
  }
}
    `;
export const CertificatesDocument = `
    query Certificates($userId: UUID, $workplaceId: UUID, $type: String, $skip: Int = 0, $take: Int = 10) {
  certificates(
    userId: $userId
    workplaceId: $workplaceId
    type: $type
    pagination: {skip: $skip, take: $take}
  ) {
    meta {
      count
    }
    data {
      id
      workplaceId
      userId
      fileId
      type
      isExpired
    }
  }
}
    `;
export const AttachmentDetailDocument = `
    query AttachmentDetail($id: UUID) {
  document(id: $id) {
    id
    items {
      id
      type
      extra
    }
  }
}
    `;
export const DiscourseDocument = `
    query Discourse($id: UUID) {
  document(id: $id) {
    id
    items {
      id
      type
      extra
    }
  }
}
    `;
export const DraftDiscourseDocument = `
    query DraftDiscourse($patientId: UUID) {
  document(userId: $patientId, type: DEKURZ_DRAFT) {
    id
    items {
      id
      type
      extra
    }
  }
}
    `;
export const DoctorBasicInfoDocument = `
    query DoctorBasicInfo($id: UUID) {
  user(id: $id) {
    id
    profile {
      id
      fullName
    }
  }
}
    `;
export const WorkplaceDoctorsDocument = `
    query WorkplaceDoctors($fulltext: String, $workplaceId: UUID, $workplaceIds: [UUID], $roleKeys: [String], $take: Int, $approved: Boolean) {
  workplaceDoctors(
    fulltext: $fulltext
    workplaceId: $workplaceId
    workplaceIds: $workplaceIds
    roleKeys: $roleKeys
    approved: $approved
    pagination: {take: $take}
  ) {
    data {
      __typename
      id
      user {
        id
        profile {
          id
          fullName
        }
      }
      workplaceMemberRoles {
        role {
          key
        }
      }
    }
  }
}
    `;
export const DocumentDocument = `
    query Document($id: UUID!) {
  document(id: $id) {
    id
    type
    createdAt
    title {
      id
      type
      extra
      createdAt
    }
    content {
      id
      type
      extra
      createdAt
    }
    createdBy {
      profile {
        fullName
      }
    }
    items {
      id
      type
      extra
      createdAt
    }
  }
}
    `;
export const DocumentsDocument = `
    query Documents($userId: UUID, $workplaceId: UUID, $types: [DocumentType], $take: Int = 10, $skip: Int) {
  documents(
    userId: $userId
    workplaceId: $workplaceId
    types: $types
    pagination: {skip: $skip, take: $take, order: {key: "created_at", how: DESC}}
  ) {
    meta {
      page
      totalPages
    }
    data {
      id
      type
      createdAt
      title {
        id
        type
        extra
        createdAt
      }
      content {
        id
        type
        extra
        createdAt
      }
      createdBy {
        profile {
          fullName
        }
      }
      items {
        id
        type
        extra
        createdAt
      }
      file {
        avResultText
      }
    }
  }
}
    `;
export const WorkplaceCaseTargetDocument = `
    query WorkplaceCaseTarget($id: UUID) {
  workplace(id: $id) {
    createCaseTarget
  }
}
    `;
export const WorkplaceCodeDocument = `
    query WorkplaceCode($id: UUID) {
  workplace(id: $id) {
    invitationCode
  }
}
    `;
export const EArchiveWorkplacePatientsDocument = `
    query EArchiveWorkplacePatients($workplaceId: UUID, $healthPlanIds: [UUID], $patientId: UUID, $doctorId: UUID, $status: WorkplacePatientStatus, $insuranceCompanyIds: [UUID], $take: Int = 48, $skip: Int) {
  workplacePatients(
    workplaceId: $workplaceId
    status: $status
    patientId: $patientId
    doctorId: $doctorId
    healthPlanIds: $healthPlanIds
    insuranceCompanyIds: $insuranceCompanyIds
    pagination: {take: $take, skip: $skip}
  ) {
    meta {
      count
      totalPages
      page
    }
    data {
      id
      user {
        id
        originalId
        vzpResult
        csszResult
        hasMeddi
        phoneNumber
        email
        formattedPhoneNumber
        isChild
        parents {
          profile {
            fullName
          }
          formattedPhoneNumber
          email
        }
        profile {
          firstName
          lastName
          fullName
          birthNumber
          formattedBirthNumber
          birthDate
          age
          contactEmail
          contactPhoneNumber
          insuranceCompanyTermItem {
            id
            value
            value2
          }
          address {
            fullAddress
            city
            street
            descriptiveNumber
            guideNumber
            postCode
          }
        }
        profileImageUrl
        archivedAt
        workplaceMember {
          dateOfDeath
        }
        meta {
          key
          value
        }
      }
      createdAt
      status
    }
  }
}
    `;
export const CreateUserMedicationLastedDocument = `
    mutation createUserMedicationLasted($input: CreateUserMedicationLastedInput!) {
  createUserMedicationLasted(input: $input) {
    id
  }
}
    `;
export const DeleteUserMedicationLastedDocument = `
    mutation DeleteUserMedicationLasted($id: UUID!) {
  deleteUserMedicationLasted(id: $id) {
    status
  }
}
    `;
export const PatientInformationDocument = `
    query PatientInformation($userId: UUID) {
  user(id: $userId) {
    id
    healthCard {
      weight
    }
    email
    formattedPhoneNumber
    vzpResult
    profile {
      id
      firstName
      lastName
      birthDate
      contactPhoneNumber
      contactEmail
      address {
        street
        guideNumber
        descriptiveNumber
        postCode
        country
        region
        city
        district
      }
      insuranceNumber
      insuranceCompanyTermItemId
      insuranceCompanyTermItem {
        id
        value
        value2
        name
      }
      gender
    }
  }
}
    `;
export const UpdateUserMedicationLastedDocument = `
    mutation UpdateUserMedicationLasted($where: UpdateUserMedicationLastedWhereInput!, $data: UpdateUserMedicationLastedDataInput!) {
  updateUserMedicationLasted(where: $where, data: $data) {
    id
  }
}
    `;
export const UserMedicationLastedDocument = `
    query UserMedicationLasted($where: UserMedicationLastedWhereInput!, $pagination: PaginationInput) {
  userMedicationLasted(where: $where, pagination: $pagination) {
    meta {
      page
      totalPages
      count
    }
    data {
      id
      data
    }
  }
}
    `;
export const DocumentationFilesDocument = `
    query DocumentationFiles($userId: UUID, $folderId: UUID, $fileIds: [UUID], $fulltext: String, $take: Int = 20, $skip: Int) {
  documentationFiles(
    userId: $userId
    folderId: $folderId
    fileIds: $fileIds
    fulltext: $fulltext
    pagination: {take: $take, skip: $skip}
    grouped: false
  ) {
    meta {
      page
      totalPages
    }
    data {
      id
      name
      extension
      displayName
      folderId
      hasThumb
      userId
      thumbUrl
      avResult
      createdAt
      file {
        id
        name
        extension
      }
      createdBy {
        id
        profile {
          fullName
        }
      }
      workplace {
        id
        name
      }
      fileTransfers {
        value
      }
      fileGroupId
      groupFiles {
        id
        name
        displayName
        createdAt
        thumbUrl
        userId
        folderId
        file {
          id
          name
          extension
        }
      }
    }
  }
}
    `;
export const DocumentationFilesCountDocument = `
    query DocumentationFilesCount($userId: UUID, $fulltext: String) {
  documentationFiles(userId: $userId, fulltext: $fulltext, grouped: false) {
    meta {
      count
    }
  }
}
    `;
export const DocumentationFoldersDocument = `
    query DocumentationFolders($userId: UUID, $take: Int = 999) {
  documentationFolders(userId: $userId, pagination: {take: $take}) {
    data {
      id
      name
      icon
      type
      filesCount
      userId
    }
  }
}
    `;
export const DocumentationFolderDocument = `
    query DocumentationFolder($folderId: UUID) {
  documentationFolder(id: $folderId) {
    id
    name
    icon
    type
    filesCount
    userId
  }
}
    `;
export const ECardNewFilesDocument = `
    query ECardNewFiles($workplaceId: UUID, $pagination: PaginationInput, $dateFrom: Date, $dateTo: Date, $seen: Boolean, $doctorId: UUID, $patientId: UUID) {
  workplacePatientDocumentationFiles(
    workplaceId: $workplaceId
    pagination: $pagination
    dateFrom: $dateFrom
    dateTo: $dateTo
    seen: $seen
    doctorId: $doctorId
    patientId: $patientId
    grouped: false
  ) {
    meta {
      page
      totalPages
    }
    data {
      id
      name
      displayName
      folderId
      folder {
        name
      }
      userId
      avResult
      createdAt
      file {
        id
        name
        extension
      }
      virtualUserId
      virtualUser {
        id
        profile {
          fullName
          formattedBirthNumber
        }
      }
      isSeenMarkedBy {
        profile {
          fullName
        }
      }
      isSeen
      user {
        id
        profile {
          fullName
          formattedBirthNumber
        }
        userRelations(workplaceId: $workplaceId, useOriginalId: true) {
          id
          relationUser {
            profile {
              fullName
            }
          }
          type
        }
      }
      virtualUserId
      createdBy {
        id
        profile {
          fullName
        }
      }
      fileTransfers {
        value
      }
      fileGroupId
      groupFiles {
        id
        name
        displayName
        createdAt
        thumbUrl
        userId
        folderId
        file {
          id
          name
          extension
        }
      }
    }
  }
}
    `;
export const TransferDocumentDocument = `
    mutation TransferDocument($input: DocumentTransferInput) {
  transferDocument(input: $input) {
    id
  }
}
    `;
export const TransferDocumentsDocument = `
    mutation TransferDocuments($input: DocumentsTransferInput!) {
  transferDocuments(input: $input) {
    id
  }
}
    `;
export const GetUserOriginalIdDocument = `
    query getUserOriginalId($id: UUID) {
  user(id: $id) {
    originalId
  }
}
    `;
export const WorkplacePatientDocumentationFilesMarkAsSeenDocument = `
    mutation WorkplacePatientDocumentationFilesMarkAsSeen {
  workplacePatientDocumentationFilesMarkAsSeen {
    status
  }
}
    `;
export const EducationMaterialsDocument = `
    query EducationMaterials($workplaceId: UUID, $pagination: PaginationInput) {
  educationMaterials(workplaceId: $workplaceId, pagination: $pagination) {
    data {
      id
      name
    }
  }
}
    `;
export const EventDocument = `
    query Event($id: UUID) {
  event(id: $id) {
    id
    title
    dateFrom
    dateTo
    description
  }
}
    `;
export const EventsDocument = `
    query Events($start: DateTime, $end: DateTime, $types: [EventType], $workplaceIds: [UUID], $userIds: [UUID], $metaKey: String) {
  events(
    start: $start
    end: $end
    types: $types
    workplaceIds: $workplaceIds
    userIds: $userIds
    metaKey: $metaKey
    pagination: {take: 9999}
  ) {
    data {
      id
      title
      dateFrom
      dateTo
      description
      type
      caseId
      description
      calendar {
        workplaceId
        workplace {
          name
          doctorDisplayName
        }
      }
      eventMembers {
        id
        userId
        user {
          id
          isPatient
          isDoctor
          formattedPhoneNumber
          profile {
            fullName
            birthNumber
            age
          }
        }
        status
        role
      }
      layout
      meta {
        key
        value
      }
    }
  }
}
    `;
export const WorkplaceEventsDocument = `
    query WorkplaceEvents($start: DateTime, $end: DateTime, $types: [EventType], $workplaceIds: [UUID], $userIds: [UUID]) {
  workplaceEvents(
    start: $start
    end: $end
    types: $types
    workplaceIds: $workplaceIds
    userIds: $userIds
    pagination: {take: 9999}
  ) {
    data {
      id
      title
      dateFrom
      dateTo
      description
      type
      caseId
      description
      calendar {
        workplaceId
        workplace {
          name
          doctorDisplayName
        }
      }
      eventMembers {
        id
        userId
        state
        user {
          id
          isPatient
          isDoctor
          isChild
          formattedPhoneNumber
          profile {
            fullName
            birthNumber
            age
          }
        }
        status
        role
      }
      layout
      meta {
        key
        value
      }
      createdBy {
        profile {
          fullName
        }
        isPatient
      }
    }
  }
}
    `;
export const GetOrdersDocument = `
    query getOrders($filter: OrdersFilter, $take: Int = 20, $skip: Int) {
  orders(filter: $filter, pagination: {take: $take, skip: $skip}) {
    meta {
      count
      page
      limit
      totalPages
    }
    data {
      id
      issueDate
      number
      priceInvoicing
      commission
      name
      invoices {
        id
        url
        number
      }
      orderLogs {
        type
      }
      orderMembers {
        userId
        type
        user {
          id
          profile {
            fullName
          }
        }
      }
    }
  }
}
    `;
export const OrderStatisticsDocument = `
    query OrderStatistics($where: OrderStatisticsWhereInput) {
  orderStatistics(where: $where) {
    data {
      label
      totalInvoiced
      totalCommission
      currency
    }
  }
}
    `;
export const HealthPlanBabyPregnancyDocument = `
    query HealthPlanBabyPregnancy($patientId: UUID!) {
  healthPlanBabyPregnancy(patientId: $patientId) {
    gestationalAgeFUM
    dateOfDelivery
  }
}
    `;
export const SubmitQuestionnaireResultDocument = `
    mutation SubmitQuestionnaireResult($input: SubmitQuestionnaireResultInput) {
  submitQuestionnaireResult(input: $input) {
    id
    questionnaire {
      id
      questionnaireItems {
        id
      }
    }
  }
}
    `;
export const EndHealthPlanUserDocument = `
    mutation EndHealthPlanUser($healthPlanUserId: UUID!, $questionnaireResultId: UUID) {
  endHealthPlanUser(
    input: {healthPlanUserId: $healthPlanUserId, questionnaireResultId: $questionnaireResultId}
  ) {
    id
  }
}
    `;
export const CreateHealthPlanUserFromDataDocument = `
    mutation CreateHealthPlanUserFromData($input: CreateHealthPlanUserFromDataInput) {
  createHealthPlanUserFromData(input: $input) {
    id
  }
}
    `;
export const HealthPlanUserInformationDocument = `
    query HealthPlanUserInformation($userId: UUID!) {
  user(id: $userId) {
    id
    email
    meta(
      keys: ["insurance", "identificationDocument", "historyClinicNumber", "canTreatHimself", "canTreatHimselfSpecification", "emergencyContact", "referred", "legalRepresentative"]
    ) {
      key
      value
    }
  }
}
    `;
export const HealthPlanUserItemIdDocument = `
    query HealthPlanUserItemId($healthPlanUserId: UUID, $type: String, $subtype: String) {
  healthPlanUserItem(
    type: $type
    subtype: $subtype
    healthPlanUserId: $healthPlanUserId
  ) {
    id
  }
}
    `;
export const HealthPlanUserDocument = `
    query HealthPlanUser($userId: UUID, $healthPlanCode: String, $workplaceId: UUID) {
  healthPlanUser(
    userId: $userId
    healthPlanCode: $healthPlanCode
    workplaceId: $workplaceId
  ) {
    id
    healthPlanId
    activeMonth
    doctorId
    offerContent
    statusText
    isActive
    ready
    doctor {
      id
      profile {
        fullName
      }
    }
    price {
      priceWithVat
      formattedPrice
    }
    pricing {
      paymentMethod
      totalPrice {
        id
        priceWithVat
        currency
        formattedPrice
      }
      remainsToPay {
        id
        priceWithVat
        currency
        formattedPrice
      }
    }
    healthPlan {
      code
      name
      totalMonths
    }
    periods {
      label
      value
      sale
      id
    }
    activeFrom
    activeTo
  }
}
    `;
export const HealthPlanIdDocument = `
    query HealthPlanId($code: String) {
  healthPlan(code: $code) {
    id
  }
}
    `;
export const HealthPlanDetailsDocument = `
    query HealthPlanDetails($code: String) {
  healthPlan(code: $code) {
    id
    doctorInitialQuestionnaireCode
  }
}
    `;
export const CreateHealthPlanUserDocument = `
    mutation CreateHealthPlanUser($healthPlanId: UUID!, $userId: UUID!, $questionnaireResultId: UUID) {
  createHealthPlanUser(
    input: {healthPlanId: $healthPlanId, userId: $userId, questionnaireResultId: $questionnaireResultId}
  ) {
    id
  }
}
    `;
export const HealthPlansDocument = `
    query HealthPlans {
  healthPlans {
    meta {
      count
    }
    data {
      id
      name
      code
    }
  }
}
    `;
export const RequestPaymentHealthPlanUserDocument = `
    mutation RequestPaymentHealthPlanUser($input: RequestPaymentHealthPlanUserInput) {
  requestPaymentHealthPlanUser(input: $input) {
    id
  }
}
    `;
export const HealthPlanRequirementsDocument = `
    query HealthPlanRequirements($where: HealthPlanUserItemWhereInput, $pagination: PaginationInput) {
  healthPlanUserItems(where: $where, pagination: $pagination) {
    meta {
      page
      totalPages
    }
    data {
      id
      type
      extra
    }
  }
}
    `;
export const HealthPlanUserIdDocument = `
    query HealthPlanUserId($patientId: UUID, $healthPlanCode: String) {
  healthPlanUser(userId: $patientId, healthPlanCode: $healthPlanCode) {
    id
    healthPlanId
  }
}
    `;
export const HealthPlanUsersDocument = `
    query HealthPlanUsers($userId: UUID, $healthPlanCode: HealthPlanCodeEnum) {
  healthPlanUsers(userId: $userId, healthPlanCode: $healthPlanCode) {
    data {
      id
      healthPlanId
      activeMonth
      doctorId
      offerContent
      statusText
      isActive
      ready
      doctor {
        id
        profile {
          fullName
        }
      }
      price {
        priceWithVat
        formattedPrice
      }
      pricing {
        paymentMethod
        totalPrice {
          id
          priceWithVat
          currency
          formattedPrice
        }
        remainsToPay {
          id
          priceWithVat
          currency
          formattedPrice
        }
      }
      healthPlan {
        code
        name
        totalMonths
      }
      periods {
        label
        value
        sale
        id
      }
      activeFrom
      activeTo
    }
  }
}
    `;
export const HealthPlanUserBabyDocument = `
    query HealthPlanUserBaby($patientId: UUID!) {
  healthPlanUser(userId: $patientId, healthPlanCode: "meddibaby") {
    healthPlanUserBaby {
      gestionalAge
      dateOfBirth
    }
  }
}
    `;
export const InitialQuestionnaireResultDocument = `
    query InitialQuestionnaireResult($userId: UUID, $healthPlanCode: String) {
  healthPlanUser(userId: $userId, healthPlanCode: $healthPlanCode) {
    id
    initialQuestionnaireResult {
      questionnaireResultItems {
        question {
          key
        }
        valueJson
      }
    }
  }
}
    `;
export const QuestionnaireResultItemsDocument = `
    query QuestionnaireResultItems($questionnaireId: UUID, $questionnaireCode: String, $questionKey: String, $questionKeys: [String], $patientId: UUID, $dateFrom: DateTime, $dateTo: DateTime, $take: Int = 10) {
  questionnaireResultItems(
    questionnaireId: $questionnaireId
    questionnaireCode: $questionnaireCode
    questionKey: $questionKey
    questionKeys: $questionKeys
    patientId: $patientId
    dateFrom: $dateFrom
    dateTo: $dateTo
    pagination: {take: $take}
  ) {
    data {
      id
      questionnaireResult {
        id
        createdAt
      }
      question {
        id
        key
        questionnaire {
          id
          code
          partnerId
        }
        title
        parentQuestionnaireItem {
          id
        }
      }
      answer {
        id
        value
        title
        subtitle
        childQuestionnaireItems {
          id
          title
          subtitle
          value
        }
      }
      value
      valueJson
    }
  }
}
    `;
export const QuestionnaireIdDocument = `
    query QuestionnaireId($code: String) {
  questionnaire(code: $code) {
    id
  }
}
    `;
export const WorkplaceHealthPlansDocument = `
    query WorkplaceHealthPlans {
  workplaceHealthPlans {
    meta {
      count
    }
    data {
      id
      name
      code
      structure {
        name
        steps {
          key
          name
          type
          settings
        }
        settings
      }
    }
  }
}
    `;
export const CreateInsuranceReportExportFilesDocument = `
    mutation CreateInsuranceReportExportFiles($input: CreateInsuranceReportExportFiles!) {
  createInsuranceReportExportFiles(input: $input)
}
    `;
export const DeleteInsuranceReportDocument = `
    mutation DeleteInsuranceReport($id: UUID!) {
  deleteInsuranceReport(id: $id) {
    status
  }
}
    `;
export const InsuranceOperationCreateDocument = `
    mutation InsuranceOperationCreate($input: CreateOperationReportInput) {
  createInsuranceOperation(input: $input) {
    id
  }
}
    `;
export const InsuranceOperationDeleteDocument = `
    mutation InsuranceOperationDelete($id: UUID!) {
  deleteInsuranceOperation(id: $id) {
    status
  }
}
    `;
export const InsuranceOperationsDocument = `
    query InsuranceOperations($where: InsuranceOperationsWhereInput!) {
  insuranceOperations(where: $where) {
    data {
      id
      code
      title
      points
      pricePerPoint
    }
  }
}
    `;
export const InsuranceReportDocument = `
    query InsuranceReport($id: UUID!) {
  insuranceReport(id: $id) {
    id
    createdAt
    birthNumber
    diagnosis
    operation {
      id
      title
    }
    count
    points
  }
}
    `;
export const InsuranceReportCreateDocument = `
    mutation InsuranceReportCreate($input: CreateInsuranceReportInput!) {
  createInsuranceReport(input: $input) {
    id
  }
}
    `;
export const InsuranceReportUserDataDocument = `
    query InsuranceReportUserData($id: UUID) {
  user(id: $id) {
    profile {
      birthNumber
      insuranceCompanyTermItemId
    }
  }
}
    `;
export const InsuranceReportsDocument = `
    query InsuranceReports($where: InsuranceReportsWhereInput!, $take: Int = 20, $skip: Int) {
  insuranceReports(where: $where, pagination: {take: $take, skip: $skip}) {
    meta {
      page
      totalPages
    }
    data {
      id
      createdAt
      birthNumber
      diagnosis
      operation {
        id
        title
      }
      count
      points
    }
  }
}
    `;
export const AddLaboratoryRequisitionToPatientDocument = `
    mutation AddLaboratoryRequisitionToPatient($input: AddLaboratoryRequisitionToPatientInput!) {
  addLaboratoryRequisitionToPatient(input: $input) {
    id
  }
}
    `;
export const CreateLaboratoryWorkplaceDocument = `
    mutation CreateLaboratoryWorkplace($input: CreateLaboratoryWorkplaceInput!) {
  createLaboratoryWorkplace(input: $input) {
    id
  }
}
    `;
export const CreateLaboratoryRequisitionWorkplaceDocument = `
    mutation CreateLaboratoryRequisitionWorkplace($input: CreateLaboratoryRequisitionWorkplaceInput!) {
  createLaboratoryRequisitionWorkplace(input: $input) {
    id
    workplaceId
    laboratoryRequisition {
      id
      name
    }
  }
}
    `;
export const DeleteLaboratoryRequisitionWorkplaceDocument = `
    mutation DeleteLaboratoryRequisitionWorkplace($input: DeleteLaboratoryRequisitionWorkplaceInput!) {
  deleteLaboratoryRequisitionWorkplace(input: $input)
}
    `;
export const DeleteLaboratoryWorkplaceDocument = `
    mutation DeleteLaboratoryWorkplace($input: DeleteLaboratoryWorkplaceInput!) {
  deleteLaboratoryWorkplace(input: $input)
}
    `;
export const HideSeenLaboratoryResultsDocument = `
    mutation HideSeenLaboratoryResults($input: HideSeenLaboratoryResultsInput!) {
  hideSeenLaboratoryResults(input: $input) {
    id
  }
}
    `;
export const IssuedLaboratoryRequestsDocument = `
    query IssuedLaboratoryRequests($where: LaboratoryRequisitionResultsWhereInput!, $take: Int = 20, $skip: Int, $order: PaginationInputOrder) {
  laboratoryRequisitionResults(
    where: $where
    pagination: {take: $take, skip: $skip, order: $order}
  ) {
    meta {
      totalPages
      page
    }
    data {
      id
      requisition {
        name
        laboratory {
          name
        }
      }
      createdAt
      laboratoryExaminationRequest {
        id
        name
        folderId
        userId
        createdAt
        file {
          id
          name
          extension
        }
      }
      laboratoryExaminationRequestPatientId
    }
  }
}
    `;
export const LaboratoriesDocument = `
    query Laboratories($pagination: PaginationInput) {
  laboratories(pagination: $pagination) {
    data {
      id
      name
      code
    }
  }
}
    `;
export const LaboratoryRequestCreateDocument = `
    mutation LaboratoryRequestCreate($input: SaveLaboratoryRequisitionResultInput!) {
  saveLaboratoryRequisitionResult(input: $input) {
    id
  }
}
    `;
export const LaboratoryRequestFormDocument = `
    query LaboratoryRequestForm($where: LaboratoryRequisitionFormWhereInput!) {
  laboratoryRequisitionForm(where: $where) {
    requisition {
      name
      laboratory {
        name
      }
    }
    form {
      settings
      samples {
        key
        name
      }
      children
    }
  }
}
    `;
export const LaboratoryRequestsDocument = `
    query LaboratoryRequests($where: LaboratoryRequisitionsWhereInput!, $pagination: PaginationInput) {
  laboratoryRequisitions(where: $where, pagination: $pagination) {
    data {
      id
      name
      createdAt
      laboratory {
        name
      }
      allowed
    }
  }
}
    `;
export const LaboratoryResultsDocument = `
    query LaboratoryResults($where: LaboratoryResultsWhereInput!, $pagination: PaginationInput) {
  laboratoryResults(where: $where, pagination: $pagination) {
    meta {
      page
      totalPages
    }
    data {
      id
      createdAt
      user {
        id
        profile {
          fullName
        }
      }
      laboratory {
        name
      }
      laboratoryResultItems {
        id
        createdAt
        name
        result
        chart
        unit
        lowerReferenceValue
        upperReferenceValue
        evaluation {
          value
          type
          color
        }
        acceptedAt
        acceptedBy
        processedAt
        processedBy
      }
      isSeen
      isSeenMarkedBy {
        profile {
          fullName
        }
      }
    }
  }
}
    `;
export const LaboratoryWorkplacesDocument = `
    query LaboratoryWorkplaces($where: LaboratoryWorkplacesWhereInput!, $pagination: PaginationInput) {
  laboratoryWorkplaces(where: $where, pagination: $pagination) {
    data {
      id
      laboratory {
        id
        name
      }
    }
  }
}
    `;
export const AllCertificatesDocument = `
    query AllCertificates {
  termItems(termType: "workplace_cert_types") {
    data {
      id
      value
      name
    }
  }
}
    `;
export const AllHealthPlansDocument = `
    query AllHealthPlans($all: Boolean) {
  healthPlans(all: $all) {
    data {
      id
      name
      code
      active
      description
      settings
    }
  }
}
    `;
export const AvailableServicesDocument = `
    query AvailableServices {
  termItems(termType: "third_party_services") {
    data {
      id
      value
    }
  }
}
    `;
export const CreateHealthPlanWorkplaceDocument = `
    mutation createHealthPlanWorkplace($input: CreateHealthPlanWorkplaceInput) {
  createHealthPlanWorkplace(input: $input) {
    id
  }
}
    `;
export const DeleteHealthPlanWorkplaceDocument = `
    mutation deleteHealthPlanWorkplace($input: RemoveHealthPlanWorkplaceInput) {
  deleteHealthPlanWorkplace(input: $input) {
    id
  }
}
    `;
export const SimpleWorkerInformationDocument = `
    query SimpleWorkerInformation($userId: UUID) {
  user(id: $userId) {
    profileImageUrl
    profile {
      fullName
    }
    formattedPhoneNumber
    email
  }
}
    `;
export const UpdateWorkplaceMemberDocument = `
    mutation UpdateWorkplaceMember($input: UpdateWorkplaceMembersInput) {
  updateWorkplaceMembers(input: $input) {
    id
  }
}
    `;
export const WorkerInformationDocument = `
    query WorkerInformation($userId: UUID) {
  user(id: $userId) {
    id
    profile {
      nationalityTermItem {
        id
        name
        value
      }
    }
    meta {
      key
      value
    }
  }
}
    `;
export const WorkerWorkplacesDocument = `
    query WorkerWorkplaces($rootWorkplaceId: UUID, $userId: UUID) {
  workplaceMembers(
    rootWorkplaceId: $rootWorkplaceId
    userId: $userId
    pagination: {take: 999}
  ) {
    data {
      id
      code
      workplace {
        id
        name
      }
      workplaceMemberRoles {
        role {
          id
          name
          key
        }
      }
      memberSearchableOutside
    }
  }
}
    `;
export const WorkplaceBasicDataDocument = `
    query WorkplaceBasicData($id: UUID) {
  workplace(id: $id) {
    id
    parentWorkplaceId
    parentWorkplace {
      id
      doctorDisplayName
    }
    name
    codeName
    phone
    address {
      street
      descriptiveNumber
      guideNumber
      city
      postCode
    }
    termItems {
      id
      term {
        type
        name
      }
      value
    }
    meta {
      id
      key
      value
    }
    calendarEmailNotification
    memberSearchableOutside
    workplaceSearchableOutside
    createCaseTarget
    onlineOrderTarget
    defaultDoctorId
    defaultInvitation
  }
}
    `;
export const FullWorkplaceCaseTypeDocument = `
    query FullWorkplaceCaseType($id: UUID) {
  workplaceCaseType(id: $id) {
    id
    workplaceId
    canSearchDoctor
    canSendToAmbulance
    canSelectTransport
    workplaceDefaultCaseType
    labelTranslations {
      key
      language
      value
    }
    caseType {
      id
      rank
      canBookOnline
      canBookOnSite
      canOrderImmediate
      priceId
      code
      label
      parentCaseTypeId
      hiddenForPatient
      eventInterval
      notificationCase
      notificationBook
      price {
        id
        priceWithVat
        priceWithVatRaw
        vatRate
      }
      caseTypeItems {
        id
        rank
        title
        description
        settings
        key
        type
        subtype
      }
      isEditable
    }
    labelTranslations {
      key
      value
    }
  }
}
    `;
export const WorkplaceCertificatesDocument = `
    query WorkplaceCertificates($where: WorkplaceCertificatesWhereInput!) {
  workplaceCertificates(where: $where) {
    data {
      name
      description
      type
      certificate {
        id
        type
        expires
        isExpired
      }
    }
  }
}
    `;
export const WorkplaceWorkersListDocument = `
    query WorkplaceWorkersList($rootWorkplaceId: UUID, $workplaceIds: [UUID], $fulltext: String, $roleIds: [UUID], $take: Int = 48, $skip: Int) {
  doctors(
    rootWorkplaceId: $rootWorkplaceId
    includeNurses: true
    workplaceIds: $workplaceIds
    fulltext: $fulltext
    roleIds: $roleIds
    pagination: {take: $take, skip: $skip}
  ) {
    meta {
      count
      page
      totalPages
    }
    data {
      id
      email
      profileImageUrl
      rootWorkplaceMemberStatus
      profile {
        fullName
      }
    }
  }
}
    `;
export const WorkplacesCsszDocument = `
    query WorkplacesCssz {
  workplaces(type: "normal") {
    data {
      id
      name
      meta(key: "csszClientId") {
        id
        key
        value
      }
    }
  }
}
    `;
export const WorkplacesSuklCodeDocument = `
    query WorkplacesSuklCode {
  workplaces(type: "normal") {
    data {
      id
      name
      meta(key: "suklCode") {
        id
        key
        value
      }
    }
  }
}
    `;
export const MedicalRequestFormsDocument = `
    query MedicalRequestForms {
  medicalRequestForms(pagination: {take: 999}) {
    data {
      id
      name
      type
      wizardKey
    }
  }
}
    `;
export const CreateUserMetaTranslationDocument = `
    mutation CreateUserMetaTranslation($input: [UserMetaTranslationInput]) {
  createUserMetaTranslation(input: $input) {
    id
  }
}
    `;
export const MetaDocument = `
    query Meta($userId: UUID, $workplaceId: UUID, $key: String!, $useOriginalId: Boolean) {
  meta(
    userId: $userId
    workplaceId: $workplaceId
    key: $key
    useOriginalId: $useOriginalId
  ) {
    id
    value
    key
  }
}
    `;
export const MyMetaDocument = `
    query MyMeta {
  me {
    meta {
      key
      value
    }
  }
}
    `;
export const AssignCaseDocument = `
    mutation AssignCase($caseId: UUID!, $workplaceId: UUID, $workplaceMemberId: UUID, $note: String) {
  assignCase(
    input: {caseId: $caseId, workplaceId: $workplaceId, workplaceMemberId: $workplaceMemberId, note: $note}
  ) {
    id
  }
}
    `;
export const MonitoringCentreCasesDocument = `
    query MonitoringCentreCases($caseTypeIds: [UUID], $priorityId: UUID, $patientId: UUID, $date: Date, $caseStatusValue: String, $parentCaseTypeId: UUID, $caseTypeCode: String, $doctorId: UUID, $attendingDoctorId: UUID, $workplaceId: UUID, $solved: Boolean, $createdAt: CaseCreateDay, $code: String, $take: Int = 40, $skip: Int, $solvedAtRange: DateFilter, $createdAtRange: DateFilter, $patient: String, $order: PaginationInputOrder) {
  monitoringCentreCases(
    caseTypeIds: $caseTypeIds
    priorityId: $priorityId
    patientId: $patientId
    date: $date
    caseStatusValue: $caseStatusValue
    parentCaseTypeId: $parentCaseTypeId
    caseTypeCode: $caseTypeCode
    doctorId: $doctorId
    attendingDoctorId: $attendingDoctorId
    workplaceId: $workplaceId
    solved: $solved
    createdAt: $createdAt
    code: $code
    patient: $patient
    pagination: {take: $take, skip: $skip, order: $order}
    solvedAtRange: $solvedAtRange
    createdAtRange: $createdAtRange
  ) {
    meta {
      totalPages
      page
      count
    }
    data {
      id
      title
      isNew
      isAssigned
      isMyCase
      isImmediate
      createdAt
      solveTo
      patientDescription
      lastNote {
        id
        text
      }
      diagnosis
      patient {
        id
        profileImageUrl
        profile {
          fullName
          age
          address {
            city
          }
          insuranceCompanyTermItem {
            name
            value
          }
          formattedBirthNumber
        }
        userRelations(useOriginalId: true) {
          id
          relationUser {
            profile {
              fullName
              salutationBefore
              lastName
            }
          }
        }
        avatarFile {
          createdAt
        }
        originalId
      }
      patientParent {
        profile {
          fullName
        }
      }
      workplace {
        id
        name
        doctorDisplayName
        codeName
      }
      doctor {
        id
        profileImageUrl
        profile {
          age
          fullName
          salutationBefore
          lastName
        }
      }
      lastCaseEntry {
        message
        createdAt
      }
      medicalReports {
        id
        diagnosis
        treatment
        note
        createdAt
        documentId
        type
        document {
          id
          type
          title {
            extra
          }
        }
      }
      totalUnreadCaseEntries
      priority {
        id
        name
        value
        value2
        value3
      }
      code
      updatedAt
      caseType {
        id
        label
        type
        code
        rootCaseType {
          id
          label
          type
        }
      }
      medicationLasted
    }
  }
}
    `;
export const PriorityCaseDocument = `
    mutation PriorityCase($input: PriorityCaseInput) {
  priorityCase(input: $input) {
    id
    priorityId
    priority {
      name
      value
      value2
    }
  }
}
    `;
export const CasesAssignedCountDocument = `
    query casesAssignedCount {
  casesAssigned(onlyVisible: true) {
    meta {
      count
    }
  }
}
    `;
export const QuestionnaireResultsCountDocument = `
    query questionnaireResultsCount($type: QuestionnaireResultResult, $seen: Boolean, $questionnaireCodes: [String], $doctorId: UUID) {
  questionnaireResults(
    result: $type
    seen: $seen
    questionnaireCodes: $questionnaireCodes
    doctorId: $doctorId
  ) {
    meta {
      count
    }
  }
}
    `;
export const WorkplaceCasesCountDocument = `
    query workplaceCasesCount {
  workplaceCases {
    meta {
      count
    }
  }
}
    `;
export const WorkplacePatientDocumentationFilesCountDocument = `
    query WorkplacePatientDocumentationFilesCount($workplaceId: UUID) {
  workplacePatientDocumentationFiles(workplaceId: $workplaceId, seen: false) {
    meta {
      count
    }
  }
}
    `;
export const NcziListDiagnosisItemsDocument = `
    query NcziListDiagnosisItems($fulltext: String, $take: Int = 10) {
  items: ncziListDiagnosis(fulltext: $fulltext, pagination: {take: $take}) {
    meta {
      count
      page
      limit
      totalPages
    }
    data {
      code
      ncziCode
      name
      enum {
        oid
        version
      }
    }
  }
}
    `;
export const NcziListEnumItemsDocument = `
    query NcziListEnumItems($oid: String!, $fulltext: String, $take: Int = 10) {
  items: ncziListEnumItems(
    oid: $oid
    fulltext: $fulltext
    pagination: {take: $take}
  ) {
    meta {
      count
      page
      limit
      totalPages
    }
    data {
      code
      name
      abbreviation
      description
      enum {
        oid
        version
      }
    }
  }
}
    `;
export const NcziRefrenceItemDocument = `
    query NcziRefrenceItem($oid: String!, $code: String!) {
  item: ncziEnumItem(oid: $oid, code: $code) {
    code
    name
    abbreviation
    description
    params
    enum {
      oid
      version
    }
  }
}
    `;
export const NcziRefrenceItemsByCodeDocument = `
    query NcziRefrenceItemsByCode($oid: String!, $code: [String!]!) {
  items: ncziEnumItems(oid: $oid, code: $code) {
    enumItems {
      code
      name
      abbreviation
      description
    }
  }
}
    `;
export const NcziRefrenceItemByAbbrDocument = `
    query NcziRefrenceItemByAbbr($oid: String!, $abbr: String!) {
  item: ncziEnumItemByAbbr(oid: $oid, abbr: $abbr) {
    code
    name
    abbreviation
    description
    params
    enum {
      oid
      version
    }
  }
}
    `;
export const NcziListEnumsDocument = `
    query NcziListEnums {
  result: ncziListEnums {
    data {
      name
      oid
      version
      type
    }
  }
}
    `;
export const NcziListExtensionItemsDocument = `
    query NcziListExtensionItems($oid: String!, $fulltext: String, $take: Int = 10, $vaccination: Boolean = false) {
  items: ncziListExtensionItems(
    oid: $oid
    fulltext: $fulltext
    pagination: {take: $take}
    vaccination: $vaccination
  ) {
    meta {
      count
      page
      limit
      totalPages
    }
    data {
      code
      name
      abbreviation
      params
      extension {
        name
        oid
      }
    }
  }
}
    `;
export const NcziExtensionItemDocument = `
    query NcziExtensionItem($oid: String!, $code: String!) {
  item: ncziExtensionItem(oid: $oid, code: $code) {
    code
    name
    abbreviation
    params
    extension {
      name
      oid
    }
  }
}
    `;
export const NcziExtensionItemByAbbrDocument = `
    query NcziExtensionItemByAbbr($oid: String!, $abbr: String!) {
  item: ncziExtensionItemByAbbr(oid: $oid, abbr: $abbr) {
    code
    name
    abbreviation
    params
    extension {
      name
      oid
    }
  }
}
    `;
export const NcziMedicamentDocument = `
    query NcziMedicament($code: String!) {
  medicament: ncziMedicamentItem(code: $code) {
    code
    name
    additionalName
    opl
    multiplePrescription
    antibioticsChemotherapy
  }
}
    `;
export const FindOupzsDocument = `
    query FindOupzs($code: String!) {
  items: ncziOUPZsByPZSCode(pzsCode: $code) {
    code
    name
    extension {
      code
      scheme {
        oid
      }
    }
    provider {
      code
      name
      extension {
        code
        scheme {
          oid
        }
      }
    }
    specialization {
      ZPrCode
      specialization {
        displayName
        code
        scheme {
          oid
          version
        }
      }
    }
  }
}
    `;
export const NcziProductListDocument = `
    query NcziProductList($fulltext: String) {
  items: ncziListProductItems(fulltext: $fulltext) {
    data {
      code
      name
      additionalName
      opl
      antibioticsChemotherapy
      type
      tailored
      atcCode
      atcName
      atcAddon
      ioNeeded
      ioOptions
      ventilator
      quantityLimit
    }
  }
}
    `;
export const NcziProductDocument = `
    query NcziProduct($code: String!) {
  product: ncziProductItem(code: $code) {
    code
    name
    additionalName
    opl
    antibioticsChemotherapy
    type
    tailored
    atcCode
    atcName
    atcAddon
    ioNeeded
    ioOptions
    ventilator
    quantityLimit
  }
}
    `;
export const NcziQueueDocument = `
    query NcziQueue($userId: String!) {
  items: ncziListQueue(userId: $userId) {
    data {
      id
      userId
      type
      lastState
      createdAt
      updatedAt
      finished
    }
    meta {
      count
    }
  }
}
    `;
export const UserBirthNumberDocument = `
    query UserBirthNumber($id: UUID!) {
  user(id: $id) {
    profile {
      birthNumber
    }
  }
}
    `;
export const UserNcziProfileDocument = `
    query UserNcziProfile($id: UUID!) {
  user(id: $id) {
    profile {
      birthNumber
      insuranceCompanyTermItem {
        name
        value
        value2
        value3
      }
    }
  }
}
    `;
export const MarkAllNotificationsAsSeenDocument = `
    mutation MarkAllNotificationsAsSeen {
  markAsSeenUserNotifications {
    success
  }
}
    `;
export const ConversationMessageDocument = `
    query ConversationMessage($id: UUID) {
  message(id: $id) {
    id
    conversationId
    content
    createdAt
  }
}
    `;
export const NotificationConversationDocument = `
    query NotificationConversation($id: UUID) {
  conversation(id: $id) {
    id
    name
    type
    createdAt
    conversationMembers {
      userId
      user {
        profile {
          fullName
        }
      }
    }
    lastMessage {
      id
      content
      type
      sender {
        user {
          profile {
            fullName
          }
        }
      }
      messageAttachments {
        id
        message {
          content
        }
        type
        questionnaireId
        questionnaire {
          title
        }
        educationMaterialId
        educationMaterial {
          name
        }
      }
    }
  }
}
    `;
export const ListNotificationsDocument = `
    query ListNotifications {
  items: notifications(pagination: {take: 20}) {
    data {
      __typename
      id
      type
      createdAt
      content
      conversationId
      myMessageMember {
        id
        seen
      }
      sender {
        id
        user {
          id
          profile {
            id
            fullName
          }
        }
      }
    }
    meta {
      count
      page
      totalPages
    }
  }
}
    `;
export const UnreadNotificationDocument = `
    query UnreadNotification {
  userNotice {
    unreadNotifications
  }
}
    `;
export const SetUserNotificationSettingsDocument = `
    mutation SetUserNotificationSettings($input: SetUserNotificationSettingInput!) {
  setUserNotificationSetting(input: $input) {
    id
  }
}
    `;
export const UserNotificationSettingsDocument = `
    query UserNotificationSettings($where: UserNotificationSettingsWhereInput!) {
  userNotificationSettings(where: $where) {
    data {
      id
      sending
      typeTermItemId
    }
  }
}
    `;
export const ArchiveWorkplaceMemberDocument = `
    mutation ArchiveWorkplaceMember($input: DeleteWorkplaceMemberInput) {
  deleteWorkplaceMember(input: $input) {
    status
  }
}
    `;
export const PatientDataDocument = `
    query PatientData($id: UUID!) {
  user(id: $id) {
    id
    isChild
    profile {
      id
      firstName
      lastName
      birthDate
      address {
        id
        street
        descriptiveNumber
        guideNumber
        city
        postCode
      }
    }
  }
}
    `;
export const PatientMetaDocument = `
    query PatientMeta($id: UUID) {
  user(id: $id) {
    id
    meta {
      id
      key
      value
      workplaceId
    }
  }
}
    `;
export const PatientBasicInfoDocument = `
    query PatientBasicInfo($id: UUID) {
  user(id: $id) {
    id
    profile {
      birthNumber
      id
      fullName
    }
  }
}
    `;
export const WorkplacePatientsDocument = `
    query WorkplacePatients($fulltext: String, $workplaceId: UUID, $workplaceIds: [UUID]) {
  workplacePatients(
    fulltext: $fulltext
    workplaceId: $workplaceId
    workplaceIds: $workplaceIds
  ) {
    data {
      __typename
      id
      user {
        id
        originalId
        profile {
          id
          fullName
          timezone
          formattedBirthNumber
          birthDate
          birthNumber
          address {
            fullAddress
          }
        }
      }
    }
  }
}
    `;
export const GroupMembersDocument = `
    query GroupMembers($groupId: UUID, $pagination: PaginationInput) {
  groupMembers(groupId: $groupId, pagination: $pagination) {
    meta {
      count
      page
      totalPages
    }
    data {
      id
      user {
        profile {
          fullName
          birthNumber
          age
          address {
            fullAddress
          }
        }
        formattedPhoneNumber
        profileImageUrl
        avatarFile {
          createdAt
        }
        isDoctor
        userRelations {
          user {
            profile {
              fullName
            }
          }
          workplace {
            name
          }
        }
      }
    }
  }
}
    `;
export const GroupAuditLogsDocument = `
    query GroupAuditLogs($targetEntityId: String, $pagination: PaginationInput) {
  auditLogs(
    targetEntityType: "GROUP"
    targetEntityId: $targetEntityId
    pagination: $pagination
  ) {
    meta {
      count
      page
      totalPages
    }
    data {
      id
      type
      targetEntityType
      text
      createdAt
      createdBy {
        profile {
          fullName
        }
      }
    }
  }
}
    `;
export const GroupsDocument = `
    query Groups($fulltext: String, $pagination: PaginationInput) {
  groups(fulltext: $fulltext, pagination: $pagination) {
    meta {
      count
      page
      totalPages
    }
    data {
      id
      name
      createdAt
      totalMembers
      description
      createdByLog {
        createdAt
        createdBy {
          profile {
            fullName
          }
        }
      }
      updatedByLog {
        createdAt
        createdBy {
          profile {
            fullName
          }
        }
      }
    }
  }
}
    `;
export const MassFindDocument = `
    query MassFind($fulltext: String, $pagination: PaginationInput) {
  groups(fulltext: $fulltext, pagination: $pagination) {
    meta {
      count
      page
      totalPages
    }
    data {
      id
      name
      createdAt
      totalMembers
      description
      createdByLog {
        createdAt
        createdBy {
          profile {
            fullName
          }
        }
      }
      updatedByLog {
        createdAt
        createdBy {
          profile {
            fullName
          }
        }
      }
    }
  }
  workplaceDoctors(
    fulltext: $fulltext
    pagination: $pagination
    roleKeys: ["doctor", "therapist", "nurse"]
    approved: null
  ) {
    meta {
      count
    }
    data {
      id
      workplaceMemberRoles {
        role {
          key
        }
      }
      user {
        id
        profile {
          fullName
        }
      }
    }
  }
  workplacePatients(fulltext: $fulltext, pagination: $pagination) {
    meta {
      count
    }
    data {
      id
      user {
        id
        formattedPhoneNumber
        profile {
          fullName
          birthNumber
          age
          address {
            fullAddress
          }
        }
        userRelations(useOriginalId: true) {
          id
          type
          relationUser {
            profile {
              fullName
            }
          }
          workplace {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export const CreatePhraseDocument = `
    mutation CreatePhrase($input: CreatePhraseInput!) {
  createPhrase(input: $input) {
    id
  }
}
    `;
export const DeletePhraseDocument = `
    mutation DeletePhrase($id: UUID!) {
  deletePhrase(id: $id) {
    status
  }
}
    `;
export const MyPhrasesDocument = `
    query MyPhrases($where: MyPhrasesWhereInput, $pagination: PaginationInput) {
  myPhrases(where: $where, pagination: $pagination) {
    meta {
      count
      page
      totalPages
    }
    data {
      id
      rank
      value
      type
      name
      meta {
        id
        key
        value
        formattedValue
      }
    }
  }
}
    `;
export const UpdatePhraseDocument = `
    mutation UpdatePhrase($input: UpdatePhraseInput!, $where: PhrasesWhereUnique!) {
  updatePhrase(input: $input, where: $where) {
    id
  }
}
    `;
export const CreateP1PrescriptionDocument = `
    mutation CreateP1Prescription($input: CreateP1PrescriptionInput!) {
  createP1Prescription(input: $input) {
    id
  }
}
    `;
export const PrescriptionMedicamentDocument = `
    query PrescriptionMedicament($search: String) {
  prescriptionMedicaments(fulltext: $search, take: 30) {
    data {
      id
      name
      code
      indicationLimitations
      specialityLimitations
      specialityLimitationTermItems {
        name
        value
      }
      hasLimitations
      hasIndicationLimitations
      hasSpecialityLimitations
      strength
      packaging
      form
      lim
      limTermItem {
        name
        value
        value2
      }
      priceRawFormatted
      priceInsuranceCompanyRawFormatted
      priceExtraFormatted
      rationalPrescription
      addition
      doping
      dopingTermItem {
        name
        value
      }
      dispensing
      dispensingTermItem {
        name
        value
      }
    }
  }
}
    `;
export const PrescriptionsDocument = `
    query Prescriptions($userId: UUID, $take: Int = 20, $skip: Int) {
  prescriptions(userId: $userId, pagination: {skip: $skip, take: $take}) {
    meta {
      count
      totalPages
      page
    }
    data {
      id
      userId
      code
      type
      createdById
      createdAt
      validUntil
      data
      items {
        id
        extra
        quantity
        prescriptionMedicament {
          id
          code
          name
          strength
          form
          atc
          packaging
          indicationLimitations
          hasIndicationLimitations
          specialityLimitations
          hasSpecialityLimitations
          specialityLimitationTermItems {
            id
            termId
            name
            value
            value2
            value3
            data
          }
          hasLimitations
          lim
          limTermItem {
            id
            termId
            name
            value
            value2
            value3
            data
          }
          rationalPrescription
          routeOfAdministration
          priceRawFormatted
          priceInsuranceCompanyRawFormatted
          priceExtraFormatted
          addition
          dispensing
          dispensingTermItem {
            id
            termId
            name
            value
            value2
            value3
            data
          }
          doping
          dopingTermItem {
            id
            termId
            name
            value
            value2
            value3
            data
          }
        }
      }
    }
  }
}
    `;
export const SingleQuestionnaireResultItemsDocument = `
    query SingleQuestionnaireResultItems($questionnaireResultId: UUID, $take: Int = 10, $skip: Int = 0) {
  questionnaireResultItems(
    questionnaireResultId: $questionnaireResultId
    pagination: {take: $take, skip: $skip}
  ) {
    data {
      id
      questionnaireResult {
        id
        createdAt
      }
      question {
        id
        key
        questionnaire {
          id
          code
          partnerId
        }
        title
        parentQuestionnaireItem {
          id
        }
      }
      answer {
        id
        value
        key
      }
      value
      valueJson
    }
  }
}
    `;
export const QuestionnaireSearchDocument = `
    query QuestionnaireSearch($fulltext: String, $take: Int, $showHidden: Boolean) {
  questionnaires(fulltext: $fulltext, take: $take, showHidden: $showHidden) {
    data {
      id
      code
      title
    }
  }
}
    `;
export const QuestionnaireSearchByCodeDocument = `
    query QuestionnaireSearchByCode($code: String) {
  questionnaire(code: $code) {
    id
    title
  }
}
    `;
export const QuestionnaireBasicInfoDocument = `
    query QuestionnaireBasicInfo($id: UUID) {
  questionnaire(id: $id) {
    id
    title
    code
    mainQuestionnaireId
  }
}
    `;
export const QuestionnaireSchedulesByParentScheduleDocument = `
    query QuestionnaireSchedulesByParentSchedule($parentQuestionnaireScheduleId: UUID) {
  questionnaireSchedules(
    parentQuestionnaireScheduleId: $parentQuestionnaireScheduleId
  ) {
    data {
      id
      userId
      dateFrom
      repeatHours
      type
      questionnaire {
        id
        title
        code
        type
      }
      questionnaireItem {
        title
        id
      }
    }
  }
}
    `;
export const QuestionnaireScheduleDocument = `
    query QuestionnaireSchedule($id: UUID) {
  questionnaireSchedule(id: $id) {
    id
    userId
    dateFrom
    dateTo
    frequencyText
    repeatHours
    type
    createdBy {
      id
      profile {
        fullName
      }
    }
    user {
      id
      profile {
        fullName
      }
    }
    questionnaireId
    questionnaire {
      id
      title
      code
      type
    }
  }
}
    `;
export const QuestionnaireDetailDocument = `
    query QuestionnaireDetail($code: String) {
  questionnaire(code: $code) {
    id
    title
  }
}
    `;
export const QuestionnaireResultsDocument = `
    query QuestionnaireResults($fulltext: String, $onlyPatient: Boolean, $ids: [UUID], $seen: Boolean, $dateFrom: Date, $dateTo: Date, $patientId: UUID, $scheduledById: UUID, $questionnaireId: UUID, $questionnaireCode: String, $questionnaire: String, $result: QuestionnaireResultResult, $doctorId: UUID, $workplaceIds: [UUID], $take: Int = 10, $skip: Int, $excludeQuestionnaireCodes: [String], $module: QuestionnaireModule, $scheduledByIds: [UUID]) {
  questionnaireResults(
    fulltext: $fulltext
    onlyPatient: $onlyPatient
    ids: $ids
    seen: $seen
    dateFrom: $dateFrom
    dateTo: $dateTo
    patientId: $patientId
    scheduledById: $scheduledById
    questionnaireId: $questionnaireId
    questionnaireCode: $questionnaireCode
    questionnaire: $questionnaire
    result: $result
    doctorId: $doctorId
    workplaceIds: $workplaceIds
    pagination: {skip: $skip, take: $take, order: {how: DESC, key: "created_at"}}
    excludeQuestionnaireCodes: $excludeQuestionnaireCodes
    module: $module
    scheduledByIds: $scheduledByIds
  ) {
    meta {
      count
      page
      totalPages
    }
    data {
      id
      createdAt
      result
      isSeen
      user {
        id
        profile {
          fullName
          formattedBirthNumber
        }
      }
      scheduledBy {
        id
        profile {
          fullName
        }
      }
      questionnaire {
        id
        title
        code
      }
      isSeenMarkedBy {
        profile {
          fullName
        }
      }
    }
  }
}
    `;
export const QuestionnaireSchedulesDocument = `
    query QuestionnaireSchedules($userId: UUID, $questionnaireId: UUID) {
  questionnaireSchedules(
    userId: $userId
    questionnaireId: $questionnaireId
    pagination: {take: 999, order: {key: "questionnaire_schedule.created_at", how: DESC}}
  ) {
    data {
      id
      userId
      dateFrom
      dateTo
      frequencyText
      repeatHours
      type
      createdBy {
        id
        profile {
          fullName
        }
      }
      user {
        id
        profile {
          fullName
        }
      }
      questionnaire {
        id
        title
        code
        type
      }
    }
  }
}
    `;
export const QuestionnairesDocument = `
    query Questionnaires($take: Int = 20, $skip: Int, $module: QuestionnaireModule, $showHidden: Boolean) {
  questionnaires(
    take: $take
    skip: $skip
    module: $module
    showHidden: $showHidden
  ) {
    meta {
      count
      totalPages
      page
    }
    data {
      id
      title
      code
      type
    }
  }
}
    `;
export const RequirementFileDocument = `
    query RequirementFile($id: UUID) {
  documentationFiles(fileIds: [$id]) {
    data {
      id
      name
      userId
      folderId
      file {
        id
        extension
      }
    }
  }
}
    `;
export const TermItemsDocument = `
    query TermItems($termType: String, $fullText: String, $filter: TermItemsFilter, $take: Int, $pagination: PaginationInput) {
  termItems(
    termType: $termType
    fulltext: $fullText
    filter: $filter
    take: $take
    pagination: $pagination
  ) {
    data {
      id
      termId
      name
      value
      value2
      value3
      data
    }
  }
}
    `;
export const TermItemByValueDocument = `
    query TermItemByValue($termType: String!, $value: String!) {
  termItem: termItemByValue(termType: $termType, value: $value) {
    id
    name
    value
  }
}
    `;
export const UserMetaTranslationsDocument = `
    query userMetaTranslations($id: UUID, $keys: [String]) {
  user(id: $id) {
    id
    metaTranslation(keys: $keys) {
      id
      key
      value
      language
    }
  }
}
    `;
export const TransmiseListDocument = `
    query TransmiseList($where: TransmiseListWhereInput!) {
  transmiseList(where: $where) {
    meta {
      page
      totalPages
    }
    data {
      id
      name
      date
      workplace
      diagnosis
      link
    }
  }
}
    `;
export const FullUserInfoDocument = `
    query FullUserInfo($id: UUID!) {
  user(id: $id) {
    id
    email
    phoneNumber
    formattedPhoneNumber
    isDoctor
    isChild
    partnerIdentifier
    partner
    profileImageUrl
    meta {
      key
      value
    }
    memberOf {
      title
      theme
    }
    parents {
      id
      profile {
        fullName
        firstName
        lastName
      }
    }
    csszResult
    vzpResult
    badge {
      title
      theme
    }
    avatarFile {
      createdAt
    }
    profile {
      age
      birthNumber
      formattedBirthNumber
      birthDate
      insuranceNumber
      gender
      formattedGender
      timezone
      nationalityTermItem {
        id
        name
        value
      }
      nationalityOther
      fullName
      firstName
      lastName
      address {
        fullAddress
        shortAddress
        formattedFullAddress
        formattedShortAddress
        street
        postCode
        descriptiveNumber
        guideNumber
        city
        province
        street2
        floor
        district
        accommodationZone
        country
        region
        apartmentNumber
      }
      insuranceCompanyTermItem {
        name
        value
        value2
      }
    }
    rootWorkplace {
      name
      address {
        fullAddress
      }
    }
    workplace {
      name
      address {
        fullAddress
      }
    }
    invitations {
      code
      used
    }
  }
}
    `;
export const UserEmailDocument = `
    query UserEmail($id: UUID) {
  user(id: $id) {
    email
  }
}
    `;
export const UserHasMeddiDocument = `
    query UserHasMeddi($id: UUID) {
  user(id: $id) {
    id
    hasMeddi
  }
}
    `;
export const UserMetaDocument = `
    query UserMeta($id: UUID, $useOriginalId: Boolean) {
  user(id: $id) {
    id
    meta(useOriginalId: $useOriginalId) {
      id
      key
      value
    }
  }
}
    `;
export const UserParentsDocument = `
    query UserParents($id: UUID) {
  user(id: $id) {
    id
    parents {
      id
      hasMeddi
    }
  }
}
    `;
export const UserProfileImageDocument = `
    query UserProfileImage($userId: UUID) {
  user(id: $userId) {
    profileImageUrl
  }
}
    `;
export const UserRelationsDocument = `
    query UserRelations($userId: UUID, $workplaceId: UUID, $useOriginalId: Boolean) {
  user(id: $userId) {
    id
    userRelations(workplaceId: $workplaceId, useOriginalId: $useOriginalId) {
      userId
      relationUserId
      type
    }
  }
}
    `;
export const UserTermItemsDocument = `
    query UserTermItems($id: UUID) {
  user(id: $id) {
    termItems {
      id
      name
      value
      value2
      value3
      term {
        type
      }
    }
  }
}
    `;
export const SubmitWizardDocument = `
    mutation SubmitWizard($input: WizardResultInput) {
  submitWizard(input: $input) {
    id
  }
}
    `;
export const RootWorkplaceByChildDocument = `
    query RootWorkplaceByChild($workplaceId: UUID) {
  workplace(id: $workplaceId) {
    id
    name
    address {
      fullAddress
    }
    rootWorkplace {
      id
      partnerId
      name
      fullName
      address {
        fullAddress
      }
    }
  }
}
    `;
export const WorkplaceMemberRoleDocument = `
    query WorkplaceMemberRole($workplaceId: UUID, $userId: UUID) {
  workplaceMember(userId: $userId, workplaceId: $workplaceId) {
    id
    workplaceMemberRoles {
      role {
        key
      }
    }
  }
}
    `;
export const WorkplacesDocument = `
    query Workplaces($fulltext: String, $take: Int, $skip: Int, $type: String) {
  workplaces(fulltext: $fulltext, take: $take, skip: $skip, type: $type) {
    data {
      id
      doctorDisplayName
      rootWorkplace {
        id
        doctorDisplayName
      }
    }
  }
}
    `;
export const WorkplacesForSelectDocument = `
    query WorkplacesForSelect($fulltext: String, $take: Int, $skip: Int, $type: String, $rootWorkplaceId: UUID, $managed: Boolean) {
  workplaces(
    fulltext: $fulltext
    take: $take
    skip: $skip
    type: $type
    rootWorkplaceId: $rootWorkplaceId
    managed: $managed
  ) {
    data {
      id
      doctorDisplayName
      type
    }
  }
}
    `;
export const NormalWorkplacesDocument = `
    query NormalWorkplaces($fulltext: String, $take: Int, $skip: Int, $type: String = "normal", $rootWorkplaceId: UUID, $managed: Boolean) {
  workplaces(
    fulltext: $fulltext
    take: $take
    skip: $skip
    type: $type
    rootWorkplaceId: $rootWorkplaceId
    managed: $managed
  ) {
    data {
      id
      doctorDisplayName
      rootWorkplace {
        id
        doctorDisplayName
      }
      address {
        fullAddress
      }
    }
  }
}
    `;
export const WorkplaceMetaDocument = `
    query WorkplaceMeta($id: UUID) {
  workplace(id: $id) {
    meta(strict: true) {
      id
      key
      value
    }
  }
}
    `;
export const WorkplacePrivateDocument = `
    query WorkplacePrivate($id: UUID) {
  workplace(id: $id) {
    privateAmbulance
  }
}
    `;
export const WorkplaceNameDocument = `
    query WorkplaceName($id: UUID!) {
  workplace(id: $id) {
    name
  }
}
    `;
export const WorkplaceCaseTypeDocument = `
    query WorkplaceCaseType($workplaceId: UUID, $caseTypeCode: String) {
  workplaceCaseType(workplaceId: $workplaceId, caseTypeCode: $caseTypeCode) {
    id
    caseType {
      label
      type
      eventInterval
    }
  }
}
    `;
export const WorkplaceCaseTypesDocument = `
    query WorkplaceCaseTypes($workplaceId: UUID, $caseTypeTypes: [CaseTypeType]) {
  workplaceCaseTypes(
    workplaceId: $workplaceId
    caseTypeTypes: $caseTypeTypes
    take: 9999
  ) {
    data {
      id
      caseType {
        id
        label
        type
        eventInterval
      }
    }
  }
}
    `;
export const WorkplaceMemberIdDocument = `
    query WorkplaceMemberId($workplaceId: UUID, $userId: UUID) {
  workplaceMember(workplaceId: $workplaceId, userId: $userId) {
    id
    code
  }
}
    `;
export const SimpleWorkplaceMemberDocument = `
    query SimpleWorkplaceMember($workplaceId: UUID, $userId: UUID) {
  workplaceMember(workplaceId: $workplaceId, userId: $userId) {
    id
    user {
      profile {
        fullName
      }
    }
  }
}
    `;
export const WorkplacePartnerDocument = `
    query WorkplacePartner($id: UUID) {
  workplace(id: $id) {
    partnerId
  }
}
    `;
export const WorkplaceServiceScheduleDocument = `
    query workplaceServiceSchedule($from: DateTime, $to: DateTime, $workplaceIds: [UUID], $type: ServiceScheduleType, $types: [ServiceScheduleType], $pagination: PaginationInput, $includeOccurrences: Boolean) {
  serviceSchedules(
    from: $from
    to: $to
    workplaceIds: $workplaceIds
    type: $type
    types: $types
    pagination: $pagination
    includeOccurrences: $includeOccurrences
  ) {
    data {
      id
      dateFrom
      dateTo
      type
      workplaceId
      workplace {
        name
        doctorDisplayName
      }
      serviceScheduleItems {
        id
        day
        timeFrom
        timeTo
        interval
        occurrences(start: $from, end: $to)
        price {
          id
          price
          priceWithVatRaw
        }
        serviceScheduleItemMembers {
          workplaceMemberId
          workplaceMember {
            workplaceMemberRoles {
              role {
                name
                key
              }
            }
            user {
              id
              profile {
                fullName
              }
            }
          }
        }
        serviceScheduleItemCaseTypes {
          workplaceCaseTypeId
          workplaceCaseType {
            id
            caseType {
              label
              eventInterval
            }
          }
        }
        repeatable
      }
    }
  }
}
    `;
export const WorkplaceMemberMetaDocument = `
    query WorkplaceMemberMeta($userId: UUID, $workplaceId: UUID) {
  workplaceMember(userId: $userId, workplaceId: $workplaceId) {
    meta {
      id
      key
      value
    }
  }
}
    `;
export const WorkplaceMembersDocument = `
    query WorkplaceMembers($userId: UUID, $workplaceIds: [UUID]) {
  workplaceMembers(userId: $userId, workplaceIds: $workplaceIds) {
    data {
      id
      workplace {
        id
        doctorDisplayName
      }
    }
  }
}
    `;
export const FilterCaseContactsDocument = `
    query FilterCaseContacts($fulltext: String, $caseTypeCode: String, $roleKeys: [String]) {
  filterCaseContacts(
    fulltext: $fulltext
    caseTypeCode: $caseTypeCode
    roleKeys: $roleKeys
  ) {
    data {
      userId
      workplaceMemberId
      workplaceId
      textRow1
      textRow2
      textRow3
      type
      iconUrl
      workplaceMemberUserRelation {
        id
        userId
        user {
          profile {
            fullName
          }
        }
      }
    }
  }
}
    `;
export const WorkplaceMemberDocument = `
    query WorkplaceMember($userId: UUID, $workplaceId: UUID) {
  workplaceMember(userId: $userId, workplaceId: $workplaceId) {
    id
    status
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    CaseChatEntries: build.query<CaseChatEntriesQuery, CaseChatEntriesQueryVariables>({
      query: (variables) => ({ document: CaseChatEntriesDocument, variables })
    }),
    CreateHealthPlanUserPayment: build.mutation<CreateHealthPlanUserPaymentMutation, CreateHealthPlanUserPaymentMutationVariables | void>({
      query: (variables) => ({ document: CreateHealthPlanUserPaymentDocument, variables })
    }),
    WorkplaceBillingAddress: build.query<WorkplaceBillingAddressQuery, WorkplaceBillingAddressQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceBillingAddressDocument, variables })
    }),
    WorkplaceUseCustomBillingAddress: build.query<WorkplaceUseCustomBillingAddressQuery, WorkplaceUseCustomBillingAddressQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceUseCustomBillingAddressDocument, variables })
    }),
    PatientConsent: build.query<PatientConsentQuery, PatientConsentQueryVariables>({
      query: (variables) => ({ document: PatientConsentDocument, variables })
    }),
    PatientProfileData: build.query<PatientProfileDataQuery, PatientProfileDataQueryVariables>({
      query: (variables) => ({ document: PatientProfileDataDocument, variables })
    }),
    PatientUserRelations: build.query<PatientUserRelationsQuery, PatientUserRelationsQueryVariables>({
      query: (variables) => ({ document: PatientUserRelationsDocument, variables })
    }),
    WorkplaceMemberDetails: build.query<WorkplaceMemberDetailsQuery, WorkplaceMemberDetailsQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceMemberDetailsDocument, variables })
    }),
    ConversationDetail: build.query<ConversationDetailQuery, ConversationDetailQueryVariables | void>({
      query: (variables) => ({ document: ConversationDetailDocument, variables })
    }),
    ConversationMessages: build.query<ConversationMessagesQuery, ConversationMessagesQueryVariables | void>({
      query: (variables) => ({ document: ConversationMessagesDocument, variables })
    }),
    MessagesByConversation: build.query<MessagesByConversationQuery, MessagesByConversationQueryVariables | void>({
      query: (variables) => ({ document: MessagesByConversationDocument, variables })
    }),
    DoctorsSearch: build.query<DoctorsSearchQuery, DoctorsSearchQueryVariables | void>({
      query: (variables) => ({ document: DoctorsSearchDocument, variables })
    }),
    GetGridFilter: build.query<GetGridFilterQuery, GetGridFilterQueryVariables>({
      query: (variables) => ({ document: GetGridFilterDocument, variables })
    }),
    saveGridFilter: build.mutation<SaveGridFilterMutation, SaveGridFilterMutationVariables | void>({
      query: (variables) => ({ document: SaveGridFilterDocument, variables })
    }),
    GroupsSearch: build.query<GroupsSearchQuery, GroupsSearchQueryVariables | void>({
      query: (variables) => ({ document: GroupsSearchDocument, variables })
    }),
    NonDoctorsSearch: build.query<NonDoctorsSearchQuery, NonDoctorsSearchQueryVariables | void>({
      query: (variables) => ({ document: NonDoctorsSearchDocument, variables })
    }),
    PatientsSearch: build.query<PatientsSearchQuery, PatientsSearchQueryVariables | void>({
      query: (variables) => ({ document: PatientsSearchDocument, variables })
    }),
    RootWorkplaceDoctors: build.query<RootWorkplaceDoctorsQuery, RootWorkplaceDoctorsQueryVariables | void>({
      query: (variables) => ({ document: RootWorkplaceDoctorsDocument, variables })
    }),
    SimpleWorkplaces: build.query<SimpleWorkplacesQuery, SimpleWorkplacesQueryVariables | void>({
      query: (variables) => ({ document: SimpleWorkplacesDocument, variables })
    }),
    WorkplaceRoles: build.query<WorkplaceRolesQuery, WorkplaceRolesQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceRolesDocument, variables })
    }),
    CreateWorkplaceMemberAbsence: build.mutation<CreateWorkplaceMemberAbsenceMutation, CreateWorkplaceMemberAbsenceMutationVariables>({
      query: (variables) => ({ document: CreateWorkplaceMemberAbsenceDocument, variables })
    }),
    DoneEvent: build.mutation<DoneEventMutation, DoneEventMutationVariables | void>({
      query: (variables) => ({ document: DoneEventDocument, variables })
    }),
    AssignCaseToMe: build.mutation<AssignCaseToMeMutation, AssignCaseToMeMutationVariables | void>({
      query: (variables) => ({ document: AssignCaseToMeDocument, variables })
    }),
    CaseMedicalReports: build.query<CaseMedicalReportsQuery, CaseMedicalReportsQueryVariables | void>({
      query: (variables) => ({ document: CaseMedicalReportsDocument, variables })
    }),
    CasesAssigned: build.query<CasesAssignedQuery, CasesAssignedQueryVariables | void>({
      query: (variables) => ({ document: CasesAssignedDocument, variables })
    }),
    IsMyCase: build.query<IsMyCaseQuery, IsMyCaseQueryVariables | void>({
      query: (variables) => ({ document: IsMyCaseDocument, variables })
    }),
    CreateNote: build.mutation<CreateNoteMutation, CreateNoteMutationVariables>({
      query: (variables) => ({ document: CreateNoteDocument, variables })
    }),
    UpdateNote: build.mutation<UpdateNoteMutation, UpdateNoteMutationVariables>({
      query: (variables) => ({ document: UpdateNoteDocument, variables })
    }),
    NurseCases: build.query<NurseCasesQuery, NurseCasesQueryVariables | void>({
      query: (variables) => ({ document: NurseCasesDocument, variables })
    }),
    ReAssignCase: build.mutation<ReAssignCaseMutation, ReAssignCaseMutationVariables>({
      query: (variables) => ({ document: ReAssignCaseDocument, variables })
    }),
    WorkplaceCases: build.query<WorkplaceCasesQuery, WorkplaceCasesQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceCasesDocument, variables })
    }),
    WorkplaceCasesArchived: build.query<WorkplaceCasesArchivedQuery, WorkplaceCasesArchivedQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceCasesArchivedDocument, variables })
    }),
    FullWorkplaceCaseTypes: build.query<FullWorkplaceCaseTypesQuery, FullWorkplaceCaseTypesQueryVariables | void>({
      query: (variables) => ({ document: FullWorkplaceCaseTypesDocument, variables })
    }),
    WorkplaceRootCaseTypes: build.query<WorkplaceRootCaseTypesQuery, WorkplaceRootCaseTypesQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceRootCaseTypesDocument, variables })
    }),
    RootWorkplacesPatient: build.query<RootWorkplacesPatientQuery, RootWorkplacesPatientQueryVariables | void>({
      query: (variables) => ({ document: RootWorkplacesPatientDocument, variables })
    }),
    Certificates: build.query<CertificatesQuery, CertificatesQueryVariables | void>({
      query: (variables) => ({ document: CertificatesDocument, variables })
    }),
    AttachmentDetail: build.query<AttachmentDetailQuery, AttachmentDetailQueryVariables | void>({
      query: (variables) => ({ document: AttachmentDetailDocument, variables })
    }),
    Discourse: build.query<DiscourseQuery, DiscourseQueryVariables | void>({
      query: (variables) => ({ document: DiscourseDocument, variables })
    }),
    DraftDiscourse: build.query<DraftDiscourseQuery, DraftDiscourseQueryVariables | void>({
      query: (variables) => ({ document: DraftDiscourseDocument, variables })
    }),
    DoctorBasicInfo: build.query<DoctorBasicInfoQuery, DoctorBasicInfoQueryVariables | void>({
      query: (variables) => ({ document: DoctorBasicInfoDocument, variables })
    }),
    WorkplaceDoctors: build.query<WorkplaceDoctorsQuery, WorkplaceDoctorsQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceDoctorsDocument, variables })
    }),
    Document: build.query<DocumentQuery, DocumentQueryVariables>({
      query: (variables) => ({ document: DocumentDocument, variables })
    }),
    Documents: build.query<DocumentsQuery, DocumentsQueryVariables | void>({
      query: (variables) => ({ document: DocumentsDocument, variables })
    }),
    WorkplaceCaseTarget: build.query<WorkplaceCaseTargetQuery, WorkplaceCaseTargetQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceCaseTargetDocument, variables })
    }),
    WorkplaceCode: build.query<WorkplaceCodeQuery, WorkplaceCodeQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceCodeDocument, variables })
    }),
    EArchiveWorkplacePatients: build.query<EArchiveWorkplacePatientsQuery, EArchiveWorkplacePatientsQueryVariables | void>({
      query: (variables) => ({ document: EArchiveWorkplacePatientsDocument, variables })
    }),
    createUserMedicationLasted: build.mutation<CreateUserMedicationLastedMutation, CreateUserMedicationLastedMutationVariables>({
      query: (variables) => ({ document: CreateUserMedicationLastedDocument, variables })
    }),
    DeleteUserMedicationLasted: build.mutation<DeleteUserMedicationLastedMutation, DeleteUserMedicationLastedMutationVariables>({
      query: (variables) => ({ document: DeleteUserMedicationLastedDocument, variables })
    }),
    PatientInformation: build.query<PatientInformationQuery, PatientInformationQueryVariables | void>({
      query: (variables) => ({ document: PatientInformationDocument, variables })
    }),
    UpdateUserMedicationLasted: build.mutation<UpdateUserMedicationLastedMutation, UpdateUserMedicationLastedMutationVariables>({
      query: (variables) => ({ document: UpdateUserMedicationLastedDocument, variables })
    }),
    UserMedicationLasted: build.query<UserMedicationLastedQuery, UserMedicationLastedQueryVariables>({
      query: (variables) => ({ document: UserMedicationLastedDocument, variables })
    }),
    DocumentationFiles: build.query<DocumentationFilesQuery, DocumentationFilesQueryVariables | void>({
      query: (variables) => ({ document: DocumentationFilesDocument, variables })
    }),
    DocumentationFilesCount: build.query<DocumentationFilesCountQuery, DocumentationFilesCountQueryVariables | void>({
      query: (variables) => ({ document: DocumentationFilesCountDocument, variables })
    }),
    DocumentationFolders: build.query<DocumentationFoldersQuery, DocumentationFoldersQueryVariables | void>({
      query: (variables) => ({ document: DocumentationFoldersDocument, variables })
    }),
    DocumentationFolder: build.query<DocumentationFolderQuery, DocumentationFolderQueryVariables | void>({
      query: (variables) => ({ document: DocumentationFolderDocument, variables })
    }),
    ECardNewFiles: build.query<ECardNewFilesQuery, ECardNewFilesQueryVariables | void>({
      query: (variables) => ({ document: ECardNewFilesDocument, variables })
    }),
    TransferDocument: build.mutation<TransferDocumentMutation, TransferDocumentMutationVariables | void>({
      query: (variables) => ({ document: TransferDocumentDocument, variables })
    }),
    TransferDocuments: build.mutation<TransferDocumentsMutation, TransferDocumentsMutationVariables>({
      query: (variables) => ({ document: TransferDocumentsDocument, variables })
    }),
    getUserOriginalId: build.query<GetUserOriginalIdQuery, GetUserOriginalIdQueryVariables | void>({
      query: (variables) => ({ document: GetUserOriginalIdDocument, variables })
    }),
    WorkplacePatientDocumentationFilesMarkAsSeen: build.mutation<WorkplacePatientDocumentationFilesMarkAsSeenMutation, WorkplacePatientDocumentationFilesMarkAsSeenMutationVariables | void>({
      query: (variables) => ({ document: WorkplacePatientDocumentationFilesMarkAsSeenDocument, variables })
    }),
    EducationMaterials: build.query<EducationMaterialsQuery, EducationMaterialsQueryVariables | void>({
      query: (variables) => ({ document: EducationMaterialsDocument, variables })
    }),
    Event: build.query<EventQuery, EventQueryVariables | void>({
      query: (variables) => ({ document: EventDocument, variables })
    }),
    Events: build.query<EventsQuery, EventsQueryVariables | void>({
      query: (variables) => ({ document: EventsDocument, variables })
    }),
    WorkplaceEvents: build.query<WorkplaceEventsQuery, WorkplaceEventsQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceEventsDocument, variables })
    }),
    getOrders: build.query<GetOrdersQuery, GetOrdersQueryVariables | void>({
      query: (variables) => ({ document: GetOrdersDocument, variables })
    }),
    OrderStatistics: build.query<OrderStatisticsQuery, OrderStatisticsQueryVariables | void>({
      query: (variables) => ({ document: OrderStatisticsDocument, variables })
    }),
    HealthPlanBabyPregnancy: build.query<HealthPlanBabyPregnancyQuery, HealthPlanBabyPregnancyQueryVariables>({
      query: (variables) => ({ document: HealthPlanBabyPregnancyDocument, variables })
    }),
    SubmitQuestionnaireResult: build.mutation<SubmitQuestionnaireResultMutation, SubmitQuestionnaireResultMutationVariables | void>({
      query: (variables) => ({ document: SubmitQuestionnaireResultDocument, variables })
    }),
    EndHealthPlanUser: build.mutation<EndHealthPlanUserMutation, EndHealthPlanUserMutationVariables>({
      query: (variables) => ({ document: EndHealthPlanUserDocument, variables })
    }),
    CreateHealthPlanUserFromData: build.mutation<CreateHealthPlanUserFromDataMutation, CreateHealthPlanUserFromDataMutationVariables | void>({
      query: (variables) => ({ document: CreateHealthPlanUserFromDataDocument, variables })
    }),
    HealthPlanUserInformation: build.query<HealthPlanUserInformationQuery, HealthPlanUserInformationQueryVariables>({
      query: (variables) => ({ document: HealthPlanUserInformationDocument, variables })
    }),
    HealthPlanUserItemId: build.query<HealthPlanUserItemIdQuery, HealthPlanUserItemIdQueryVariables | void>({
      query: (variables) => ({ document: HealthPlanUserItemIdDocument, variables })
    }),
    HealthPlanUser: build.query<HealthPlanUserQuery, HealthPlanUserQueryVariables | void>({
      query: (variables) => ({ document: HealthPlanUserDocument, variables })
    }),
    HealthPlanId: build.query<HealthPlanIdQuery, HealthPlanIdQueryVariables | void>({
      query: (variables) => ({ document: HealthPlanIdDocument, variables })
    }),
    HealthPlanDetails: build.query<HealthPlanDetailsQuery, HealthPlanDetailsQueryVariables | void>({
      query: (variables) => ({ document: HealthPlanDetailsDocument, variables })
    }),
    CreateHealthPlanUser: build.mutation<CreateHealthPlanUserMutation, CreateHealthPlanUserMutationVariables>({
      query: (variables) => ({ document: CreateHealthPlanUserDocument, variables })
    }),
    HealthPlans: build.query<HealthPlansQuery, HealthPlansQueryVariables | void>({
      query: (variables) => ({ document: HealthPlansDocument, variables })
    }),
    RequestPaymentHealthPlanUser: build.mutation<RequestPaymentHealthPlanUserMutation, RequestPaymentHealthPlanUserMutationVariables | void>({
      query: (variables) => ({ document: RequestPaymentHealthPlanUserDocument, variables })
    }),
    HealthPlanRequirements: build.query<HealthPlanRequirementsQuery, HealthPlanRequirementsQueryVariables | void>({
      query: (variables) => ({ document: HealthPlanRequirementsDocument, variables })
    }),
    HealthPlanUserId: build.query<HealthPlanUserIdQuery, HealthPlanUserIdQueryVariables | void>({
      query: (variables) => ({ document: HealthPlanUserIdDocument, variables })
    }),
    HealthPlanUsers: build.query<HealthPlanUsersQuery, HealthPlanUsersQueryVariables | void>({
      query: (variables) => ({ document: HealthPlanUsersDocument, variables })
    }),
    HealthPlanUserBaby: build.query<HealthPlanUserBabyQuery, HealthPlanUserBabyQueryVariables>({
      query: (variables) => ({ document: HealthPlanUserBabyDocument, variables })
    }),
    InitialQuestionnaireResult: build.query<InitialQuestionnaireResultQuery, InitialQuestionnaireResultQueryVariables | void>({
      query: (variables) => ({ document: InitialQuestionnaireResultDocument, variables })
    }),
    QuestionnaireResultItems: build.query<QuestionnaireResultItemsQuery, QuestionnaireResultItemsQueryVariables | void>({
      query: (variables) => ({ document: QuestionnaireResultItemsDocument, variables })
    }),
    QuestionnaireId: build.query<QuestionnaireIdQuery, QuestionnaireIdQueryVariables | void>({
      query: (variables) => ({ document: QuestionnaireIdDocument, variables })
    }),
    WorkplaceHealthPlans: build.query<WorkplaceHealthPlansQuery, WorkplaceHealthPlansQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceHealthPlansDocument, variables })
    }),
    CreateInsuranceReportExportFiles: build.mutation<CreateInsuranceReportExportFilesMutation, CreateInsuranceReportExportFilesMutationVariables>({
      query: (variables) => ({ document: CreateInsuranceReportExportFilesDocument, variables })
    }),
    DeleteInsuranceReport: build.mutation<DeleteInsuranceReportMutation, DeleteInsuranceReportMutationVariables>({
      query: (variables) => ({ document: DeleteInsuranceReportDocument, variables })
    }),
    InsuranceOperationCreate: build.mutation<InsuranceOperationCreateMutation, InsuranceOperationCreateMutationVariables | void>({
      query: (variables) => ({ document: InsuranceOperationCreateDocument, variables })
    }),
    InsuranceOperationDelete: build.mutation<InsuranceOperationDeleteMutation, InsuranceOperationDeleteMutationVariables>({
      query: (variables) => ({ document: InsuranceOperationDeleteDocument, variables })
    }),
    InsuranceOperations: build.query<InsuranceOperationsQuery, InsuranceOperationsQueryVariables>({
      query: (variables) => ({ document: InsuranceOperationsDocument, variables })
    }),
    InsuranceReport: build.query<InsuranceReportQuery, InsuranceReportQueryVariables>({
      query: (variables) => ({ document: InsuranceReportDocument, variables })
    }),
    InsuranceReportCreate: build.mutation<InsuranceReportCreateMutation, InsuranceReportCreateMutationVariables>({
      query: (variables) => ({ document: InsuranceReportCreateDocument, variables })
    }),
    InsuranceReportUserData: build.query<InsuranceReportUserDataQuery, InsuranceReportUserDataQueryVariables | void>({
      query: (variables) => ({ document: InsuranceReportUserDataDocument, variables })
    }),
    InsuranceReports: build.query<InsuranceReportsQuery, InsuranceReportsQueryVariables>({
      query: (variables) => ({ document: InsuranceReportsDocument, variables })
    }),
    AddLaboratoryRequisitionToPatient: build.mutation<AddLaboratoryRequisitionToPatientMutation, AddLaboratoryRequisitionToPatientMutationVariables>({
      query: (variables) => ({ document: AddLaboratoryRequisitionToPatientDocument, variables })
    }),
    CreateLaboratoryWorkplace: build.mutation<CreateLaboratoryWorkplaceMutation, CreateLaboratoryWorkplaceMutationVariables>({
      query: (variables) => ({ document: CreateLaboratoryWorkplaceDocument, variables })
    }),
    CreateLaboratoryRequisitionWorkplace: build.mutation<CreateLaboratoryRequisitionWorkplaceMutation, CreateLaboratoryRequisitionWorkplaceMutationVariables>({
      query: (variables) => ({ document: CreateLaboratoryRequisitionWorkplaceDocument, variables })
    }),
    DeleteLaboratoryRequisitionWorkplace: build.mutation<DeleteLaboratoryRequisitionWorkplaceMutation, DeleteLaboratoryRequisitionWorkplaceMutationVariables>({
      query: (variables) => ({ document: DeleteLaboratoryRequisitionWorkplaceDocument, variables })
    }),
    DeleteLaboratoryWorkplace: build.mutation<DeleteLaboratoryWorkplaceMutation, DeleteLaboratoryWorkplaceMutationVariables>({
      query: (variables) => ({ document: DeleteLaboratoryWorkplaceDocument, variables })
    }),
    HideSeenLaboratoryResults: build.mutation<HideSeenLaboratoryResultsMutation, HideSeenLaboratoryResultsMutationVariables>({
      query: (variables) => ({ document: HideSeenLaboratoryResultsDocument, variables })
    }),
    IssuedLaboratoryRequests: build.query<IssuedLaboratoryRequestsQuery, IssuedLaboratoryRequestsQueryVariables>({
      query: (variables) => ({ document: IssuedLaboratoryRequestsDocument, variables })
    }),
    Laboratories: build.query<LaboratoriesQuery, LaboratoriesQueryVariables | void>({
      query: (variables) => ({ document: LaboratoriesDocument, variables })
    }),
    LaboratoryRequestCreate: build.mutation<LaboratoryRequestCreateMutation, LaboratoryRequestCreateMutationVariables>({
      query: (variables) => ({ document: LaboratoryRequestCreateDocument, variables })
    }),
    LaboratoryRequestForm: build.query<LaboratoryRequestFormQuery, LaboratoryRequestFormQueryVariables>({
      query: (variables) => ({ document: LaboratoryRequestFormDocument, variables })
    }),
    LaboratoryRequests: build.query<LaboratoryRequestsQuery, LaboratoryRequestsQueryVariables>({
      query: (variables) => ({ document: LaboratoryRequestsDocument, variables })
    }),
    LaboratoryResults: build.query<LaboratoryResultsQuery, LaboratoryResultsQueryVariables>({
      query: (variables) => ({ document: LaboratoryResultsDocument, variables })
    }),
    LaboratoryWorkplaces: build.query<LaboratoryWorkplacesQuery, LaboratoryWorkplacesQueryVariables>({
      query: (variables) => ({ document: LaboratoryWorkplacesDocument, variables })
    }),
    AllCertificates: build.query<AllCertificatesQuery, AllCertificatesQueryVariables | void>({
      query: (variables) => ({ document: AllCertificatesDocument, variables })
    }),
    AllHealthPlans: build.query<AllHealthPlansQuery, AllHealthPlansQueryVariables | void>({
      query: (variables) => ({ document: AllHealthPlansDocument, variables })
    }),
    AvailableServices: build.query<AvailableServicesQuery, AvailableServicesQueryVariables | void>({
      query: (variables) => ({ document: AvailableServicesDocument, variables })
    }),
    createHealthPlanWorkplace: build.mutation<CreateHealthPlanWorkplaceMutation, CreateHealthPlanWorkplaceMutationVariables | void>({
      query: (variables) => ({ document: CreateHealthPlanWorkplaceDocument, variables })
    }),
    deleteHealthPlanWorkplace: build.mutation<DeleteHealthPlanWorkplaceMutation, DeleteHealthPlanWorkplaceMutationVariables | void>({
      query: (variables) => ({ document: DeleteHealthPlanWorkplaceDocument, variables })
    }),
    SimpleWorkerInformation: build.query<SimpleWorkerInformationQuery, SimpleWorkerInformationQueryVariables | void>({
      query: (variables) => ({ document: SimpleWorkerInformationDocument, variables })
    }),
    UpdateWorkplaceMember: build.mutation<UpdateWorkplaceMemberMutation, UpdateWorkplaceMemberMutationVariables | void>({
      query: (variables) => ({ document: UpdateWorkplaceMemberDocument, variables })
    }),
    WorkerInformation: build.query<WorkerInformationQuery, WorkerInformationQueryVariables | void>({
      query: (variables) => ({ document: WorkerInformationDocument, variables })
    }),
    WorkerWorkplaces: build.query<WorkerWorkplacesQuery, WorkerWorkplacesQueryVariables | void>({
      query: (variables) => ({ document: WorkerWorkplacesDocument, variables })
    }),
    WorkplaceBasicData: build.query<WorkplaceBasicDataQuery, WorkplaceBasicDataQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceBasicDataDocument, variables })
    }),
    FullWorkplaceCaseType: build.query<FullWorkplaceCaseTypeQuery, FullWorkplaceCaseTypeQueryVariables | void>({
      query: (variables) => ({ document: FullWorkplaceCaseTypeDocument, variables })
    }),
    WorkplaceCertificates: build.query<WorkplaceCertificatesQuery, WorkplaceCertificatesQueryVariables>({
      query: (variables) => ({ document: WorkplaceCertificatesDocument, variables })
    }),
    WorkplaceWorkersList: build.query<WorkplaceWorkersListQuery, WorkplaceWorkersListQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceWorkersListDocument, variables })
    }),
    WorkplacesCssz: build.query<WorkplacesCsszQuery, WorkplacesCsszQueryVariables | void>({
      query: (variables) => ({ document: WorkplacesCsszDocument, variables })
    }),
    WorkplacesSuklCode: build.query<WorkplacesSuklCodeQuery, WorkplacesSuklCodeQueryVariables | void>({
      query: (variables) => ({ document: WorkplacesSuklCodeDocument, variables })
    }),
    MedicalRequestForms: build.query<MedicalRequestFormsQuery, MedicalRequestFormsQueryVariables | void>({
      query: (variables) => ({ document: MedicalRequestFormsDocument, variables })
    }),
    CreateUserMetaTranslation: build.mutation<CreateUserMetaTranslationMutation, CreateUserMetaTranslationMutationVariables | void>({
      query: (variables) => ({ document: CreateUserMetaTranslationDocument, variables })
    }),
    Meta: build.query<MetaQuery, MetaQueryVariables>({
      query: (variables) => ({ document: MetaDocument, variables })
    }),
    MyMeta: build.query<MyMetaQuery, MyMetaQueryVariables | void>({
      query: (variables) => ({ document: MyMetaDocument, variables })
    }),
    AssignCase: build.mutation<AssignCaseMutation, AssignCaseMutationVariables>({
      query: (variables) => ({ document: AssignCaseDocument, variables })
    }),
    MonitoringCentreCases: build.query<MonitoringCentreCasesQuery, MonitoringCentreCasesQueryVariables | void>({
      query: (variables) => ({ document: MonitoringCentreCasesDocument, variables })
    }),
    PriorityCase: build.mutation<PriorityCaseMutation, PriorityCaseMutationVariables | void>({
      query: (variables) => ({ document: PriorityCaseDocument, variables })
    }),
    casesAssignedCount: build.query<CasesAssignedCountQuery, CasesAssignedCountQueryVariables | void>({
      query: (variables) => ({ document: CasesAssignedCountDocument, variables })
    }),
    questionnaireResultsCount: build.query<QuestionnaireResultsCountQuery, QuestionnaireResultsCountQueryVariables | void>({
      query: (variables) => ({ document: QuestionnaireResultsCountDocument, variables })
    }),
    workplaceCasesCount: build.query<WorkplaceCasesCountQuery, WorkplaceCasesCountQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceCasesCountDocument, variables })
    }),
    WorkplacePatientDocumentationFilesCount: build.query<WorkplacePatientDocumentationFilesCountQuery, WorkplacePatientDocumentationFilesCountQueryVariables | void>({
      query: (variables) => ({ document: WorkplacePatientDocumentationFilesCountDocument, variables })
    }),
    NcziListDiagnosisItems: build.query<NcziListDiagnosisItemsQuery, NcziListDiagnosisItemsQueryVariables | void>({
      query: (variables) => ({ document: NcziListDiagnosisItemsDocument, variables })
    }),
    NcziListEnumItems: build.query<NcziListEnumItemsQuery, NcziListEnumItemsQueryVariables>({
      query: (variables) => ({ document: NcziListEnumItemsDocument, variables })
    }),
    NcziRefrenceItem: build.query<NcziRefrenceItemQuery, NcziRefrenceItemQueryVariables>({
      query: (variables) => ({ document: NcziRefrenceItemDocument, variables })
    }),
    NcziRefrenceItemsByCode: build.query<NcziRefrenceItemsByCodeQuery, NcziRefrenceItemsByCodeQueryVariables>({
      query: (variables) => ({ document: NcziRefrenceItemsByCodeDocument, variables })
    }),
    NcziRefrenceItemByAbbr: build.query<NcziRefrenceItemByAbbrQuery, NcziRefrenceItemByAbbrQueryVariables>({
      query: (variables) => ({ document: NcziRefrenceItemByAbbrDocument, variables })
    }),
    NcziListEnums: build.query<NcziListEnumsQuery, NcziListEnumsQueryVariables | void>({
      query: (variables) => ({ document: NcziListEnumsDocument, variables })
    }),
    NcziListExtensionItems: build.query<NcziListExtensionItemsQuery, NcziListExtensionItemsQueryVariables>({
      query: (variables) => ({ document: NcziListExtensionItemsDocument, variables })
    }),
    NcziExtensionItem: build.query<NcziExtensionItemQuery, NcziExtensionItemQueryVariables>({
      query: (variables) => ({ document: NcziExtensionItemDocument, variables })
    }),
    NcziExtensionItemByAbbr: build.query<NcziExtensionItemByAbbrQuery, NcziExtensionItemByAbbrQueryVariables>({
      query: (variables) => ({ document: NcziExtensionItemByAbbrDocument, variables })
    }),
    NcziMedicament: build.query<NcziMedicamentQuery, NcziMedicamentQueryVariables>({
      query: (variables) => ({ document: NcziMedicamentDocument, variables })
    }),
    FindOupzs: build.query<FindOupzsQuery, FindOupzsQueryVariables>({
      query: (variables) => ({ document: FindOupzsDocument, variables })
    }),
    NcziProductList: build.query<NcziProductListQuery, NcziProductListQueryVariables | void>({
      query: (variables) => ({ document: NcziProductListDocument, variables })
    }),
    NcziProduct: build.query<NcziProductQuery, NcziProductQueryVariables>({
      query: (variables) => ({ document: NcziProductDocument, variables })
    }),
    NcziQueue: build.query<NcziQueueQuery, NcziQueueQueryVariables>({
      query: (variables) => ({ document: NcziQueueDocument, variables })
    }),
    UserBirthNumber: build.query<UserBirthNumberQuery, UserBirthNumberQueryVariables>({
      query: (variables) => ({ document: UserBirthNumberDocument, variables })
    }),
    UserNcziProfile: build.query<UserNcziProfileQuery, UserNcziProfileQueryVariables>({
      query: (variables) => ({ document: UserNcziProfileDocument, variables })
    }),
    MarkAllNotificationsAsSeen: build.mutation<MarkAllNotificationsAsSeenMutation, MarkAllNotificationsAsSeenMutationVariables | void>({
      query: (variables) => ({ document: MarkAllNotificationsAsSeenDocument, variables })
    }),
    ConversationMessage: build.query<ConversationMessageQuery, ConversationMessageQueryVariables | void>({
      query: (variables) => ({ document: ConversationMessageDocument, variables })
    }),
    NotificationConversation: build.query<NotificationConversationQuery, NotificationConversationQueryVariables | void>({
      query: (variables) => ({ document: NotificationConversationDocument, variables })
    }),
    ListNotifications: build.query<ListNotificationsQuery, ListNotificationsQueryVariables | void>({
      query: (variables) => ({ document: ListNotificationsDocument, variables })
    }),
    UnreadNotification: build.query<UnreadNotificationQuery, UnreadNotificationQueryVariables | void>({
      query: (variables) => ({ document: UnreadNotificationDocument, variables })
    }),
    SetUserNotificationSettings: build.mutation<SetUserNotificationSettingsMutation, SetUserNotificationSettingsMutationVariables>({
      query: (variables) => ({ document: SetUserNotificationSettingsDocument, variables })
    }),
    UserNotificationSettings: build.query<UserNotificationSettingsQuery, UserNotificationSettingsQueryVariables>({
      query: (variables) => ({ document: UserNotificationSettingsDocument, variables })
    }),
    ArchiveWorkplaceMember: build.mutation<ArchiveWorkplaceMemberMutation, ArchiveWorkplaceMemberMutationVariables | void>({
      query: (variables) => ({ document: ArchiveWorkplaceMemberDocument, variables })
    }),
    PatientData: build.query<PatientDataQuery, PatientDataQueryVariables>({
      query: (variables) => ({ document: PatientDataDocument, variables })
    }),
    PatientMeta: build.query<PatientMetaQuery, PatientMetaQueryVariables | void>({
      query: (variables) => ({ document: PatientMetaDocument, variables })
    }),
    PatientBasicInfo: build.query<PatientBasicInfoQuery, PatientBasicInfoQueryVariables | void>({
      query: (variables) => ({ document: PatientBasicInfoDocument, variables })
    }),
    WorkplacePatients: build.query<WorkplacePatientsQuery, WorkplacePatientsQueryVariables | void>({
      query: (variables) => ({ document: WorkplacePatientsDocument, variables })
    }),
    GroupMembers: build.query<GroupMembersQuery, GroupMembersQueryVariables | void>({
      query: (variables) => ({ document: GroupMembersDocument, variables })
    }),
    GroupAuditLogs: build.query<GroupAuditLogsQuery, GroupAuditLogsQueryVariables | void>({
      query: (variables) => ({ document: GroupAuditLogsDocument, variables })
    }),
    Groups: build.query<GroupsQuery, GroupsQueryVariables | void>({
      query: (variables) => ({ document: GroupsDocument, variables })
    }),
    MassFind: build.query<MassFindQuery, MassFindQueryVariables | void>({
      query: (variables) => ({ document: MassFindDocument, variables })
    }),
    CreatePhrase: build.mutation<CreatePhraseMutation, CreatePhraseMutationVariables>({
      query: (variables) => ({ document: CreatePhraseDocument, variables })
    }),
    DeletePhrase: build.mutation<DeletePhraseMutation, DeletePhraseMutationVariables>({
      query: (variables) => ({ document: DeletePhraseDocument, variables })
    }),
    MyPhrases: build.query<MyPhrasesQuery, MyPhrasesQueryVariables | void>({
      query: (variables) => ({ document: MyPhrasesDocument, variables })
    }),
    UpdatePhrase: build.mutation<UpdatePhraseMutation, UpdatePhraseMutationVariables>({
      query: (variables) => ({ document: UpdatePhraseDocument, variables })
    }),
    CreateP1Prescription: build.mutation<CreateP1PrescriptionMutation, CreateP1PrescriptionMutationVariables>({
      query: (variables) => ({ document: CreateP1PrescriptionDocument, variables })
    }),
    PrescriptionMedicament: build.query<PrescriptionMedicamentQuery, PrescriptionMedicamentQueryVariables | void>({
      query: (variables) => ({ document: PrescriptionMedicamentDocument, variables })
    }),
    Prescriptions: build.query<PrescriptionsQuery, PrescriptionsQueryVariables | void>({
      query: (variables) => ({ document: PrescriptionsDocument, variables })
    }),
    SingleQuestionnaireResultItems: build.query<SingleQuestionnaireResultItemsQuery, SingleQuestionnaireResultItemsQueryVariables | void>({
      query: (variables) => ({ document: SingleQuestionnaireResultItemsDocument, variables })
    }),
    QuestionnaireSearch: build.query<QuestionnaireSearchQuery, QuestionnaireSearchQueryVariables | void>({
      query: (variables) => ({ document: QuestionnaireSearchDocument, variables })
    }),
    QuestionnaireSearchByCode: build.query<QuestionnaireSearchByCodeQuery, QuestionnaireSearchByCodeQueryVariables | void>({
      query: (variables) => ({ document: QuestionnaireSearchByCodeDocument, variables })
    }),
    QuestionnaireBasicInfo: build.query<QuestionnaireBasicInfoQuery, QuestionnaireBasicInfoQueryVariables | void>({
      query: (variables) => ({ document: QuestionnaireBasicInfoDocument, variables })
    }),
    QuestionnaireSchedulesByParentSchedule: build.query<QuestionnaireSchedulesByParentScheduleQuery, QuestionnaireSchedulesByParentScheduleQueryVariables | void>({
      query: (variables) => ({ document: QuestionnaireSchedulesByParentScheduleDocument, variables })
    }),
    QuestionnaireSchedule: build.query<QuestionnaireScheduleQuery, QuestionnaireScheduleQueryVariables | void>({
      query: (variables) => ({ document: QuestionnaireScheduleDocument, variables })
    }),
    QuestionnaireDetail: build.query<QuestionnaireDetailQuery, QuestionnaireDetailQueryVariables | void>({
      query: (variables) => ({ document: QuestionnaireDetailDocument, variables })
    }),
    QuestionnaireResults: build.query<QuestionnaireResultsQuery, QuestionnaireResultsQueryVariables | void>({
      query: (variables) => ({ document: QuestionnaireResultsDocument, variables })
    }),
    QuestionnaireSchedules: build.query<QuestionnaireSchedulesQuery, QuestionnaireSchedulesQueryVariables | void>({
      query: (variables) => ({ document: QuestionnaireSchedulesDocument, variables })
    }),
    Questionnaires: build.query<QuestionnairesQuery, QuestionnairesQueryVariables | void>({
      query: (variables) => ({ document: QuestionnairesDocument, variables })
    }),
    RequirementFile: build.query<RequirementFileQuery, RequirementFileQueryVariables | void>({
      query: (variables) => ({ document: RequirementFileDocument, variables })
    }),
    TermItems: build.query<TermItemsQuery, TermItemsQueryVariables | void>({
      query: (variables) => ({ document: TermItemsDocument, variables })
    }),
    TermItemByValue: build.query<TermItemByValueQuery, TermItemByValueQueryVariables>({
      query: (variables) => ({ document: TermItemByValueDocument, variables })
    }),
    userMetaTranslations: build.query<UserMetaTranslationsQuery, UserMetaTranslationsQueryVariables | void>({
      query: (variables) => ({ document: UserMetaTranslationsDocument, variables })
    }),
    TransmiseList: build.query<TransmiseListQuery, TransmiseListQueryVariables>({
      query: (variables) => ({ document: TransmiseListDocument, variables })
    }),
    FullUserInfo: build.query<FullUserInfoQuery, FullUserInfoQueryVariables>({
      query: (variables) => ({ document: FullUserInfoDocument, variables })
    }),
    UserEmail: build.query<UserEmailQuery, UserEmailQueryVariables | void>({
      query: (variables) => ({ document: UserEmailDocument, variables })
    }),
    UserHasMeddi: build.query<UserHasMeddiQuery, UserHasMeddiQueryVariables | void>({
      query: (variables) => ({ document: UserHasMeddiDocument, variables })
    }),
    UserMeta: build.query<UserMetaQuery, UserMetaQueryVariables | void>({
      query: (variables) => ({ document: UserMetaDocument, variables })
    }),
    UserParents: build.query<UserParentsQuery, UserParentsQueryVariables | void>({
      query: (variables) => ({ document: UserParentsDocument, variables })
    }),
    UserProfileImage: build.query<UserProfileImageQuery, UserProfileImageQueryVariables | void>({
      query: (variables) => ({ document: UserProfileImageDocument, variables })
    }),
    UserRelations: build.query<UserRelationsQuery, UserRelationsQueryVariables | void>({
      query: (variables) => ({ document: UserRelationsDocument, variables })
    }),
    UserTermItems: build.query<UserTermItemsQuery, UserTermItemsQueryVariables | void>({
      query: (variables) => ({ document: UserTermItemsDocument, variables })
    }),
    SubmitWizard: build.mutation<SubmitWizardMutation, SubmitWizardMutationVariables | void>({
      query: (variables) => ({ document: SubmitWizardDocument, variables })
    }),
    RootWorkplaceByChild: build.query<RootWorkplaceByChildQuery, RootWorkplaceByChildQueryVariables | void>({
      query: (variables) => ({ document: RootWorkplaceByChildDocument, variables })
    }),
    WorkplaceMemberRole: build.query<WorkplaceMemberRoleQuery, WorkplaceMemberRoleQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceMemberRoleDocument, variables })
    }),
    Workplaces: build.query<WorkplacesQuery, WorkplacesQueryVariables | void>({
      query: (variables) => ({ document: WorkplacesDocument, variables })
    }),
    WorkplacesForSelect: build.query<WorkplacesForSelectQuery, WorkplacesForSelectQueryVariables | void>({
      query: (variables) => ({ document: WorkplacesForSelectDocument, variables })
    }),
    NormalWorkplaces: build.query<NormalWorkplacesQuery, NormalWorkplacesQueryVariables | void>({
      query: (variables) => ({ document: NormalWorkplacesDocument, variables })
    }),
    WorkplaceMeta: build.query<WorkplaceMetaQuery, WorkplaceMetaQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceMetaDocument, variables })
    }),
    WorkplacePrivate: build.query<WorkplacePrivateQuery, WorkplacePrivateQueryVariables | void>({
      query: (variables) => ({ document: WorkplacePrivateDocument, variables })
    }),
    WorkplaceName: build.query<WorkplaceNameQuery, WorkplaceNameQueryVariables>({
      query: (variables) => ({ document: WorkplaceNameDocument, variables })
    }),
    WorkplaceCaseType: build.query<WorkplaceCaseTypeQuery, WorkplaceCaseTypeQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceCaseTypeDocument, variables })
    }),
    WorkplaceCaseTypes: build.query<WorkplaceCaseTypesQuery, WorkplaceCaseTypesQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceCaseTypesDocument, variables })
    }),
    WorkplaceMemberId: build.query<WorkplaceMemberIdQuery, WorkplaceMemberIdQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceMemberIdDocument, variables })
    }),
    SimpleWorkplaceMember: build.query<SimpleWorkplaceMemberQuery, SimpleWorkplaceMemberQueryVariables | void>({
      query: (variables) => ({ document: SimpleWorkplaceMemberDocument, variables })
    }),
    WorkplacePartner: build.query<WorkplacePartnerQuery, WorkplacePartnerQueryVariables | void>({
      query: (variables) => ({ document: WorkplacePartnerDocument, variables })
    }),
    workplaceServiceSchedule: build.query<WorkplaceServiceScheduleQuery, WorkplaceServiceScheduleQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceServiceScheduleDocument, variables })
    }),
    WorkplaceMemberMeta: build.query<WorkplaceMemberMetaQuery, WorkplaceMemberMetaQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceMemberMetaDocument, variables })
    }),
    WorkplaceMembers: build.query<WorkplaceMembersQuery, WorkplaceMembersQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceMembersDocument, variables })
    }),
    FilterCaseContacts: build.query<FilterCaseContactsQuery, FilterCaseContactsQueryVariables | void>({
      query: (variables) => ({ document: FilterCaseContactsDocument, variables })
    }),
    WorkplaceMember: build.query<WorkplaceMemberQuery, WorkplaceMemberQueryVariables | void>({
      query: (variables) => ({ document: WorkplaceMemberDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useCaseChatEntriesQuery, useLazyCaseChatEntriesQuery, useCreateHealthPlanUserPaymentMutation, useWorkplaceBillingAddressQuery, useLazyWorkplaceBillingAddressQuery, useWorkplaceUseCustomBillingAddressQuery, useLazyWorkplaceUseCustomBillingAddressQuery, usePatientConsentQuery, useLazyPatientConsentQuery, usePatientProfileDataQuery, useLazyPatientProfileDataQuery, usePatientUserRelationsQuery, useLazyPatientUserRelationsQuery, useWorkplaceMemberDetailsQuery, useLazyWorkplaceMemberDetailsQuery, useConversationDetailQuery, useLazyConversationDetailQuery, useConversationMessagesQuery, useLazyConversationMessagesQuery, useMessagesByConversationQuery, useLazyMessagesByConversationQuery, useDoctorsSearchQuery, useLazyDoctorsSearchQuery, useGetGridFilterQuery, useLazyGetGridFilterQuery, useSaveGridFilterMutation, useGroupsSearchQuery, useLazyGroupsSearchQuery, useNonDoctorsSearchQuery, useLazyNonDoctorsSearchQuery, usePatientsSearchQuery, useLazyPatientsSearchQuery, useRootWorkplaceDoctorsQuery, useLazyRootWorkplaceDoctorsQuery, useSimpleWorkplacesQuery, useLazySimpleWorkplacesQuery, useWorkplaceRolesQuery, useLazyWorkplaceRolesQuery, useCreateWorkplaceMemberAbsenceMutation, useDoneEventMutation, useAssignCaseToMeMutation, useCaseMedicalReportsQuery, useLazyCaseMedicalReportsQuery, useCasesAssignedQuery, useLazyCasesAssignedQuery, useIsMyCaseQuery, useLazyIsMyCaseQuery, useCreateNoteMutation, useUpdateNoteMutation, useNurseCasesQuery, useLazyNurseCasesQuery, useReAssignCaseMutation, useWorkplaceCasesQuery, useLazyWorkplaceCasesQuery, useWorkplaceCasesArchivedQuery, useLazyWorkplaceCasesArchivedQuery, useFullWorkplaceCaseTypesQuery, useLazyFullWorkplaceCaseTypesQuery, useWorkplaceRootCaseTypesQuery, useLazyWorkplaceRootCaseTypesQuery, useRootWorkplacesPatientQuery, useLazyRootWorkplacesPatientQuery, useCertificatesQuery, useLazyCertificatesQuery, useAttachmentDetailQuery, useLazyAttachmentDetailQuery, useDiscourseQuery, useLazyDiscourseQuery, useDraftDiscourseQuery, useLazyDraftDiscourseQuery, useDoctorBasicInfoQuery, useLazyDoctorBasicInfoQuery, useWorkplaceDoctorsQuery, useLazyWorkplaceDoctorsQuery, useDocumentQuery, useLazyDocumentQuery, useDocumentsQuery, useLazyDocumentsQuery, useWorkplaceCaseTargetQuery, useLazyWorkplaceCaseTargetQuery, useWorkplaceCodeQuery, useLazyWorkplaceCodeQuery, useEArchiveWorkplacePatientsQuery, useLazyEArchiveWorkplacePatientsQuery, useCreateUserMedicationLastedMutation, useDeleteUserMedicationLastedMutation, usePatientInformationQuery, useLazyPatientInformationQuery, useUpdateUserMedicationLastedMutation, useUserMedicationLastedQuery, useLazyUserMedicationLastedQuery, useDocumentationFilesQuery, useLazyDocumentationFilesQuery, useDocumentationFilesCountQuery, useLazyDocumentationFilesCountQuery, useDocumentationFoldersQuery, useLazyDocumentationFoldersQuery, useDocumentationFolderQuery, useLazyDocumentationFolderQuery, useECardNewFilesQuery, useLazyECardNewFilesQuery, useTransferDocumentMutation, useTransferDocumentsMutation, useGetUserOriginalIdQuery, useLazyGetUserOriginalIdQuery, useWorkplacePatientDocumentationFilesMarkAsSeenMutation, useEducationMaterialsQuery, useLazyEducationMaterialsQuery, useEventQuery, useLazyEventQuery, useEventsQuery, useLazyEventsQuery, useWorkplaceEventsQuery, useLazyWorkplaceEventsQuery, useGetOrdersQuery, useLazyGetOrdersQuery, useOrderStatisticsQuery, useLazyOrderStatisticsQuery, useHealthPlanBabyPregnancyQuery, useLazyHealthPlanBabyPregnancyQuery, useSubmitQuestionnaireResultMutation, useEndHealthPlanUserMutation, useCreateHealthPlanUserFromDataMutation, useHealthPlanUserInformationQuery, useLazyHealthPlanUserInformationQuery, useHealthPlanUserItemIdQuery, useLazyHealthPlanUserItemIdQuery, useHealthPlanUserQuery, useLazyHealthPlanUserQuery, useHealthPlanIdQuery, useLazyHealthPlanIdQuery, useHealthPlanDetailsQuery, useLazyHealthPlanDetailsQuery, useCreateHealthPlanUserMutation, useHealthPlansQuery, useLazyHealthPlansQuery, useRequestPaymentHealthPlanUserMutation, useHealthPlanRequirementsQuery, useLazyHealthPlanRequirementsQuery, useHealthPlanUserIdQuery, useLazyHealthPlanUserIdQuery, useHealthPlanUsersQuery, useLazyHealthPlanUsersQuery, useHealthPlanUserBabyQuery, useLazyHealthPlanUserBabyQuery, useInitialQuestionnaireResultQuery, useLazyInitialQuestionnaireResultQuery, useQuestionnaireResultItemsQuery, useLazyQuestionnaireResultItemsQuery, useQuestionnaireIdQuery, useLazyQuestionnaireIdQuery, useWorkplaceHealthPlansQuery, useLazyWorkplaceHealthPlansQuery, useCreateInsuranceReportExportFilesMutation, useDeleteInsuranceReportMutation, useInsuranceOperationCreateMutation, useInsuranceOperationDeleteMutation, useInsuranceOperationsQuery, useLazyInsuranceOperationsQuery, useInsuranceReportQuery, useLazyInsuranceReportQuery, useInsuranceReportCreateMutation, useInsuranceReportUserDataQuery, useLazyInsuranceReportUserDataQuery, useInsuranceReportsQuery, useLazyInsuranceReportsQuery, useAddLaboratoryRequisitionToPatientMutation, useCreateLaboratoryWorkplaceMutation, useCreateLaboratoryRequisitionWorkplaceMutation, useDeleteLaboratoryRequisitionWorkplaceMutation, useDeleteLaboratoryWorkplaceMutation, useHideSeenLaboratoryResultsMutation, useIssuedLaboratoryRequestsQuery, useLazyIssuedLaboratoryRequestsQuery, useLaboratoriesQuery, useLazyLaboratoriesQuery, useLaboratoryRequestCreateMutation, useLaboratoryRequestFormQuery, useLazyLaboratoryRequestFormQuery, useLaboratoryRequestsQuery, useLazyLaboratoryRequestsQuery, useLaboratoryResultsQuery, useLazyLaboratoryResultsQuery, useLaboratoryWorkplacesQuery, useLazyLaboratoryWorkplacesQuery, useAllCertificatesQuery, useLazyAllCertificatesQuery, useAllHealthPlansQuery, useLazyAllHealthPlansQuery, useAvailableServicesQuery, useLazyAvailableServicesQuery, useCreateHealthPlanWorkplaceMutation, useDeleteHealthPlanWorkplaceMutation, useSimpleWorkerInformationQuery, useLazySimpleWorkerInformationQuery, useUpdateWorkplaceMemberMutation, useWorkerInformationQuery, useLazyWorkerInformationQuery, useWorkerWorkplacesQuery, useLazyWorkerWorkplacesQuery, useWorkplaceBasicDataQuery, useLazyWorkplaceBasicDataQuery, useFullWorkplaceCaseTypeQuery, useLazyFullWorkplaceCaseTypeQuery, useWorkplaceCertificatesQuery, useLazyWorkplaceCertificatesQuery, useWorkplaceWorkersListQuery, useLazyWorkplaceWorkersListQuery, useWorkplacesCsszQuery, useLazyWorkplacesCsszQuery, useWorkplacesSuklCodeQuery, useLazyWorkplacesSuklCodeQuery, useMedicalRequestFormsQuery, useLazyMedicalRequestFormsQuery, useCreateUserMetaTranslationMutation, useMetaQuery, useLazyMetaQuery, useMyMetaQuery, useLazyMyMetaQuery, useAssignCaseMutation, useMonitoringCentreCasesQuery, useLazyMonitoringCentreCasesQuery, usePriorityCaseMutation, useCasesAssignedCountQuery, useLazyCasesAssignedCountQuery, useQuestionnaireResultsCountQuery, useLazyQuestionnaireResultsCountQuery, useWorkplaceCasesCountQuery, useLazyWorkplaceCasesCountQuery, useWorkplacePatientDocumentationFilesCountQuery, useLazyWorkplacePatientDocumentationFilesCountQuery, useNcziListDiagnosisItemsQuery, useLazyNcziListDiagnosisItemsQuery, useNcziListEnumItemsQuery, useLazyNcziListEnumItemsQuery, useNcziRefrenceItemQuery, useLazyNcziRefrenceItemQuery, useNcziRefrenceItemsByCodeQuery, useLazyNcziRefrenceItemsByCodeQuery, useNcziRefrenceItemByAbbrQuery, useLazyNcziRefrenceItemByAbbrQuery, useNcziListEnumsQuery, useLazyNcziListEnumsQuery, useNcziListExtensionItemsQuery, useLazyNcziListExtensionItemsQuery, useNcziExtensionItemQuery, useLazyNcziExtensionItemQuery, useNcziExtensionItemByAbbrQuery, useLazyNcziExtensionItemByAbbrQuery, useNcziMedicamentQuery, useLazyNcziMedicamentQuery, useFindOupzsQuery, useLazyFindOupzsQuery, useNcziProductListQuery, useLazyNcziProductListQuery, useNcziProductQuery, useLazyNcziProductQuery, useNcziQueueQuery, useLazyNcziQueueQuery, useUserBirthNumberQuery, useLazyUserBirthNumberQuery, useUserNcziProfileQuery, useLazyUserNcziProfileQuery, useMarkAllNotificationsAsSeenMutation, useConversationMessageQuery, useLazyConversationMessageQuery, useNotificationConversationQuery, useLazyNotificationConversationQuery, useListNotificationsQuery, useLazyListNotificationsQuery, useUnreadNotificationQuery, useLazyUnreadNotificationQuery, useSetUserNotificationSettingsMutation, useUserNotificationSettingsQuery, useLazyUserNotificationSettingsQuery, useArchiveWorkplaceMemberMutation, usePatientDataQuery, useLazyPatientDataQuery, usePatientMetaQuery, useLazyPatientMetaQuery, usePatientBasicInfoQuery, useLazyPatientBasicInfoQuery, useWorkplacePatientsQuery, useLazyWorkplacePatientsQuery, useGroupMembersQuery, useLazyGroupMembersQuery, useGroupAuditLogsQuery, useLazyGroupAuditLogsQuery, useGroupsQuery, useLazyGroupsQuery, useMassFindQuery, useLazyMassFindQuery, useCreatePhraseMutation, useDeletePhraseMutation, useMyPhrasesQuery, useLazyMyPhrasesQuery, useUpdatePhraseMutation, useCreateP1PrescriptionMutation, usePrescriptionMedicamentQuery, useLazyPrescriptionMedicamentQuery, usePrescriptionsQuery, useLazyPrescriptionsQuery, useSingleQuestionnaireResultItemsQuery, useLazySingleQuestionnaireResultItemsQuery, useQuestionnaireSearchQuery, useLazyQuestionnaireSearchQuery, useQuestionnaireSearchByCodeQuery, useLazyQuestionnaireSearchByCodeQuery, useQuestionnaireBasicInfoQuery, useLazyQuestionnaireBasicInfoQuery, useQuestionnaireSchedulesByParentScheduleQuery, useLazyQuestionnaireSchedulesByParentScheduleQuery, useQuestionnaireScheduleQuery, useLazyQuestionnaireScheduleQuery, useQuestionnaireDetailQuery, useLazyQuestionnaireDetailQuery, useQuestionnaireResultsQuery, useLazyQuestionnaireResultsQuery, useQuestionnaireSchedulesQuery, useLazyQuestionnaireSchedulesQuery, useQuestionnairesQuery, useLazyQuestionnairesQuery, useRequirementFileQuery, useLazyRequirementFileQuery, useTermItemsQuery, useLazyTermItemsQuery, useTermItemByValueQuery, useLazyTermItemByValueQuery, useUserMetaTranslationsQuery, useLazyUserMetaTranslationsQuery, useTransmiseListQuery, useLazyTransmiseListQuery, useFullUserInfoQuery, useLazyFullUserInfoQuery, useUserEmailQuery, useLazyUserEmailQuery, useUserHasMeddiQuery, useLazyUserHasMeddiQuery, useUserMetaQuery, useLazyUserMetaQuery, useUserParentsQuery, useLazyUserParentsQuery, useUserProfileImageQuery, useLazyUserProfileImageQuery, useUserRelationsQuery, useLazyUserRelationsQuery, useUserTermItemsQuery, useLazyUserTermItemsQuery, useSubmitWizardMutation, useRootWorkplaceByChildQuery, useLazyRootWorkplaceByChildQuery, useWorkplaceMemberRoleQuery, useLazyWorkplaceMemberRoleQuery, useWorkplacesQuery, useLazyWorkplacesQuery, useWorkplacesForSelectQuery, useLazyWorkplacesForSelectQuery, useNormalWorkplacesQuery, useLazyNormalWorkplacesQuery, useWorkplaceMetaQuery, useLazyWorkplaceMetaQuery, useWorkplacePrivateQuery, useLazyWorkplacePrivateQuery, useWorkplaceNameQuery, useLazyWorkplaceNameQuery, useWorkplaceCaseTypeQuery, useLazyWorkplaceCaseTypeQuery, useWorkplaceCaseTypesQuery, useLazyWorkplaceCaseTypesQuery, useWorkplaceMemberIdQuery, useLazyWorkplaceMemberIdQuery, useSimpleWorkplaceMemberQuery, useLazySimpleWorkplaceMemberQuery, useWorkplacePartnerQuery, useLazyWorkplacePartnerQuery, useWorkplaceServiceScheduleQuery, useLazyWorkplaceServiceScheduleQuery, useWorkplaceMemberMetaQuery, useLazyWorkplaceMemberMetaQuery, useWorkplaceMembersQuery, useLazyWorkplaceMembersQuery, useFilterCaseContactsQuery, useLazyFilterCaseContactsQuery, useWorkplaceMemberQuery, useLazyWorkplaceMemberQuery } = injectedRtkApi;

